(function () {
  Window.data = Window.data || {};
  Window.data.csv = { data: null };

  Window.data.csv.data = [
    {
      anio: 2015,
      lat: 27.5085,
      lng: -107.9124944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2015,
      lat: 27.53225,
      lng: -107.9939444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 26.074,
      lng: -106.7970278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2015,
      lat: 27.54077778,
      lng: -108.0007222,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2015,
      lat: 26.77888889,
      lng: -107.1019444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2015,
      lat: 26.10686111,
      lng: -106.6921667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.10522222,
      lng: -106.8366111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2015,
      lat: 26.05663889,
      lng: -106.8128333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2015,
      lat: 27.1014,
      lng: -107.0572667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2015,
      lat: 26.78061111,
      lng: -107.1037222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2015,
      lat: 26.90540278,
      lng: -107.0969944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.05527778,
      lng: -106.8167778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.06222222,
      lng: -106.9191944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2015,
      lat: 25.95994444,
      lng: -106.7323333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.86733889,
      lng: -107.0556028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1,
    },
    {
      anio: 2015,
      lat: 26.769275,
      lng: -107.1002361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 26.79806111,
      lng: -107.3089417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.85010278,
      lng: -107.3856472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 27.07104444,
      lng: -107.2197222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 0.8,
    },
    {
      anio: 2015,
      lat: 27.56230556,
      lng: -107.9484444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2015,
      lat: 26.20833333,
      lng: -106.79725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 26.07316667,
      lng: -106.9031667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.13638889,
      lng: -106.9133056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2015,
      lat: 26.91755,
      lng: -107.0539722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.04005556,
      lng: -106.7225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.09691667,
      lng: -106.8536944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.09883333,
      lng: -106.9055278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 26.92817222,
      lng: -107.0528472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2015,
      lat: 26.8352,
      lng: -107.1101444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2015,
      lat: 26.80593611,
      lng: -107.2424028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2015,
      lat: 26.86951667,
      lng: -106.9971389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 27.46713889,
      lng: -107.9188611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 27.47641667,
      lng: -107.9066944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2015,
      lat: 26.11869444,
      lng: -106.8614444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 27.43672222,
      lng: -107.8913889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.07561111,
      lng: -106.8347222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.11152778,
      lng: -106.9241667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.07344444,
      lng: -106.8989167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.063,
      lng: -106.7240278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 26.17002778,
      lng: -106.8090833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2015,
      lat: 26.88925556,
      lng: -107.0430472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2015,
      lat: 26.82891667,
      lng: -107.2729722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.86119167,
      lng: -107.0543639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2015,
      lat: 26.03244444,
      lng: -106.7429722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2015,
      lat: 26.07072222,
      lng: -106.9003333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.12675,
      lng: -106.8116389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 26.10383333,
      lng: -106.8331111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 26.12677778,
      lng: -106.8323056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2015,
      lat: 26.87669722,
      lng: -107.3993972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 27.51461111,
      lng: -107.8853889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.25,
    },
    {
      anio: 2015,
      lat: 26.13108333,
      lng: -106.8035833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2015,
      lat: 26.70583611,
      lng: -107.1816528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2015,
      lat: 26.69394444,
      lng: -107.1784972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.7,
    },
    {
      anio: 2015,
      lat: 25.03328056,
      lng: -106.1397833,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 24.33855556,
      lng: -106.0351944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 24.47733333,
      lng: -105.7230278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2015,
      lat: 24.87308333,
      lng: -106.0045556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Naturales",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2015,
      lat: 23.74441667,
      lng: -105.5519444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras actividades productivas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 23.47952778,
      lng: -105.1736944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 23.75844444,
      lng: -105.3645278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.91,
    },
    {
      anio: 2015,
      lat: 23.35872222,
      lng: -105.0927778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2015,
      lat: 23.76188889,
      lng: -105.7299167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.25,
    },
    {
      anio: 2015,
      lat: 25.59916667,
      lng: -106.1980556,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 22.89519444,
      lng: -104.84895,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2015,
      lat: 22.96366667,
      lng: -104.5896389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2015,
      lat: 22.98486111,
      lng: -104.6868333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2015,
      lat: 22.98134444,
      lng: -104.6509944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2015,
      lat: 22.61366111,
      lng: -104.2780972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2015,
      lat: 23.55088889,
      lng: -105.7553611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2015,
      lat: 24.84836111,
      lng: -105.7729167,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 23.62061111,
      lng: -104.3432778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 23.28827778,
      lng: -105.1301111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2015,
      lat: 23.53525,
      lng: -105.3458611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 23.46922222,
      lng: -105.375,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.3,
    },
    {
      anio: 2015,
      lat: 23.62705556,
      lng: -105.4147222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 25.72533333,
      lng: -106.155,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2015,
      lat: 23.67419444,
      lng: -105.8246389,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 27.5,
    },
    {
      anio: 2015,
      lat: 24.48888889,
      lng: -106.1225,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 24.34986111,
      lng: -105.4444722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2015,
      lat: 25.70677778,
      lng: -106.1216667,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2015,
      lat: 25.43483333,
      lng: -106.1976667,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 24.72669444,
      lng: -106.1153611,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2015,
      lat: 25.72911111,
      lng: -106.1541944,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 25.08777778,
      lng: -105.5073611,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2015,
      lat: 22.80441111,
      lng: -104.4451611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2015,
      lat: 22.95793056,
      lng: -104.5135361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2015,
      lat: 22.80806389,
      lng: -104.4473028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2015,
      lat: 22.99923889,
      lng: -104.7225139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2015,
      lat: 22.97796944,
      lng: -104.6498917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 22.94947222,
      lng: -104.6114,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Quema de basureros",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 23.11333611,
      lng: -104.3993833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2015,
      lat: 23.11981389,
      lng: -104.4456611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 22.99051944,
      lng: -104.5655833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2015,
      lat: 22.98888056,
      lng: -104.575575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2015,
      lat: 23.12591667,
      lng: -104.4449139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2015,
      lat: 22.98344722,
      lng: -104.5439556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2015,
      lat: 23.07435833,
      lng: -104.5840417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2015,
      lat: 22.67852222,
      lng: -104.5405083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2015,
      lat: 22.97225833,
      lng: -104.5022222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2015,
      lat: 25.23194444,
      lng: -106.1341944,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2015,
      lat: 23.79447222,
      lng: -105.6368333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2015,
      lat: 23.63168611,
      lng: -105.4852139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 24.293922,
      lng: -106.26835,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29528.3011,
    },
    {
      anio: 2025,
      lat: 23.397243,
      lng: -105.82285,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 130.4272,
    },
    {
      anio: 2025,
      lat: 24.165756,
      lng: -106.31085,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8142.2392,
    },
    {
      anio: 2019,
      lat: 24.15946111,
      lng: -106.5276528,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 7374,
    },
    {
      anio: 2023,
      lat: 26.050642,
      lng: -107.784424,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 7373.9386,
    },
    {
      anio: 2018,
      lat: 26.31566389,
      lng: -108.067375,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 6364,
    },
    {
      anio: 2024,
      lat: 24.171175,
      lng: -106.533516,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5776.3951,
    },
    {
      anio: 2023,
      lat: 25.76,
      lng: -107.6475,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5299.2118,
    },
    {
      anio: 2025,
      lat: 25.180292,
      lng: -107.1482,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4989.5529,
    },
    {
      anio: 2025,
      lat: 23.686083,
      lng: -106.074036,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 4621.3982,
    },
    {
      anio: 2025,
      lat: 23.61507,
      lng: -106.110466,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 4104.5729,
    },
    {
      anio: 2024,
      lat: 24.264074,
      lng: -106.42858,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 52,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3776.6868,
    },
    {
      anio: 2024,
      lat: 23.999294,
      lng: -105.978645,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3655.256,
    },
    {
      anio: 2023,
      lat: 24.127045,
      lng: -106.540184,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3168.717,
    },
    {
      anio: 2016,
      lat: 26.07216667,
      lng: -106.7840278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2016,
      lat: 26.08119444,
      lng: -106.7842778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.7,
    },
    {
      anio: 2016,
      lat: 26.08497222,
      lng: -106.8333056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.06538889,
      lng: -106.7914722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.07544444,
      lng: -106.7764667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.09375,
      lng: -106.8120556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.0925,
      lng: -106.8046944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.08797222,
      lng: -106.8099722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 27.51222222,
      lng: -107.8884167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.07894444,
      lng: -106.7444167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.10075,
      lng: -106.7016111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 27.50069444,
      lng: -107.8933056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.07952778,
      lng: -106.7877778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.07969444,
      lng: -106.8057778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.14166667,
      lng: -106.7927222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.89545556,
      lng: -107.0529806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2016,
      lat: 26.871,
      lng: -107.0268278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.80825833,
      lng: -107.1052639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.81358333,
      lng: -107.0931944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.88804722,
      lng: -107.3906694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.88428333,
      lng: -107.3838111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.8806,
      lng: -107.3793972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.867225,
      lng: -107.3732861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.80634722,
      lng: -107.1350444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.81701944,
      lng: -107.1252528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.78194722,
      lng: -107.1890861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.05569444,
      lng: -106.7594722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 27.00290278,
      lng: -107.1197333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agropecuarias",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 26.83471389,
      lng: -107.0973972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 26.84173611,
      lng: -107.0607528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.81765833,
      lng: -107.0752944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 7,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.84353611,
      lng: -107.1004139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.74269722,
      lng: -107.1068056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.81340556,
      lng: -107.0923056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.89523333,
      lng: -107.0952333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.08966667,
      lng: -106.77925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.48775,
      lng: -107.8835556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.06527778,
      lng: -106.8586389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 27.55463889,
      lng: -108.0108889,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.10008611,
      lng: -106.8311389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 26.91095556,
      lng: -107.3893056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62.4,
    },
    {
      anio: 2016,
      lat: 26.8632,
      lng: -107.0886722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.86030278,
      lng: -107.0953056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.15,
    },
    {
      anio: 2016,
      lat: 26.01391667,
      lng: -106.9273889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 27.54377778,
      lng: -107.8205556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.54561111,
      lng: -107.8206111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.07630556,
      lng: -106.7701667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.88469444,
      lng: -107.0286667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Otras causas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.4,
    },
    {
      anio: 2016,
      lat: 27.56022222,
      lng: -108.0263611,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 27.60330556,
      lng: -108.0605833,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2016,
      lat: 27.49991667,
      lng: -107.8750556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.97865,
      lng: -107.1486667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2016,
      lat: 26.8244,
      lng: -107.076125,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.86308611,
      lng: -107.06075,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2,
    },
    {
      anio: 2016,
      lat: 26.84122222,
      lng: -107.1590278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.2,
    },
    {
      anio: 2016,
      lat: 26.82441667,
      lng: -107.2668889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.2,
    },
    {
      anio: 2016,
      lat: 26.68302778,
      lng: -107.1732222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 83.9,
    },
    {
      anio: 2016,
      lat: 26.86995556,
      lng: -106.9891611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.90005556,
      lng: -107.1315278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 27.44275,
      lng: -108.0284444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.11197222,
      lng: -106.7399167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.08694444,
      lng: -106.9418611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 27.49369444,
      lng: -107.886,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 27.50672222,
      lng: -107.9090833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.6948,
      lng: -107.1977778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Otras causas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.19576389,
      lng: -106.8223111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.01038056,
      lng: -106.9488667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.70069722,
      lng: -107.0773944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Otras causas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.1,
    },
    {
      anio: 2016,
      lat: 27.54930556,
      lng: -107.8324444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.50122222,
      lng: -107.8534722,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.08330556,
      lng: -106.7605,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.05996111,
      lng: -107.1037417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Otras causas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 27.47388889,
      lng: -107.8628333,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.14580556,
      lng: -106.8326389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.01677778,
      lng: -106.8568889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.05672222,
      lng: -106.7593333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.07758333,
      lng: -106.8124444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.09763889,
      lng: -106.7251111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.099,
      lng: -106.7276667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 27.26496111,
      lng: -107.0015472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 27.138875,
      lng: -107.2757167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.4,
    },
    {
      anio: 2016,
      lat: 27.53319444,
      lng: -107.82825,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2016,
      lat: 27.64769444,
      lng: -108.0872222,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34,
    },
    {
      anio: 2016,
      lat: 27.51452778,
      lng: -107.9646111,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2,
    },
    {
      anio: 2016,
      lat: 26.06458333,
      lng: -106.7101111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.06772222,
      lng: -106.8045,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 26.09319444,
      lng: -106.7126667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2016,
      lat: 26.28544444,
      lng: -106.5109444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 115,
    },
    {
      anio: 2016,
      lat: 26.08725,
      lng: -106.7789444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.02368889,
      lng: -107.2239528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2016,
      lat: 27.16556944,
      lng: -107.2774667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2016,
      lat: 26.75352778,
      lng: -107.3848833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2016,
      lat: 26.16552778,
      lng: -106.9076667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2016,
      lat: 25.86552778,
      lng: -106.8159722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 25.83605556,
      lng: -106.78675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2016,
      lat: 26.80876944,
      lng: -107.2661306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 26.81341389,
      lng: -107.1329722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 27.09853056,
      lng: -107.2848472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2016,
      lat: 26.13711111,
      lng: -106.8126389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2016,
      lat: 27.47022222,
      lng: -107.8887778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.21097222,
      lng: -106.8616944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2016,
      lat: 26.19144444,
      lng: -106.8255278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.07591667,
      lng: -106.7745,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.72707222,
      lng: -106.8470639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.72468056,
      lng: -106.8293222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.72429722,
      lng: -106.8100778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.09711667,
      lng: -106.9388083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.09728056,
      lng: -106.9501194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 25.86442778,
      lng: -106.9524306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.13632222,
      lng: -106.8113722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.23574167,
      lng: -106.6430667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.05776944,
      lng: -106.9709139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 25.81748333,
      lng: -106.792225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.72930556,
      lng: -106.8182361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.10773889,
      lng: -107.020325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Limpias de derecho de vía",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.71194444,
      lng: -106.8674722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.69028056,
      lng: -106.9338444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Limpias de derecho de vía",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.85280833,
      lng: -106.8119,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.83299444,
      lng: -106.8001583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.79846111,
      lng: -107.275075,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 27.03153889,
      lng: -107.2788306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.23544444,
      lng: -106.8537222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2016,
      lat: 26.076,
      lng: -106.7833639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.44686111,
      lng: -108.0973333,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.8,
    },
    {
      anio: 2016,
      lat: 27.50163889,
      lng: -107.8742778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.8,
    },
    {
      anio: 2016,
      lat: 27.46969444,
      lng: -107.8607222,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.48056389,
      lng: -107.2816528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4.5,
    },
    {
      anio: 2016,
      lat: 26.40426944,
      lng: -107.2984194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2016,
      lat: 26.48677222,
      lng: -107.3083639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.39825278,
      lng: -107.3120694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.31006389,
      lng: -107.3338694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 8.5,
    },
    {
      anio: 2016,
      lat: 26.36554722,
      lng: -107.3925222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.30675556,
      lng: -107.1302361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.07326944,
      lng: -107.0004917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.08431111,
      lng: -106.9460917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.084775,
      lng: -106.9683,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.91114167,
      lng: -106.7958028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.89848889,
      lng: -106.8061917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Festividades y rituales",
      semana: 16,
      vegetacion: "Bosque de Táscate",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.67413889,
      lng: -106.8563778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.88519167,
      lng: -106.8001361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.72674444,
      lng: -106.8429556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.16875833,
      lng: -106.8290167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 26.19272778,
      lng: -106.6045222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.34265,
      lng: -106.7159667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.19629167,
      lng: -106.6379944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.11259444,
      lng: -106.7822417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.26058611,
      lng: -106.6589833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 26.38320833,
      lng: -106.913,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.33595556,
      lng: -106.9398056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.28389722,
      lng: -106.793,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.08579444,
      lng: -106.8071861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.85762778,
      lng: -106.7835083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.86363056,
      lng: -106.8244667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.83424722,
      lng: -106.7962917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.84660833,
      lng: -106.7863556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.83791389,
      lng: -106.8067139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.22356944,
      lng: -106.9643111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.04884722,
      lng: -106.9279611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.22522222,
      lng: -106.9660278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.05653611,
      lng: -106.9844,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 25.75118889,
      lng: -106.8323389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 25.84898333,
      lng: -106.8657444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.10171944,
      lng: -106.9281639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.78991944,
      lng: -106.8446306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.78676667,
      lng: -106.8079111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.74568333,
      lng: -106.84275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.83349444,
      lng: -106.7889222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.81266667,
      lng: -106.928,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.91010833,
      lng: -106.974675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.78818889,
      lng: -106.7862472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.107625,
      lng: -107.0068139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.0198,
      lng: -106.9328667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.04900833,
      lng: -106.8972556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.19160556,
      lng: -106.8423083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.34929444,
      lng: -106.8919361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.24805278,
      lng: -106.7668778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.26036111,
      lng: -106.5006056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 26.27655,
      lng: -106.5370167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.14558333,
      lng: -106.7831361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.19595,
      lng: -106.6624917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.2175,
      lng: -106.7677167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.21577222,
      lng: -106.6285278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.17223611,
      lng: -106.9093528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 26.21936667,
      lng: -106.8964611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 26.42454444,
      lng: -106.9270861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.25953333,
      lng: -106.7322167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 26.124275,
      lng: -106.5764944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.19198611,
      lng: -106.6081361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 27.33266389,
      lng: -108.0609333,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 27.60163056,
      lng: -108.1340444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 27.61819444,
      lng: -108.2414,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 27.25060556,
      lng: -107.8032333,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 27.57151944,
      lng: -108.2996528,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2016,
      lat: 27.22283611,
      lng: -107.9890111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.26154444,
      lng: -107.97875,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 27.17686111,
      lng: -107.9854389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 27.27355278,
      lng: -107.9964056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 27.25105,
      lng: -107.9690528,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 27.26277778,
      lng: -107.9788611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.79744444,
      lng: -107.2835472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 216,
    },
    {
      anio: 2016,
      lat: 26.7587,
      lng: -107.2767333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.79095278,
      lng: -107.2070333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.743625,
      lng: -107.1144083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.20858333,
      lng: -106.8510833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2016,
      lat: 27.51594444,
      lng: -107.8675556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2016,
      lat: 26.08822222,
      lng: -106.9361667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.6,
    },
    {
      anio: 2016,
      lat: 26.05961111,
      lng: -106.921,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.06066667,
      lng: -106.9235,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2016,
      lat: 26.20913056,
      lng: -106.9710222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.07770278,
      lng: -106.9605833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.99991389,
      lng: -107.0067222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.10500278,
      lng: -106.9334667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.94785833,
      lng: -106.7382361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.92838333,
      lng: -106.7574722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.92375,
      lng: -106.87105,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.41499444,
      lng: -107.2978806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.41699444,
      lng: -107.3020722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2016,
      lat: 26.55556111,
      lng: -107.4610556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 26.03975278,
      lng: -106.7860889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.07491111,
      lng: -106.9474056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.007025,
      lng: -106.8919361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 26.0146,
      lng: -106.9531639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.42276389,
      lng: -107.3458417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.3424,
      lng: -107.3607306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras actividades productivas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5.5,
    },
    {
      anio: 2016,
      lat: 25.812475,
      lng: -106.7941917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Limpias de derecho de vía",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.81561667,
      lng: -106.79185,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.81745278,
      lng: -106.8009528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 25.72771389,
      lng: -106.8401944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.68344722,
      lng: -106.9582889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.76340833,
      lng: -106.7943111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.72064167,
      lng: -106.8167111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.04137222,
      lng: -106.9011611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.01285556,
      lng: -107.0713056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.43809444,
      lng: -107.2897917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 14,
    },
    {
      anio: 2016,
      lat: 26.27957222,
      lng: -107.1043778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 25.89922778,
      lng: -106.7956028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 25.88363056,
      lng: -106.7884472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.88363056,
      lng: -106.7884472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 25.86384722,
      lng: -106.9065722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.92759722,
      lng: -106.9898833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.92545278,
      lng: -106.9045028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.89247778,
      lng: -106.9680972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 27.20811389,
      lng: -108.1167167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 27.66922778,
      lng: -108.0780333,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.09533333,
      lng: -106.7817778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.1865,
      lng: -106.8305833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2016,
      lat: 26.22625,
      lng: -106.8213611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.3,
    },
    {
      anio: 2016,
      lat: 27.49355556,
      lng: -107.9089167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2016,
      lat: 27.48975,
      lng: -107.9124722,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.1,
    },
    {
      anio: 2016,
      lat: 27.50447222,
      lng: -107.9003889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2016,
      lat: 26.22080556,
      lng: -106.862,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2016,
      lat: 26.15158333,
      lng: -106.8438611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2016,
      lat: 27.50566667,
      lng: -108.0270278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.4,
    },
    {
      anio: 2016,
      lat: 26.07297222,
      lng: -106.9133333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 27.52994444,
      lng: -107.9853333,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.4,
    },
    {
      anio: 2016,
      lat: 26.12283333,
      lng: -106.9098333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2016,
      lat: 26.10036111,
      lng: -106.8359444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 26.10027778,
      lng: -106.8177222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 26.1,
      lng: -106.8365833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 27.51594444,
      lng: -108.0283611,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 75.7,
    },
    {
      anio: 2016,
      lat: 27.46715,
      lng: -108.0932083,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.30436389,
      lng: -108.0386306,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 27.59118611,
      lng: -108.1117278,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.57890556,
      lng: -108.1450611,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 27.47580556,
      lng: -107.9100278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.10013889,
      lng: -106.83375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.14158333,
      lng: -106.9096111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2016,
      lat: 27.45313889,
      lng: -107.9246944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 27.44830556,
      lng: -107.9290278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.1,
    },
    {
      anio: 2016,
      lat: 26.078275,
      lng: -106.9810722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.07844722,
      lng: -106.9926944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.97497222,
      lng: -106.9999556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.06999444,
      lng: -106.9944028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.03771944,
      lng: -107.0159778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.75320278,
      lng: -106.6610972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.79595,
      lng: -106.6304083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.836425,
      lng: -106.7658083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2016,
      lat: 25.72973611,
      lng: -106.6519917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.01561111,
      lng: -106.8879083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.99078056,
      lng: -106.8435667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.04273889,
      lng: -106.9578361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.96835,
      lng: -106.9181361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.01576944,
      lng: -106.9253611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.04043333,
      lng: -106.9653194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.79478611,
      lng: -106.5795417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.81595556,
      lng: -106.70105,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.01816389,
      lng: -106.9694167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.03375833,
      lng: -106.911,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.99993889,
      lng: -106.9270639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.81656944,
      lng: -106.8022306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.76582778,
      lng: -106.7931694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 26.02559444,
      lng: -106.7595806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.07158889,
      lng: -106.7255194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.20615556,
      lng: -106.8239583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 26.14518056,
      lng: -106.883075,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.04787222,
      lng: -106.7536333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.21699722,
      lng: -106.6226222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.20943333,
      lng: -106.6374361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.25389722,
      lng: -106.6794389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.19365278,
      lng: -106.6297472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.25306111,
      lng: -106.6255472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.02768333,
      lng: -106.6620972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.57595556,
      lng: -107.0626833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 26.09515,
      lng: -106.8029222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 26.40309444,
      lng: -106.9240389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.29034444,
      lng: -106.8220167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.36219444,
      lng: -106.9049306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 26.32926389,
      lng: -106.6525444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.30182778,
      lng: -106.5931944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.28961389,
      lng: -106.5732333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 26.16605,
      lng: -106.6323306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 27.49141667,
      lng: -107.9385278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2016,
      lat: 26.13188889,
      lng: -106.87575,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.8,
    },
    {
      anio: 2016,
      lat: 26.03169444,
      lng: -106.7805,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.15408333,
      lng: -106.8786944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2016,
      lat: 26.04177778,
      lng: -106.7061389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2016,
      lat: 27.61713889,
      lng: -108.0515278,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 43.3,
    },
    {
      anio: 2016,
      lat: 27.508025,
      lng: -108.0506417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.62396111,
      lng: -108.2532889,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 27.49241389,
      lng: -108.2223667,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 26.77736111,
      lng: -107.1117639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 26.79836944,
      lng: -107.2246167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.45,
    },
    {
      anio: 2016,
      lat: 26.90377778,
      lng: -107.0960667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2016,
      lat: 27.57661111,
      lng: -108.0305278,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.4,
    },
    {
      anio: 2016,
      lat: 26.21716667,
      lng: -106.8280833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 26.24847222,
      lng: -106.8226667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 84,
    },
    {
      anio: 2016,
      lat: 25.86161389,
      lng: -106.780425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 25.89697222,
      lng: -106.8488972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.82596667,
      lng: -106.8818194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.89626667,
      lng: -106.8031639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.96136111,
      lng: -106.7200556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.94506944,
      lng: -106.8497194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.8164,
      lng: -106.7878167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Festividades y rituales",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.85462778,
      lng: -106.7886556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.72675833,
      lng: -106.8207528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.07509167,
      lng: -106.9543833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 26.01078611,
      lng: -106.9926028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.08548611,
      lng: -106.9514833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.09971944,
      lng: -106.9342972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.06965556,
      lng: -106.9474111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.07436667,
      lng: -106.9593333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 25.95448889,
      lng: -106.8335333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.06171389,
      lng: -106.9107222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.88191667,
      lng: -106.8009028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.70879444,
      lng: -106.8374833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.91131944,
      lng: -106.7924528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.86133611,
      lng: -106.7851444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.8164,
      lng: -106.7878167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.88271111,
      lng: -106.8038889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.919725,
      lng: -106.8137833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.85840833,
      lng: -106.8993556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.92653889,
      lng: -106.9379167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.615975,
      lng: -106.7717944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.88118611,
      lng: -106.9259278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.85745556,
      lng: -106.9065083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.76356667,
      lng: -106.8435972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.88443056,
      lng: -106.8510889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.853225,
      lng: -106.9300417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.83928889,
      lng: -106.903225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.81688333,
      lng: -106.7839861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.89275556,
      lng: -106.9250167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.02518333,
      lng: -107.0189,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 26.22619444,
      lng: -106.8160556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 27.357,
      lng: -108.2561389,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 772,
    },
    {
      anio: 2016,
      lat: 26.09501667,
      lng: -106.9479972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.12525556,
      lng: -107.0228889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.81429444,
      lng: -106.8057556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.84465833,
      lng: -106.734975,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.84658889,
      lng: -106.7917889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.85920556,
      lng: -106.7784278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.92590556,
      lng: -106.7163167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.87516944,
      lng: -106.6529083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.81349444,
      lng: -106.6595139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.81197778,
      lng: -106.5957,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.72625833,
      lng: -106.8729889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 25.81696389,
      lng: -106.6978333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.86181944,
      lng: -106.5761694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Festividades y rituales",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.92476111,
      lng: -106.9356944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 25.86319722,
      lng: -106.8951528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.86873056,
      lng: -107.0045,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.48535833,
      lng: -106.8321306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 26.185475,
      lng: -106.5974306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 26.28168611,
      lng: -106.5448583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 26.39895,
      lng: -107.0269611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.15971667,
      lng: -106.5202167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 26.16363889,
      lng: -106.6973806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 26.21001389,
      lng: -106.7247611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 26.2416,
      lng: -106.8125722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.13756389,
      lng: -106.7182778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 26.09885833,
      lng: -106.81105,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 26.797,
      lng: -107.0143833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 27.51836111,
      lng: -107.9109444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.66,
    },
    {
      anio: 2016,
      lat: 27.47827778,
      lng: -107.8926389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2016,
      lat: 26.79015556,
      lng: -107.3455167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 208,
    },
    {
      anio: 2016,
      lat: 26.84785,
      lng: -107.3582222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 26.92719167,
      lng: -107.101425,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2016,
      lat: 26.75211389,
      lng: -107.2990167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 26.08437222,
      lng: -106.5296444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 330,
    },
    {
      anio: 2016,
      lat: 26.29090278,
      lng: -106.6227194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 370,
    },
    {
      anio: 2016,
      lat: 26.53061389,
      lng: -107.0525194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2016,
      lat: 26.57725,
      lng: -106.9540611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 292,
    },
    {
      anio: 2016,
      lat: 26.54097222,
      lng: -106.9630917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 118,
    },
    {
      anio: 2016,
      lat: 22.97355556,
      lng: -104.6306111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 1,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.84,
    },
    {
      anio: 2016,
      lat: 22.96558333,
      lng: -104.6218333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 1,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.41,
    },
    {
      anio: 2016,
      lat: 22.97605556,
      lng: -104.6147222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.4,
    },
    {
      anio: 2016,
      lat: 24.44211111,
      lng: -105.7575,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 3,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.2,
    },
    {
      anio: 2016,
      lat: 25.38261111,
      lng: -106.2318889,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 23.75783333,
      lng: -105.453,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.03619444,
      lng: -106.2905556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 24.41966667,
      lng: -105.701,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.25,
    },
    {
      anio: 2016,
      lat: 25.10708333,
      lng: -106.2798333,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2016,
      lat: 23.77011111,
      lng: -105.3469444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2016,
      lat: 23.79088889,
      lng: -105.3626389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.5,
    },
    {
      anio: 2016,
      lat: 23.44277778,
      lng: -105.3651667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2016,
      lat: 23.31305556,
      lng: -105.4417222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 81,
    },
    {
      anio: 2016,
      lat: 24.97080556,
      lng: -105.9910833,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 24.93316667,
      lng: -106.0557222,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2016,
      lat: 23.23966667,
      lng: -104.7494167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 24.12688889,
      lng: -105.7149444,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 23.67775,
      lng: -105.5765556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 23.56397222,
      lng: -105.5113889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2016,
      lat: 24.37266667,
      lng: -105.4234444,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Pastizal Inducido",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 23.66491667,
      lng: -105.5865,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.25,
    },
    {
      anio: 2016,
      lat: 23.62266667,
      lng: -105.4614444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 23.65472222,
      lng: -105.52075,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2016,
      lat: 24.92758333,
      lng: -106.0530278,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2016,
      lat: 23.6275,
      lng: -105.6050833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.2,
    },
    {
      anio: 2016,
      lat: 24.862,
      lng: -105.9133056,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.5,
    },
    {
      anio: 2016,
      lat: 25.61847222,
      lng: -106.2996667,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2016,
      lat: 23.66441667,
      lng: -104.3741111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 420,
    },
    {
      anio: 2016,
      lat: 23.62463889,
      lng: -105.5261389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.2,
    },
    {
      anio: 2016,
      lat: 24.04425,
      lng: -105.6934722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2016,
      lat: 23.23344444,
      lng: -104.4281667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2016,
      lat: 22.96469444,
      lng: -104.5226944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2016,
      lat: 22.91486111,
      lng: -104.5449722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 89,
    },
    {
      anio: 2016,
      lat: 23.51075,
      lng: -105.5334444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2,
    },
    {
      anio: 2016,
      lat: 24.95313889,
      lng: -106.2282778,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2016,
      lat: 25.03863889,
      lng: -106.2357222,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2016,
      lat: 25.10205556,
      lng: -106.4542222,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2016,
      lat: 23.74505556,
      lng: -105.292,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 23.52180556,
      lng: -105.1056944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 586,
    },
    {
      anio: 2016,
      lat: 23.83855556,
      lng: -105.5018611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 81.2,
    },
    {
      anio: 2016,
      lat: 23.56741667,
      lng: -105.4161667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.5,
    },
    {
      anio: 2016,
      lat: 23.62258333,
      lng: -105.4804722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 76.1,
    },
    {
      anio: 2016,
      lat: 23.73866667,
      lng: -105.2861389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 25.07566667,
      lng: -106.2905,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 95,
    },
    {
      anio: 2016,
      lat: 25.54172222,
      lng: -106.2737222,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 88,
    },
    {
      anio: 2016,
      lat: 22.94502778,
      lng: -104.6034444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.94188889,
      lng: -104.6023889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.93761111,
      lng: -104.5673333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.96308333,
      lng: -104.5466944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.95894444,
      lng: -104.5533611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 23.11197222,
      lng: -104.31575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2016,
      lat: 22.96311111,
      lng: -104.3990833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 23.00497222,
      lng: -104.3188333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 22.87802778,
      lng: -104.2714167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.8,
    },
    {
      anio: 2016,
      lat: 22.67175,
      lng: -104.3167778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 22.96347222,
      lng: -104.5951389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 23.00636111,
      lng: -104.6281389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Pastizal Inducido",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.96283333,
      lng: -104.5760278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.90797222,
      lng: -104.5923611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.96663889,
      lng: -104.5811667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 22.96980556,
      lng: -104.5705833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 23.022,
      lng: -104.5566389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 22.93427778,
      lng: -104.5920833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2016,
      lat: 22.96638889,
      lng: -104.5834528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 22.98902778,
      lng: -104.6636944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.96738889,
      lng: -104.5780833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.94880556,
      lng: -104.6212222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.95283333,
      lng: -104.5978056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 23.01408333,
      lng: -104.63625,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 22.61830556,
      lng: -104.5916944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.20130556,
      lng: -106.47525,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 25.46741667,
      lng: -106.8307222,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.65,
    },
    {
      anio: 2016,
      lat: 25.611,
      lng: -106.3308333,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 181,
    },
    {
      anio: 2016,
      lat: 23.26619444,
      lng: -104.7187778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2016,
      lat: 23.1475,
      lng: -104.3723056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 320,
    },
    {
      anio: 2016,
      lat: 22.94455556,
      lng: -104.4951389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 270,
    },
    {
      anio: 2016,
      lat: 22.93813889,
      lng: -104.63925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 23.79238889,
      lng: -105.7929167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2016,
      lat: 22.98944444,
      lng: -104.8632778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 23.60358333,
      lng: -105.5121944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.5,
    },
    {
      anio: 2016,
      lat: 22.92308333,
      lng: -104.6323056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 23.01711111,
      lng: -104.6298056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 23.048,
      lng: -104.6298333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.69605556,
      lng: -104.3140278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2016,
      lat: 22.69472222,
      lng: -104.32975,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2016,
      lat: 22.60708333,
      lng: -104.2868611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 22.59561111,
      lng: -104.2923333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2016,
      lat: 22.94094444,
      lng: -104.2472778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 23.00486111,
      lng: -104.3282778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 23.07827778,
      lng: -104.3454444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 23.0205,
      lng: -104.3201944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 22.99427778,
      lng: -104.2639722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 22.86516667,
      lng: -104.3210556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 22.89313889,
      lng: -104.3141389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 25.23452778,
      lng: -105.9283889,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 23.53072222,
      lng: -105.4525,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 81,
    },
    {
      anio: 2016,
      lat: 23.29011111,
      lng: -104.9810556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 175,
    },
    {
      anio: 2016,
      lat: 25.54947222,
      lng: -105.9826944,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 25.39597222,
      lng: -106.0857222,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 24.30947222,
      lng: -105.5992222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Pastizal Inducido",
      impacto: "Impacto Mínimo",
      superficie: 12.4,
    },
    {
      anio: 2016,
      lat: 25.11919444,
      lng: -105.7805278,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 23.59338889,
      lng: -105.5309167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 23.50580556,
      lng: -105.7091944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2016,
      lat: 23.57694444,
      lng: -105.6910556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2016,
      lat: 23.24936111,
      lng: -104.9574722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 23.34941667,
      lng: -104.9445278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2016,
      lat: 23.3675,
      lng: -104.9675556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 23.41730556,
      lng: -104.9035,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 23.27838889,
      lng: -104.9494444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 23.40133333,
      lng: -104.8885278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 23.73847222,
      lng: -105.3660278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2016,
      lat: 23.31338889,
      lng: -104.31925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2016,
      lat: 24.73711111,
      lng: -105.9494167,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2016,
      lat: 24.35527778,
      lng: -105.5029167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.58,
    },
    {
      anio: 2016,
      lat: 23.77063889,
      lng: -105.7789167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2016,
      lat: 23.60530556,
      lng: -105.8336111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 87,
    },
    {
      anio: 2016,
      lat: 23.57683333,
      lng: -105.6592778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 89,
    },
    {
      anio: 2016,
      lat: 23.27313889,
      lng: -105.36075,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2016,
      lat: 23.39838889,
      lng: -105.656,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2016,
      lat: 23.18786111,
      lng: -105.3011944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2016,
      lat: 23.14841667,
      lng: -105.2541389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 88,
    },
    {
      anio: 2016,
      lat: 23.34172222,
      lng: -105.3467222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2016,
      lat: 23.32722222,
      lng: -105.4904167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2016,
      lat: 23.61883333,
      lng: -105.5106389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.3,
    },
    {
      anio: 2016,
      lat: 23.60036111,
      lng: -105.32375,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2016,
      lat: 23.87402778,
      lng: -105.4320833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2016,
      lat: 23.80225,
      lng: -105.3922778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2016,
      lat: 23.80433333,
      lng: -105.7168333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2016,
      lat: 24.33327778,
      lng: -106.0755556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 350,
    },
    {
      anio: 2016,
      lat: 22.81122222,
      lng: -104.5038333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53,
    },
    {
      anio: 2016,
      lat: 23.59255556,
      lng: -105.6912778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 340,
    },
    {
      anio: 2016,
      lat: 23.22252778,
      lng: -104.3641944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2016,
      lat: 22.85636111,
      lng: -104.2841389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2016,
      lat: 22.87438889,
      lng: -104.3011111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2016,
      lat: 22.81597222,
      lng: -104.5105278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2016,
      lat: 23.06083333,
      lng: -104.7678611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2016,
      lat: 23.06347222,
      lng: -104.4984444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 22.95894444,
      lng: -104.5533611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 23.05494444,
      lng: -104.7038333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 22.81936111,
      lng: -104.5826944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2016,
      lat: 23.0185,
      lng: -104.5023056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 22.99541667,
      lng: -104.5101667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2016,
      lat: 22.97313889,
      lng: -104.57325,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 22.91205556,
      lng: -104.57825,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.89186111,
      lng: -104.6225278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 22.88722222,
      lng: -104.6352778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 22.97102778,
      lng: -104.6478333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 23.47180556,
      lng: -105.5515,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2016,
      lat: 23.67702778,
      lng: -105.6553333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 58,
    },
    {
      anio: 2016,
      lat: 23.56225,
      lng: -105.6556389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2016,
      lat: 23.66191667,
      lng: -105.6891944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80.1,
    },
    {
      anio: 2016,
      lat: 24.1285,
      lng: -105.6727222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.54,
    },
    {
      anio: 2016,
      lat: 23.33333333,
      lng: -105.1331111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2016,
      lat: 24.16497222,
      lng: -105.6563611,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2016,
      lat: 25.7325,
      lng: -106.1486111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 23.63622222,
      lng: -105.5341667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.3,
    },
    {
      anio: 2016,
      lat: 24.89083333,
      lng: -106.0866944,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 190,
    },
    {
      anio: 2016,
      lat: 24.96286111,
      lng: -106.2718889,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 75,
    },
    {
      anio: 2016,
      lat: 23.6305,
      lng: -105.4995,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2016,
      lat: 23.39730556,
      lng: -105.2260833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2016,
      lat: 25.48338889,
      lng: -106.8937222,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2016,
      lat: 25.51258333,
      lng: -106.7846111,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2016,
      lat: 25.39963889,
      lng: -106.9548333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2016,
      lat: 23.60966667,
      lng: -105.3336944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.8,
    },
    {
      anio: 2016,
      lat: 23.22719444,
      lng: -104.3653333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 25.07780556,
      lng: -105.6254167,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2016,
      lat: 23.39252778,
      lng: -104.8917778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 24.14361111,
      lng: -105.79125,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 75,
    },
    {
      anio: 2016,
      lat: 25.03822222,
      lng: -105.9933056,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.95136111,
      lng: -104.3997222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100.6,
    },
    {
      anio: 2016,
      lat: 22.48447222,
      lng: -104.3555278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2016,
      lat: 22.92133333,
      lng: -104.3675278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2016,
      lat: 23.10833333,
      lng: -104.5891389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 22.999,
      lng: -104.5529167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 23.01022222,
      lng: -104.556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 23.00288889,
      lng: -104.6428056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2016,
      lat: 22.99313889,
      lng: -104.5688611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 22.99055556,
      lng: -104.645,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 22.97844444,
      lng: -104.6453889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 23.00519444,
      lng: -104.6404722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2016,
      lat: 22.97933333,
      lng: -104.64875,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.73877778,
      lng: -104.3393333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.62322222,
      lng: -104.2991667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2016,
      lat: 22.72613889,
      lng: -104.33275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2016,
      lat: 22.719,
      lng: -104.3266667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 23.29677778,
      lng: -104.8118333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2016,
      lat: 22.70208333,
      lng: -104.3297778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 22.66086111,
      lng: -104.3377222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 23.19830556,
      lng: -105.6249167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2016,
      lat: 24.06955556,
      lng: -105.6424722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2016,
      lat: 24.16558333,
      lng: -105.7246389,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2016,
      lat: 24.15755556,
      lng: -105.6330278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2016,
      lat: 25.09586111,
      lng: -106.5521667,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2016,
      lat: 25.0245,
      lng: -106.2627778,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.28294444,
      lng: -106.5328333,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2016,
      lat: 25.28805556,
      lng: -106.5696111,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 24.97983333,
      lng: -106.2395556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Pastizal Inducido",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2016,
      lat: 25.14113889,
      lng: -106.3131667,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 22.97075,
      lng: -104.6401389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 24.83822222,
      lng: -105.8453056,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2024,
      lat: 23.64539,
      lng: -106.005585,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Severo",
      superficie: 3051.1129,
    },
    {
      anio: 2025,
      lat: 25.529242,
      lng: -107.41249,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2880.3098,
    },
    {
      anio: 2023,
      lat: 26.109833,
      lng: -107.68341,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2757.7224,
    },
    {
      anio: 2025,
      lat: 24.461313,
      lng: -106.59127,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 2640.9076,
    },
    {
      anio: 2025,
      lat: 24.25286,
      lng: -106.53397,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2569.7278,
    },
    {
      anio: 2025,
      lat: 23.798042,
      lng: -106.24812,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2500.5332,
    },
    {
      anio: 2025,
      lat: 25.455973,
      lng: -107.16959,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2496.778,
    },
    {
      anio: 2025,
      lat: 26.96738,
      lng: -108.392876,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Transportes",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2391.3831,
    },
    {
      anio: 2023,
      lat: 24.230602,
      lng: -106.09217,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2331.6089,
    },
    {
      anio: 2023,
      lat: 25.85688,
      lng: -107.25657,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2252.305,
    },
    {
      anio: 2024,
      lat: 24.026571,
      lng: -106.55112,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 2071.0937,
    },
    {
      anio: 2022,
      lat: 26.813019,
      lng: -108.04977,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1988.1223,
    },
    {
      anio: 2024,
      lat: 23.641314,
      lng: -105.9743,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Severo",
      superficie: 1913.4214,
    },
    {
      anio: 2025,
      lat: 25.747437,
      lng: -107.4047,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1708.8664,
    },
    {
      anio: 2025,
      lat: 23.55758,
      lng: -105.82934,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 145.8411,
    },
    {
      anio: 2025,
      lat: 25.046143,
      lng: -107.2742,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1658.0445,
    },
    {
      anio: 2025,
      lat: 23.532888,
      lng: -105.79162,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 940.3604,
    },
    {
      anio: 2025,
      lat: 24.171753,
      lng: -106.18333,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1458.3935,
    },
    {
      anio: 2023,
      lat: 26.15006,
      lng: -107.56392,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1451.7051,
    },
    {
      anio: 2023,
      lat: 24.150728,
      lng: -106.04072,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1417.6209,
    },
    {
      anio: 2023,
      lat: 24.117231,
      lng: -106.19616,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1313.4686,
    },
    {
      anio: 2022,
      lat: 25.58415,
      lng: -107.09924,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1152.3342,
    },
    {
      anio: 2025,
      lat: 26.305058,
      lng: -108.124176,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1115.319,
    },
    {
      anio: 2023,
      lat: 24.107658,
      lng: -106.15604,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1091.0422,
    },
    {
      anio: 2024,
      lat: 23.682278,
      lng: -106.27773,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 1086.7915,
    },
    {
      anio: 2025,
      lat: 26.538605,
      lng: -108.08043,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1045.6987,
    },
    {
      anio: 2025,
      lat: 24.56054,
      lng: -106.967026,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 1034.7969,
    },
    {
      anio: 2025,
      lat: 26.414053,
      lng: -107.99531,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1015.7371,
    },
    {
      anio: 2022,
      lat: 24.232594,
      lng: -106.08613,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Severo",
      superficie: 1010,
    },
    {
      anio: 2023,
      lat: 25.152328,
      lng: -107.16224,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1000.1325,
    },
    {
      anio: 2017,
      lat: 26.05272222,
      lng: -106.8403611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 26.10155556,
      lng: -106.7746111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.4,
    },
    {
      anio: 2017,
      lat: 26.06983333,
      lng: -106.7930556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.1,
    },
    {
      anio: 2017,
      lat: 26.76660833,
      lng: -107.0778278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.79772778,
      lng: -107.2177028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.748825,
      lng: -107.2539889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.75322778,
      lng: -107.1295444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 26.81543056,
      lng: -107.2630389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 25.93324444,
      lng: -106.6720833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.06934444,
      lng: -106.8369639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.07697222,
      lng: -106.7883333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.86842778,
      lng: -107.1218389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 27.4,
    },
    {
      anio: 2017,
      lat: 26.78400278,
      lng: -107.3135833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2017,
      lat: 26.70280278,
      lng: -107.1986833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 26.81691389,
      lng: -107.0898639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.34,
    },
    {
      anio: 2017,
      lat: 27.147075,
      lng: -107.1549389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.07325,
      lng: -106.7832222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.05477778,
      lng: -106.9355833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2017,
      lat: 26.07858333,
      lng: -106.7964167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 27.60393889,
      lng: -108.0538028,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.9,
    },
    {
      anio: 2017,
      lat: 26.30808333,
      lng: -106.91425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 27.49430556,
      lng: -107.9327778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 26.74780278,
      lng: -107.2844778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 26.79781111,
      lng: -107.2738778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2017,
      lat: 26.07505556,
      lng: -106.8036944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2017,
      lat: 26.05672222,
      lng: -106.7945833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2017,
      lat: 26.15358333,
      lng: -106.6155278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2017,
      lat: 26.10313889,
      lng: -106.8085278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.10330556,
      lng: -106.7089444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 26.20241667,
      lng: -106.8030833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31.77,
    },
    {
      anio: 2017,
      lat: 26.08961111,
      lng: -106.7245278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.56,
    },
    {
      anio: 2017,
      lat: 26.07838889,
      lng: -106.8128333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.69,
    },
    {
      anio: 2017,
      lat: 26.17319444,
      lng: -106.8041944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.89,
    },
    {
      anio: 2017,
      lat: 26.05741667,
      lng: -106.7965278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.87369167,
      lng: -107.2103139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 26.91084444,
      lng: -107.0383778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.3,
    },
    {
      anio: 2017,
      lat: 26.96811944,
      lng: -107.1454278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2017,
      lat: 26.968125,
      lng: -107.1454278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.10697222,
      lng: -106.8096389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.77,
    },
    {
      anio: 2017,
      lat: 26.13230556,
      lng: -106.8311944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.17,
    },
    {
      anio: 2017,
      lat: 27.44352778,
      lng: -107.8861667,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 27.42793611,
      lng: -107.8864639,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.1,
    },
    {
      anio: 2017,
      lat: 26.82406667,
      lng: -107.1351667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2017,
      lat: 26.773,
      lng: -106.9554778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51.5,
    },
    {
      anio: 2017,
      lat: 26.8766,
      lng: -107.0608306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.82523333,
      lng: -107.1285917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 27.53013889,
      lng: -107.9799444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.21297222,
      lng: -106.8061389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2017,
      lat: 27.68840556,
      lng: -108.1089422,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2017,
      lat: 26.16011111,
      lng: -106.7996389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.6,
    },
    {
      anio: 2017,
      lat: 26.740875,
      lng: -107.1883139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.74620833,
      lng: -107.1001694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.90480278,
      lng: -107.0508056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2017,
      lat: 26.70527778,
      lng: -107.0705583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.82465278,
      lng: -107.2553917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.78694167,
      lng: -107.2736,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.5,
    },
    {
      anio: 2017,
      lat: 26.20641667,
      lng: -106.8024167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.21202778,
      lng: -106.8500278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 26.75571111,
      lng: -107.0441861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 661,
    },
    {
      anio: 2017,
      lat: 26.78855556,
      lng: -107.2736944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.84377778,
      lng: -107.1237778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.90497778,
      lng: -107.2065889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.88983333,
      lng: -107.089,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.84458611,
      lng: -107.0760194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.8626,
      lng: -107.3582,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 216,
    },
    {
      anio: 2017,
      lat: 26.78979444,
      lng: -107.2762083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.21352778,
      lng: -106.8479722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.8,
    },
    {
      anio: 2017,
      lat: 27.53501117,
      lng: -108.0001207,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.7,
    },
    {
      anio: 2017,
      lat: 26.06138889,
      lng: -106.79625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2017,
      lat: 27.50537222,
      lng: -107.8400111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2017,
      lat: 26.05547222,
      lng: -106.8209444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.13,
    },
    {
      anio: 2017,
      lat: 27.53335,
      lng: -107.9289444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 27.51475,
      lng: -107.8570833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 27.46263889,
      lng: -107.8726944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.3,
    },
    {
      anio: 2017,
      lat: 27.49206111,
      lng: -107.9495306,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2017,
      lat: 26.05683333,
      lng: -106.8977778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.62,
    },
    {
      anio: 2017,
      lat: 26.88955278,
      lng: -107.1010667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.7512,
      lng: -107.2742889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 26.88918611,
      lng: -107.0197889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.76533889,
      lng: -107.2680139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 27.51511111,
      lng: -107.8576944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.21,
    },
    {
      anio: 2017,
      lat: 26.08994444,
      lng: -106.8183611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 26.04216667,
      lng: -106.8111667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.83,
    },
    {
      anio: 2017,
      lat: 26.27938889,
      lng: -106.8158056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18.69,
    },
    {
      anio: 2017,
      lat: 27.46044444,
      lng: -107.9074444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.3,
    },
    {
      anio: 2017,
      lat: 27.51936111,
      lng: -107.8524167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.15,
    },
    {
      anio: 2017,
      lat: 27.54402778,
      lng: -107.8273889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2017,
      lat: 27.46711111,
      lng: -107.9045556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.2,
    },
    {
      anio: 2017,
      lat: 27.51027778,
      lng: -107.9247778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.1,
    },
    {
      anio: 2017,
      lat: 26.08858333,
      lng: -106.81475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.69,
    },
    {
      anio: 2017,
      lat: 26.09641667,
      lng: -106.8097222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.81,
    },
    {
      anio: 2017,
      lat: 26.05261111,
      lng: -106.8371667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.9,
    },
    {
      anio: 2017,
      lat: 26.10472222,
      lng: -106.7813611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.28,
    },
    {
      anio: 2017,
      lat: 27.53391667,
      lng: -107.9955556,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2017,
      lat: 27.51988889,
      lng: -107.8516667,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.2,
    },
    {
      anio: 2017,
      lat: 26.07302778,
      lng: -106.9499167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.02908333,
      lng: -106.9424167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.23,
    },
    {
      anio: 2017,
      lat: 26.80375833,
      lng: -107.1602889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.76048889,
      lng: -107.0709111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.94709722,
      lng: -107.3279278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2017,
      lat: 26.11136111,
      lng: -106.9316667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.55,
    },
    {
      anio: 2017,
      lat: 26.07227778,
      lng: -106.7842222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.49,
    },
    {
      anio: 2017,
      lat: 26.07706111,
      lng: -106.7853889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2017,
      lat: 26.05591667,
      lng: -106.8089444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18.15,
    },
    {
      anio: 2017,
      lat: 26.74836111,
      lng: -107.2823833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.80855,
      lng: -107.1061417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.90226111,
      lng: -107.1338611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.59,
    },
    {
      anio: 2017,
      lat: 26.81188889,
      lng: -107.3524611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 26.79211111,
      lng: -107.2012222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.68698056,
      lng: -107.1312361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 154,
    },
    {
      anio: 2017,
      lat: 26.81781389,
      lng: -107.0371889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.96589444,
      lng: -107.0488694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 26.09141667,
      lng: -106.8139444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.25,
    },
    {
      anio: 2017,
      lat: 26.12661111,
      lng: -106.7986389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.94,
    },
    {
      anio: 2017,
      lat: 26.14436111,
      lng: -106.9225833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70.6,
    },
    {
      anio: 2017,
      lat: 26.11705556,
      lng: -106.9220833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 110.74,
    },
    {
      anio: 2017,
      lat: 26.10302778,
      lng: -106.7943333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 75.5,
    },
    {
      anio: 2017,
      lat: 27.50638056,
      lng: -108.042125,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.3,
    },
    {
      anio: 2017,
      lat: 26.15888889,
      lng: -106.7666694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.68,
    },
    {
      anio: 2017,
      lat: 26.0825,
      lng: -106.8239444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40.5,
    },
    {
      anio: 2017,
      lat: 26.08691667,
      lng: -106.8095833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50.98,
    },
    {
      anio: 2017,
      lat: 26.05863889,
      lng: -106.8336667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45.92,
    },
    {
      anio: 2017,
      lat: 27.56011389,
      lng: -107.998975,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 89.9,
    },
    {
      anio: 2017,
      lat: 26.70528611,
      lng: -107.2803333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2017,
      lat: 26.87313056,
      lng: -107.4155889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 340,
    },
    {
      anio: 2017,
      lat: 26.79421111,
      lng: -107.0599472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2017,
      lat: 26.88072778,
      lng: -107.2134722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.89130833,
      lng: -107.1717306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2017,
      lat: 26.97463611,
      lng: -107.368875,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 26.89925,
      lng: -106.9888333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.83022778,
      lng: -107.292975,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95,
    },
    {
      anio: 2017,
      lat: 26.89198333,
      lng: -107.1855,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 26.720325,
      lng: -107.1878472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.70771389,
      lng: -107.1975639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.73511111,
      lng: -107.2015833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 27.48538889,
      lng: -107.9258056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2017,
      lat: 26.07494444,
      lng: -106.9213889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.64,
    },
    {
      anio: 2017,
      lat: 26.08983333,
      lng: -106.7674444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.45,
    },
    {
      anio: 2017,
      lat: 26.13575,
      lng: -106.8321944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 210.59,
    },
    {
      anio: 2017,
      lat: 26.08375,
      lng: -106.82475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.31,
    },
    {
      anio: 2017,
      lat: 26.09025,
      lng: -106.7601944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 206,
    },
    {
      anio: 2017,
      lat: 26.44383333,
      lng: -107.2149444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.95,
    },
    {
      anio: 2017,
      lat: 26.43755556,
      lng: -107.3195278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.82,
    },
    {
      anio: 2017,
      lat: 26.41325,
      lng: -107.3491667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.42694444,
      lng: -107.3247222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.69,
    },
    {
      anio: 2017,
      lat: 26.39833333,
      lng: -107.325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.93111111,
      lng: -106.6381944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2017,
      lat: 26.07994444,
      lng: -106.8066111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 38.28,
    },
    {
      anio: 2017,
      lat: 26.00722222,
      lng: -106.7443889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.38,
    },
    {
      anio: 2017,
      lat: 26.09483333,
      lng: -106.8104722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.47,
    },
    {
      anio: 2017,
      lat: 26.00863889,
      lng: -106.7426667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.04211111,
      lng: -106.7707222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.96,
    },
    {
      anio: 2017,
      lat: 25.93013889,
      lng: -106.9290278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.2,
    },
    {
      anio: 2017,
      lat: 25.86002778,
      lng: -106.9613889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.9,
    },
    {
      anio: 2017,
      lat: 25.90294444,
      lng: -106.9572556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.9,
    },
    {
      anio: 2017,
      lat: 25.88301111,
      lng: -106.9393889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.71,
    },
    {
      anio: 2017,
      lat: 25.88253889,
      lng: -106.9470111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.83,
    },
    {
      anio: 2017,
      lat: 25.93575,
      lng: -106.9529444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31.4,
    },
    {
      anio: 2017,
      lat: 25.91975,
      lng: -106.9547222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.18,
    },
    {
      anio: 2017,
      lat: 25.90080556,
      lng: -106.9445,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8,
    },
    {
      anio: 2017,
      lat: 25.88930556,
      lng: -106.9681389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.88969444,
      lng: -106.9393889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.73,
    },
    {
      anio: 2017,
      lat: 25.94011111,
      lng: -106.9655,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.74,
    },
    {
      anio: 2017,
      lat: 25.87644444,
      lng: -106.9387222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.61,
    },
    {
      anio: 2017,
      lat: 25.89036111,
      lng: -106.9401111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.89336111,
      lng: -106.9001111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.74,
    },
    {
      anio: 2017,
      lat: 26.02352778,
      lng: -107.016,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.04775,
      lng: -107.0057778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.69,
    },
    {
      anio: 2017,
      lat: 26.01655556,
      lng: -107.0051944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 25.09594444,
      lng: -107.0490278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.0505,
      lng: -107.0141111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.04233333,
      lng: -107.0185833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.03922222,
      lng: -107.0026111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 26.12925,
      lng: -107.0191389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 87.33,
    },
    {
      anio: 2017,
      lat: 26.02583333,
      lng: -107.0308889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.11451111,
      lng: -106.9333917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.35,
    },
    {
      anio: 2017,
      lat: 26.08622222,
      lng: -107.0348889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 52.9,
    },
    {
      anio: 2017,
      lat: 26.06225,
      lng: -107.0143611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.14188889,
      lng: -106.9995833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.01988889,
      lng: -107.0000833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.01763889,
      lng: -107.0012778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.28787222,
      lng: -107.1117139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.13,
    },
    {
      anio: 2017,
      lat: 26.32111111,
      lng: -107.1577778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.13,
    },
    {
      anio: 2017,
      lat: 26.30527778,
      lng: -107.2155306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.35,
    },
    {
      anio: 2017,
      lat: 26.31555556,
      lng: -107.1542778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.32555556,
      lng: -107.1152778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.39,
    },
    {
      anio: 2017,
      lat: 26.10677778,
      lng: -106.8096389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 26.07747222,
      lng: -106.81225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.25,
    },
    {
      anio: 2017,
      lat: 26.07316667,
      lng: -106.8122778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.20777778,
      lng: -106.8061111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.07472222,
      lng: -106.9022222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.32,
    },
    {
      anio: 2017,
      lat: 26.09772222,
      lng: -106.9370833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 25.97694444,
      lng: -106.7397222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2017,
      lat: 26.15888889,
      lng: -106.7961111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.09194444,
      lng: -106.7755556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2017,
      lat: 26.06205556,
      lng: -107.0062222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.33802778,
      lng: -106.6183611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.4,
    },
    {
      anio: 2017,
      lat: 26.23905556,
      lng: -106.5414444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.7,
    },
    {
      anio: 2017,
      lat: 26.26133333,
      lng: -106.5706111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.9,
    },
    {
      anio: 2017,
      lat: 25.86616667,
      lng: -106.9462778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.7,
    },
    {
      anio: 2017,
      lat: 25.89852778,
      lng: -106.924,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 25.77298889,
      lng: -106.7959056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.9,
    },
    {
      anio: 2017,
      lat: 26.21444444,
      lng: -106.7891667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 37.8,
    },
    {
      anio: 2017,
      lat: 26.20067778,
      lng: -106.8094444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 25.75694444,
      lng: -106.7883333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.74361111,
      lng: -106.8222222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.77298889,
      lng: -106.8040833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 25.74852778,
      lng: -106.7940833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.73308333,
      lng: -106.8316111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.77911944,
      lng: -106.8084444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.27,
    },
    {
      anio: 2017,
      lat: 26.42841667,
      lng: -107.3251944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2017,
      lat: 26.53077778,
      lng: -107.3093611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23.9,
    },
    {
      anio: 2017,
      lat: 26.43991667,
      lng: -107.2981111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.2,
    },
    {
      anio: 2017,
      lat: 26.20841667,
      lng: -106.6330278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.7,
    },
    {
      anio: 2017,
      lat: 26.26388889,
      lng: -106.6530556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.24444444,
      lng: -106.6222222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.29194444,
      lng: -106.6280556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.2775,
      lng: -106.725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 26.10694444,
      lng: -106.6744444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.24,
    },
    {
      anio: 2017,
      lat: 26.22869444,
      lng: -106.6383611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.68,
    },
    {
      anio: 2017,
      lat: 26.24555556,
      lng: -106.6986111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.1,
    },
    {
      anio: 2017,
      lat: 25.77833333,
      lng: -106.8055556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.29,
    },
    {
      anio: 2017,
      lat: 25.8045,
      lng: -106.7788333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.8,
    },
    {
      anio: 2017,
      lat: 26.44386111,
      lng: -107.3276944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.8,
    },
    {
      anio: 2017,
      lat: 26.40369444,
      lng: -107.3219722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.67,
    },
    {
      anio: 2017,
      lat: 26.3355,
      lng: -106.652,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.21,
    },
    {
      anio: 2017,
      lat: 26.01104444,
      lng: -106.8786944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.54,
    },
    {
      anio: 2017,
      lat: 26.40508333,
      lng: -107.2893056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.27,
    },
    {
      anio: 2017,
      lat: 26.37869444,
      lng: -107.2700556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.89,
    },
    {
      anio: 2017,
      lat: 26.41125,
      lng: -107.3219444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2017,
      lat: 26.41611111,
      lng: -107.3273056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.27,
    },
    {
      anio: 2017,
      lat: 26.20694444,
      lng: -106.6483333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.83,
    },
    {
      anio: 2017,
      lat: 26.08655556,
      lng: -106.9995556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.10097222,
      lng: -106.9917778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.836,
      lng: -106.9425278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2017,
      lat: 25.90980556,
      lng: -106.9515833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2017,
      lat: 25.93463889,
      lng: -106.9057222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.9,
    },
    {
      anio: 2017,
      lat: 25.93827778,
      lng: -106.97375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.20472222,
      lng: -106.8491667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.57,
    },
    {
      anio: 2017,
      lat: 26.22666667,
      lng: -106.6638889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.27416667,
      lng: -106.6466667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2017,
      lat: 25.72844444,
      lng: -106.8278056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2017,
      lat: 26.05722222,
      lng: -106.8033333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.49,
    },
    {
      anio: 2017,
      lat: 26.07916667,
      lng: -106.725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.26,
    },
    {
      anio: 2017,
      lat: 26.22277778,
      lng: -106.6633333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.24638889,
      lng: -106.7027778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.28,
    },
    {
      anio: 2017,
      lat: 26.27805556,
      lng: -106.6413889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.06583333,
      lng: -106.7361111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.2,
    },
    {
      anio: 2017,
      lat: 25.94861111,
      lng: -106.7494444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.73,
    },
    {
      anio: 2017,
      lat: 25.70916667,
      lng: -106.8258333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.27,
    },
    {
      anio: 2017,
      lat: 26.08788889,
      lng: -106.8139722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.15,
    },
    {
      anio: 2017,
      lat: 26.01033333,
      lng: -106.92675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.98,
    },
    {
      anio: 2017,
      lat: 26.06555556,
      lng: -106.7866667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.17638889,
      lng: -106.9127778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.54,
    },
    {
      anio: 2017,
      lat: 26.05588889,
      lng: -106.7872222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 26.05388889,
      lng: -106.8147222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2017,
      lat: 26.08830556,
      lng: -106.7888611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.1,
    },
    {
      anio: 2017,
      lat: 25.67833333,
      lng: -106.8344444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.98,
    },
    {
      anio: 2017,
      lat: 25.76138889,
      lng: -106.7980556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.98,
    },
    {
      anio: 2017,
      lat: 26.02130556,
      lng: -106.7988333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.53,
    },
    {
      anio: 2017,
      lat: 26.03188889,
      lng: -106.9058889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.97,
    },
    {
      anio: 2017,
      lat: 26.02233333,
      lng: -106.9424167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.85,
    },
    {
      anio: 2017,
      lat: 25.69125,
      lng: -106.8525833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.5,
    },
    {
      anio: 2017,
      lat: 26.00802778,
      lng: -106.9834167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 26.12,
    },
    {
      anio: 2017,
      lat: 26.01311111,
      lng: -106.9318333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.72,
    },
    {
      anio: 2017,
      lat: 25.68777778,
      lng: -106.8583333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.16,
    },
    {
      anio: 2017,
      lat: 25.98769444,
      lng: -106.8841111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.87,
    },
    {
      anio: 2017,
      lat: 26.01436111,
      lng: -106.9339444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 25.95975,
      lng: -106.9018611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.75444444,
      lng: -106.69,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.4,
    },
    {
      anio: 2017,
      lat: 25.84138889,
      lng: -106.6222222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.48,
    },
    {
      anio: 2017,
      lat: 25.67861111,
      lng: -106.8625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.67,
    },
    {
      anio: 2017,
      lat: 25.70555556,
      lng: -106.6475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.45,
    },
    {
      anio: 2017,
      lat: 25.75272222,
      lng: -106.6947222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.43,
    },
    {
      anio: 2017,
      lat: 25.77455556,
      lng: -106.7059444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 25.7,
    },
    {
      anio: 2017,
      lat: 25.8475,
      lng: -106.6503611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2017,
      lat: 25.8625,
      lng: -106.6125,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.7,
    },
    {
      anio: 2017,
      lat: 25.87111111,
      lng: -106.6783333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.58,
    },
    {
      anio: 2017,
      lat: 25.71711111,
      lng: -106.8236111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.14,
    },
    {
      anio: 2017,
      lat: 25.68777778,
      lng: -106.8477778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2017,
      lat: 25.69,
      lng: -106.8500278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 25.67805556,
      lng: -106.8558333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2017,
      lat: 25.69722222,
      lng: -106.8225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.34,
    },
    {
      anio: 2017,
      lat: 25.68722222,
      lng: -106.8225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.34,
    },
    {
      anio: 2017,
      lat: 25.73638889,
      lng: -106.8097222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.40811111,
      lng: -106.9368889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.91,
    },
    {
      anio: 2017,
      lat: 26.14611111,
      lng: -106.8319444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.39,
    },
    {
      anio: 2017,
      lat: 26.00972222,
      lng: -106.73,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.32,
    },
    {
      anio: 2017,
      lat: 26.04916667,
      lng: -106.7852778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.12888889,
      lng: -106.7425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.15180556,
      lng: -106.8966667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.99,
    },
    {
      anio: 2017,
      lat: 25.79305556,
      lng: -106.7633333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.6,
    },
    {
      anio: 2017,
      lat: 25.75305556,
      lng: -106.8503611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 56.3,
    },
    {
      anio: 2017,
      lat: 26.23375,
      lng: -106.5997222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2017,
      lat: 26.22388889,
      lng: -106.4668333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.23355556,
      lng: -106.6016944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.03,
    },
    {
      anio: 2017,
      lat: 26.1725,
      lng: -106.6394444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.81,
    },
    {
      anio: 2017,
      lat: 26.22161111,
      lng: -106.66625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.22022222,
      lng: -106.6665556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.26486111,
      lng: -106.7226389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.79,
    },
    {
      anio: 2017,
      lat: 26.26955556,
      lng: -106.6319444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.25986111,
      lng: -106.6445556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.28197222,
      lng: -106.7378056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.82,
    },
    {
      anio: 2017,
      lat: 26.34980556,
      lng: -106.7187778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.41,
    },
    {
      anio: 2017,
      lat: 26.27869444,
      lng: -106.6942222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.28591667,
      lng: -106.7305556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.28,
    },
    {
      anio: 2017,
      lat: 26.28688889,
      lng: -106.7654167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.66,
    },
    {
      anio: 2017,
      lat: 26.02944444,
      lng: -107.0188056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.7,
    },
    {
      anio: 2017,
      lat: 26.01,
      lng: -106.8850556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.06141667,
      lng: -107.0040833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.15,
    },
    {
      anio: 2017,
      lat: 26.04211111,
      lng: -106.7707222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.96,
    },
    {
      anio: 2017,
      lat: 25.90294444,
      lng: -106.95725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.9,
    },
    {
      anio: 2017,
      lat: 26.04233333,
      lng: -107.0185833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.02583333,
      lng: -107.0308889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.01988889,
      lng: -107.0000833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.96713889,
      lng: -106.9776389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27.86,
    },
    {
      anio: 2017,
      lat: 26.845175,
      lng: -107.2876444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 27.35595556,
      lng: -107.0614667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 26.90464722,
      lng: -107.2004361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.72082222,
      lng: -107.2843583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 26.72979444,
      lng: -107.1008222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.12413889,
      lng: -106.7835,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 216,
    },
    {
      anio: 2017,
      lat: 26.09041667,
      lng: -106.8225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 222.94,
    },
    {
      anio: 2017,
      lat: 27.52,
      lng: -107.967,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.9,
    },
    {
      anio: 2017,
      lat: 27.37280556,
      lng: -108.0929167,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 41.1,
    },
    {
      anio: 2017,
      lat: 27.51419444,
      lng: -107.8573333,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.89,
    },
    {
      anio: 2017,
      lat: 26.05702778,
      lng: -106.82775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2017,
      lat: 26.59767222,
      lng: -107.9485056,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 3.4,
    },
    {
      anio: 2017,
      lat: 26.41019722,
      lng: -107.8802583,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.7,
    },
    {
      anio: 2017,
      lat: 26.41040556,
      lng: -107.8804667,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2017,
      lat: 26.44643333,
      lng: -107.8743417,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5.6,
    },
    {
      anio: 2017,
      lat: 26.51341389,
      lng: -107.84945,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4.2,
    },
    {
      anio: 2017,
      lat: 26.06136111,
      lng: -106.7186667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.87,
    },
    {
      anio: 2017,
      lat: 26.02297222,
      lng: -106.7754167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.15866667,
      lng: -106.8003889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.1,
    },
    {
      anio: 2017,
      lat: 27.38825556,
      lng: -107.9787,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.3,
    },
    {
      anio: 2017,
      lat: 27.42292778,
      lng: -107.9616722,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 90.5,
    },
    {
      anio: 2017,
      lat: 25.75638056,
      lng: -106.8422222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.5,
    },
    {
      anio: 2017,
      lat: 25.72961111,
      lng: -106.8217778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.6,
    },
    {
      anio: 2017,
      lat: 25.75733333,
      lng: -106.8483333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2017,
      lat: 25.684975,
      lng: -106.8185,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2017,
      lat: 25.75733333,
      lng: -106.8483333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.66606667,
      lng: -106.8152778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.3,
    },
    {
      anio: 2017,
      lat: 25.68988889,
      lng: -106.8188611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 25.64228056,
      lng: -106.8912222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.5,
    },
    {
      anio: 2017,
      lat: 25.70427778,
      lng: -106.8094722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 25.76121667,
      lng: -106.84675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18.9,
    },
    {
      anio: 2017,
      lat: 25.65951111,
      lng: -106.8611944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 115.9,
    },
    {
      anio: 2017,
      lat: 25.75588889,
      lng: -106.8485833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 25.75463889,
      lng: -106.80005,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.82736111,
      lng: -106.7778333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.5,
    },
    {
      anio: 2017,
      lat: 25.81993889,
      lng: -106.7963333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.4,
    },
    {
      anio: 2017,
      lat: 25.62980556,
      lng: -106.8631111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2017,
      lat: 25.64575833,
      lng: -106.8931944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.4,
    },
    {
      anio: 2017,
      lat: 25.69244444,
      lng: -106.8436389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 25.68943889,
      lng: -106.7778056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2017,
      lat: 25.73028056,
      lng: -106.8295,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 25.67162222,
      lng: -106.8685278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 25.74072222,
      lng: -106.8217778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 25.78675,
      lng: -106.76525,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 25.79705556,
      lng: -106.7565833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 25.72679167,
      lng: -106.8688611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.3,
    },
    {
      anio: 2017,
      lat: 25.64383333,
      lng: -106.8493056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.2,
    },
    {
      anio: 2017,
      lat: 25.79111111,
      lng: -106.776,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 25.77582222,
      lng: -106.7720556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2017,
      lat: 27.49967222,
      lng: -107.9745583,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2017,
      lat: 26.12088889,
      lng: -106.7998333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.78792778,
      lng: -107.2211694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.794875,
      lng: -107.2087333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 26.79544444,
      lng: -107.2098167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.90848889,
      lng: -107.2023611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.77966944,
      lng: -107.0780806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.74335833,
      lng: -107.1207778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 27.54036389,
      lng: -108.0095556,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 27.3103,
      lng: -108.0268611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 52,
    },
    {
      anio: 2017,
      lat: 27.25857778,
      lng: -107.9419694,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 220,
    },
    {
      anio: 2017,
      lat: 27.53379167,
      lng: -108.009475,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 27.35244167,
      lng: -108.0136389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 85,
    },
    {
      anio: 2017,
      lat: 27.56743333,
      lng: -108.1076444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 27.56136111,
      lng: -108.0327639,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 27.329,
      lng: -108.2061556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 27.61458611,
      lng: -108.0367556,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 27.15857222,
      lng: -108.0259056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2017,
      lat: 27.21473056,
      lng: -108.0954333,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 27.52633889,
      lng: -107.9889806,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 27.55959167,
      lng: -108.0183444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 27.29206944,
      lng: -108.1525833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 27.11871667,
      lng: -108.063525,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 26.06109722,
      lng: -106.9129722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 25.95496667,
      lng: -106.89125,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.9,
    },
    {
      anio: 2017,
      lat: 26.05696667,
      lng: -106.9182778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2,
    },
    {
      anio: 2017,
      lat: 26.05007778,
      lng: -106.9230833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.057125,
      lng: -106.9184722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2017,
      lat: 26.00543889,
      lng: -106.9116111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.2,
    },
    {
      anio: 2017,
      lat: 26.03869444,
      lng: -106.9506944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 26.01049167,
      lng: -107.0024444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.6,
    },
    {
      anio: 2017,
      lat: 26.04408333,
      lng: -106.9594444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2017,
      lat: 26.00066389,
      lng: -107.0042778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2017,
      lat: 26.03827222,
      lng: -106.9453333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 26.05056667,
      lng: -106.9202778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.4,
    },
    {
      anio: 2017,
      lat: 26.06036111,
      lng: -106.9299167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 27.26983333,
      lng: -108.1845861,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2197,
    },
    {
      anio: 2017,
      lat: 27.22389167,
      lng: -108.2414167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 327,
    },
    {
      anio: 2017,
      lat: 27.49030556,
      lng: -108.0213056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.9,
    },
    {
      anio: 2017,
      lat: 27.47825556,
      lng: -108.0157889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 115.7,
    },
    {
      anio: 2017,
      lat: 26.90936944,
      lng: -107.1109222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.80320833,
      lng: -107.1461833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2017,
      lat: 26.90769722,
      lng: -107.186,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.11791667,
      lng: -106.7503333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 84.2,
    },
    {
      anio: 2017,
      lat: 27.44626944,
      lng: -107.938575,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.8,
    },
    {
      anio: 2017,
      lat: 27.46313889,
      lng: -107.8899444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 27.53480556,
      lng: -107.87395,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.3,
    },
    {
      anio: 2017,
      lat: 26.63168611,
      lng: -107.9249583,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.5,
    },
    {
      anio: 2017,
      lat: 26.46209444,
      lng: -107.7139417,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2017,
      lat: 26.64005,
      lng: -107.9209222,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 605,
    },
    {
      anio: 2017,
      lat: 26.85168333,
      lng: -108.0289139,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 47.1,
    },
    {
      anio: 2017,
      lat: 26.74268333,
      lng: -107.9240889,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 67.8,
    },
    {
      anio: 2017,
      lat: 26.78065278,
      lng: -107.7968083,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 563,
    },
    {
      anio: 2017,
      lat: 26.50504167,
      lng: -107.6972694,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.5,
    },
    {
      anio: 2017,
      lat: 26.35643889,
      lng: -107.8085778,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 183,
    },
    {
      anio: 2017,
      lat: 27.00514,
      lng: -108.3340417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4956,
    },
    {
      anio: 2017,
      lat: 27.56928889,
      lng: -108.31875,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1249,
    },
    {
      anio: 2017,
      lat: 25.91588333,
      lng: -106.5885611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1910,
    },
    {
      anio: 2017,
      lat: 26.01705556,
      lng: -106.7379722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 140,
    },
    {
      anio: 2017,
      lat: 26.00833333,
      lng: -106.7365,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.9,
    },
    {
      anio: 2017,
      lat: 26.059,
      lng: -106.7052222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 39,
    },
    {
      anio: 2017,
      lat: 26.32352778,
      lng: -107.40475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2017,
      lat: 26.32175,
      lng: -107.4001667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2017,
      lat: 26.34,
      lng: -107.4054444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.30372222,
      lng: -107.4543889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.28866667,
      lng: -107.4511389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.30433333,
      lng: -107.2196111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2017,
      lat: 26.30775,
      lng: -107.2186944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.31430556,
      lng: -107.1934167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 26.32338889,
      lng: -107.1849167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.39897222,
      lng: -107.3402222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2017,
      lat: 26.34886111,
      lng: -107.2995278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.05530556,
      lng: -106.8795833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 26.10325,
      lng: -106.9444722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.05416667,
      lng: -106.9443333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.05872222,
      lng: -106.9450833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2017,
      lat: 26.02058333,
      lng: -106.9072222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.06272222,
      lng: -106.9265,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 26.05452778,
      lng: -106.9203056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.01177778,
      lng: -106.9912222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2017,
      lat: 26.04041667,
      lng: -106.9154722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 27.60416944,
      lng: -108.068225,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 27.57191667,
      lng: -108.1590361,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 27.22387222,
      lng: -108.272325,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 27.29036667,
      lng: -108.2987111,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 27.379125,
      lng: -108.2597556,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2017,
      lat: 27.24320278,
      lng: -108.3049389,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 27.34342778,
      lng: -108.3047306,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2017,
      lat: 27.21478333,
      lng: -108.2811889,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2017,
      lat: 27.4043,
      lng: -108.0231917,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 27.55259444,
      lng: -108.1138222,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 27.24911667,
      lng: -108.2986083,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 27.62694444,
      lng: -108.0654417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 27.58407222,
      lng: -108.0562889,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 27.36921111,
      lng: -108.0990056,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2017,
      lat: 27.2913,
      lng: -107.9911444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 27.26877222,
      lng: -108.3191167,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 27.24080278,
      lng: -107.3025556,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 26.35172222,
      lng: -107.2168889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2017,
      lat: 26.39138889,
      lng: -107.30375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2017,
      lat: 26.39622222,
      lng: -107.2241667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.39894444,
      lng: -107.2132222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 26.50169444,
      lng: -107.2790833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.07783333,
      lng: -106.9709444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 26.04986111,
      lng: -106.9240556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 26.06880556,
      lng: -106.8764167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.05044444,
      lng: -106.9209167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.09811111,
      lng: -106.9401111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.06411111,
      lng: -106.9427778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2017,
      lat: 26.21480556,
      lng: -106.7955556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.22666667,
      lng: -106.8369444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.12277778,
      lng: -106.8302778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.15041667,
      lng: -106.7940556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.13636111,
      lng: -106.7796389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.18513889,
      lng: -106.8030556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.23602778,
      lng: -106.858,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.35527778,
      lng: -106.9015556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.11791667,
      lng: -106.7503333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.21875,
      lng: -106.6606389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.21767778,
      lng: -106.7325833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.22758333,
      lng: -106.7158889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.26686111,
      lng: -106.6903333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 26.27522222,
      lng: -106.6690833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.31688889,
      lng: -106.6621389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.25705556,
      lng: -106.6321667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.27625,
      lng: -106.6215556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 26.28777778,
      lng: -106.7044444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 26.25986111,
      lng: -106.663,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.16925,
      lng: -106.6603056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2017,
      lat: 26.26358333,
      lng: -106.6524444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 26.05041667,
      lng: -106.6563333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 26.059,
      lng: -106.7052222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 26.10080556,
      lng: -106.7700556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 26.086,
      lng: -106.7287778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 23.56291667,
      lng: -105.4113944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 25.06558333,
      lng: -106.1413056,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 23.76497222,
      lng: -105.3883889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2017,
      lat: 22.96894444,
      lng: -104.6210278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2017,
      lat: 23.77969444,
      lng: -105.3483889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.9,
    },
    {
      anio: 2017,
      lat: 23.16185,
      lng: -105.0375639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.77636111,
      lng: -105.3476667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 22.97855556,
      lng: -104.6470556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 22.96219444,
      lng: -104.6875,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2017,
      lat: 23.68427778,
      lng: -105.6118889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.7,
    },
    {
      anio: 2017,
      lat: 23.39202778,
      lng: -104.3415583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 22.99647222,
      lng: -104.3391111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 25.07514444,
      lng: -106.1259917,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 23.06077778,
      lng: -104.6610556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2017,
      lat: 24.27694444,
      lng: -105.2666667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 957.7,
    },
    {
      anio: 2017,
      lat: 24.37648611,
      lng: -105.5450222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2017,
      lat: 22.59794444,
      lng: -104.3087222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 25.57147222,
      lng: -106.5779444,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 23.79966667,
      lng: -105.542,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2017,
      lat: 23.79530556,
      lng: -105.3467778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2017,
      lat: 23.11097222,
      lng: -104.4551111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 227,
    },
    {
      anio: 2017,
      lat: 23.08194444,
      lng: -104.4613889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 22.93358333,
      lng: -104.5123333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 22.94011111,
      lng: -104.6362222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 22.95034167,
      lng: -104.6019944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 22.92436111,
      lng: -104.6008056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 25.27888889,
      lng: -105.7797222,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Otras actividades productivas",
      semana: 14,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 67,
    },
    {
      anio: 2017,
      lat: 24.41358611,
      lng: -105.8630611,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.14,
    },
    {
      anio: 2017,
      lat: 23.24794444,
      lng: -104.8501,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 250,
    },
    {
      anio: 2017,
      lat: 23.77258333,
      lng: -105.3763611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2017,
      lat: 23.32096667,
      lng: -104.8530306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 23.05422222,
      lng: -104.3243611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2017,
      lat: 22.86075,
      lng: -104.5118056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.33,
    },
    {
      anio: 2017,
      lat: 22.56011111,
      lng: -104.3185,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.43,
    },
    {
      anio: 2017,
      lat: 23.21613889,
      lng: -104.3707222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 23.318075,
      lng: -104.8536611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 22.93852778,
      lng: -104.6509167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 22.96116667,
      lng: -104.44375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 22.96377778,
      lng: -104.6031389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 22.96825,
      lng: -104.4114167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.5,
    },
    {
      anio: 2017,
      lat: 22.62633333,
      lng: -104.2810389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2017,
      lat: 22.49388889,
      lng: -104.3683333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2017,
      lat: 24.68914722,
      lng: -105.9148917,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 24.10260556,
      lng: -105.6517528,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2017,
      lat: 23.05175,
      lng: -104.3270278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.8,
    },
    {
      anio: 2017,
      lat: 22.95188333,
      lng: -104.6668889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 23.05422222,
      lng: -104.3243611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2017,
      lat: 24.10193333,
      lng: -105.6359722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2017,
      lat: 22.94438889,
      lng: -104.5854167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2017,
      lat: 22.93722222,
      lng: -104.6335056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 22.94669444,
      lng: -104.5995556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 25.04869444,
      lng: -106.2127778,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.79,
    },
    {
      anio: 2017,
      lat: 25.08325,
      lng: -106.2033056,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.39,
    },
    {
      anio: 2017,
      lat: 23.7965,
      lng: -105.3620278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.8,
    },
    {
      anio: 2017,
      lat: 23.13561667,
      lng: -104.1794944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2017,
      lat: 23.64730556,
      lng: -105.4966389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 23.75602778,
      lng: -105.3813889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 23.63702778,
      lng: -105.6115556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2017,
      lat: 23.64730556,
      lng: -105.4966389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45.05,
    },
    {
      anio: 2017,
      lat: 23.75602778,
      lng: -105.3813889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2,
    },
    {
      anio: 2017,
      lat: 25.05523056,
      lng: -106.3069083,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 24.34691944,
      lng: -105.5463889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 22.55891944,
      lng: -104.3664889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2734,
    },
    {
      anio: 2017,
      lat: 25.54194444,
      lng: -105.9861111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 24.64102778,
      lng: -106.0835833,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 23.29069444,
      lng: -104.82325,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2017,
      lat: 24.92116944,
      lng: -105.9385833,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 22.87247222,
      lng: -104.5976667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 22.52216667,
      lng: -104.5840556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 22.95538889,
      lng: -104.6110556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2017,
      lat: 22.98491667,
      lng: -104.66275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2017,
      lat: 22.96430556,
      lng: -104.6223889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.3,
    },
    {
      anio: 2017,
      lat: 22.93338889,
      lng: -104.5725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 22.95033333,
      lng: -104.6041667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2017,
      lat: 23.84944444,
      lng: -105.2935278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2017,
      lat: 22.83134167,
      lng: -104.7185,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2017,
      lat: 23.547,
      lng: -105.4037778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.3,
    },
    {
      anio: 2017,
      lat: 22.99647222,
      lng: -104.3391111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 22.751,
      lng: -104.2636944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2017,
      lat: 23.07313889,
      lng: -104.2934167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2017,
      lat: 23.00744444,
      lng: -104.3378333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.6,
    },
    {
      anio: 2017,
      lat: 23.01741667,
      lng: -104.3485556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.6,
    },
    {
      anio: 2017,
      lat: 22.63919444,
      lng: -104.29275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.8,
    },
    {
      anio: 2017,
      lat: 24.15018889,
      lng: -105.7002139,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2017,
      lat: 25.02035,
      lng: -105.1689556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 22.96652778,
      lng: -104.2270278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 84.3,
    },
    {
      anio: 2017,
      lat: 24.99102778,
      lng: -106.1518333,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2017,
      lat: 23.80916667,
      lng: -105.33675,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras actividades productivas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2017,
      lat: 25.40825,
      lng: -106.2373333,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 22.88663889,
      lng: -104.6033611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.6,
    },
    {
      anio: 2017,
      lat: 22.95422222,
      lng: -104.6057222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 22.97038889,
      lng: -104.675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.3,
    },
    {
      anio: 2017,
      lat: 22.9765,
      lng: -104.5851111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.89,
    },
    {
      anio: 2017,
      lat: 23.38042778,
      lng: -104.785,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 23.21560278,
      lng: -104.6666667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 22.96997222,
      lng: -104.33675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2017,
      lat: 23.66227778,
      lng: -105.4796389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2017,
      lat: 23.63244444,
      lng: -105.6027778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.5,
    },
    {
      anio: 2017,
      lat: 23.77272222,
      lng: -105.5936389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64.4,
    },
    {
      anio: 2017,
      lat: 24.29288889,
      lng: -105.5217222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2017,
      lat: 24.93333333,
      lng: -106.2339722,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.21,
    },
    {
      anio: 2017,
      lat: 23.99988889,
      lng: -105.7065278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.78,
    },
    {
      anio: 2017,
      lat: 24.31285278,
      lng: -105.4848667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 40.7,
    },
    {
      anio: 2017,
      lat: 22.98466667,
      lng: -104.3283056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 23.11430556,
      lng: -104.3151667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2017,
      lat: 23.05302778,
      lng: -104.3146111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2017,
      lat: 23.66894444,
      lng: -105.4808889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.6,
    },
    {
      anio: 2017,
      lat: 25.07325,
      lng: -106.3068056,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.45,
    },
    {
      anio: 2017,
      lat: 25.06886111,
      lng: -106.3010278,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.07,
    },
    {
      anio: 2017,
      lat: 25.41255,
      lng: -106.8363333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 22.95986111,
      lng: -104.5923333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.42,
    },
    {
      anio: 2017,
      lat: 22.64847222,
      lng: -104.2984167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.08,
    },
    {
      anio: 2017,
      lat: 22.67305278,
      lng: -104.2833333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.7,
    },
    {
      anio: 2017,
      lat: 22.93669444,
      lng: -104.5791111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.65,
    },
    {
      anio: 2017,
      lat: 22.94363889,
      lng: -104.5456667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.44,
    },
    {
      anio: 2017,
      lat: 22.94330556,
      lng: -104.5710278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.4,
    },
    {
      anio: 2017,
      lat: 22.6445,
      lng: -104.2807333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.64,
    },
    {
      anio: 2017,
      lat: 25.08310556,
      lng: -106.2029944,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 23.26036111,
      lng: -104.973,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 320,
    },
    {
      anio: 2017,
      lat: 23.81525,
      lng: -105.3285,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2017,
      lat: 24.8835,
      lng: -106.0980556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.7,
    },
    {
      anio: 2017,
      lat: 23.58041667,
      lng: -105.7252778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2017,
      lat: 23.79286111,
      lng: -105.6143333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 400,
    },
    {
      anio: 2017,
      lat: 24.16025,
      lng: -105.5830639,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.31,
    },
    {
      anio: 2017,
      lat: 23.67647222,
      lng: -105.5561667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2017,
      lat: 25.50822222,
      lng: -106.8198333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 22.58228333,
      lng: -104.3406889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 300,
    },
    {
      anio: 2017,
      lat: 23.63586111,
      lng: -105.6210278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2017,
      lat: 25.29722222,
      lng: -105.8283333,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 25.06319444,
      lng: -106.361,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2017,
      lat: 24.1035,
      lng: -105.7744722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 509,
    },
    {
      anio: 2017,
      lat: 25.10052778,
      lng: -106.2773333,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.95,
    },
    {
      anio: 2017,
      lat: 23.45229722,
      lng: -105.2697417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2017,
      lat: 25.48395,
      lng: -106.8368389,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.08,
    },
    {
      anio: 2017,
      lat: 25.4819,
      lng: -106.943175,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.1,
    },
    {
      anio: 2017,
      lat: 25.12908333,
      lng: -106.2966944,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.23,
    },
    {
      anio: 2017,
      lat: 25.18183333,
      lng: -106.5097222,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.9,
    },
    {
      anio: 2017,
      lat: 25.26162778,
      lng: -106.5883806,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 61,
    },
    {
      anio: 2017,
      lat: 25.19061111,
      lng: -106.3895056,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2017,
      lat: 22.62046667,
      lng: -104.2831472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.3,
    },
    {
      anio: 2017,
      lat: 24.15845556,
      lng: -105.7012333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.7,
    },
    {
      anio: 2017,
      lat: 24.08594444,
      lng: -105.57625,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.69,
    },
    {
      anio: 2017,
      lat: 24.12016667,
      lng: -105.7553611,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.93,
    },
    {
      anio: 2017,
      lat: 24.18075,
      lng: -105.5848333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.02,
    },
    {
      anio: 2017,
      lat: 25.01797222,
      lng: -106.2491389,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.8,
    },
    {
      anio: 2017,
      lat: 25.05055556,
      lng: -106.4868611,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23.58,
    },
    {
      anio: 2017,
      lat: 25.13761111,
      lng: -106.4945278,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 47.49,
    },
    {
      anio: 2017,
      lat: 23.68336111,
      lng: -105.6693611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 115,
    },
    {
      anio: 2017,
      lat: 25.07480556,
      lng: -106.3059167,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 144,
    },
    {
      anio: 2017,
      lat: 23.67047222,
      lng: -105.6694167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 480,
    },
    {
      anio: 2017,
      lat: 23.99652778,
      lng: -105.7992222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 250,
    },
    {
      anio: 2017,
      lat: 25.06875,
      lng: -106.3628611,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 300,
    },
    {
      anio: 2017,
      lat: 25.44858333,
      lng: -106.8308611,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.43,
    },
    {
      anio: 2017,
      lat: 22.90005556,
      lng: -104.5899167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.24,
    },
    {
      anio: 2017,
      lat: 22.577,
      lng: -104.2991667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.13,
    },
    {
      anio: 2017,
      lat: 22.96183333,
      lng: -104.6409167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.23,
    },
    {
      anio: 2017,
      lat: 22.96741667,
      lng: -104.5921667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.13,
    },
    {
      anio: 2017,
      lat: 23.45,
      lng: -104.7888889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 22.97933333,
      lng: -104.2768611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.43,
    },
    {
      anio: 2017,
      lat: 22.92894444,
      lng: -104.2728889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.22,
    },
    {
      anio: 2017,
      lat: 22.96505556,
      lng: -104.2650556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 121.2,
    },
    {
      anio: 2017,
      lat: 23.01330556,
      lng: -104.3782222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.51,
    },
    {
      anio: 2017,
      lat: 22.88452778,
      lng: -104.5095833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.16,
    },
    {
      anio: 2017,
      lat: 22.94852778,
      lng: -104.53625,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.25,
    },
    {
      anio: 2017,
      lat: 22.91036111,
      lng: -104.5393889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.25,
    },
    {
      anio: 2017,
      lat: 22.87775,
      lng: -104.5377778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.64,
    },
    {
      anio: 2017,
      lat: 22.66633333,
      lng: -104.3235833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.69,
    },
    {
      anio: 2017,
      lat: 22.80011111,
      lng: -104.5509167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.45,
    },
    {
      anio: 2017,
      lat: 22.89952778,
      lng: -104.5881389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.76,
    },
    {
      anio: 2017,
      lat: 22.98147222,
      lng: -104.3254167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.03,
    },
    {
      anio: 2017,
      lat: 22.95986111,
      lng: -104.5923333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.78,
    },
    {
      anio: 2017,
      lat: 22.99277778,
      lng: -104.6514722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.34,
    },
    {
      anio: 2017,
      lat: 22.98058333,
      lng: -104.6548056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.44,
    },
    {
      anio: 2017,
      lat: 22.95708333,
      lng: -104.5936667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.88,
    },
    {
      anio: 2017,
      lat: 22.91388889,
      lng: -104.6352778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.99,
    },
    {
      anio: 2017,
      lat: 22.92086111,
      lng: -104.6398611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.24,
    },
    {
      anio: 2017,
      lat: 23.63802778,
      lng: -105.7333056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2017,
      lat: 22.98305556,
      lng: -104.6443889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 167.42,
    },
    {
      anio: 2017,
      lat: 23.20555556,
      lng: -105.0361111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 24.50444444,
      lng: -106.2191111,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1823,
    },
    {
      anio: 2017,
      lat: 23.21963889,
      lng: -104.96025,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 24.76355556,
      lng: -105.7096111,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 600,
    },
    {
      anio: 2017,
      lat: 25.18288889,
      lng: -105.2720278,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 121,
    },
    {
      anio: 2017,
      lat: 23.04069444,
      lng: -104.5376667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2017,
      lat: 25.18138889,
      lng: -106.0176111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2017,
      lat: 24.17281111,
      lng: -105.5965028,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 56.4,
    },
    {
      anio: 2017,
      lat: 24.29861944,
      lng: -105.50465,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2017,
      lat: 24.18091667,
      lng: -105.5814167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.3,
    },
    {
      anio: 2017,
      lat: 24.33461944,
      lng: -105.695825,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 24.29064167,
      lng: -105.5212306,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.2,
    },
    {
      anio: 2017,
      lat: 24.02216667,
      lng: -105.6678333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.8,
    },
    {
      anio: 2017,
      lat: 23.32297222,
      lng: -105.65325,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2017,
      lat: 22.95966667,
      lng: -104.2498056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 217,
    },
    {
      anio: 2017,
      lat: 24.40061111,
      lng: -105.5987222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 137.7,
    },
    {
      anio: 2017,
      lat: 23.02736111,
      lng: -104.2650833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 95,
    },
    {
      anio: 2017,
      lat: 22.81819444,
      lng: -104.5521667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.55,
    },
    {
      anio: 2017,
      lat: 23.20841667,
      lng: -105.1832778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 25.17511111,
      lng: -106.4924444,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2017,
      lat: 25.39397222,
      lng: -106.7801944,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 81,
    },
    {
      anio: 2017,
      lat: 24.78732778,
      lng: -106.1459667,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2017,
      lat: 25.48516667,
      lng: -106.8268333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 167.25,
    },
    {
      anio: 2017,
      lat: 25.24269444,
      lng: -106.5618889,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 22.80186111,
      lng: -104.2723611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 90.71,
    },
    {
      anio: 2017,
      lat: 22.8165,
      lng: -104.2736944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.07,
    },
    {
      anio: 2017,
      lat: 22.95016667,
      lng: -104.6097778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.29,
    },
    {
      anio: 2017,
      lat: 22.97744444,
      lng: -104.5811111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.79,
    },
    {
      anio: 2017,
      lat: 22.88647222,
      lng: -104.3230833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.4,
    },
    {
      anio: 2017,
      lat: 23.03372222,
      lng: -104.3247778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.65,
    },
    {
      anio: 2017,
      lat: 22.57666667,
      lng: -104.2979167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 218.9,
    },
    {
      anio: 2017,
      lat: 22.91947222,
      lng: -104.65025,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 148.64,
    },
    {
      anio: 2017,
      lat: 23.20353611,
      lng: -104.3683861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.25,
    },
    {
      anio: 2017,
      lat: 22.63416667,
      lng: -104.2906389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.87,
    },
    {
      anio: 2017,
      lat: 22.51313889,
      lng: -104.3209167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 515.89,
    },
    {
      anio: 2017,
      lat: 22.98852778,
      lng: -104.6815833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.87,
    },
    {
      anio: 2017,
      lat: 22.93847222,
      lng: -104.6615556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.32,
    },
    {
      anio: 2017,
      lat: 22.97608333,
      lng: -104.6081667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.52,
    },
    {
      anio: 2017,
      lat: 24.39963889,
      lng: -105.8351111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.8,
    },
    {
      anio: 2017,
      lat: 22.45661111,
      lng: -104.3333333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 40.5,
    },
    {
      anio: 2017,
      lat: 22.50747222,
      lng: -104.3379167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 22.96838889,
      lng: -104.2981111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 23.247,
      lng: -104.7925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2017,
      lat: 23.15752778,
      lng: -104.179,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57,
    },
    {
      anio: 2017,
      lat: 22.91638889,
      lng: -104.486,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2017,
      lat: 22.91108333,
      lng: -104.2789444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2017,
      lat: 22.91219444,
      lng: -104.6875,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2017,
      lat: 22.96894444,
      lng: -104.6210278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.2,
    },
    {
      anio: 2017,
      lat: 22.97855556,
      lng: -104.6470556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 22.86127778,
      lng: -104.5114167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 1.85,
    },
    {
      anio: 2017,
      lat: 22.821,
      lng: -104.5586389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.55,
    },
    {
      anio: 2017,
      lat: 22.75758333,
      lng: -104.5140556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.51,
    },
    {
      anio: 2017,
      lat: 22.93158333,
      lng: -104.5142778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.36,
    },
    {
      anio: 2017,
      lat: 22.82486111,
      lng: -104.5039722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.23,
    },
    {
      anio: 2017,
      lat: 22.98358333,
      lng: -104.5484444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.47,
    },
    {
      anio: 2017,
      lat: 22.96880556,
      lng: -104.5373056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.74,
    },
    {
      anio: 2017,
      lat: 22.97655556,
      lng: -104.5855556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.42,
    },
    {
      anio: 2017,
      lat: 23.53698611,
      lng: -105.1110278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 177.19,
    },
    {
      anio: 2017,
      lat: 24.20441667,
      lng: -105.6211667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2017,
      lat: 23.15916667,
      lng: -104.9823333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2017,
      lat: 23.58925,
      lng: -105.6176667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 140,
    },
    {
      anio: 2017,
      lat: 23.85377778,
      lng: -105.6051667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 23.51741667,
      lng: -105.3997389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 315,
    },
    {
      anio: 2017,
      lat: 23.30985833,
      lng: -105.4184722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 300,
    },
    {
      anio: 2017,
      lat: 25.50541667,
      lng: -106.5182,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 25.27063889,
      lng: -105.7370556,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 110,
    },
    {
      anio: 2017,
      lat: 25.68666667,
      lng: -106.0683333,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 23.71216667,
      lng: -105.5004417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 230,
    },
    {
      anio: 2017,
      lat: 23.37590833,
      lng: -105.3990861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2017,
      lat: 23.57088611,
      lng: -105.5189444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 190,
    },
    {
      anio: 2017,
      lat: 23.61338056,
      lng: -105.6000278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2017,
      lat: 23.63877778,
      lng: -105.6350778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 37,
    },
    {
      anio: 2017,
      lat: 23.31930556,
      lng: -105.43575,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 225,
    },
    {
      anio: 2017,
      lat: 23.14035278,
      lng: -105.4721583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2017,
      lat: 23.63841667,
      lng: -105.6183056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 23.60500556,
      lng: -105.69795,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 23.32425,
      lng: -104.9376389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 23.46111111,
      lng: -104.9354444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.29069444,
      lng: -104.8637778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.2665,
      lng: -104.9720833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.25830556,
      lng: -104.9354167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.20519444,
      lng: -104.9852222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Ayarín",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 24.97175,
      lng: -106.0045556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2017,
      lat: 24.99808333,
      lng: -105.4460556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2017,
      lat: 25.02476944,
      lng: -106.3244556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2017,
      lat: 24.10927778,
      lng: -105.6095833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.63,
    },
    {
      anio: 2017,
      lat: 24.09797222,
      lng: -105.6616944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60.5,
    },
    {
      anio: 2017,
      lat: 24.12890833,
      lng: -105.6700639,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.43,
    },
    {
      anio: 2017,
      lat: 23.00611111,
      lng: -104.5500278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 330,
    },
    {
      anio: 2017,
      lat: 22.81700278,
      lng: -104.541,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 22.80838889,
      lng: -104.4990833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2017,
      lat: 23.04116667,
      lng: -104.3326944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 360,
    },
    {
      anio: 2017,
      lat: 22.89538889,
      lng: -104.2983611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 23.30425833,
      lng: -104.7809444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 550,
    },
    {
      anio: 2017,
      lat: 25.47405556,
      lng: -106.83825,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.06,
    },
    {
      anio: 2017,
      lat: 25.47461111,
      lng: -106.8248333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.37,
    },
    {
      anio: 2017,
      lat: 25.44841667,
      lng: -106.8100833,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.43,
    },
    {
      anio: 2017,
      lat: 25.41330556,
      lng: -106.9272222,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 25.44622222,
      lng: -106.8750556,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.03,
    },
    {
      anio: 2017,
      lat: 25.08638889,
      lng: -106.3075,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64.56,
    },
    {
      anio: 2017,
      lat: 25.06841667,
      lng: -106.3149444,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.31,
    },
    {
      anio: 2017,
      lat: 25.00616667,
      lng: -106.2674167,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.13,
    },
    {
      anio: 2017,
      lat: 25.21055556,
      lng: -106.4521111,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 25.11036111,
      lng: -106.3071667,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.04,
    },
    {
      anio: 2017,
      lat: 25.11441667,
      lng: -106.2889722,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.44,
    },
    {
      anio: 2017,
      lat: 22.89201667,
      lng: -104.6140917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2017,
      lat: 23.21066667,
      lng: -105.5432,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 170,
    },
    {
      anio: 2017,
      lat: 22.97944444,
      lng: -104.6029167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 22.63058333,
      lng: -104.2971667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 23.13029722,
      lng: -105.3801667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 85,
    },
    {
      anio: 2017,
      lat: 23.45275,
      lng: -105.4808306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 140,
    },
    {
      anio: 2017,
      lat: 23.50000556,
      lng: -105.5266583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 190,
    },
    {
      anio: 2017,
      lat: 25.62630556,
      lng: -106.5836944,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 155,
    },
    {
      anio: 2017,
      lat: 24.29084722,
      lng: -105.8222472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.15,
    },
    {
      anio: 2017,
      lat: 24.12335278,
      lng: -105.6700639,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2017,
      lat: 25.25052778,
      lng: -106.5883056,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 25.19122222,
      lng: -106.3923611,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2017,
      lat: 25.25777778,
      lng: -106.5836667,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 22.63886111,
      lng: -104.3000556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.34,
    },
    {
      anio: 2017,
      lat: 22.66811111,
      lng: -104.2883889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.71,
    },
    {
      anio: 2017,
      lat: 23.58831667,
      lng: -105.3557306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 23.57073611,
      lng: -105.3685472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 23.53593889,
      lng: -105.3544722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 23.59947222,
      lng: -105.3786889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.1,
    },
    {
      anio: 2017,
      lat: 23.29179167,
      lng: -105.4053,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 31,
    },
    {
      anio: 2017,
      lat: 23.46016944,
      lng: -105.3290056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2017,
      lat: 23.81497222,
      lng: -105.5086389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.2,
    },
    {
      anio: 2017,
      lat: 23.66208333,
      lng: -105.6276111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 116,
    },
    {
      anio: 2017,
      lat: 23.46769444,
      lng: -104.6321111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2017,
      lat: 23.67588889,
      lng: -105.71025,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 140,
    },
    {
      anio: 2017,
      lat: 25.37030556,
      lng: -106.0895833,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2017,
      lat: 23.2375,
      lng: -104.8513889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 63,
    },
    {
      anio: 2017,
      lat: 23.26333333,
      lng: -104.8888889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2017,
      lat: 23.46358333,
      lng: -105.30125,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 240,
    },
    {
      anio: 2017,
      lat: 24.800975,
      lng: -106.1282528,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 24.78908333,
      lng: -106.1276861,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 24.79454167,
      lng: -106.0424056,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 24.31355556,
      lng: -105.47625,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.1,
    },
    {
      anio: 2017,
      lat: 24.56834167,
      lng: -105.5333556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.7,
    },
    {
      anio: 2017,
      lat: 22.63094444,
      lng: -104.2963611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.69,
    },
    {
      anio: 2017,
      lat: 22.98802778,
      lng: -104.5935,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.93,
    },
    {
      anio: 2017,
      lat: 22.96983333,
      lng: -104.5978056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2017,
      lat: 22.96816667,
      lng: -104.6023056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.74,
    },
    {
      anio: 2017,
      lat: 24.14055556,
      lng: -105.7074444,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.16,
    },
    {
      anio: 2017,
      lat: 25.11875,
      lng: -105.6416333,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 24.66027778,
      lng: -105.4352222,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 24.07220833,
      lng: -105.5793139,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.95,
    },
    {
      anio: 2017,
      lat: 24.38022222,
      lng: -106.0976306,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 85,
    },
    {
      anio: 2017,
      lat: 24.48257222,
      lng: -105.7958667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2017,
      lat: 25.14136389,
      lng: -105.1043056,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 250,
    },
    {
      anio: 2017,
      lat: 23.90344444,
      lng: -105.4460278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 37.3,
    },
    {
      anio: 2017,
      lat: 25.44794444,
      lng: -105.8360556,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 295,
    },
    {
      anio: 2017,
      lat: 25.71308333,
      lng: -106.4329722,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 25.36158333,
      lng: -106.4016389,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2017,
      lat: 25.39597222,
      lng: -106.18175,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 23.36163333,
      lng: -104.333725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 781.99,
    },
    {
      anio: 2017,
      lat: 25.05983333,
      lng: -106.282,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.29,
    },
    {
      anio: 2017,
      lat: 24.48254722,
      lng: -105.7960167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2017,
      lat: 24.18231389,
      lng: -105.6125833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.6,
    },
    {
      anio: 2017,
      lat: 24.24481389,
      lng: -105.6543472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 74.5,
    },
    {
      anio: 2017,
      lat: 24.04216667,
      lng: -105.6051944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.11,
    },
    {
      anio: 2017,
      lat: 23.48230556,
      lng: -104.6018333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 22.65106944,
      lng: -104.2847167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.69,
    },
    {
      anio: 2017,
      lat: 24.09602778,
      lng: -105.6831111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.11,
    },
    {
      anio: 2017,
      lat: 24.11683333,
      lng: -105.6222778,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.65,
    },
    {
      anio: 2017,
      lat: 24.18344444,
      lng: -105.6100278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.02,
    },
    {
      anio: 2017,
      lat: 24.10922222,
      lng: -105.6093333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.14,
    },
    {
      anio: 2017,
      lat: 23.75033333,
      lng: -104.3836111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 27,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 170,
    },
    {
      anio: 2017,
      lat: 24.98397222,
      lng: -106.17725,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 280,
    },
    {
      anio: 2017,
      lat: 22.98355556,
      lng: -104.6714722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.43,
    },
    {
      anio: 2017,
      lat: 22.93491667,
      lng: -104.56675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.64,
    },
    {
      anio: 2017,
      lat: 22.96138889,
      lng: -104.6045556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.74,
    },
    {
      anio: 2017,
      lat: 22.91136111,
      lng: -104.6162778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.67,
    },
    {
      anio: 2017,
      lat: 22.93855556,
      lng: -104.6139167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.74,
    },
    {
      anio: 2017,
      lat: 22.82083333,
      lng: -104.5147778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 22.81630556,
      lng: -104.5123056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 22.93080556,
      lng: -104.8579722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2017,
      lat: 22.97263889,
      lng: -104.5446111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 22.81919444,
      lng: -104.5496944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2017,
      lat: 22.92119444,
      lng: -104.5454444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 22.87847222,
      lng: -104.5303333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 22.89541667,
      lng: -104.4916111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2017,
      lat: 22.88144444,
      lng: -104.5042778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2017,
      lat: 22.91036111,
      lng: -104.5393889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.25,
    },
    {
      anio: 2017,
      lat: 22.85105556,
      lng: -104.5413056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 22.88280556,
      lng: -104.5015833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2017,
      lat: 22.88136111,
      lng: -104.312,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.34,
    },
    {
      anio: 2017,
      lat: 22.98297222,
      lng: -104.2977222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.65,
    },
    {
      anio: 2017,
      lat: 22.98413889,
      lng: -104.2452222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2017,
      lat: 23.01969444,
      lng: -104.2605833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 54.87,
    },
    {
      anio: 2017,
      lat: 22.96036111,
      lng: -104.2573611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.46,
    },
    {
      anio: 2017,
      lat: 23.66413889,
      lng: -105.8225,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 255,
    },
    {
      anio: 2017,
      lat: 22.68087222,
      lng: -104.2822222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.08,
    },
    {
      anio: 2017,
      lat: 22.63521667,
      lng: -104.3011583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.3,
    },
    {
      anio: 2017,
      lat: 22.70061944,
      lng: -104.2868194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.17,
    },
    {
      anio: 2017,
      lat: 22.63875556,
      lng: -104.2822944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.67,
    },
    {
      anio: 2017,
      lat: 22.56825833,
      lng: -104.3050361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.41,
    },
    {
      anio: 2017,
      lat: 22.58636389,
      lng: -104.2924472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 132.07,
    },
    {
      anio: 2017,
      lat: 23.3753,
      lng: -104.9614972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 23.39671111,
      lng: -104.8674389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 23.23277778,
      lng: -104.9641667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 23.45036111,
      lng: -105.0104694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65,
    },
    {
      anio: 2017,
      lat: 23.37236111,
      lng: -104.8688389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 23.27561389,
      lng: -105.1938778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2017,
      lat: 23.20165556,
      lng: -105.1842583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2017,
      lat: 23.21846667,
      lng: -105.1810278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50.5,
    },
    {
      anio: 2017,
      lat: 23.23444444,
      lng: -105.005,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 67,
    },
    {
      anio: 2017,
      lat: 23.25043611,
      lng: -105.1832028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 107,
    },
    {
      anio: 2017,
      lat: 23.20598056,
      lng: -104.9430417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Ayarín",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.20749722,
      lng: -105.1556944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 107.5,
    },
    {
      anio: 2017,
      lat: 23.39055556,
      lng: -104.93775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 23.39322222,
      lng: -104.9174167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2017,
      lat: 23.38176389,
      lng: -105.1296,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2017,
      lat: 23.36431389,
      lng: -105.1783861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34,
    },
    {
      anio: 2017,
      lat: 23.38952222,
      lng: -105.0776611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2017,
      lat: 23.38959722,
      lng: -105.1816722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2017,
      lat: 25.09625,
      lng: -106.2936111,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.02,
    },
    {
      anio: 2017,
      lat: 24.99705556,
      lng: -106.30475,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2017,
      lat: 25.421,
      lng: -106.4301389,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2017,
      lat: 23.51763889,
      lng: -105.3895,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.5,
    },
    {
      anio: 2017,
      lat: 23.76630556,
      lng: -105.6161944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 109,
    },
    {
      anio: 2017,
      lat: 23.70958333,
      lng: -105.6550556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.11,
    },
    {
      anio: 2017,
      lat: 23.65955556,
      lng: -105.6336111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57,
    },
    {
      anio: 2017,
      lat: 23.77705556,
      lng: -105.5849722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 57,
    },
    {
      anio: 2017,
      lat: 23.65105556,
      lng: -105.6213611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2017,
      lat: 23.47325,
      lng: -105.5188056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83,
    },
    {
      anio: 2017,
      lat: 23.79375,
      lng: -105.3755556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2017,
      lat: 23.40233333,
      lng: -105.3638056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2017,
      lat: 23.46161111,
      lng: -105.5962167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2017,
      lat: 23.27994444,
      lng: -105.3947972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 23.40380556,
      lng: -105.3748056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2017,
      lat: 25.32472222,
      lng: -106.0086944,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agropecuarias",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2017,
      lat: 22.6285,
      lng: -104.3013333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 170,
    },
    {
      anio: 2017,
      lat: 23.77355556,
      lng: -105.5951111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras causas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.7,
    },
    {
      anio: 2017,
      lat: 25.02066667,
      lng: -106.26725,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.88,
    },
    {
      anio: 2017,
      lat: 25.19403611,
      lng: -106.4756417,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 320,
    },
    {
      anio: 2017,
      lat: 25.24252778,
      lng: -106.5630556,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 25.23008333,
      lng: -106.5147222,
      estado: "Durango",
      municipio: "Topia",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2017,
      lat: 25.20216389,
      lng: -106.4181861,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 550,
    },
    {
      anio: 2017,
      lat: 25.114225,
      lng: -105.6340361,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 24.74035,
      lng: -106.22485,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 24.72914444,
      lng: -105.7109333,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Otras causas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 170,
    },
    {
      anio: 2017,
      lat: 25.16452778,
      lng: -105.7304444,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras causas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2017,
      lat: 22.6255,
      lng: -104.2783611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.39,
    },
    {
      anio: 2025,
      lat: 23.531538,
      lng: -105.8322,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 41.4784,
    },
    {
      anio: 2018,
      lat: 25.5187,
      lng: -107.4135306,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 930,
    },
    {
      anio: 2024,
      lat: 24.604483,
      lng: -106.79878,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Severo",
      superficie: 902.0488,
    },
    {
      anio: 2023,
      lat: 23.543194,
      lng: -105.88167,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 887.6272,
    },
    {
      anio: 2025,
      lat: 23.550386,
      lng: -106.14392,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 371.5076,
    },
    {
      anio: 2024,
      lat: 26.745892,
      lng: -108.04839,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Quema de basureros",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 834.6347,
    },
    {
      anio: 2017,
      lat: 26.82877778,
      lng: -108.1710556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 800,
    },
    {
      anio: 2024,
      lat: 25.958885,
      lng: -107.574326,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 780.0019,
    },
    {
      anio: 2025,
      lat: 26.388014,
      lng: -108.07213,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 779.8415,
    },
    {
      anio: 2022,
      lat: 26.15353,
      lng: -108.16242,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 727.8634,
    },
    {
      anio: 2017,
      lat: 26.00740306,
      lng: -107.6617497,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Severo",
      superficie: 716,
    },
    {
      anio: 2023,
      lat: 26.137583,
      lng: -107.79767,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 712.4972,
    },
    {
      anio: 2024,
      lat: 24.528217,
      lng: -106.83241,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 703.5895,
    },
    {
      anio: 2023,
      lat: 25.848019,
      lng: -107.199165,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 703.3295,
    },
    {
      anio: 2025,
      lat: 24.916912,
      lng: -107.236496,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Severo",
      superficie: 698.8663,
    },
    {
      anio: 2025,
      lat: 25.534773,
      lng: -107.484406,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Severo",
      superficie: 661.7452,
    },
    {
      anio: 2022,
      lat: 24.187273,
      lng: -106.13264,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Severo",
      superficie: 654,
    },
    {
      anio: 2023,
      lat: 25.19413,
      lng: -107.13319,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 616.3629,
    },
    {
      anio: 2025,
      lat: 24.141241,
      lng: -106.21113,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 596.3988,
    },
    {
      anio: 2024,
      lat: 23.26733,
      lng: -106.00066,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 559.0453,
    },
    {
      anio: 2025,
      lat: 24.148026,
      lng: -106.19951,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 556.8387,
    },
    {
      anio: 2022,
      lat: 25.696035,
      lng: -107.24635,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 551,
    },
    {
      anio: 2025,
      lat: 24.252209,
      lng: -106.410675,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 550.6896,
    },
    {
      anio: 2024,
      lat: 26.451145,
      lng: -108.02196,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Quema de basureros",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 547.0198,
    },
    {
      anio: 2017,
      lat: 25.74491667,
      lng: -107.532,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 545,
    },
    {
      anio: 2020,
      lat: 23.11951111,
      lng: -105.9408611,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 544,
    },
    {
      anio: 2023,
      lat: 24.918337,
      lng: -107.22099,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 518.1425,
    },
    {
      anio: 2025,
      lat: 26.098764,
      lng: -107.487114,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 511.8168,
    },
    {
      anio: 2024,
      lat: 23.592062,
      lng: -106.11458,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 495.7121,
    },
    {
      anio: 2023,
      lat: 26.592628,
      lng: -108.03625,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 440.315,
    },
    {
      anio: 2025,
      lat: 24.066603,
      lng: -106.60292,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 440,
    },
    {
      anio: 2022,
      lat: 25.564817,
      lng: -107.05669,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 439.1669,
    },
    {
      anio: 2024,
      lat: 24.474142,
      lng: -106.88209,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 417.8962,
    },
    {
      anio: 2023,
      lat: 25.937319,
      lng: -107.31593,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 412.4904,
    },
    {
      anio: 2025,
      lat: 23.95405,
      lng: -106.511696,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 409,
    },
    {
      anio: 2025,
      lat: 26.109367,
      lng: -107.91629,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 405,
    },
    {
      anio: 2025,
      lat: 25.039371,
      lng: -107.18165,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 402,
    },
    {
      anio: 2024,
      lat: 24.69346,
      lng: -106.86737,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 393.7346,
    },
    {
      anio: 2025,
      lat: 23.74762,
      lng: -106.308586,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 391.4207,
    },
    {
      anio: 2024,
      lat: 23.62167,
      lng: -106.508896,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 386.3024,
    },
    {
      anio: 2024,
      lat: 23.54438,
      lng: -105.85353,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 53,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 376.016,
    },
    {
      anio: 2025,
      lat: 23.579916,
      lng: -105.95861,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 869.1272,
    },
    {
      anio: 2025,
      lat: 23.593014,
      lng: -106.38814,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 366.256,
    },
    {
      anio: 2016,
      lat: 26.25300278,
      lng: -108.0037667,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Cultivos ilícitos",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 350,
    },
    {
      anio: 2018,
      lat: 26.0773,
      lng: -106.6245583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 4,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.194,
      lng: -106.585,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2018,
      lat: 27.57605556,
      lng: -108.0315278,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.1,
    },
    {
      anio: 2018,
      lat: 26.0635,
      lng: -106.7961389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.18144444,
      lng: -106.5978333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.20052778,
      lng: -106.6063889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.24822222,
      lng: -106.6449167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.1335,
      lng: -106.7885556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2018,
      lat: 26.08911111,
      lng: -106.7627778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.13345,
      lng: -106.7821667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.17111111,
      lng: -106.8363611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31,
    },
    {
      anio: 2018,
      lat: 25.78856667,
      lng: -108.0699889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.08777778,
      lng: -106.76325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2018,
      lat: 26.05780556,
      lng: -106.7916667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.94648056,
      lng: -107.3513778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.05583333,
      lng: -106.7916389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 27.53753889,
      lng: -108.0880417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.14470833,
      lng: -106.9047167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 26.16363889,
      lng: -106.8642694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2018,
      lat: 27.50916667,
      lng: -107.9134167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.17358333,
      lng: -106.8039722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.7,
    },
    {
      anio: 2018,
      lat: 26.12019444,
      lng: -106.8140278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.8,
    },
    {
      anio: 2018,
      lat: 27.48357222,
      lng: -107.8799194,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.1,
    },
    {
      anio: 2018,
      lat: 25.76108611,
      lng: -106.7860861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 27.01261111,
      lng: -107.1438139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.949225,
      lng: -107.2686167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.07551389,
      lng: -106.8132722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2018,
      lat: 26.08877778,
      lng: -106.7777222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2018,
      lat: 27.42013889,
      lng: -107.9615556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.8,
    },
    {
      anio: 2018,
      lat: 27.5339,
      lng: -107.9657889,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.6,
    },
    {
      anio: 2018,
      lat: 26.07947222,
      lng: -106.7731111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2018,
      lat: 26.19994167,
      lng: -106.5748222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.03530278,
      lng: -106.9353389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.96354722,
      lng: -106.5101333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 81,
    },
    {
      anio: 2018,
      lat: 27.43922778,
      lng: -108.0764389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.5,
    },
    {
      anio: 2018,
      lat: 26.08697222,
      lng: -106.8133611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.72995556,
      lng: -106.793625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.26083333,
      lng: -106.6602778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.25139722,
      lng: -106.6760222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.18159444,
      lng: -106.6557722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.076125,
      lng: -106.9565361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.27113611,
      lng: -106.7356028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.11198056,
      lng: -106.62695,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10001667,
      lng: -106.59,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 25.71041667,
      lng: -106.8136083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.20185,
      lng: -107.019275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.08650278,
      lng: -106.9358361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.03525278,
      lng: -106.9357083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.43902778,
      lng: -107.2832778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.37941667,
      lng: -107.2242778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Naturales",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.96856111,
      lng: -107.0514444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 27.13314722,
      lng: -107.3192389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23.7,
    },
    {
      anio: 2018,
      lat: 27.00680833,
      lng: -106.9671833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 27.11562222,
      lng: -107.1582583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.75941111,
      lng: -107.2099167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2018,
      lat: 27.11000278,
      lng: -107.2430667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.37,
    },
    {
      anio: 2018,
      lat: 27.03173056,
      lng: -107.1846694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18.5,
    },
    {
      anio: 2018,
      lat: 26.90436111,
      lng: -107.133,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.1,
    },
    {
      anio: 2018,
      lat: 26.88088056,
      lng: -107.1960472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.61,
    },
    {
      anio: 2018,
      lat: 26.07477222,
      lng: -106.8100639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.05036111,
      lng: -106.7950278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.32841111,
      lng: -107.164,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.03752778,
      lng: -106.8413611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.795975,
      lng: -107.1318639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2018,
      lat: 26.3135,
      lng: -107.1469444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.32688889,
      lng: -107.1664167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.30669444,
      lng: -107.1285556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.40502778,
      lng: -107.2368056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.41595556,
      lng: -107.2404972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2018,
      lat: 26.06655556,
      lng: -106.94475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.39816667,
      lng: -107.2409167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.19252778,
      lng: -106.7998056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.07813889,
      lng: -106.7846389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.401375,
      lng: -107.2381083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 52.5,
    },
    {
      anio: 2018,
      lat: 26.19294444,
      lng: -106.7989167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2018,
      lat: 25.71288611,
      lng: -106.884675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.07658333,
      lng: -106.9426944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.49025556,
      lng: -107.2615778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2018,
      lat: 26.22939722,
      lng: -107.5455,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1323,
    },
    {
      anio: 2018,
      lat: 25.89394444,
      lng: -106.8396306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.81553611,
      lng: -107.1295417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.90319167,
      lng: -106.9380361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.81573611,
      lng: -106.9247806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.17652778,
      lng: -106.8685,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2018,
      lat: 27.55083056,
      lng: -108.2195167,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 27.30262222,
      lng: -107.9898972,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 27.52474444,
      lng: -107.8328806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2018,
      lat: 27.51838889,
      lng: -107.9692861,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.98664167,
      lng: -107.3226556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.55,
    },
    {
      anio: 2018,
      lat: 26.79636111,
      lng: -107.2541667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.1,
    },
    {
      anio: 2018,
      lat: 27.0673,
      lng: -106.997125,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2018,
      lat: 26.85336389,
      lng: -107.3623833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.09572222,
      lng: -107.0742778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2018,
      lat: 27.51562778,
      lng: -107.0593194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2018,
      lat: 26.48169444,
      lng: -107.2672778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2018,
      lat: 25.76529444,
      lng: -106.9196444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.75700833,
      lng: -107.3471722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 118,
    },
    {
      anio: 2018,
      lat: 26.833075,
      lng: -107.2681583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.22,
    },
    {
      anio: 2018,
      lat: 26.72588611,
      lng: -107.0715194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.61,
    },
    {
      anio: 2018,
      lat: 26.51407222,
      lng: -107.2606694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 26.32277222,
      lng: -107.4393306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 233,
    },
    {
      anio: 2018,
      lat: 27.55541667,
      lng: -107.6388139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2018,
      lat: 26.90835556,
      lng: -107.1679556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.105975,
      lng: -106.7786472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.13002222,
      lng: -106.4827583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.84159722,
      lng: -106.6588722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.88140833,
      lng: -106.7916361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.88988889,
      lng: -106.8436167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2018,
      lat: 26.08805833,
      lng: -106.6644278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.68677778,
      lng: -106.8584722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.06363889,
      lng: -106.9661389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.40623333,
      lng: -107.2685056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 25.74122222,
      lng: -106.7917056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.70358056,
      lng: -106.8898694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.86176667,
      lng: -106.87325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.661275,
      lng: -106.8682472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.72103056,
      lng: -106.8281028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.10058333,
      lng: -107.0071389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.09431111,
      lng: -106.9496889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.06743056,
      lng: -106.9546306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.11627778,
      lng: -107.0206111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.16876944,
      lng: -106.8562028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.11338889,
      lng: -106.8265556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.8,
    },
    {
      anio: 2018,
      lat: 26.08668611,
      lng: -106.7804528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.08862222,
      lng: -106.7220222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.50222222,
      lng: -107.3173111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.32343056,
      lng: -107.1014139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.27634722,
      lng: -107.0712556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.05997222,
      lng: -106.7958333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 27.51292889,
      lng: -107.0629969,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.64,
    },
    {
      anio: 2018,
      lat: 26.49993333,
      lng: -107.2408167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2018,
      lat: 26.36597222,
      lng: -107.4282306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 26.10660556,
      lng: -106.7104167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.24,
      lng: -106.6737278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.17072222,
      lng: -106.8966944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2018,
      lat: 26.25130556,
      lng: -107.13795,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.41927778,
      lng: -107.2508889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.11758333,
      lng: -107.0316111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.76523611,
      lng: -106.7828139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.93270278,
      lng: -106.9224417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.92130556,
      lng: -106.9549222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.77459444,
      lng: -106.8527611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.73098056,
      lng: -106.7174194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.08386111,
      lng: -106.96825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.91753056,
      lng: -106.9224917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.04669444,
      lng: -106.9204833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.23420278,
      lng: -106.6392222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.23420278,
      lng: -106.6615028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.74003333,
      lng: -106.7944861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.20455556,
      lng: -106.794,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.07161111,
      lng: -106.9633056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.07472778,
      lng: -106.8027167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 27.63473333,
      lng: -107.5197528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64,
    },
    {
      anio: 2018,
      lat: 26.72349444,
      lng: -107.0705278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.58,
    },
    {
      anio: 2018,
      lat: 26.90288611,
      lng: -107.1745806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.99097222,
      lng: -107.2462667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.89,
    },
    {
      anio: 2018,
      lat: 27.23733333,
      lng: -107.2428139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.88,
    },
    {
      anio: 2018,
      lat: 26.17313889,
      lng: -106.9073333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 32,
    },
    {
      anio: 2018,
      lat: 26.38420556,
      lng: -107.2352528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Naturales",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 26.47688333,
      lng: -107.7608222,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 137.9,
    },
    {
      anio: 2018,
      lat: 25.87050278,
      lng: -106.75475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.42255833,
      lng: -107.2438889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.36373333,
      lng: -107.4271667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 25.43809444,
      lng: -106.956825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.22238056,
      lng: -106.8175889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.77535556,
      lng: -106.779375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 27.60598889,
      lng: -108.1057417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.75331667,
      lng: -106.7588333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.20352778,
      lng: -106.7941944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.863225,
      lng: -106.8046194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.24972222,
      lng: -107.2634861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2018,
      lat: 26.27750278,
      lng: -107.1295722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 27.27359444,
      lng: -107.9808972,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2018,
      lat: 27.27521667,
      lng: -108.0654361,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 27.23576667,
      lng: -107.2450167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.51,
    },
    {
      anio: 2018,
      lat: 27.01553611,
      lng: -107.4537917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 134,
    },
    {
      anio: 2018,
      lat: 27.42961667,
      lng: -107.6821694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.81,
    },
    {
      anio: 2018,
      lat: 27.26745278,
      lng: -107.4488278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2018,
      lat: 27.52474444,
      lng: -107.8328806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.8,
    },
    {
      anio: 2018,
      lat: 27.41429167,
      lng: -107.7404028,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2018,
      lat: 27.57653056,
      lng: -107.6301889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 68.9,
    },
    {
      anio: 2018,
      lat: 27.53309167,
      lng: -107.5780361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2018,
      lat: 26.33792778,
      lng: -107.1146389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.39853056,
      lng: -107.2910972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.11911111,
      lng: -106.9658056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.32143889,
      lng: -107.4805833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 236,
    },
    {
      anio: 2018,
      lat: 26.10088889,
      lng: -106.7033611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.6,
    },
    {
      anio: 2018,
      lat: 26.51731667,
      lng: -107.7886694,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 72.28,
    },
    {
      anio: 2018,
      lat: 26.05119722,
      lng: -106.7712444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.09755556,
      lng: -106.8253333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.144,
      lng: -106.7754167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.32094167,
      lng: -107.1500333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2018,
      lat: 25.705925,
      lng: -106.8618861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.75418056,
      lng: -106.7869139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.703575,
      lng: -106.7950111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.76819444,
      lng: -106.7911861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.90945556,
      lng: -106.94535,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.91821667,
      lng: -106.9098944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.91432222,
      lng: -106.9183,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.72900556,
      lng: -106.7976944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.43228333,
      lng: -107.2782917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.08433333,
      lng: -106.9746111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.0855,
      lng: -106.9684722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.11472222,
      lng: -107.0044167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.32990556,
      lng: -107.1397194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.325675,
      lng: -107.139625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 26.23022222,
      lng: -106.6156056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.14061111,
      lng: -106.7789,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.00718056,
      lng: -106.9307,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.896425,
      lng: -106.924925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.39695833,
      lng: -107.1801,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.32958889,
      lng: -107.2129972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2018,
      lat: 26.13772222,
      lng: -106.8173056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.9,
    },
    {
      anio: 2018,
      lat: 26.17438333,
      lng: -107.0583944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.07855556,
      lng: -106.9593611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.34225,
      lng: -107.2205556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 600.5,
    },
    {
      anio: 2018,
      lat: 26.46406944,
      lng: -107.2995167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.81766389,
      lng: -107.0573667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2018,
      lat: 27.05754722,
      lng: -107.4172972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 333,
    },
    {
      anio: 2018,
      lat: 26.16908333,
      lng: -106.8035,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 65,
    },
    {
      anio: 2018,
      lat: 25.791825,
      lng: -106.7626278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.02075278,
      lng: -106.9336806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.94383889,
      lng: -107.0364222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.2,
    },
    {
      anio: 2018,
      lat: 26.16438889,
      lng: -106.87525,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 58,
    },
    {
      anio: 2018,
      lat: 25.78856389,
      lng: -106.8125583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.82317778,
      lng: -106.6549417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 27.37968056,
      lng: -107.9072306,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 18,
    },
    {
      anio: 2018,
      lat: 26.16855556,
      lng: -106.8694444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 26.05228056,
      lng: -106.7684,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2018,
      lat: 26.22313889,
      lng: -107.1174444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 27.06408056,
      lng: -107.2740056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 437,
    },
    {
      anio: 2018,
      lat: 26.94211111,
      lng: -107.0333472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95.7,
    },
    {
      anio: 2018,
      lat: 26.73446389,
      lng: -107.2987528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 314,
    },
    {
      anio: 2018,
      lat: 26.8911,
      lng: -107.4848389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2018,
      lat: 26.73981944,
      lng: -107.0851306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.2,
    },
    {
      anio: 2018,
      lat: 27.2329,
      lng: -107.0688417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.1,
    },
    {
      anio: 2018,
      lat: 26.90563889,
      lng: -107.3327083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.19,
    },
    {
      anio: 2018,
      lat: 27.03185556,
      lng: -107.2690778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.2,
    },
    {
      anio: 2018,
      lat: 26.50753056,
      lng: -107.8524333,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 18.18,
    },
    {
      anio: 2018,
      lat: 26.52060278,
      lng: -107.7856306,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 45.62,
    },
    {
      anio: 2018,
      lat: 26.17886667,
      lng: -106.6266639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.17886667,
      lng: -106.6266639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.86725833,
      lng: -106.9130972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.9339,
      lng: -106.9288333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.79108056,
      lng: -106.7617889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.79265278,
      lng: -106.7787472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10019444,
      lng: -106.9534722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.07769444,
      lng: -107.0243056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.91277778,
      lng: -106.7690389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.29833333,
      lng: -106.6682083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.07675,
      lng: -107.0319167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.18697222,
      lng: -107.0756389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 25.93661389,
      lng: -106.7075,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.79063611,
      lng: -106.8123306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.79099722,
      lng: -106.8123167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2018,
      lat: 25.72952778,
      lng: -106.8648056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.81356111,
      lng: -106.7585444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.91690833,
      lng: -106.9558472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.93288611,
      lng: -106.9527944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.06326667,
      lng: -107.0323472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.10041667,
      lng: -106.9512222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.75617778,
      lng: -106.8184389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.68687778,
      lng: -106.8266361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.94183611,
      lng: -106.8015639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.98019722,
      lng: -106.7751778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.86944167,
      lng: -106.8022556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.80742778,
      lng: -106.6399361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.74025833,
      lng: -106.6792556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.76258333,
      lng: -106.7916222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.71783889,
      lng: -106.7414583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.17261111,
      lng: -106.7949444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.1945,
      lng: -106.8338889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2018,
      lat: 26.16927778,
      lng: -106.7974722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 25.81432778,
      lng: -106.8021306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 25.76517778,
      lng: -106.7926222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.42265833,
      lng: -107.3789639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2018,
      lat: 26.06002778,
      lng: -107.0215556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.08336111,
      lng: -106.7390556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.24697222,
      lng: -107.2573056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.22533889,
      lng: -106.7331194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.15058333,
      lng: -106.5632778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.07531667,
      lng: -106.8540083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2018,
      lat: 26.94393889,
      lng: -106.9061389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.18533333,
      lng: -107.0557778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.40395556,
      lng: -107.2357972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.02655833,
      lng: -107.042425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.24383611,
      lng: -106.6742167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.66487222,
      lng: -106.9047806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.76971944,
      lng: -106.7807472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 27.46694167,
      lng: -108.0921667,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 27.38543056,
      lng: -107.908825,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 40.5,
    },
    {
      anio: 2018,
      lat: 25.99727778,
      lng: -107.0462222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.02113889,
      lng: -106.9256833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10263889,
      lng: -106.6695556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.03626389,
      lng: -106.8997583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.0935,
      lng: -106.9763333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.10722222,
      lng: -107.0305278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.25196111,
      lng: -107.2683639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2018,
      lat: 26.09361111,
      lng: -106.9261667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.86932778,
      lng: -106.623175,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.93341667,
      lng: -106.9637806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.82088889,
      lng: -106.5812528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2018,
      lat: 25.81009167,
      lng: -106.577025,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2018,
      lat: 25.78518889,
      lng: -106.7819444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 25.8645,
      lng: -106.853225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.10722222,
      lng: -107.0305278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10130556,
      lng: -106.8022222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2018,
      lat: 26.22504722,
      lng: -106.6206667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.22673611,
      lng: -106.6176667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.22411667,
      lng: -106.6234444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.15486944,
      lng: -107.0800694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.41535556,
      lng: -107.2437056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 25.78736944,
      lng: -106.7867083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2018,
      lat: 26.0967,
      lng: -106.9507722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.18030556,
      lng: -106.8039167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 53,
    },
    {
      anio: 2018,
      lat: 27.17463889,
      lng: -107.9318083,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 506,
    },
    {
      anio: 2018,
      lat: 26.2145,
      lng: -106.6638333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.10319444,
      lng: -106.5828833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.90669444,
      lng: -106.8347917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 26.06885,
      lng: -107.0505944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.050775,
      lng: -106.7119139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.02275278,
      lng: -106.7523167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.15751944,
      lng: -106.5588028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2018,
      lat: 26.11244444,
      lng: -106.6229583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.29176111,
      lng: -107.1195472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.10461111,
      lng: -106.7925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.41103889,
      lng: -107.2829611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.25909722,
      lng: -106.7520278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 27.20588056,
      lng: -108.0219111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 66.2,
    },
    {
      anio: 2018,
      lat: 26.82510278,
      lng: -108.0115167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto mínimo",
      superficie: 4115,
    },
    {
      anio: 2018,
      lat: 26.23651389,
      lng: -107.4949306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto mínimo",
      superficie: 1173,
    },
    {
      anio: 2018,
      lat: 27.499825,
      lng: -108.0480222,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 27.07475833,
      lng: -108.0672944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.54205556,
      lng: -107.2254556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2018,
      lat: 26.40375556,
      lng: -107.2967333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2018,
      lat: 26.29894722,
      lng: -107.1118056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10344444,
      lng: -106.7908056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.04524722,
      lng: -106.8462389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.90566111,
      lng: -107.6665611,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Selva Baja Espinosa",
      impacto: "Impacto mínimo",
      superficie: 230,
    },
    {
      anio: 2018,
      lat: 26.22744444,
      lng: -106.5203611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.05891667,
      lng: -107.01425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2018,
      lat: 26.07275,
      lng: -106.9680806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.00757778,
      lng: -106.8013028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.02119167,
      lng: -106.936575,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.03877778,
      lng: -106.7717778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10447222,
      lng: -106.7778333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.5,
    },
    {
      anio: 2018,
      lat: 26.01404167,
      lng: -106.7467472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.44450556,
      lng: -107.3418806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 26.43443333,
      lng: -107.3201,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 25.66408333,
      lng: -106.8089944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 27.20348056,
      lng: -108.0245722,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 360,
    },
    {
      anio: 2018,
      lat: 26.68233056,
      lng: -107.9118056,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Selva Baja Espinosa",
      impacto: "Impacto mínimo",
      superficie: 668,
    },
    {
      anio: 2018,
      lat: 26.38075556,
      lng: -106.7454583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.04461111,
      lng: -107.0126944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 27.61578611,
      lng: -107.5236778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto mínimo",
      superficie: 82.7,
    },
    {
      anio: 2018,
      lat: 26.03627778,
      lng: -106.75375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.38693611,
      lng: -107.3113528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2018,
      lat: 26.09319444,
      lng: -106.7890556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.4,
    },
    {
      anio: 2018,
      lat: 27.29430278,
      lng: -107.9881167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 320,
    },
    {
      anio: 2018,
      lat: 27.06727778,
      lng: -107.8096611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 655,
    },
    {
      anio: 2018,
      lat: 25.72882222,
      lng: -106.8301139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.03373056,
      lng: -106.8398944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 25.93468889,
      lng: -106.927375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2018,
      lat: 26.08261667,
      lng: -106.9286389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.11005556,
      lng: -106.6198722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.12897222,
      lng: -106.7972222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.04678611,
      lng: -106.8153694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 25.75998611,
      lng: -106.69,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2018,
      lat: 26.11769444,
      lng: -106.9452778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.91150556,
      lng: -106.8205611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.39185278,
      lng: -107.2994583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2018,
      lat: 26.60255556,
      lng: -107.2374583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2018,
      lat: 25.65128611,
      lng: -106.8917778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.68372778,
      lng: -106.8557639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2018,
      lat: 25.72704722,
      lng: -106.8240083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.03488889,
      lng: -107.0088889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.82750833,
      lng: -107.3126972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 61.7,
    },
    {
      anio: 2018,
      lat: 26.77348333,
      lng: -107.3332528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 41.6,
    },
    {
      anio: 2018,
      lat: 26.02098333,
      lng: -106.9245833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 27.111325,
      lng: -108.1109528,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 387,
    },
    {
      anio: 2018,
      lat: 27.20605556,
      lng: -108.359025,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto mínimo",
      superficie: 364,
    },
    {
      anio: 2018,
      lat: 27.42219722,
      lng: -107.8844222,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 27.51965,
      lng: -108.1831944,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 27.52005833,
      lng: -108.1330139,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 27.53213611,
      lng: -108.0954917,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.12813889,
      lng: -106.8001389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 44,
    },
    {
      anio: 2018,
      lat: 26.02649722,
      lng: -106.6203861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.17490833,
      lng: -106.6829194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2018,
      lat: 25.72144722,
      lng: -106.8145444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.69187222,
      lng: -106.8142139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.76476389,
      lng: -106.7940667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.10263889,
      lng: -106.6695556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 25.99640833,
      lng: -107.0214972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.04011111,
      lng: -107.0255278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.91583056,
      lng: -106.9850389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.89916111,
      lng: -106.8985917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.90018889,
      lng: -106.9401111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 26.07344444,
      lng: -106.7836111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 26.33209444,
      lng: -106.7852444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.27692222,
      lng: -106.6570583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.20719167,
      lng: -106.6361361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.14380556,
      lng: -106.6956667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.70459167,
      lng: -106.7041444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 25.76841389,
      lng: -106.8360417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.73059722,
      lng: -106.8200333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.72175,
      lng: -106.8194611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.09405556,
      lng: -106.9825556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.75292778,
      lng: -106.6705889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.17122778,
      lng: -106.6721444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.69734444,
      lng: -106.8157028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.72921111,
      lng: -106.8326139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.82466111,
      lng: -106.7866778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.11335278,
      lng: -106.6353306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.95547222,
      lng: -106.9295528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 25.86470833,
      lng: -106.8558,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 25.9021,
      lng: -106.9221806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.08033333,
      lng: -106.745,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.10308333,
      lng: -106.9701667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.95705,
      lng: -106.7523917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.29949722,
      lng: -106.6144278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.25817222,
      lng: -106.7455889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.25162778,
      lng: -106.6352056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.29119444,
      lng: -106.7275417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.06697222,
      lng: -106.7950556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 27.26181389,
      lng: -108.0626639,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 27.26087222,
      lng: -108.0627139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto mínimo",
      superficie: 0.75,
    },
    {
      anio: 2018,
      lat: 25.67886389,
      lng: -106.945525,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.13125,
      lng: -107.0175833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.86451667,
      lng: -106.853225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.10080556,
      lng: -106.9288333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.0735,
      lng: -107.0047222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.08402778,
      lng: -106.9756944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.6895,
      lng: -106.930275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.92645556,
      lng: -106.9242194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.67588056,
      lng: -106.9222194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.99838611,
      lng: -107.0161889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.25628056,
      lng: -106.6090083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.07352778,
      lng: -106.9653611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.03533333,
      lng: -106.7066944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 26.21433333,
      lng: -106.6631389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 26.22575,
      lng: -106.5253611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.23541667,
      lng: -106.5174722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.66408333,
      lng: -106.8089944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 25.90421944,
      lng: -106.9437167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.88736667,
      lng: -106.9976556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.90407778,
      lng: -106.7775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.01724167,
      lng: -106.9201056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.10283333,
      lng: -106.9523333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.07961111,
      lng: -106.9797222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.01237222,
      lng: -106.8042028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.08886111,
      lng: -106.9434167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.91150556,
      lng: -106.8205611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 25.65128611,
      lng: -106.8917778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.76366389,
      lng: -106.7916111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.72430556,
      lng: -106.8354778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 26.03286111,
      lng: -106.6175556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.03877778,
      lng: -106.7717778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.12625,
      lng: -106.7991944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.05028056,
      lng: -106.8178278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.80314722,
      lng: -106.6788528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.77915278,
      lng: -106.723275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.93965,
      lng: -106.9744972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.89783333,
      lng: -106.8812889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.17093333,
      lng: -106.5528306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2018,
      lat: 26.23082222,
      lng: -106.6281056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.40796111,
      lng: -107.2647278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.45774722,
      lng: -107.2592472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.4066,
      lng: -107.2563056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.387,
      lng: -107.2228611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 26.52708056,
      lng: -107.2499722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2018,
      lat: 26.12954444,
      lng: -106.60055,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.09280556,
      lng: -106.7647778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.752775,
      lng: -106.6851,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 26.01771667,
      lng: -106.7093083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.40110556,
      lng: -107.2006917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 26.40946389,
      lng: -107.2701611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.06858333,
      lng: -106.7873333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.76750278,
      lng: -106.6766139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.16416667,
      lng: -106.9427778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.89209722,
      lng: -106.8567222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.89022222,
      lng: -106.8637778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 26.13677778,
      lng: -106.941,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.05428611,
      lng: -106.926175,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.084675,
      lng: -106.9904167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.69816944,
      lng: -106.8727944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 26.01014722,
      lng: -106.9309694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.02072222,
      lng: -106.9236361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.87101111,
      lng: -106.5974139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.75237222,
      lng: -106.8458222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.17211111,
      lng: -106.6827778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.28352778,
      lng: -106.5168056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.19780556,
      lng: -106.5077778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.17208333,
      lng: -106.6826667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.90907222,
      lng: -106.9309306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.92999444,
      lng: -106.9373167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.88841667,
      lng: -106.8775861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.06393889,
      lng: -106.7402083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 26.20933056,
      lng: -106.5651222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 25.26516111,
      lng: -106.7254472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.25911389,
      lng: -106.625725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 26.32436667,
      lng: -106.7040861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.34681944,
      lng: -107.1727056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 26.32371944,
      lng: -107.2091111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.451925,
      lng: -107.296575,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2018,
      lat: 26.11206389,
      lng: -106.7126778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 23.65098333,
      lng: -105.7402,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.63,
    },
    {
      anio: 2018,
      lat: 24.33012778,
      lng: -105.9235111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 25.31048056,
      lng: -105.7152306,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 8,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.42,
    },
    {
      anio: 2018,
      lat: 23.74029722,
      lng: -105.5985194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2018,
      lat: 23.76111111,
      lng: -105.7155556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2018,
      lat: 23.6575,
      lng: -105.6130556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2018,
      lat: 25.35641667,
      lng: -105.7135278,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2018,
      lat: 24.26835,
      lng: -105.4951417,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2018,
      lat: 23.80213056,
      lng: -105.3948361,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.4,
    },
    {
      anio: 2018,
      lat: 23.08547222,
      lng: -104.4859444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2018,
      lat: 24.23177222,
      lng: -105.357875,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 85,
    },
    {
      anio: 2018,
      lat: 25.01743611,
      lng: -106.3570306,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 72,
    },
    {
      anio: 2018,
      lat: 23.69528333,
      lng: -105.5110167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 58,
    },
    {
      anio: 2018,
      lat: 23.63965833,
      lng: -105.6781722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2018,
      lat: 23.63655556,
      lng: -105.5253889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2018,
      lat: 22.92208889,
      lng: -104.62315,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.93,
    },
    {
      anio: 2018,
      lat: 25.05242222,
      lng: -106.0543861,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Severo",
      superficie: 1600,
    },
    {
      anio: 2018,
      lat: 22.91532778,
      lng: -104.5019944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.32,
    },
    {
      anio: 2018,
      lat: 23.79598889,
      lng: -105.3689472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2018,
      lat: 25.46023056,
      lng: -106.8671306,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.01,
    },
    {
      anio: 2018,
      lat: 23.32030833,
      lng: -105.4202472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.8,
    },
    {
      anio: 2018,
      lat: 23.32259722,
      lng: -105.4197361,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 49.5,
    },
    {
      anio: 2018,
      lat: 23.30515833,
      lng: -105.1803917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 295,
    },
    {
      anio: 2018,
      lat: 22.89083889,
      lng: -104.5601056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.8,
    },
    {
      anio: 2018,
      lat: 22.98374167,
      lng: -104.5851028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 25.08411667,
      lng: -106.3242861,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.2,
    },
    {
      anio: 2018,
      lat: 23.75259444,
      lng: -105.6662389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 23.14888889,
      lng: -105.0986306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2018,
      lat: 22.46147222,
      lng: -104.5718611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 570,
    },
    {
      anio: 2018,
      lat: 23.79155,
      lng: -105.3509556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.22,
    },
    {
      anio: 2018,
      lat: 24.29795,
      lng: -105.4394194,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.84,
    },
    {
      anio: 2018,
      lat: 24.46590833,
      lng: -105.6919472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.45,
    },
    {
      anio: 2018,
      lat: 22.99418889,
      lng: -104.3284611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50.5,
    },
    {
      anio: 2018,
      lat: 22.95238333,
      lng: -104.4925389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 513,
    },
    {
      anio: 2018,
      lat: 23.10415278,
      lng: -104.6069083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 89,
    },
    {
      anio: 2018,
      lat: 23.09131111,
      lng: -104.6061778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 244,
    },
    {
      anio: 2018,
      lat: 22.97555556,
      lng: -104.5071667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 266,
    },
    {
      anio: 2018,
      lat: 23.25819167,
      lng: -105.1520889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2018,
      lat: 25.31149444,
      lng: -106.1241806,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 22.98361944,
      lng: -104.666075,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 23.658,
      lng: -105.5316667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 487,
    },
    {
      anio: 2018,
      lat: 24.818,
      lng: -105.9471111,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 23.04926667,
      lng: -104.6187667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2018,
      lat: 24.22769167,
      lng: -106.000775,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 600,
    },
    {
      anio: 2018,
      lat: 22.94558889,
      lng: -104.4454389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.21,
    },
    {
      anio: 2018,
      lat: 22.96266389,
      lng: -104.5083917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Limpias de derecho de vía",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.22,
    },
    {
      anio: 2018,
      lat: 23.04970278,
      lng: -104.6186389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.08777778,
      lng: -106.4150833,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.32,
    },
    {
      anio: 2018,
      lat: 25.34523056,
      lng: -105.7509083,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2018,
      lat: 22.879125,
      lng: -104.6645139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 23.38297222,
      lng: -104.9897194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2018,
      lat: 23.61431944,
      lng: -104.5344,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2018,
      lat: 22.92718889,
      lng: -104.5889444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2018,
      lat: 22.97641667,
      lng: -104.6642917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 24.8529,
      lng: -105.7656889,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Naturales",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1069,
    },
    {
      anio: 2018,
      lat: 24.50336944,
      lng: -105.7714917,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 465,
    },
    {
      anio: 2018,
      lat: 24.35691389,
      lng: -105.8142389,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.6,
    },
    {
      anio: 2018,
      lat: 24.43122222,
      lng: -105.7194111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.14,
    },
    {
      anio: 2018,
      lat: 23.67017778,
      lng: -105.5093472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 110,
    },
    {
      anio: 2018,
      lat: 23.45608333,
      lng: -105.1544167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 23.76576389,
      lng: -105.3361028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2018,
      lat: 23.78689722,
      lng: -105.3785667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 23.95693056,
      lng: -105.8527861,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 1100,
    },
    {
      anio: 2018,
      lat: 22.91611389,
      lng: -104.5889139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 22.64284167,
      lng: -104.3081111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.82,
    },
    {
      anio: 2018,
      lat: 24.43352222,
      lng: -105.6081667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2018,
      lat: 22.63486944,
      lng: -104.3057722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.04,
    },
    {
      anio: 2018,
      lat: 23.68235,
      lng: -105.5146222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 23.16031389,
      lng: -104.3909556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 800,
    },
    {
      anio: 2018,
      lat: 22.90506389,
      lng: -104.6144972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2018,
      lat: 22.62980556,
      lng: -104.3461389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79,
    },
    {
      anio: 2018,
      lat: 25.33113889,
      lng: -106.2868111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2006,
    },
    {
      anio: 2018,
      lat: 25.60371389,
      lng: -106.5371861,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1101.75,
    },
    {
      anio: 2018,
      lat: 25.55563333,
      lng: -105.5018556,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 384,
    },
    {
      anio: 2018,
      lat: 23.58623611,
      lng: -105.3622889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 106,
    },
    {
      anio: 2018,
      lat: 25.20938611,
      lng: -106.5795611,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.2,
    },
    {
      anio: 2018,
      lat: 24.10536111,
      lng: -105.8414167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2018,
      lat: 23.72960278,
      lng: -105.4730417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 22.97568056,
      lng: -104.6387,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 22.68483611,
      lng: -104.2745556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.69,
    },
    {
      anio: 2018,
      lat: 22.97394167,
      lng: -104.5137389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 23.76139722,
      lng: -105.6758083,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.87,
    },
    {
      anio: 2018,
      lat: 24.965725,
      lng: -105.4213222,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 24.04604167,
      lng: -105.9295778,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1021.2,
    },
    {
      anio: 2018,
      lat: 24.09469722,
      lng: -105.8296833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1229.25,
    },
    {
      anio: 2018,
      lat: 23.61498889,
      lng: -105.6864389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2018,
      lat: 24.38347222,
      lng: -105.9419083,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 25.34236667,
      lng: -106.1628389,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 753,
    },
    {
      anio: 2018,
      lat: 23.41906667,
      lng: -105.3873778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 23.60702778,
      lng: -105.4188611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 23.77152222,
      lng: -105.6893917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 24.84902222,
      lng: -106.0631389,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 738.29,
    },
    {
      anio: 2018,
      lat: 23.23533333,
      lng: -104.93485,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 23.79144722,
      lng: -105.3727639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.13,
    },
    {
      anio: 2018,
      lat: 23.75318611,
      lng: -105.6660722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2018,
      lat: 23.76035833,
      lng: -105.6766194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.72,
    },
    {
      anio: 2018,
      lat: 23.75630556,
      lng: -105.6745222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 23.791475,
      lng: -105.3719389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.6,
    },
    {
      anio: 2018,
      lat: 23.75608333,
      lng: -105.4465778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.37,
    },
    {
      anio: 2018,
      lat: 23.40154722,
      lng: -105.2441083,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.5,
    },
    {
      anio: 2018,
      lat: 23.791125,
      lng: -105.3409639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 23.619975,
      lng: -105.4146056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 25.39138889,
      lng: -106.9197778,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.67,
    },
    {
      anio: 2018,
      lat: 22.97334722,
      lng: -104.6387583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 23.48536389,
      lng: -104.703375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.28,
    },
    {
      anio: 2018,
      lat: 23.03413333,
      lng: -104.5564778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.57,
    },
    {
      anio: 2018,
      lat: 22.99367778,
      lng: -104.6593833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.110125,
      lng: -105.576125,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2018,
      lat: 23.04103056,
      lng: -104.5609861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.56,
    },
    {
      anio: 2018,
      lat: 25.74900833,
      lng: -106.2277722,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2018,
      lat: 22.96496111,
      lng: -104.5739667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 22.97627778,
      lng: -104.6170833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 22.91699722,
      lng: -104.3180889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.82,
    },
    {
      anio: 2018,
      lat: 22.60781389,
      lng: -104.2774694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.53,
    },
    {
      anio: 2018,
      lat: 22.81446389,
      lng: -104.5021611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.13,
    },
    {
      anio: 2018,
      lat: 22.95819444,
      lng: -104.5391389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.17,
    },
    {
      anio: 2018,
      lat: 24.00160556,
      lng: -105.6043278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.58,
    },
    {
      anio: 2018,
      lat: 22.96635556,
      lng: -104.3918944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2018,
      lat: 23.02159167,
      lng: -104.6307778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 23.03825833,
      lng: -104.5527083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 22.96317222,
      lng: -104.545025,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Limpias de derecho de vía",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 22.96191667,
      lng: -104.5337611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Limpias de derecho de vía",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 25.42812222,
      lng: -106.9387139,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.35,
    },
    {
      anio: 2018,
      lat: 22.88236111,
      lng: -104.62,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 23.01682222,
      lng: -104.3228028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.64,
    },
    {
      anio: 2018,
      lat: 22.94351944,
      lng: -104.3261167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.72,
    },
    {
      anio: 2018,
      lat: 24.96614722,
      lng: -106.2857917,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.63,
    },
    {
      anio: 2018,
      lat: 24.11056389,
      lng: -105.7913417,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Naturales",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.38,
    },
    {
      anio: 2018,
      lat: 24.21108611,
      lng: -105.5017472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 25.69992778,
      lng: -106.07775,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2018,
      lat: 23.00227778,
      lng: -104.5956111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2018,
      lat: 23.00512222,
      lng: -104.5943667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 23.61905,
      lng: -105.4632306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50.4,
    },
    {
      anio: 2018,
      lat: 23.62640556,
      lng: -105.5747806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2018,
      lat: 25.26024722,
      lng: -106.5566361,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 47,
    },
    {
      anio: 2018,
      lat: 23.38319167,
      lng: -104.9603944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 23.26209444,
      lng: -105.0360861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 482,
    },
    {
      anio: 2018,
      lat: 23.35333333,
      lng: -104.7688889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 23.21111111,
      lng: -104.7194444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.5,
    },
    {
      anio: 2018,
      lat: 23.20316111,
      lng: -104.7505833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2018,
      lat: 23.15288056,
      lng: -105.1727361,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 23.08183056,
      lng: -105.1485583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 3.75,
    },
    {
      anio: 2018,
      lat: 24.95583611,
      lng: -105.682175,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 24.70233056,
      lng: -106.2097667,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 22.96088611,
      lng: -104.6437472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 22.97139167,
      lng: -104.694525,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 23.02566667,
      lng: -104.4744472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 566,
    },
    {
      anio: 2018,
      lat: 23.17031667,
      lng: -104.266675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.15,
    },
    {
      anio: 2018,
      lat: 24.121525,
      lng: -105.7959083,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.46,
    },
    {
      anio: 2018,
      lat: 22.97427222,
      lng: -104.6355556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 23.79827778,
      lng: -105.4701111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 24.25361111,
      lng: -105.6522472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 457,
    },
    {
      anio: 2018,
      lat: 23.12626944,
      lng: -104.1846472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 392.99,
    },
    {
      anio: 2018,
      lat: 23.69204444,
      lng: -105.6688222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.24,
    },
    {
      anio: 2018,
      lat: 23.38969722,
      lng: -105.0264028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 194,
    },
    {
      anio: 2018,
      lat: 23.00956944,
      lng: -104.634725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 22.98730556,
      lng: -104.98975,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2018,
      lat: 23.0207,
      lng: -104.3237028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 72.45,
    },
    {
      anio: 2018,
      lat: 22.95951667,
      lng: -104.6710694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 22.93794444,
      lng: -104.6213333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 23.41566667,
      lng: -104.9250806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 22.95525,
      lng: -104.4930389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.64,
    },
    {
      anio: 2018,
      lat: 22.85802778,
      lng: -104.5115556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.65,
    },
    {
      anio: 2018,
      lat: 22.76359167,
      lng: -104.5172778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.33,
    },
    {
      anio: 2018,
      lat: 22.99593889,
      lng: -104.6614889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 23.2999,
      lng: -105.5240972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 240.6,
    },
    {
      anio: 2018,
      lat: 23.2611,
      lng: -105.5562,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 140.7,
    },
    {
      anio: 2018,
      lat: 23.47675278,
      lng: -105.5275361,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 134,
    },
    {
      anio: 2018,
      lat: 23.323,
      lng: -105.4671,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.9,
    },
    {
      anio: 2018,
      lat: 23.36336111,
      lng: -105.5328028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 22.4,
    },
    {
      anio: 2018,
      lat: 23.62396667,
      lng: -105.4847583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.7,
    },
    {
      anio: 2018,
      lat: 24.80679444,
      lng: -105.9229972,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 103,
    },
    {
      anio: 2018,
      lat: 22.99916667,
      lng: -104.6455833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 23.59425833,
      lng: -105.3546306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 123.81,
    },
    {
      anio: 2018,
      lat: 23.30994444,
      lng: -105.3509722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 277.44,
    },
    {
      anio: 2018,
      lat: 23.36073889,
      lng: -105.2663389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 385.53,
    },
    {
      anio: 2018,
      lat: 23.48899444,
      lng: -105.3887861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 548,
    },
    {
      anio: 2018,
      lat: 23.33817778,
      lng: -105.3952667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 72.82,
    },
    {
      anio: 2018,
      lat: 23.68688889,
      lng: -105.7320833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2018,
      lat: 24.94788333,
      lng: -106.2271167,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.38,
    },
    {
      anio: 2018,
      lat: 24.50403889,
      lng: -105.7375556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1812,
    },
    {
      anio: 2018,
      lat: 22.96020556,
      lng: -104.490875,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.92,
    },
    {
      anio: 2018,
      lat: 22.99576111,
      lng: -104.5150583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83,
    },
    {
      anio: 2018,
      lat: 22.95956944,
      lng: -104.4913056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 22.647625,
      lng: -104.3752583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46.66,
    },
    {
      anio: 2018,
      lat: 22.94048611,
      lng: -104.537925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.45,
    },
    {
      anio: 2018,
      lat: 23.01597222,
      lng: -104.6514167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 23.00494444,
      lng: -104.6618611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 22.98145278,
      lng: -104.6774278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 22.92063889,
      lng: -104.3717778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 689,
    },
    {
      anio: 2018,
      lat: 23.19219444,
      lng: -104.9215,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 467,
    },
    {
      anio: 2018,
      lat: 23.61378611,
      lng: -105.3999806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41,
    },
    {
      anio: 2018,
      lat: 24.84818889,
      lng: -105.6751528,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 76,
    },
    {
      anio: 2018,
      lat: 25.14382222,
      lng: -106.4236417,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 23.06584444,
      lng: -104.2492306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.99,
    },
    {
      anio: 2018,
      lat: 22.96858333,
      lng: -104.3669722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.42,
    },
    {
      anio: 2018,
      lat: 23.09834167,
      lng: -104.2848972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.9,
    },
    {
      anio: 2018,
      lat: 22.83122222,
      lng: -104.5143889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2018,
      lat: 25.11181667,
      lng: -106.3043778,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.69,
    },
    {
      anio: 2018,
      lat: 22.95897222,
      lng: -104.5916111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2018,
      lat: 23.30817222,
      lng: -105.4502389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42.68,
    },
    {
      anio: 2018,
      lat: 23.57112778,
      lng: -105.6977111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.99,
    },
    {
      anio: 2018,
      lat: 23.75219167,
      lng: -105.6868139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 56.4,
    },
    {
      anio: 2018,
      lat: 23.56413889,
      lng: -105.5168056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 357.1,
    },
    {
      anio: 2018,
      lat: 22.96275,
      lng: -104.6026389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 22.85016389,
      lng: -104.4923694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.24,
    },
    {
      anio: 2018,
      lat: 23.02698333,
      lng: -104.6458583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 22.9735,
      lng: -104.5551111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2018,
      lat: 22.98066667,
      lng: -104.5650278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 22.98093056,
      lng: -104.5519056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 22.97317222,
      lng: -104.5698194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 22.97237778,
      lng: -104.5732306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Limpias de derecho de vía",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2018,
      lat: 24.73308056,
      lng: -106.2248861,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 24.79625556,
      lng: -106.1054861,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2018,
      lat: 24.73647778,
      lng: -106.2209944,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 24.75909722,
      lng: -106.131975,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 24.41624167,
      lng: -105.4947944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2018,
      lat: 25.00584167,
      lng: -106.2739111,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.82,
    },
    {
      anio: 2018,
      lat: 23.00691667,
      lng: -104.6187778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2018,
      lat: 22.97390278,
      lng: -104.5821583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 22.65333333,
      lng: -104.2983056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.6,
    },
    {
      anio: 2018,
      lat: 22.63241667,
      lng: -104.3376528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.18,
    },
    {
      anio: 2018,
      lat: 22.54501111,
      lng: -104.3299111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 124.01,
    },
    {
      anio: 2018,
      lat: 22.97694722,
      lng: -104.5632028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 23.12936111,
      lng: -104.3000833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.91,
    },
    {
      anio: 2018,
      lat: 22.80891667,
      lng: -104.5418333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50.34,
    },
    {
      anio: 2018,
      lat: 22.837325,
      lng: -104.5393722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.23,
    },
    {
      anio: 2018,
      lat: 22.87674722,
      lng: -104.5474778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.27,
    },
    {
      anio: 2018,
      lat: 25.42712222,
      lng: -105.7112111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 287,
    },
    {
      anio: 2018,
      lat: 23.70208333,
      lng: -105.5019722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2018,
      lat: 23.54263611,
      lng: -105.5165556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 23.55043611,
      lng: -105.7214778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.09,
    },
    {
      anio: 2018,
      lat: 23.51108333,
      lng: -105.3821667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 88.9,
    },
    {
      anio: 2018,
      lat: 23.64396389,
      lng: -105.4949722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 348,
    },
    {
      anio: 2018,
      lat: 25.19374722,
      lng: -105.1597611,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 87,
    },
    {
      anio: 2018,
      lat: 25.09073333,
      lng: -106.3081778,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.92,
    },
    {
      anio: 2018,
      lat: 25.18463889,
      lng: -105.1468333,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2018,
      lat: 22.99035278,
      lng: -104.6284917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2018,
      lat: 22.64463889,
      lng: -104.2934667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.36,
    },
    {
      anio: 2018,
      lat: 22.91866667,
      lng: -104.5147222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.51,
    },
    {
      anio: 2018,
      lat: 23.68830556,
      lng: -105.6208611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2018,
      lat: 23.385575,
      lng: -105.3494944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 67.4,
    },
    {
      anio: 2018,
      lat: 25.42545556,
      lng: -106.9091417,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2018,
      lat: 25.46402222,
      lng: -106.9718083,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51.8,
    },
    {
      anio: 2018,
      lat: 25.41190556,
      lng: -106.9410833,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.39,
    },
    {
      anio: 2018,
      lat: 24.93386389,
      lng: -106.2535583,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2018,
      lat: 25.06945833,
      lng: -106.386925,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.99,
    },
    {
      anio: 2018,
      lat: 25.28693333,
      lng: -106.4753333,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 490,
    },
    {
      anio: 2018,
      lat: 25.45783611,
      lng: -105.6390111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1010,
    },
    {
      anio: 2018,
      lat: 23.10683889,
      lng: -104.2672556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 96.62,
    },
    {
      anio: 2018,
      lat: 22.87433333,
      lng: -104.500775,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.12,
    },
    {
      anio: 2018,
      lat: 24.96012222,
      lng: -106.1273778,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Residuos de aprovechamiento forestal",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2018,
      lat: 24.80155556,
      lng: -106.0930167,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2018,
      lat: 23.49138889,
      lng: -104.7037167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 219,
    },
    {
      anio: 2018,
      lat: 23.38222222,
      lng: -104.6983778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 23.29915,
      lng: -104.7262222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 23.24845278,
      lng: -104.7518,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 23.32740833,
      lng: -104.8121667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2018,
      lat: 23.26566667,
      lng: -104.8257806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 23.29361111,
      lng: -104.8438611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 23.20931389,
      lng: -104.6559,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2018,
      lat: 23.34426667,
      lng: -104.7590361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 24.95757778,
      lng: -106.1492167,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 377,
    },
    {
      anio: 2018,
      lat: 22.63318056,
      lng: -104.2997667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.37,
    },
    {
      anio: 2018,
      lat: 22.63005833,
      lng: -104.2991389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43,
    },
    {
      anio: 2018,
      lat: 23.650575,
      lng: -105.6185333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 199,
    },
    {
      anio: 2018,
      lat: 23.60838611,
      lng: -105.6901139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.8,
    },
    {
      anio: 2018,
      lat: 25.72152778,
      lng: -106.0662778,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 25.06413333,
      lng: -105.6716694,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2018,
      lat: 25.45624167,
      lng: -105.6320111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2018,
      lat: 23.29638056,
      lng: -104.8534306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.3,
    },
    {
      anio: 2018,
      lat: 23.38994722,
      lng: -105.0882389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 795,
    },
    {
      anio: 2018,
      lat: 23.23019444,
      lng: -105.1874861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2018,
      lat: 23.27034722,
      lng: -104.8720667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33.8,
    },
    {
      anio: 2018,
      lat: 23.31303611,
      lng: -104.869225,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.9,
    },
    {
      anio: 2018,
      lat: 23.38259722,
      lng: -104.8843389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 23.38716944,
      lng: -104.8939833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 23.37831389,
      lng: -105.0184639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 300,
    },
    {
      anio: 2025,
      lat: 23.440994,
      lng: -105.81846,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 242.2238,
    },
    {
      anio: 2024,
      lat: 23.740877,
      lng: -106.367256,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 329.1018,
    },
    {
      anio: 2025,
      lat: 26.139917,
      lng: -107.5962,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 311,
    },
    {
      anio: 2025,
      lat: 24.492205,
      lng: -106.92799,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 305.5508,
    },
    {
      anio: 2020,
      lat: 24.21711944,
      lng: -106.05365,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 304,
    },
    {
      anio: 2025,
      lat: 26.263369,
      lng: -108.236206,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 295,
    },
    {
      anio: 2023,
      lat: 26.116266,
      lng: -107.368355,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 292.4566,
    },
    {
      anio: 2025,
      lat: 25.996262,
      lng: -107.97188,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 291,
    },
    {
      anio: 2024,
      lat: 24.817816,
      lng: -106.86606,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 286.4525,
    },
    {
      anio: 2025,
      lat: 24.926506,
      lng: -107.11012,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 275.8242,
    },
    {
      anio: 2024,
      lat: 26.831663,
      lng: -108.188065,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 264.8444,
    },
    {
      anio: 2023,
      lat: 24.276192,
      lng: -106.08653,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 261.6996,
    },
    {
      anio: 2024,
      lat: 23.71069,
      lng: -106.32729,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 255.0447,
    },
    {
      anio: 2023,
      lat: 25.839695,
      lng: -108.04724,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades pecuarias",
      semana: 16,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 253.3519,
    },
    {
      anio: 2025,
      lat: 26.308056,
      lng: -107.99439,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 253.1385,
    },
    {
      anio: 2016,
      lat: 25.82948611,
      lng: -107.5419389,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 250,
    },
    {
      anio: 2016,
      lat: 26.63561111,
      lng: -107.9983611,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 250,
    },
    {
      anio: 2025,
      lat: 23.553267,
      lng: -106.09034,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 1692.09,
    },
    {
      anio: 2025,
      lat: 26.219366,
      lng: -107.87471,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 241,
    },
    {
      anio: 2025,
      lat: 26.935467,
      lng: -108.327034,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 238.8606,
    },
    {
      anio: 2024,
      lat: 24.32077,
      lng: -106.14756,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 227.712,
    },
    {
      anio: 2025,
      lat: 24.361895,
      lng: -107.00008,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 223,
    },
    {
      anio: 2018,
      lat: 24.24489167,
      lng: -106.0528972,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 217,
    },
    {
      anio: 2017,
      lat: 26.78648611,
      lng: -108.4206028,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2018,
      lat: 25.41265278,
      lng: -107.621275,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2019,
      lat: 23.85112222,
      lng: -106.0295833,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2021,
      lat: 23.72696111,
      lng: -106.33245,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2023,
      lat: 25.766666,
      lng: -107.56555,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 197.3008,
    },
    {
      anio: 2022,
      lat: 26.837122,
      lng: -108.213036,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades pecuarias",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 193.2734,
    },
    {
      anio: 2021,
      lat: 25.79962778,
      lng: -107.6475556,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 192,
    },
    {
      anio: 2025,
      lat: 23.575422,
      lng: -106.2251,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 189,
    },
    {
      anio: 2023,
      lat: 25.607573,
      lng: -107.06624,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 183.6548,
    },
    {
      anio: 2018,
      lat: 26.57827778,
      lng: -108.2823556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2025,
      lat: 27.005613,
      lng: -108.409454,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2025,
      lat: 25.976038,
      lng: -107.70277,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 173,
    },
    {
      anio: 2018,
      lat: 24.27196778,
      lng: -106.4794206,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 168,
    },
    {
      anio: 2022,
      lat: 25.748674,
      lng: -107.4341,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 168,
    },
    {
      anio: 2017,
      lat: 26.53494444,
      lng: -108.4028056,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Otras causas",
      semana: 15,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2022,
      lat: 23.335356,
      lng: -105.8408,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2025,
      lat: 23.385344,
      lng: -105.78258,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2015,
      lat: 24.18538611,
      lng: -106.4502278,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Quema de basureros",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 150,
    },
    {
      anio: 2025,
      lat: 24.478374,
      lng: -106.7484,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 148.8513,
    },
    {
      anio: 2025,
      lat: 23.238129,
      lng: -105.97699,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 340,
    },
    {
      anio: 2024,
      lat: 26.592081,
      lng: -108.21054,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades pecuarias",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 138.2304,
    },
    {
      anio: 2020,
      lat: 23.88151944,
      lng: -106.1521,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 138,
    },
    {
      anio: 2019,
      lat: 26.54130833,
      lng: -107.2723722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2019,
      lat: 26.07227778,
      lng: -106.7890556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.23997222,
      lng: -106.5510278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.98,
    },
    {
      anio: 2019,
      lat: 26.30114167,
      lng: -106.79365,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 27.55333333,
      lng: -108.0759417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.6,
    },
    {
      anio: 2019,
      lat: 27.58786111,
      lng: -108.0650833,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.08743333,
      lng: -106.6463444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 105,
    },
    {
      anio: 2019,
      lat: 27.0495,
      lng: -107.43975,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2019,
      lat: 26.48290278,
      lng: -106.9391722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.17815278,
      lng: -107.2203972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2019,
      lat: 25.89693333,
      lng: -106.9662056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.44728611,
      lng: -107.5527444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.12436667,
      lng: -107.5344389,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 27.32008889,
      lng: -107.2017167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32.5,
    },
    {
      anio: 2019,
      lat: 26.21045278,
      lng: -107.33235,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2019,
      lat: 26.95945,
      lng: -107.3171889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.69788333,
      lng: -107.1775778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Residuos de aprovechamiento forestal",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 233,
    },
    {
      anio: 2019,
      lat: 26.74235833,
      lng: -106.971325,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 773,
    },
    {
      anio: 2019,
      lat: 26.28961111,
      lng: -107.5349694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 110,
    },
    {
      anio: 2019,
      lat: 26.20880556,
      lng: -107.3464167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2019,
      lat: 26.08263889,
      lng: -106.6486111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2019,
      lat: 26.37817222,
      lng: -106.5808722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 254,
    },
    {
      anio: 2019,
      lat: 26.87461111,
      lng: -107.3388056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2019,
      lat: 27.65120556,
      lng: -107.6265583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2019,
      lat: 26.37856389,
      lng: -106.9002722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2019,
      lat: 27.14344444,
      lng: -107.4655278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 27.21031944,
      lng: -107.3794778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2019,
      lat: 26.14075,
      lng: -107.2374167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 61,
    },
    {
      anio: 2019,
      lat: 26.28579444,
      lng: -106.7975,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.555475,
      lng: -107.4657611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 178,
    },
    {
      anio: 2019,
      lat: 26.16104444,
      lng: -106.8172972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 27.54091667,
      lng: -107.8441778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2,
    },
    {
      anio: 2019,
      lat: 26.55730556,
      lng: -107.0505111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 77,
    },
    {
      anio: 2019,
      lat: 27.12494444,
      lng: -106.9985889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 26.35666667,
      lng: -106.5668694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2019,
      lat: 26.78643056,
      lng: -107.3829056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.04730556,
      lng: -106.7991389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 27.63428056,
      lng: -107.5847056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.34708333,
      lng: -106.5774722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2019,
      lat: 26.26255556,
      lng: -106.7780278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 25.84463889,
      lng: -106.92675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.57813889,
      lng: -106.9950833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Festividades y rituales",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 26.17704167,
      lng: -107.0751778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.56661111,
      lng: -107.8186417,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42.6,
    },
    {
      anio: 2019,
      lat: 26.53233333,
      lng: -107.0418333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.968875,
      lng: -107.0669278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.61088889,
      lng: -107.0360056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.93399722,
      lng: -106.9718611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.13543333,
      lng: -106.6181194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.97269444,
      lng: -107.1068722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.59,
    },
    {
      anio: 2019,
      lat: 26.88800556,
      lng: -107.1052333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.1,
    },
    {
      anio: 2019,
      lat: 27.32410278,
      lng: -107.0544972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 40.7,
    },
    {
      anio: 2019,
      lat: 26.90620833,
      lng: -107.1782833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.4,
    },
    {
      anio: 2019,
      lat: 26.36113889,
      lng: -107.1908056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.38716667,
      lng: -107.2445833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.43044444,
      lng: -107.2301111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.46069444,
      lng: -107.3925833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.46818611,
      lng: -107.3016972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.46188889,
      lng: -107.2124444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.15956389,
      lng: -106.8147278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2019,
      lat: 26.08295833,
      lng: -106.6057917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 70,
    },
    {
      anio: 2019,
      lat: 26.97306389,
      lng: -107.1064111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.59,
    },
    {
      anio: 2019,
      lat: 26.8875,
      lng: -107.1055278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.1,
    },
    {
      anio: 2019,
      lat: 27.5215,
      lng: -107.8363611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2019,
      lat: 26.13786111,
      lng: -106.7947222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.12461111,
      lng: -106.8207778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.17673056,
      lng: -106.9853222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.61625556,
      lng: -107.6615417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 27.59765833,
      lng: -107.6666694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.30708333,
      lng: -107.3443333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 60,
    },
    {
      anio: 2019,
      lat: 27.60113611,
      lng: -107.6615583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 27.284275,
      lng: -107.9567806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.16658333,
      lng: -106.8230278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.5,
    },
    {
      anio: 2019,
      lat: 26.33758333,
      lng: -106.9774444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.82199722,
      lng: -107.3972222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.92713889,
      lng: -107.3335111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2019,
      lat: 27.47649167,
      lng: -107.8813083,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.1,
    },
    {
      anio: 2019,
      lat: 26.07677778,
      lng: -106.9606667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.16602778,
      lng: -106.8209167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2019,
      lat: 27.27607222,
      lng: -107.9543833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 27.10269444,
      lng: -107.9226361,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.53122222,
      lng: -107.2737778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.08566111,
      lng: -106.9903056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.92802778,
      lng: -106.9688472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.45716667,
      lng: -107.2092778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.5748,
      lng: -106.9950861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 26.18515556,
      lng: -106.8973056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2019,
      lat: 26.82247222,
      lng: -107.0331667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.09827778,
      lng: -107.2515639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2019,
      lat: 26.09108333,
      lng: -106.7393611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.37,
    },
    {
      anio: 2019,
      lat: 25.77525,
      lng: -106.804,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.56,
    },
    {
      anio: 2019,
      lat: 25.78977778,
      lng: -106.7876944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 25.78343889,
      lng: -106.7865,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2019,
      lat: 26.05168889,
      lng: -106.9116111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.44805556,
      lng: -108.1015139,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.07127778,
      lng: -107.0079167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.85,
    },
    {
      anio: 2019,
      lat: 26.31857222,
      lng: -107.3346444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.46275,
      lng: -107.7325,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.6,
    },
    {
      anio: 2019,
      lat: 25.92930556,
      lng: -106.93175,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2019,
      lat: 26.13986111,
      lng: -106.6133611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.11371667,
      lng: -106.5923417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 27.156,
      lng: -107.0240833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.39752778,
      lng: -107.30475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 27.25863056,
      lng: -107.7894778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50.95,
    },
    {
      anio: 2019,
      lat: 27.14663056,
      lng: -108.0446806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 26.39202778,
      lng: -106.6780139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2019,
      lat: 26.87978056,
      lng: -107.3829028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 26.18652778,
      lng: -106.8855722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2019,
      lat: 26.05291667,
      lng: -107.0209722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.83175,
      lng: -107.5770833,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Perennifolia",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.61463889,
      lng: -107.6454139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 27.28325,
      lng: -107.6676333,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.16086111,
      lng: -106.6056111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 26.14886111,
      lng: -106.6092222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.16233333,
      lng: -106.6099722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.88555278,
      lng: -106.9341778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.28986944,
      lng: -107.6500472,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2019,
      lat: 26.56455556,
      lng: -106.9832222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 41,
    },
    {
      anio: 2019,
      lat: 26.32491667,
      lng: -106.8832222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.18091667,
      lng: -106.8794444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.10259722,
      lng: -106.7720833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.12041667,
      lng: -106.6614444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 26.01834444,
      lng: -106.8307222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2019,
      lat: 26.39766667,
      lng: -106.9154167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.52838333,
      lng: -107.8374611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.1,
    },
    {
      anio: 2019,
      lat: 26.09055833,
      lng: -107.0110833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.05109722,
      lng: -106.5263333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 27.17975,
      lng: -106.9386389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.55130833,
      lng: -107.8382778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50.1,
    },
    {
      anio: 2019,
      lat: 26.30189167,
      lng: -106.6752333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.68630556,
      lng: -106.8187083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 25.98036389,
      lng: -106.7286861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.16140833,
      lng: -106.6027194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2019,
      lat: 26.49461111,
      lng: -106.9282778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.47675,
      lng: -107.2599444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.90452778,
      lng: -107.2553889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 27.60997778,
      lng: -107.6031556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2019,
      lat: 27.64621667,
      lng: -107.624075,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.11750278,
      lng: -106.8026833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2019,
      lat: 27.47334167,
      lng: -107.4342306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 401,
    },
    {
      anio: 2019,
      lat: 26.67567222,
      lng: -107.2090944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 37.4,
    },
    {
      anio: 2019,
      lat: 26.10716667,
      lng: -106.8003167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.17313889,
      lng: -106.8040833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.90177778,
      lng: -107.1768333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.7,
    },
    {
      anio: 2019,
      lat: 26.82155556,
      lng: -106.9166361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.1,
    },
    {
      anio: 2019,
      lat: 27.39430556,
      lng: -107.7601389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2019,
      lat: 27.12675,
      lng: -108.0556944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.33254722,
      lng: -106.7962111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2019,
      lat: 26.44011667,
      lng: -107.1473667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 129,
    },
    {
      anio: 2019,
      lat: 27.58705556,
      lng: -108.0446667,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2019,
      lat: 27.66792778,
      lng: -108.2626611,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 82,
    },
    {
      anio: 2019,
      lat: 26.08219444,
      lng: -106.8000528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.77836111,
      lng: -107.2413611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.91783611,
      lng: -106.9344917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.92883333,
      lng: -106.9319167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.84244444,
      lng: -106.9373611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.15796389,
      lng: -106.6135083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 25.77636111,
      lng: -106.8031111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.73380278,
      lng: -106.8198611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.73337222,
      lng: -106.8060278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.22008333,
      lng: -106.8165556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.108825,
      lng: -106.97145,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.41033333,
      lng: -107.2628889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.45079722,
      lng: -107.2910833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 25.71233333,
      lng: -106.8195278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.90966667,
      lng: -106.9400833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.93036111,
      lng: -106.9398333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.92280556,
      lng: -106.9628333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.14138889,
      lng: -106.6167361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 27.10672222,
      lng: -107.32625,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.1836,
      lng: -106.7943056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 26.30913333,
      lng: -106.9690028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2019,
      lat: 25.96153889,
      lng: -107.0565833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2019,
      lat: 25.70661111,
      lng: -106.8770556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.87483333,
      lng: -106.891,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.46083333,
      lng: -107.2433333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.48646389,
      lng: -107.3347306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2019,
      lat: 26.52112222,
      lng: -107.3074611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.46968611,
      lng: -107.2898389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.22993611,
      lng: -107.1085,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.39727778,
      lng: -106.90255,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.011525,
      lng: -107.0714611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.94504444,
      lng: -107.0453667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.83761111,
      lng: -106.8746389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 25.82652778,
      lng: -106.8781389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.08383333,
      lng: -106.9733889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.09419444,
      lng: -106.9400833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.09186111,
      lng: -106.7890833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 26.01022222,
      lng: -107.0744722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 63,
    },
    {
      anio: 2019,
      lat: 26.79636111,
      lng: -107.2918056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 26.88845278,
      lng: -107.191975,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.85,
    },
    {
      anio: 2019,
      lat: 26.08925,
      lng: -106.8202222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.21555556,
      lng: -107.9784167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2019,
      lat: 27.15419444,
      lng: -107.8358889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 215,
    },
    {
      anio: 2019,
      lat: 27.13158333,
      lng: -108.0135556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.76485278,
      lng: -107.2643222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.00808333,
      lng: -107.0606111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 27.51060833,
      lng: -107.8678556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.8,
    },
    {
      anio: 2019,
      lat: 26.98142778,
      lng: -107.0958333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2019,
      lat: 26.13747222,
      lng: -106.6100556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2019,
      lat: 25.91144722,
      lng: -107.0922611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 440,
    },
    {
      anio: 2019,
      lat: 25.98636389,
      lng: -107.12925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.5,
    },
    {
      anio: 2019,
      lat: 26.36870278,
      lng: -107.2440944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 234,
    },
    {
      anio: 2019,
      lat: 27.660925,
      lng: -108.2628111,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2019,
      lat: 26.61418056,
      lng: -107.9459417,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2019,
      lat: 26.47691667,
      lng: -107.2270278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.40833333,
      lng: -107.2826389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.44205556,
      lng: -107.2623333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.13280556,
      lng: -106.6358444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.24602778,
      lng: -106.6949444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.10558333,
      lng: -106.6713889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2019,
      lat: 26.16685,
      lng: -106.7075556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 25.72952778,
      lng: -106.8086111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.07808333,
      lng: -106.9671972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.09358333,
      lng: -106.7916667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.069175,
      lng: -106.9699444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 25.87525,
      lng: -106.9545472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.06400833,
      lng: -106.7316444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 130,
    },
    {
      anio: 2019,
      lat: 27.65514444,
      lng: -108.2490722,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.39,
    },
    {
      anio: 2019,
      lat: 27.47787778,
      lng: -108.0730333,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 27.51258333,
      lng: -107.8838194,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2019,
      lat: 26.95845,
      lng: -107.3121139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2019,
      lat: 27.42470833,
      lng: -108.0861472,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2019,
      lat: 26.30580556,
      lng: -107.1909167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.65905556,
      lng: -108.2684083,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2019,
      lat: 26.52944444,
      lng: -107.2778333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.301825,
      lng: -107.2487389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 472,
    },
    {
      anio: 2019,
      lat: 27.58063889,
      lng: -108.0158667,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.03592222,
      lng: -107.3130917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.9,
    },
    {
      anio: 2019,
      lat: 26.39001944,
      lng: -107.3389556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.45108333,
      lng: -107.3126667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.26261667,
      lng: -107.0282917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.17355556,
      lng: -106.9144722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.93861111,
      lng: -106.9108889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 27.38773889,
      lng: -107.96885,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 58,
    },
    {
      anio: 2019,
      lat: 25.89839444,
      lng: -106.6157083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2019,
      lat: 26.0443,
      lng: -106.9396806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.41975,
      lng: -107.20475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.43947222,
      lng: -106.9648333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 27.11455556,
      lng: -107.4946389,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.11661111,
      lng: -107.0324722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.19011944,
      lng: -106.8098611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.56402778,
      lng: -107.8334667,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.17661111,
      lng: -106.9071944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 26.17138889,
      lng: -106.8895833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.44640833,
      lng: -107.4368944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2019,
      lat: 27.04083333,
      lng: -107.3196944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.40883889,
      lng: -107.2346028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.75727778,
      lng: -106.8196944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 25.92558333,
      lng: -106.9416111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.952025,
      lng: -107.0676361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2019,
      lat: 26.33100833,
      lng: -107.2453111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.36941111,
      lng: -106.9424444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.31508333,
      lng: -106.8148611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 39,
    },
    {
      anio: 2019,
      lat: 27.23269444,
      lng: -108.0803056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.09277778,
      lng: -106.7749722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.20846111,
      lng: -106.7762778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2019,
      lat: 25.798325,
      lng: -106.6154333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2019,
      lat: 26.106225,
      lng: -107.0987528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 59.53,
    },
    {
      anio: 2019,
      lat: 26.13479444,
      lng: -106.9001639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2019,
      lat: 26.76425,
      lng: -107.2700833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.7,
    },
    {
      anio: 2019,
      lat: 25.92618056,
      lng: -106.9925583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.10002778,
      lng: -106.9903056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 27.3018,
      lng: -108.0242778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2019,
      lat: 27.14066667,
      lng: -108.0586111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.4,
    },
    {
      anio: 2019,
      lat: 27.206,
      lng: -108.0423611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 27.42755556,
      lng: -108.0958056,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.8,
    },
    {
      anio: 2019,
      lat: 26.40834167,
      lng: -107.9059222,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 584,
    },
    {
      anio: 2019,
      lat: 26.47686111,
      lng: -107.2624722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.99911667,
      lng: -107.0447056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.10644444,
      lng: -106.9294167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.07486111,
      lng: -107.0118333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.08669444,
      lng: -106.9973889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.12326944,
      lng: -106.9611722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.35043889,
      lng: -107.9134722,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 139,
    },
    {
      anio: 2019,
      lat: 26.51424167,
      lng: -107.8830778,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 66.79,
    },
    {
      anio: 2019,
      lat: 25.99977778,
      lng: -107.0593611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 25.87138889,
      lng: -106.9060833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.75797222,
      lng: -107.2816389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 27.46683611,
      lng: -108.0677806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2019,
      lat: 26.10991667,
      lng: -106.8151667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.30230556,
      lng: -107.3092222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.52291667,
      lng: -107.8229167,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.96119444,
      lng: -106.9317222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2019,
      lat: 27.44744444,
      lng: -108.0763889,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2019,
      lat: 26.14661111,
      lng: -106.8521833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.0605,
      lng: -106.8401944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 27.474275,
      lng: -107.4450917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 357,
    },
    {
      anio: 2019,
      lat: 27.46175,
      lng: -107.3615389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 347,
    },
    {
      anio: 2019,
      lat: 26.01423333,
      lng: -106.9593528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.07369444,
      lng: -106.9627778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2019,
      lat: 27.41210278,
      lng: -108.2257361,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2019,
      lat: 26.35040833,
      lng: -107.354,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2019,
      lat: 26.44033056,
      lng: -107.3401972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.12597222,
      lng: -106.8128056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 27.14008333,
      lng: -107.2841944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 26.47426944,
      lng: -107.2606167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2019,
      lat: 27.13305556,
      lng: -107.3250556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.32,
    },
    {
      anio: 2019,
      lat: 26.16754167,
      lng: -106.9109389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2019,
      lat: 26.07277778,
      lng: -106.7979444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.17522222,
      lng: -106.8058056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.838,
      lng: -106.8754167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2019,
      lat: 26.01240556,
      lng: -106.954525,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2019,
      lat: 26.05566111,
      lng: -106.6557139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2019,
      lat: 26.51393056,
      lng: -107.2861056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 27.50444444,
      lng: -107.7965,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2019,
      lat: 27.66533333,
      lng: -107.6165,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 26.086125,
      lng: -106.8200944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2019,
      lat: 26.11919722,
      lng: -106.8174694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.19186111,
      lng: -106.8239167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.19033333,
      lng: -106.809,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.17766667,
      lng: -106.8273056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 27.45719444,
      lng: -107.94525,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.2,
    },
    {
      anio: 2019,
      lat: 25.926,
      lng: -106.9400556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.05526389,
      lng: -106.6242833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 198,
    },
    {
      anio: 2019,
      lat: 26.45157778,
      lng: -107.3221111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2019,
      lat: 26.80280556,
      lng: -107.4097778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 27.01218611,
      lng: -107.358625,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 68.5,
    },
    {
      anio: 2019,
      lat: 27.11819444,
      lng: -107.3398889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 27.36602222,
      lng: -107.2522528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 67.8,
    },
    {
      anio: 2019,
      lat: 26.16325,
      lng: -106.8568333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 25.94467222,
      lng: -107.0578556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 72.3,
    },
    {
      anio: 2019,
      lat: 25.902175,
      lng: -106.82175,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2019,
      lat: 25.87263889,
      lng: -106.8136944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2019,
      lat: 27.10420833,
      lng: -107.9497278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2019,
      lat: 26.31239444,
      lng: -106.9855083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2019,
      lat: 25.97028889,
      lng: -107.0766833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 26.48097222,
      lng: -107.2498694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.22225,
      lng: -106.8208889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 27.53866667,
      lng: -107.8427778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 27.58822222,
      lng: -107.6659722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 26.192875,
      lng: -107.1099694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 25.69472222,
      lng: -106.8115,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.18094444,
      lng: -106.8753056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 27.08088889,
      lng: -107.3716944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2019,
      lat: 27.45788889,
      lng: -108.1051944,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2019,
      lat: 27.60173611,
      lng: -108.0326389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.3,
    },
    {
      anio: 2019,
      lat: 27.4985,
      lng: -107.9468889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2019,
      lat: 26.19814444,
      lng: -107.1113333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.18581111,
      lng: -106.7971667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.04375,
      lng: -106.9588139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.92084722,
      lng: -106.8198361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 27.06675,
      lng: -107.2069167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.15513611,
      lng: -106.5900917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2019,
      lat: 26.32768333,
      lng: -107.3184194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2019,
      lat: 26.42079722,
      lng: -107.2557389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.09686111,
      lng: -106.944025,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.09227778,
      lng: -106.8072778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.08702778,
      lng: -106.7801389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 26.08788889,
      lng: -106.8138056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.09538889,
      lng: -106.7741389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.13158333,
      lng: -106.8078889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.01875833,
      lng: -107.067125,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 17,
    },
    {
      anio: 2019,
      lat: 26.02036111,
      lng: -107.0809056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2019,
      lat: 25.91122222,
      lng: -106.9227222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.91824444,
      lng: -106.9403333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.89481944,
      lng: -106.9351639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.90891667,
      lng: -106.8840611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.83769444,
      lng: -106.8667361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.88763889,
      lng: -106.8669917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.72111389,
      lng: -106.8950028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2019,
      lat: 26.47691667,
      lng: -107.2106667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.34203611,
      lng: -107.1839389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.27,
    },
    {
      anio: 2019,
      lat: 26.45099722,
      lng: -107.3573889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.66,
    },
    {
      anio: 2019,
      lat: 26.35955556,
      lng: -107.2555556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2019,
      lat: 26.34591667,
      lng: -107.2419667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.4814,
      lng: -107.3000806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 36,
    },
    {
      anio: 2019,
      lat: 26.40911111,
      lng: -107.2133889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.09688889,
      lng: -107.0074722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.11241667,
      lng: -106.9945833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.07797222,
      lng: -106.9864556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.08891667,
      lng: -107.0606917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2019,
      lat: 26.14558056,
      lng: -106.94805,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2019,
      lat: 26.11602778,
      lng: -107.0054167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2019,
      lat: 26.01003889,
      lng: -106.9188972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.01748056,
      lng: -106.970925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.01047222,
      lng: -106.9114722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.83155556,
      lng: -106.9426111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.64,
    },
    {
      anio: 2019,
      lat: 25.87475,
      lng: -106.9200278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 25.91841111,
      lng: -106.9418333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.92180556,
      lng: -106.9434167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.89275,
      lng: -106.9386944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.92658333,
      lng: -106.9632222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 25.86998889,
      lng: -106.9505056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.79211111,
      lng: -106.9531111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 25.72363889,
      lng: -106.8277778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.72058333,
      lng: -106.8269444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.19252778,
      lng: -106.8108611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.17138889,
      lng: -106.8896944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.20802778,
      lng: -106.7970278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.12729444,
      lng: -106.9040389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 32,
    },
    {
      anio: 2019,
      lat: 26.48325,
      lng: -107.2975,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.46544444,
      lng: -107.23825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 26.51698611,
      lng: -107.2667444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.10260556,
      lng: -107.0244056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.04238889,
      lng: -107.0108028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.00111667,
      lng: -106.99895,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.02082222,
      lng: -106.9206917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.05733056,
      lng: -106.9144361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.930575,
      lng: -106.944075,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 25.91717222,
      lng: -106.9542778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 25.95207222,
      lng: -106.9195556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 25.90126944,
      lng: -106.9579722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.88847222,
      lng: -106.9883056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 25.66063889,
      lng: -106.8981944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1,
    },
    {
      anio: 2019,
      lat: 25.66169444,
      lng: -106.8965,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.77277778,
      lng: -106.8391389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.77375,
      lng: -106.839,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.08644444,
      lng: -106.7562222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.10911111,
      lng: -106.8653889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.392,
      lng: -107.3017111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.43870278,
      lng: -107.2864583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.51144444,
      lng: -107.2837361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2019,
      lat: 26.43395556,
      lng: -107.3384444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.45461111,
      lng: -107.3347278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.05640556,
      lng: -107.0656389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 26.07908056,
      lng: -106.9956361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.06821111,
      lng: -107.0652056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 25.99865556,
      lng: -106.9995167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.06851667,
      lng: -106.9571972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.87161111,
      lng: -106.9368611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 25.90277778,
      lng: -106.94975,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2019,
      lat: 25.92597222,
      lng: -106.9085,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.91917222,
      lng: -106.9499972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.91044444,
      lng: -106.7852972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.66572222,
      lng: -106.8651111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.69972222,
      lng: -106.8153333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 26.09527778,
      lng: -106.6596389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.28551389,
      lng: -106.6883056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 26.43869444,
      lng: -107.2512889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.43066667,
      lng: -107.291,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2019,
      lat: 26.42960278,
      lng: -107.2782444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 26.03452778,
      lng: -107.0179167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.39980556,
      lng: -107.2118056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.94366667,
      lng: -106.8050278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 25.98579167,
      lng: -106.9879972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.56,
    },
    {
      anio: 2019,
      lat: 25.72833333,
      lng: -106.8467778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 25.69266667,
      lng: -106.8474722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 25.87816667,
      lng: -106.8235278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 25.69419444,
      lng: -106.8105833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.7215,
      lng: -106.8142222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.32377222,
      lng: -107.3232861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 26.30826944,
      lng: -107.3232861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 26.10152778,
      lng: -106.9294722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.03274444,
      lng: -107.00545,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2019,
      lat: 26.01304444,
      lng: -106.9929667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.09618611,
      lng: -107.0642417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 26.01780278,
      lng: -106.9371306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.90852778,
      lng: -106.906,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 26.09961667,
      lng: -106.9497722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 25.91836667,
      lng: -106.9400278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.92363889,
      lng: -106.9531667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.71880833,
      lng: -106.8865278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2019,
      lat: 25.71853056,
      lng: -106.8894722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.72269444,
      lng: -106.8220556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 26.06766111,
      lng: -106.7153889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.08394167,
      lng: -106.793,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2019,
      lat: 26.12969444,
      lng: -106.6153611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 100,
    },
    {
      anio: 2019,
      lat: 24.29850833,
      lng: -105.4048583,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.33,
    },
    {
      anio: 2019,
      lat: 23.76190278,
      lng: -105.4697167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.5,
    },
    {
      anio: 2019,
      lat: 23.70155556,
      lng: -105.5174028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 24.00621944,
      lng: -105.6386,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2019,
      lat: 23.71374167,
      lng: -105.5674,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.5,
    },
    {
      anio: 2019,
      lat: 23.63261944,
      lng: -105.4710444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2019,
      lat: 23.36860833,
      lng: -104.8022306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 23.23560278,
      lng: -105.1120778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2019,
      lat: 24.53384444,
      lng: -105.6425083,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 179,
    },
    {
      anio: 2019,
      lat: 23.35458889,
      lng: -106.362125,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2019,
      lat: 24.09249722,
      lng: -105.6991167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2019,
      lat: 25.50085833,
      lng: -106.2846583,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2019,
      lat: 22.95038889,
      lng: -104.7409667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.55,
    },
    {
      anio: 2019,
      lat: 23.79018889,
      lng: -105.3548722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2019,
      lat: 23.23905278,
      lng: -104.9289306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2019,
      lat: 25.44688611,
      lng: -106.1850139,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 222,
    },
    {
      anio: 2019,
      lat: 23.74495278,
      lng: -105.5724944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.7,
    },
    {
      anio: 2019,
      lat: 24.28351944,
      lng: -105.4726667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 198,
    },
    {
      anio: 2019,
      lat: 23.10617778,
      lng: -105.1341306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 201,
    },
    {
      anio: 2019,
      lat: 23.63399444,
      lng: -105.683275,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2019,
      lat: 23.63753333,
      lng: -105.6133917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2019,
      lat: 23.536325,
      lng: -105.5161972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2019,
      lat: 23.64836389,
      lng: -105.5265417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 24.47761389,
      lng: -105.6140694,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2019,
      lat: 24.10384722,
      lng: -105.632425,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.52,
    },
    {
      anio: 2019,
      lat: 22.66668333,
      lng: -104.3011028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 228.77,
    },
    {
      anio: 2019,
      lat: 23.00058889,
      lng: -104.4850194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 418,
    },
    {
      anio: 2019,
      lat: 22.8913,
      lng: -104.5142528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.383,
    },
    {
      anio: 2019,
      lat: 22.94294167,
      lng: -104.5325139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.95,
    },
    {
      anio: 2019,
      lat: 22.89208333,
      lng: -104.5477333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.382,
    },
    {
      anio: 2019,
      lat: 22.99350556,
      lng: -104.5643889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.976,
    },
    {
      anio: 2019,
      lat: 22.94316389,
      lng: -104.6021306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.554,
    },
    {
      anio: 2019,
      lat: 22.893125,
      lng: -104.6490444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.725,
    },
    {
      anio: 2019,
      lat: 23.03391667,
      lng: -104.6038389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 60.122,
    },
    {
      anio: 2019,
      lat: 23.02333056,
      lng: -104.2968222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2732,
    },
    {
      anio: 2019,
      lat: 25.51614167,
      lng: -105.8982806,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 5232,
    },
    {
      anio: 2019,
      lat: 25.63065833,
      lng: -105.9555611,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1797,
    },
    {
      anio: 2019,
      lat: 24.36838333,
      lng: -105.7422889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.43,
    },
    {
      anio: 2019,
      lat: 22.60307222,
      lng: -104.3674861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 273.75,
    },
    {
      anio: 2019,
      lat: 23.020975,
      lng: -104.3140694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.3204,
    },
    {
      anio: 2019,
      lat: 22.83968056,
      lng: -104.3519639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.1336,
    },
    {
      anio: 2019,
      lat: 22.98800278,
      lng: -104.5809556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 196.12,
    },
    {
      anio: 2019,
      lat: 22.98788889,
      lng: -104.2566278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.552,
    },
    {
      anio: 2019,
      lat: 22.93073889,
      lng: -104.5317917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.68,
    },
    {
      anio: 2019,
      lat: 22.95872778,
      lng: -104.4209722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.4128,
    },
    {
      anio: 2019,
      lat: 24.67258611,
      lng: -105.9091833,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2019,
      lat: 22.91849722,
      lng: -104.5134556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 63.091,
    },
    {
      anio: 2019,
      lat: 23.60064722,
      lng: -105.3984694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2019,
      lat: 22.58231389,
      lng: -104.3282833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 122.94,
    },
    {
      anio: 2019,
      lat: 22.95539444,
      lng: -104.6195306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 102.87,
    },
    {
      anio: 2019,
      lat: 23.01122222,
      lng: -104.6268611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.76,
    },
    {
      anio: 2019,
      lat: 23.02148889,
      lng: -104.6307639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.237,
    },
    {
      anio: 2019,
      lat: 23.68186667,
      lng: -105.3465,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2181,
    },
    {
      anio: 2019,
      lat: 23.70584167,
      lng: -105.3249639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 520,
    },
    {
      anio: 2019,
      lat: 24.26723056,
      lng: -105.9824833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1948,
    },
    {
      anio: 2019,
      lat: 22.94303333,
      lng: -104.5203028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 74.3,
    },
    {
      anio: 2019,
      lat: 22.93348889,
      lng: -104.4600361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.527,
    },
    {
      anio: 2019,
      lat: 23.11535,
      lng: -104.3059778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 98.3144,
    },
    {
      anio: 2019,
      lat: 22.95730278,
      lng: -104.6461417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2019,
      lat: 23.81029444,
      lng: -105.3301556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33.5,
    },
    {
      anio: 2019,
      lat: 24.280175,
      lng: -105.380125,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.6,
    },
    {
      anio: 2019,
      lat: 25.01798056,
      lng: -106.2492167,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.52,
    },
    {
      anio: 2019,
      lat: 25.25148889,
      lng: -106.5109111,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 66,
    },
    {
      anio: 2019,
      lat: 24.84794722,
      lng: -106.2945889,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 23.63145,
      lng: -104.2941889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.953,
    },
    {
      anio: 2019,
      lat: 23.25415,
      lng: -104.3525444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1274.5,
    },
    {
      anio: 2019,
      lat: 22.61108889,
      lng: -104.2901056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.4692,
    },
    {
      anio: 2019,
      lat: 22.63758333,
      lng: -104.2713417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.037,
    },
    {
      anio: 2019,
      lat: 23.65645556,
      lng: -105.7726028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 300,
    },
    {
      anio: 2019,
      lat: 23.76289444,
      lng: -105.4430639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.4,
    },
    {
      anio: 2019,
      lat: 23.82797778,
      lng: -105.3148194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 113,
    },
    {
      anio: 2019,
      lat: 22.88816111,
      lng: -104.4968611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 122.91,
    },
    {
      anio: 2019,
      lat: 22.99910556,
      lng: -104.4968611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 22.97471667,
      lng: -104.6449694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.49,
    },
    {
      anio: 2019,
      lat: 23.00766111,
      lng: -104.6008194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.26,
    },
    {
      anio: 2019,
      lat: 22.96972778,
      lng: -104.5798139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.89,
    },
    {
      anio: 2019,
      lat: 22.91017222,
      lng: -104.5299222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 178.68,
    },
    {
      anio: 2019,
      lat: 22.89541944,
      lng: -104.521975,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.905,
    },
    {
      anio: 2019,
      lat: 23.01259167,
      lng: -104.6983833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.28,
    },
    {
      anio: 2019,
      lat: 22.61029722,
      lng: -104.2896472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.814,
    },
    {
      anio: 2019,
      lat: 22.89874722,
      lng: -104.3112611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 273.9562,
    },
    {
      anio: 2019,
      lat: 22.87595833,
      lng: -104.3589611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 387.5886,
    },
    {
      anio: 2019,
      lat: 22.83482778,
      lng: -104.3206944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 54.8019,
    },
    {
      anio: 2019,
      lat: 22.83466667,
      lng: -104.499575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.414,
    },
    {
      anio: 2019,
      lat: 22.83292778,
      lng: -104.5100278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.703,
    },
    {
      anio: 2019,
      lat: 22.93303333,
      lng: -104.5192778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.585,
    },
    {
      anio: 2019,
      lat: 22.92954444,
      lng: -104.5076139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.83,
    },
    {
      anio: 2019,
      lat: 22.95953611,
      lng: -104.5400583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 700.16,
    },
    {
      anio: 2019,
      lat: 24.67708056,
      lng: -105.9902806,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2019,
      lat: 25.60901389,
      lng: -106.0652556,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2019,
      lat: 25.25148889,
      lng: -106.5109111,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 22.72678889,
      lng: -104.4997333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 616.72,
    },
    {
      anio: 2019,
      lat: 22.9022,
      lng: -104.4831528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 119.4,
    },
    {
      anio: 2019,
      lat: 22.70642778,
      lng: -104.5071,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 228.83,
    },
    {
      anio: 2019,
      lat: 22.86999722,
      lng: -104.5536444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 102.261,
    },
    {
      anio: 2019,
      lat: 22.93195833,
      lng: -104.5110056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.593,
    },
    {
      anio: 2019,
      lat: 23.11017222,
      lng: -104.2857694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.552,
    },
    {
      anio: 2019,
      lat: 23.11338611,
      lng: -104.2734833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.519,
    },
    {
      anio: 2019,
      lat: 22.89476667,
      lng: -104.5650056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42.563,
    },
    {
      anio: 2019,
      lat: 22.87298889,
      lng: -104.5846222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 102.77,
    },
    {
      anio: 2019,
      lat: 22.99828333,
      lng: -104.6627639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.76,
    },
    {
      anio: 2019,
      lat: 23.04758056,
      lng: -104.6305278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.74,
    },
    {
      anio: 2019,
      lat: 23.45351111,
      lng: -104.9582694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 23.47234722,
      lng: -105.3338472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2019,
      lat: 23.81085,
      lng: -105.6726722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2602,
    },
    {
      anio: 2019,
      lat: 23.68063611,
      lng: -105.4686583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.4,
    },
    {
      anio: 2019,
      lat: 23.57647778,
      lng: -105.3739944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.65,
    },
    {
      anio: 2019,
      lat: 23.42664167,
      lng: -105.4666861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 444,
    },
    {
      anio: 2019,
      lat: 23.50874444,
      lng: -105.39805,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 180.5,
    },
    {
      anio: 2019,
      lat: 23.53427778,
      lng: -105.3506167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2019,
      lat: 23.40339444,
      lng: -105.3568778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 789,
    },
    {
      anio: 2019,
      lat: 23.74872222,
      lng: -105.739725,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 487,
    },
    {
      anio: 2019,
      lat: 22.9043,
      lng: -104.2578361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 68.8102,
    },
    {
      anio: 2019,
      lat: 22.87199444,
      lng: -104.5698111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.62,
    },
    {
      anio: 2019,
      lat: 22.69023611,
      lng: -104.372025,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 277.23,
    },
    {
      anio: 2019,
      lat: 22.46904167,
      lng: -104.3925528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 705,
    },
    {
      anio: 2019,
      lat: 23.95073056,
      lng: -105.9398556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 58,
    },
    {
      anio: 2019,
      lat: 24.14382222,
      lng: -105.5841056,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.3,
    },
    {
      anio: 2019,
      lat: 24.31405556,
      lng: -105.5294833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2019,
      lat: 23.09545833,
      lng: -104.2977833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 468.6396,
    },
    {
      anio: 2019,
      lat: 23.518525,
      lng: -105.0701,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 2142,
    },
    {
      anio: 2019,
      lat: 22.81407778,
      lng: -104.5094056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.23,
    },
    {
      anio: 2019,
      lat: 22.99301667,
      lng: -104.5729278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.73,
    },
    {
      anio: 2019,
      lat: 22.87614167,
      lng: -104.5760556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 22.91992778,
      lng: -104.5355,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.73,
    },
    {
      anio: 2019,
      lat: 22.98451389,
      lng: -104.2452444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 118.82,
    },
    {
      anio: 2019,
      lat: 24.15673889,
      lng: -105.5828278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.54,
    },
    {
      anio: 2019,
      lat: 24.09493056,
      lng: -105.7026278,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2019,
      lat: 24.08589444,
      lng: -105.6827528,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.2,
    },
    {
      anio: 2019,
      lat: 24.18188889,
      lng: -105.6627194,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.45,
    },
    {
      anio: 2019,
      lat: 24.39325278,
      lng: -105.9029667,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 31.6,
    },
    {
      anio: 2019,
      lat: 24.16619444,
      lng: -105.5910889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 297.57,
    },
    {
      anio: 2019,
      lat: 23.2507,
      lng: -104.7723667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2019,
      lat: 23.36633889,
      lng: -104.7630028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2019,
      lat: 23.175025,
      lng: -105.0545472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53,
    },
    {
      anio: 2019,
      lat: 23.14969722,
      lng: -105.1339972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 23.13302222,
      lng: -105.1291889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35.5,
    },
    {
      anio: 2019,
      lat: 23.16101111,
      lng: -105.1387139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 118.5,
    },
    {
      anio: 2019,
      lat: 23.19470278,
      lng: -104.8632028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 259,
    },
    {
      anio: 2019,
      lat: 25.55215833,
      lng: -106.0218167,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2019,
      lat: 23.66228333,
      lng: -105.5087139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 82.4,
    },
    {
      anio: 2019,
      lat: 22.65543611,
      lng: -104.2881139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.6638,
    },
    {
      anio: 2019,
      lat: 22.67661667,
      lng: -104.2979806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.3325,
    },
    {
      anio: 2019,
      lat: 22.95769444,
      lng: -104.66875,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27.23,
    },
    {
      anio: 2019,
      lat: 22.9825,
      lng: -104.6506194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1,
    },
    {
      anio: 2019,
      lat: 22.97994722,
      lng: -104.6514639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.77,
    },
    {
      anio: 2019,
      lat: 23.60959167,
      lng: -105.7104444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 125.68,
    },
    {
      anio: 2019,
      lat: 23.47094167,
      lng: -105.3993278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2019,
      lat: 25.57340556,
      lng: -105.5803417,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 258,
    },
    {
      anio: 2019,
      lat: 22.93850278,
      lng: -104.6091944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2019,
      lat: 23.62705556,
      lng: -105.6489667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2019,
      lat: 23.64881389,
      lng: -105.6438417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.3,
    },
    {
      anio: 2019,
      lat: 22.56668611,
      lng: -104.3144222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 54.79,
    },
    {
      anio: 2019,
      lat: 24.71235,
      lng: -106.2241528,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2019,
      lat: 24.05150556,
      lng: -105.5517306,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 104.45,
    },
    {
      anio: 2019,
      lat: 24.05068611,
      lng: -105.6562306,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.5,
    },
    {
      anio: 2019,
      lat: 24.73489167,
      lng: -106.1588972,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2019,
      lat: 24.78363056,
      lng: -106.1583667,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 103,
    },
    {
      anio: 2019,
      lat: 24.77800556,
      lng: -106.1404389,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 175,
    },
    {
      anio: 2019,
      lat: 22.97980278,
      lng: -104.6438917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.47,
    },
    {
      anio: 2019,
      lat: 22.95627222,
      lng: -104.6691917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.12,
    },
    {
      anio: 2019,
      lat: 22.97219167,
      lng: -104.4151111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.71,
    },
    {
      anio: 2019,
      lat: 22.85113333,
      lng: -104.4926972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62.48,
    },
    {
      anio: 2019,
      lat: 25.50935833,
      lng: -106.9552778,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.27,
    },
    {
      anio: 2019,
      lat: 24.89174444,
      lng: -106.3716833,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2019,
      lat: 24.83869444,
      lng: -106.2458389,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.47404444,
      lng: -106.9350222,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2,
    },
    {
      anio: 2019,
      lat: 24.84376667,
      lng: -106.2395667,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 5.7,
    },
    {
      anio: 2019,
      lat: 25.03300278,
      lng: -106.2722778,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2019,
      lat: 25.06987222,
      lng: -106.2061389,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2019,
      lat: 22.59617222,
      lng: -104.2876639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.832,
    },
    {
      anio: 2019,
      lat: 22.64110833,
      lng: -104.3310583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 62.228,
    },
    {
      anio: 2019,
      lat: 24.39297778,
      lng: -105.6984944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.37,
    },
    {
      anio: 2019,
      lat: 24.86483611,
      lng: -105.848825,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 24.85405278,
      lng: -105.8936556,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.94,
    },
    {
      anio: 2019,
      lat: 25.05094167,
      lng: -106.0691167,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2019,
      lat: 24.95793333,
      lng: -106.2548889,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 25.05817778,
      lng: -106.079625,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2,
    },
    {
      anio: 2019,
      lat: 25.22499722,
      lng: -106.239075,
      estado: "Durango",
      municipio: "Topia",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.2,
    },
    {
      anio: 2019,
      lat: 25.44763889,
      lng: -106.9313806,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.4,
    },
    {
      anio: 2019,
      lat: 25.37899444,
      lng: -106.9244167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2019,
      lat: 25.33587222,
      lng: -106.9168139,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2,
    },
    {
      anio: 2019,
      lat: 25.4794,
      lng: -106.9158167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2019,
      lat: 25.43727778,
      lng: -106.9262167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.4,
    },
    {
      anio: 2019,
      lat: 24.39482222,
      lng: -105.7694444,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.74,
    },
    {
      anio: 2019,
      lat: 24.33789444,
      lng: -105.7382889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.7,
    },
    {
      anio: 2019,
      lat: 23.82230278,
      lng: -105.3392333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.36,
    },
    {
      anio: 2019,
      lat: 23.53789722,
      lng: -105.4912694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades pecuarias",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 370,
    },
    {
      anio: 2019,
      lat: 23.47725,
      lng: -105.4750389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades pecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2019,
      lat: 25.05068611,
      lng: -106.2699833,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2019,
      lat: 25.42553889,
      lng: -105.683,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Intencional",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 58,
    },
    {
      anio: 2019,
      lat: 22.96862778,
      lng: -104.636175,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.59,
    },
    {
      anio: 2019,
      lat: 22.96419722,
      lng: -104.6691694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.58,
    },
    {
      anio: 2019,
      lat: 24.47181667,
      lng: -105.6942389,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2019,
      lat: 23.72614722,
      lng: -104.3740667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Naturales",
      semana: 28,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 175,
    },
    {
      anio: 2019,
      lat: 25.44320278,
      lng: -106.91595,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.2,
    },
    {
      anio: 2019,
      lat: 25.42411111,
      lng: -106.9219583,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 22.98335833,
      lng: -104.3279472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 98.61,
    },
    {
      anio: 2019,
      lat: 22.89232778,
      lng: -104.5393972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 85.25,
    },
    {
      anio: 2019,
      lat: 22.47270278,
      lng: -104.6447667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1155.65,
    },
    {
      anio: 2019,
      lat: 25.11854444,
      lng: -105.5872528,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 32,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2019,
      lat: 24.43006944,
      lng: -106.1778639,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2019,
      lat: 24.47514444,
      lng: -106.0460083,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2,
    },
    {
      anio: 2019,
      lat: 24.47835278,
      lng: -106.0664944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2018,
      lat: 25.893825,
      lng: -107.6516889,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 136,
    },
    {
      anio: 2020,
      lat: 23.42185,
      lng: -105.7901611,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 136,
    },
    {
      anio: 2025,
      lat: 23.787323,
      lng: -105.99266,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 151,
    },
    {
      anio: 2024,
      lat: 23.518953,
      lng: -105.771515,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 120.6066,
    },
    {
      anio: 2016,
      lat: 26.5855,
      lng: -108.34075,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2025,
      lat: 24.47755,
      lng: -106.74352,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 112,
    },
    {
      anio: 2023,
      lat: 23.486225,
      lng: -105.84014,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Festividades y rituales",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 111.9021,
    },
    {
      anio: 2025,
      lat: 25.823366,
      lng: -107.23805,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 110,
    },
    {
      anio: 2024,
      lat: 26.70057,
      lng: -108.46534,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 109.8551,
    },
    {
      anio: 2017,
      lat: 26.76688889,
      lng: -108.0418056,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Otras causas",
      semana: 48,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95,
    },
    {
      anio: 2025,
      lat: 25.927778,
      lng: -107.657,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95,
    },
    {
      anio: 2025,
      lat: 24.42873,
      lng: -106.67001,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 94,
    },
    {
      anio: 2020,
      lat: 23.43466944,
      lng: -105.9386389,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Otras actividades productivas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2023,
      lat: 26.285803,
      lng: -107.96614,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 87.1402,
    },
    {
      anio: 2020,
      lat: 23.51811111,
      lng: -105.793,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 86,
    },
    {
      anio: 2018,
      lat: 26.81783611,
      lng: -108.0471111,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 85,
    },
    {
      anio: 2020,
      lat: 26.44194444,
      lng: -107.3496111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.19141667,
      lng: -106.8566111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.60327778,
      lng: -107.3131667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 27.0865,
      lng: -107.2117778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2020,
      lat: 26.57797222,
      lng: -107.2943611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 25.87431667,
      lng: -106.8081611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44,
    },
    {
      anio: 2020,
      lat: 26.58748056,
      lng: -107.3008417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2020,
      lat: 27.50675,
      lng: -107.9158056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 27.00102222,
      lng: -107.3518139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.19208333,
      lng: -106.6093889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.25383333,
      lng: -106.49775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 27.48459167,
      lng: -107.8591889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39,
    },
    {
      anio: 2020,
      lat: 26.82991667,
      lng: -107.08875,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.75697222,
      lng: -107.2663611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 27.14013889,
      lng: -107.4850806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.20988889,
      lng: -106.895,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 25.70744444,
      lng: -106.9037778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 27.01269167,
      lng: -107.5711167,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2020,
      lat: 25.70212778,
      lng: -106.8991389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.33261111,
      lng: -106.7488889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2020,
      lat: 27.30738333,
      lng: -107.9393167,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 26.90669444,
      lng: -107.1825556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.13091389,
      lng: -106.8229278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 27.25436111,
      lng: -107.8255833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.28597778,
      lng: -106.8088056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.37211111,
      lng: -107.3464167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.95015833,
      lng: -107.0024611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.93202778,
      lng: -107.4690167,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.69859167,
      lng: -106.9585639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 103,
    },
    {
      anio: 2020,
      lat: 25.8805,
      lng: -106.7286944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.22,
    },
    {
      anio: 2020,
      lat: 26.56998333,
      lng: -107.3005528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 114.9,
    },
    {
      anio: 2020,
      lat: 26.59675556,
      lng: -107.5072861,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70.5,
    },
    {
      anio: 2020,
      lat: 27.54474444,
      lng: -108.0022639,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2020,
      lat: 25.96344444,
      lng: -106.5200556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.77639167,
      lng: -107.8039944,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 133,
    },
    {
      anio: 2020,
      lat: 27.54266667,
      lng: -107.8221389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2020,
      lat: 27.159,
      lng: -107.3921667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.19,
    },
    {
      anio: 2020,
      lat: 26.90121667,
      lng: -107.0094167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.79852778,
      lng: -107.1794444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.85947222,
      lng: -107.1483056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.85023889,
      lng: -107.1399444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.85025,
      lng: -107.1403889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 27.45246111,
      lng: -107.9275278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2020,
      lat: 25.80929064,
      lng: -106.806271,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.54152778,
      lng: -107.3158056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 27.12711111,
      lng: -108.0000139,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2020,
      lat: 26.57958611,
      lng: -107.4966583,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 68,
    },
    {
      anio: 2020,
      lat: 26.61458333,
      lng: -107.5455278,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2020,
      lat: 25.80327778,
      lng: -106.8095,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2020,
      lat: 25.66033333,
      lng: -106.900975,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 26.20663889,
      lng: -106.4974444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2020,
      lat: 26.12405833,
      lng: -106.8099389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 25.72825,
      lng: -106.8768056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 26.84436111,
      lng: -107.0814444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.806,
      lng: -107.0999444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2020,
      lat: 26.90013056,
      lng: -107.1730556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2020,
      lat: 26.72,
      lng: -107.273,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.3,
    },
    {
      anio: 2020,
      lat: 26.90855556,
      lng: -107.1833722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.84013889,
      lng: -107.0607778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2020,
      lat: 26.71500556,
      lng: -107.1860278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.90844444,
      lng: -107.1986667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1,
    },
    {
      anio: 2020,
      lat: 26.88008333,
      lng: -107.3179583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.15,
    },
    {
      anio: 2020,
      lat: 26.971675,
      lng: -107.1492306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2020,
      lat: 27.14365833,
      lng: -107.3207028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 27.09436111,
      lng: -107.2795806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.24,
    },
    {
      anio: 2020,
      lat: 26.8334,
      lng: -107.1123861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2020,
      lat: 27.03721944,
      lng: -107.1580056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 27.19536111,
      lng: -107.0528111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 27.14993889,
      lng: -107.3672778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.10245,
      lng: -106.8064722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 27.53374722,
      lng: -107.9073028,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.3,
    },
    {
      anio: 2020,
      lat: 27.12789444,
      lng: -107.3029472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.25,
    },
    {
      anio: 2020,
      lat: 26.51851389,
      lng: -107.2932944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2020,
      lat: 26.17804444,
      lng: -107.4103306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2020,
      lat: 26.07797222,
      lng: -107.0475833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2020,
      lat: 25.97891667,
      lng: -107.0917222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2020,
      lat: 27.06908333,
      lng: -108.3376278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1015,
    },
    {
      anio: 2020,
      lat: 25.92702778,
      lng: -107.0552778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.00980556,
      lng: -107.1910556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.31397222,
      lng: -106.5881944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2020,
      lat: 26.87144444,
      lng: -107.018625,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2020,
      lat: 27.02630278,
      lng: -107.0938361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.09776667,
      lng: -106.9858139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.11575833,
      lng: -106.9425556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.90406389,
      lng: -106.7693194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2020,
      lat: 25.91096944,
      lng: -106.8878667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.16618333,
      lng: -107.4234361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.8,
    },
    {
      anio: 2020,
      lat: 27.18971944,
      lng: -108.350325,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2020,
      lat: 27.50171944,
      lng: -107.6815361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 255,
    },
    {
      anio: 2020,
      lat: 26.97956944,
      lng: -107.3648222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2020,
      lat: 26.00670556,
      lng: -106.7013139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.18761944,
      lng: -106.8355389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.08085278,
      lng: -106.8192167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.29775278,
      lng: -107.4679944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2020,
      lat: 27.58998333,
      lng: -107.8398389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.18809167,
      lng: -106.8139667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 27.10579444,
      lng: -107.8740444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 26.10217778,
      lng: -106.8179861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 26.38829167,
      lng: -106.8141611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2020,
      lat: 27.10206944,
      lng: -107.88485,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.21,
    },
    {
      anio: 2020,
      lat: 27.36140833,
      lng: -107.5099139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 27.48777778,
      lng: -107.6244861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2020,
      lat: 27.47008056,
      lng: -107.630925,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 136,
    },
    {
      anio: 2020,
      lat: 26.08458056,
      lng: -106.7115,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2020,
      lat: 26.35505556,
      lng: -106.8749722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2020,
      lat: 26.10508333,
      lng: -106.84725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 26.16430556,
      lng: -106.8962222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 56,
    },
    {
      anio: 2020,
      lat: 26.02498889,
      lng: -107.0767778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 26.17547222,
      lng: -107.3890833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 27.57897222,
      lng: -107.4740833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 27.52377222,
      lng: -107.5832583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 59,
    },
    {
      anio: 2020,
      lat: 27.558675,
      lng: -107.6936778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 26.03430278,
      lng: -106.9596722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.05123611,
      lng: -106.9901639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 26.80874444,
      lng: -107.0990778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.56,
    },
    {
      anio: 2020,
      lat: 26.72635833,
      lng: -107.1388639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.56,
    },
    {
      anio: 2020,
      lat: 26.79927222,
      lng: -107.2419194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.73,
    },
    {
      anio: 2020,
      lat: 26.899,
      lng: -106.9827778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.85,
    },
    {
      anio: 2020,
      lat: 26.73066667,
      lng: -107.1006,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.67,
    },
    {
      anio: 2020,
      lat: 26.81611111,
      lng: -107.0306944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.49,
    },
    {
      anio: 2020,
      lat: 26.17780556,
      lng: -106.8045,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.03147222,
      lng: -106.7478333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 26.90087778,
      lng: -107.1878333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 26.19102778,
      lng: -106.8641667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 27.59358333,
      lng: -107.6799722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 27.02858333,
      lng: -107.3547222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 26.16835833,
      lng: -106.8583056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2020,
      lat: 26.12755556,
      lng: -106.8512389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2020,
      lat: 26.05583056,
      lng: -106.9982917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2020,
      lat: 25.83756111,
      lng: -106.84215,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.52788611,
      lng: -107.2795889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 26.45069722,
      lng: -107.2035444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.36855833,
      lng: -107.3650639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.3,
    },
    {
      anio: 2020,
      lat: 26.23164444,
      lng: -107.4692139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2020,
      lat: 26.07991111,
      lng: -107.0133639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.06024722,
      lng: -106.9997722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2020,
      lat: 26.03515556,
      lng: -106.8318611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.12717222,
      lng: -106.8594028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 26.020325,
      lng: -106.7253806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.70835833,
      lng: -106.9158306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2020,
      lat: 26.32698889,
      lng: -106.7584444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2020,
      lat: 26.17776389,
      lng: -106.8508806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.66821389,
      lng: -107.7613611,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 77.05,
    },
    {
      anio: 2020,
      lat: 26.69090833,
      lng: -107.1919889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.97,
    },
    {
      anio: 2020,
      lat: 27.58645833,
      lng: -107.6595639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 25.70621667,
      lng: -106.7683417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.46998056,
      lng: -107.2642194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2020,
      lat: 26.32645,
      lng: -106.7326333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.47586111,
      lng: -107.2625583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.43171667,
      lng: -107.3210889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 27.38286944,
      lng: -107.5893944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 229,
    },
    {
      anio: 2020,
      lat: 27.40375833,
      lng: -107.3048333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.5,
    },
    {
      anio: 2020,
      lat: 26.15940278,
      lng: -106.5813667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.17728611,
      lng: -106.6907,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 27.53558889,
      lng: -107.8205972,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6,
    },
    {
      anio: 2020,
      lat: 25.97505556,
      lng: -107.0120611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2020,
      lat: 26.1544,
      lng: -106.99755,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2020,
      lat: 26.42061389,
      lng: -107.1600306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.10308889,
      lng: -107.0016306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.34271389,
      lng: -107.1749806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.4091,
      lng: -107.5448806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2020,
      lat: 26.34724444,
      lng: -107.5298083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 75,
    },
    {
      anio: 2020,
      lat: 26.92919167,
      lng: -107.4125917,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 27.30311944,
      lng: -108.3028278,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades pecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 129,
    },
    {
      anio: 2020,
      lat: 27.43005833,
      lng: -108.3395944,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades pecuarias",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 52,
    },
    {
      anio: 2020,
      lat: 25.70278889,
      lng: -106.8864028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.90748056,
      lng: -107.2571222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.764175,
      lng: -107.2619444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.43118611,
      lng: -107.5267306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2020,
      lat: 27.64746389,
      lng: -108.1394667,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2020,
      lat: 26.04111944,
      lng: -106.9069222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.80360556,
      lng: -106.7262222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.807525,
      lng: -106.637425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2020,
      lat: 25.80708611,
      lng: -106.6999111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 25.86432778,
      lng: -106.8503306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.88960278,
      lng: -106.9293861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.91159167,
      lng: -106.9835778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.93747222,
      lng: -106.9451278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.89288056,
      lng: -106.9448417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.40441944,
      lng: -107.2697972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.9208,
      lng: -106.7444806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.91830556,
      lng: -106.76825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.73871944,
      lng: -106.8783417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.74298333,
      lng: -106.878825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.83507778,
      lng: -106.6890528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.10171667,
      lng: -106.9547306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.08762222,
      lng: -107.0176806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.11066944,
      lng: -106.9798778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.16978333,
      lng: -107.0448222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.09138889,
      lng: -106.8230556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.28198333,
      lng: -106.8023583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 26.34511667,
      lng: -106.9072694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.39938333,
      lng: -106.9433694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.13591389,
      lng: -106.7555111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.13695278,
      lng: -106.8713694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 26.27778611,
      lng: -106.7395694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.10076111,
      lng: -106.5640528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 26.06997778,
      lng: -106.7917556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.35418056,
      lng: -106.7768556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 26.47125833,
      lng: -107.2900778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.72034722,
      lng: -106.8819722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.71745556,
      lng: -106.8817667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 25.65028889,
      lng: -106.8433917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.75215833,
      lng: -106.7056806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.70864722,
      lng: -106.8002667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 25.79776389,
      lng: -106.6750167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 25.79763889,
      lng: -106.6374833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.9033,
      lng: -106.7824111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.76673889,
      lng: -106.83345,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.70334722,
      lng: -106.9035583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.46214444,
      lng: -107.2439667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.11300833,
      lng: -106.7744056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.08946111,
      lng: -106.7659639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.09553056,
      lng: -106.7516333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.19267222,
      lng: -106.6383889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.24184444,
      lng: -106.62545,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.08515278,
      lng: -106.7882222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.21584444,
      lng: -106.6003806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 25.77048611,
      lng: -106.8856333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.40671111,
      lng: -107.2841778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 27.55259444,
      lng: -107.6903444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.15,
    },
    {
      anio: 2020,
      lat: 27.63683333,
      lng: -107.6305833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.84,
    },
    {
      anio: 2020,
      lat: 26.90505833,
      lng: -107.2598889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 26.92613056,
      lng: -107.4197028,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fogatas",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 27.60322222,
      lng: -107.6647778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.90705556,
      lng: -107.6103889,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.74036111,
      lng: -107.1841,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.1,
    },
    {
      anio: 2020,
      lat: 26.77281389,
      lng: -107.1049278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.18,
    },
    {
      anio: 2020,
      lat: 26.77530556,
      lng: -107.1026833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.17,
    },
    {
      anio: 2020,
      lat: 26.77727778,
      lng: -107.0996111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.46,
    },
    {
      anio: 2020,
      lat: 26.77705556,
      lng: -107.1007361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.57,
    },
    {
      anio: 2020,
      lat: 26.78074167,
      lng: -107.0992861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.97,
    },
    {
      anio: 2020,
      lat: 26.73458333,
      lng: -107.1996667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.95,
    },
    {
      anio: 2020,
      lat: 26.78236111,
      lng: -107.0973056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.33,
    },
    {
      anio: 2020,
      lat: 26.80686111,
      lng: -107.2568889,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.33,
    },
    {
      anio: 2020,
      lat: 26.96586111,
      lng: -107.2139444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.45,
    },
    {
      anio: 2020,
      lat: 26.72007778,
      lng: -107.2133694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.82680556,
      lng: -107.0954167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.41,
    },
    {
      anio: 2020,
      lat: 26.82705278,
      lng: -107.1052417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.89,
    },
    {
      anio: 2020,
      lat: 26.81807778,
      lng: -107.0299722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.72,
    },
    {
      anio: 2020,
      lat: 26.54716111,
      lng: -107.6542278,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 52.26,
    },
    {
      anio: 2020,
      lat: 26.50398333,
      lng: -107.8117861,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades ilícitas",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.52994444,
      lng: -107.7415,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2020,
      lat: 25.65299444,
      lng: -106.8487861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 25.68336111,
      lng: -106.76795,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.40401389,
      lng: -107.293325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.40825278,
      lng: -107.279825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8,
    },
    {
      anio: 2020,
      lat: 25.90078333,
      lng: -106.7526528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.89705278,
      lng: -106.7502694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.9051,
      lng: -106.7707833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.72449722,
      lng: -106.8787194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.86928056,
      lng: -106.7849694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.92733889,
      lng: -106.7844417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.90727778,
      lng: -106.7696389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.942875,
      lng: -106.7428722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 25.91838889,
      lng: -106.7615417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.95821111,
      lng: -106.7375806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 25.96586944,
      lng: -106.7413528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 25.95817222,
      lng: -106.7112417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 25.91965556,
      lng: -106.7937611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.97461111,
      lng: -106.7671056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.09049722,
      lng: -106.7576806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.20973333,
      lng: -106.5991861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.00265,
      lng: -106.7101389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.24323889,
      lng: -106.6329167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 26.20150278,
      lng: -106.8521444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2020,
      lat: 26.22674167,
      lng: -106.7392111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.04249722,
      lng: -106.7225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.35325833,
      lng: -106.8888778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.14599167,
      lng: -106.7586139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2020,
      lat: 26.19183889,
      lng: -106.8417028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 25.99926389,
      lng: -107.0025306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 25.88910833,
      lng: -106.8249528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades pecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.90525,
      lng: -106.8296139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.86237778,
      lng: -106.7818417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.87126389,
      lng: -106.81725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.07460833,
      lng: -106.9645611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.11094722,
      lng: -107.0343583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.04830556,
      lng: -106.9213194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 26.04693611,
      lng: -106.9203278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.71845278,
      lng: -106.8400583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades pecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.46103333,
      lng: -107.2880417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 25.91136389,
      lng: -106.9598806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.91373611,
      lng: -106.9422389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 26.18756111,
      lng: -106.7374833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 26.319775,
      lng: -106.73845,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 26.402775,
      lng: -106.936825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.15180833,
      lng: -106.5847944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.31473333,
      lng: -106.7328306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.40461389,
      lng: -106.929325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.36938889,
      lng: -106.8944944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.02581944,
      lng: -106.9514778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 26.07881944,
      lng: -106.9430306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.71241667,
      lng: -106.6623861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.70173889,
      lng: -106.6507361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 25.70211389,
      lng: -106.6679833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2020,
      lat: 26.08663611,
      lng: -106.8909889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 26.04564722,
      lng: -106.9150028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2020,
      lat: 26.06890556,
      lng: -106.8540111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.92922222,
      lng: -106.9131917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.93752222,
      lng: -106.9510972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 25.86752222,
      lng: -106.9502889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2020,
      lat: 27.56486111,
      lng: -107.5037333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 41,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2020,
      lat: 26.45335556,
      lng: -107.2312611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 41,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2020,
      lat: 27.13185278,
      lng: -108.1762806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 45,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2020,
      lat: 26.76647222,
      lng: -107.2708333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 45,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2020,
      lat: 26.80115278,
      lng: -107.1555111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 45,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2020,
      lat: 26.78120833,
      lng: -107.0799056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 44,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.7,
    },
    {
      anio: 2020,
      lat: 26.82465278,
      lng: -107.0901667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 44,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2020,
      lat: 27.59635833,
      lng: -108.0732694,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 46,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2020,
      lat: 27.50473056,
      lng: -108.0499139,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 46,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.5,
    },
    {
      anio: 2020,
      lat: 27.02835278,
      lng: -107.2022944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 46,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2020,
      lat: 27.06089444,
      lng: -107.2434667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 46,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 15,
    },
    {
      anio: 2020,
      lat: 26.87480556,
      lng: -107.4503083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 46,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 64,
    },
    {
      anio: 2020,
      lat: 26.77630278,
      lng: -107.3917694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 46,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2020,
      lat: 26.36409444,
      lng: -107.1932639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 46,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 26.90269444,
      lng: -107.4271167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 47,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2020,
      lat: 26.88133333,
      lng: -107.3881111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 47,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2020,
      lat: 26.21834722,
      lng: -107.1088611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 47,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2020,
      lat: 26.86828611,
      lng: -107.3821944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 48,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2020,
      lat: 26.39788889,
      lng: -107.2361944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 48,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 26.77147222,
      lng: -107.3463333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 48,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2020,
      lat: 26.39594444,
      lng: -107.2363056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 48,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 23.81701389,
      lng: -105.3127,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 23.47152778,
      lng: -104.6936111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 61,
    },
    {
      anio: 2020,
      lat: 24.96598333,
      lng: -105.9833639,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 24.765575,
      lng: -106.1260472,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 24.43165556,
      lng: -105.7924833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2020,
      lat: 24.27316111,
      lng: -105.6915694,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.47761944,
      lng: -106.9250694,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1,
    },
    {
      anio: 2020,
      lat: 23.64866111,
      lng: -105.6291278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.8,
    },
    {
      anio: 2020,
      lat: 22.61450833,
      lng: -104.2828278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.22,
    },
    {
      anio: 2020,
      lat: 24.10701667,
      lng: -105.7420944,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 23.59041389,
      lng: -105.3852917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.35,
    },
    {
      anio: 2020,
      lat: 22.63165,
      lng: -104.2771556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.09854444,
      lng: -106.5367972,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 24.29818611,
      lng: -105.5333361,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.69,
    },
    {
      anio: 2020,
      lat: 23.58276111,
      lng: -105.3737583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.56,
    },
    {
      anio: 2020,
      lat: 22.83887222,
      lng: -104.5186889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.07,
    },
    {
      anio: 2020,
      lat: 23.66476111,
      lng: -105.6813,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.5,
    },
    {
      anio: 2020,
      lat: 23.01715278,
      lng: -104.2753722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.6,
    },
    {
      anio: 2020,
      lat: 23.02248056,
      lng: -104.3291139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 37.63,
    },
    {
      anio: 2020,
      lat: 22.84989722,
      lng: -104.492925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.03,
    },
    {
      anio: 2020,
      lat: 23.30901944,
      lng: -104.8310972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 22.94321389,
      lng: -104.6183,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.94,
    },
    {
      anio: 2020,
      lat: 23.81133889,
      lng: -105.7168333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.2,
    },
    {
      anio: 2020,
      lat: 22.89274167,
      lng: -104.513125,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.33,
    },
    {
      anio: 2020,
      lat: 23.19789444,
      lng: -105.1495778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.5,
    },
    {
      anio: 2020,
      lat: 23.45386389,
      lng: -105.0162972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.35,
    },
    {
      anio: 2020,
      lat: 22.87399444,
      lng: -104.5010583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 22.88630556,
      lng: -104.5105833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2020,
      lat: 22.78711944,
      lng: -104.3123639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.258,
    },
    {
      anio: 2020,
      lat: 23.45598889,
      lng: -105.3163639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.5,
    },
    {
      anio: 2020,
      lat: 24.23021111,
      lng: -105.6472917,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 561,
    },
    {
      anio: 2020,
      lat: 22.6188,
      lng: -104.3085944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.82,
    },
    {
      anio: 2020,
      lat: 24.968925,
      lng: -105.9824083,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 22.93441667,
      lng: -104.5176861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.15,
    },
    {
      anio: 2020,
      lat: 22.64526944,
      lng: -104.6944389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 22.67754444,
      lng: -104.3344778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.58,
    },
    {
      anio: 2020,
      lat: 23.28882222,
      lng: -104.8466056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 23.79189167,
      lng: -105.3725444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.5,
    },
    {
      anio: 2020,
      lat: 23.80684167,
      lng: -105.3642167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.8,
    },
    {
      anio: 2020,
      lat: 23.78983889,
      lng: -105.3642556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2020,
      lat: 22.84998611,
      lng: -104.7501417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.8,
    },
    {
      anio: 2020,
      lat: 22.87767778,
      lng: -104.5449417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Quema de basureros",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2020,
      lat: 23.75992222,
      lng: -105.4128611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4,
    },
    {
      anio: 2020,
      lat: 23.56601667,
      lng: -105.3406278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 67.4,
    },
    {
      anio: 2020,
      lat: 23.03583056,
      lng: -104.3645111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.496,
    },
    {
      anio: 2020,
      lat: 22.95249444,
      lng: -104.4456167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.37,
    },
    {
      anio: 2020,
      lat: 22.66171944,
      lng: -104.3261667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2020,
      lat: 22.61993056,
      lng: -104.3207917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.05,
    },
    {
      anio: 2020,
      lat: 22.90346944,
      lng: -104.8148944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.79,
    },
    {
      anio: 2020,
      lat: 22.87993611,
      lng: -104.8216417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2020,
      lat: 23.31635556,
      lng: -105.0029611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2020,
      lat: 22.79411111,
      lng: -104.5150361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1,
    },
    {
      anio: 2020,
      lat: 22.66686111,
      lng: -104.4847583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2020,
      lat: 23.40405278,
      lng: -104.7686111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 22.81355,
      lng: -104.5083972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.841,
    },
    {
      anio: 2020,
      lat: 25.41574722,
      lng: -106.8802694,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 22.88250833,
      lng: -104.7824194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 23.00343056,
      lng: -104.5384056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.92,
    },
    {
      anio: 2020,
      lat: 23.02026944,
      lng: -104.6333306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.8,
    },
    {
      anio: 2020,
      lat: 22.68904722,
      lng: -104.2817361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.51,
    },
    {
      anio: 2020,
      lat: 23.48665,
      lng: -104.9248694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41,
    },
    {
      anio: 2020,
      lat: 24.28897778,
      lng: -105.6886111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.5,
    },
    {
      anio: 2020,
      lat: 23.54979167,
      lng: -105.3951389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1,
    },
    {
      anio: 2020,
      lat: 22.93874722,
      lng: -104.5636778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.18,
    },
    {
      anio: 2020,
      lat: 22.47526389,
      lng: -104.640625,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2020,
      lat: 22.80970833,
      lng: -104.5476667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.485,
    },
    {
      anio: 2020,
      lat: 22.67038333,
      lng: -104.3344056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.112,
    },
    {
      anio: 2020,
      lat: 23.023975,
      lng: -104.371075,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.117,
    },
    {
      anio: 2020,
      lat: 22.56396389,
      lng: -104.3304639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.252,
    },
    {
      anio: 2020,
      lat: 25.40511667,
      lng: -106.8719333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 600.3,
    },
    {
      anio: 2020,
      lat: 24.32635833,
      lng: -106.0617917,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 352,
    },
    {
      anio: 2020,
      lat: 24.93989167,
      lng: -106.15695,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 80.1,
    },
    {
      anio: 2020,
      lat: 23.39194444,
      lng: -105.1143167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 23.02243056,
      lng: -104.2120389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 148,
    },
    {
      anio: 2020,
      lat: 23.57803056,
      lng: -105.3289194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.7,
    },
    {
      anio: 2020,
      lat: 23.79200278,
      lng: -105.3672111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 22.49386111,
      lng: -104.4831472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 9.07,
    },
    {
      anio: 2020,
      lat: 23.00621389,
      lng: -104.6441306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.01,
    },
    {
      anio: 2020,
      lat: 24.09020556,
      lng: -105.5848333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2020,
      lat: 22.61915556,
      lng: -104.3157528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 124.94,
    },
    {
      anio: 2020,
      lat: 24.98372222,
      lng: -106.2024917,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.6,
    },
    {
      anio: 2020,
      lat: 22.92004167,
      lng: -104.7257889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.5,
    },
    {
      anio: 2020,
      lat: 22.92317778,
      lng: -104.6345806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.54,
    },
    {
      anio: 2020,
      lat: 23.47865,
      lng: -104.9234389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.28,
    },
    {
      anio: 2020,
      lat: 22.98444444,
      lng: -104.6310306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.78,
    },
    {
      anio: 2020,
      lat: 24.12257778,
      lng: -105.7111167,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.38,
    },
    {
      anio: 2020,
      lat: 22.95040556,
      lng: -104.6201111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.06,
    },
    {
      anio: 2020,
      lat: 22.84251944,
      lng: -104.5210306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.61,
    },
    {
      anio: 2020,
      lat: 22.69707222,
      lng: -104.4882583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 47.74,
    },
    {
      anio: 2020,
      lat: 23.07984167,
      lng: -104.2196639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.45,
    },
    {
      anio: 2020,
      lat: 22.79512222,
      lng: -104.5118194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.1,
    },
    {
      anio: 2020,
      lat: 25.00066389,
      lng: -106.8424667,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 23.08591944,
      lng: -104.3242861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.7,
    },
    {
      anio: 2020,
      lat: 24.50025,
      lng: -106.6026444,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2020,
      lat: 23.01713333,
      lng: -104.3737583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2020,
      lat: 24.05506389,
      lng: -105.9370028,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 113,
    },
    {
      anio: 2020,
      lat: 23.27841389,
      lng: -105.0116306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2020,
      lat: 22.85473333,
      lng: -104.4925806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.38,
    },
    {
      anio: 2020,
      lat: 23.47796667,
      lng: -104.9259333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Transportes",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.28,
    },
    {
      anio: 2020,
      lat: 25.07753611,
      lng: -106.4918639,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 22.77280556,
      lng: -104.2296361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 141.1,
    },
    {
      anio: 2020,
      lat: 22.61830556,
      lng: -104.3024639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.42,
    },
    {
      anio: 2020,
      lat: 23.55229444,
      lng: -105.74735,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2020,
      lat: 22.9639,
      lng: -104.7318778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2020,
      lat: 23.04135278,
      lng: -104.1977,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.47,
    },
    {
      anio: 2020,
      lat: 23.03513611,
      lng: -104.2057167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 34,
    },
    {
      anio: 2020,
      lat: 23.00665833,
      lng: -104.5381667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.94,
    },
    {
      anio: 2020,
      lat: 23.83871111,
      lng: -105.2816083,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2020,
      lat: 22.87497222,
      lng: -104.4967861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.65,
    },
    {
      anio: 2020,
      lat: 24.12949167,
      lng: -105.689875,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2020,
      lat: 23.02217222,
      lng: -104.3582667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.03,
    },
    {
      anio: 2020,
      lat: 22.92794722,
      lng: -104.5801333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.32,
    },
    {
      anio: 2020,
      lat: 22.92196667,
      lng: -104.6945528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 66.75,
    },
    {
      anio: 2020,
      lat: 22.80865278,
      lng: -104.5124556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.57,
    },
    {
      anio: 2020,
      lat: 22.83556111,
      lng: -104.5150056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.71,
    },
    {
      anio: 2020,
      lat: 22.72097222,
      lng: -104.5258778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 88.34,
    },
    {
      anio: 2020,
      lat: 22.97187222,
      lng: -104.6453278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.88,
    },
    {
      anio: 2020,
      lat: 22.97384167,
      lng: -104.6533694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.77,
    },
    {
      anio: 2020,
      lat: 25.09606389,
      lng: -106.1994917,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.49,
    },
    {
      anio: 2020,
      lat: 22.919675,
      lng: -104.6843972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 75.1,
    },
    {
      anio: 2020,
      lat: 24.52465278,
      lng: -105.7216528,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 74.4,
    },
    {
      anio: 2020,
      lat: 23.39360556,
      lng: -105.3618028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 71.56,
    },
    {
      anio: 2020,
      lat: 24.35478056,
      lng: -105.5720194,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.9,
    },
    {
      anio: 2020,
      lat: 23.02835,
      lng: -104.2336306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2020,
      lat: 23.29370556,
      lng: -104.8274806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2020,
      lat: 24.68821944,
      lng: -105.6605389,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 573,
    },
    {
      anio: 2020,
      lat: 24.08091111,
      lng: -105.51005,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.35,
    },
    {
      anio: 2020,
      lat: 23.10527222,
      lng: -105.0338917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 501,
    },
    {
      anio: 2020,
      lat: 22.82763333,
      lng: -104.5146667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.08,
    },
    {
      anio: 2020,
      lat: 22.73849722,
      lng: -104.5430306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 70.09,
    },
    {
      anio: 2020,
      lat: 23.29505278,
      lng: -105.3905806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.21,
    },
    {
      anio: 2020,
      lat: 22.87533333,
      lng: -104.7987528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.72,
    },
    {
      anio: 2020,
      lat: 22.49923056,
      lng: -104.6329028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1221,
    },
    {
      anio: 2020,
      lat: 22.76913889,
      lng: -104.5164806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.39,
    },
    {
      anio: 2020,
      lat: 23.02167222,
      lng: -104.6051694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.93,
    },
    {
      anio: 2020,
      lat: 22.55864167,
      lng: -104.3319917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.46,
    },
    {
      anio: 2020,
      lat: 23.26799722,
      lng: -104.830175,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 23.39769167,
      lng: -105.1221972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 88,
    },
    {
      anio: 2020,
      lat: 23.43475,
      lng: -105.0314194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 23.03427222,
      lng: -104.1987583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.53,
    },
    {
      anio: 2020,
      lat: 24.45392222,
      lng: -106.2198111,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2020,
      lat: 22.61648889,
      lng: -104.683475,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 23.12059444,
      lng: -105.1168972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 39,
    },
    {
      anio: 2020,
      lat: 23.03041944,
      lng: -105.23875,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 928,
    },
    {
      anio: 2020,
      lat: 22.96049444,
      lng: -105.30185,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 325,
    },
    {
      anio: 2020,
      lat: 23.18972222,
      lng: -105.133775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2020,
      lat: 23.10829722,
      lng: -105.0919583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2020,
      lat: 23.10823889,
      lng: -105.1301306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2020,
      lat: 23.17418333,
      lng: -105.0428694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 72,
    },
    {
      anio: 2020,
      lat: 23.15766944,
      lng: -105.0429028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2020,
      lat: 23.32762778,
      lng: -104.3270417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 156.8,
    },
    {
      anio: 2020,
      lat: 22.94598611,
      lng: -104.8082778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.21,
    },
    {
      anio: 2020,
      lat: 23.79109444,
      lng: -105.3660667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2020,
      lat: 23.10915833,
      lng: -104.3611667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 23.58341111,
      lng: -105.2916278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 192,
    },
    {
      anio: 2020,
      lat: 22.93695278,
      lng: -104.4872833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.86,
    },
    {
      anio: 2020,
      lat: 23.51918611,
      lng: -105.3417389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.84,
    },
    {
      anio: 2020,
      lat: 23.63005278,
      lng: -105.5120611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2020,
      lat: 23.10849444,
      lng: -105.0876111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 316.5,
    },
    {
      anio: 2020,
      lat: 25.00263611,
      lng: -106.5426556,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 23.44536111,
      lng: -105.4826,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.4,
    },
    {
      anio: 2020,
      lat: 22.67912222,
      lng: -104.3409861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.7,
    },
    {
      anio: 2020,
      lat: 23.57641389,
      lng: -105.3023583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.3,
    },
    {
      anio: 2020,
      lat: 22.80973056,
      lng: -104.7110694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 75.21,
    },
    {
      anio: 2020,
      lat: 22.93816389,
      lng: -104.4896639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 98.28,
    },
    {
      anio: 2020,
      lat: 22.57950556,
      lng: -104.6349667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 362,
    },
    {
      anio: 2020,
      lat: 25.10001111,
      lng: -106.1357389,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.35,
    },
    {
      anio: 2020,
      lat: 24.74226944,
      lng: -105.688,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 72,
    },
    {
      anio: 2020,
      lat: 23.10395556,
      lng: -104.34865,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 226,
    },
    {
      anio: 2020,
      lat: 22.99125833,
      lng: -104.5671306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.42,
    },
    {
      anio: 2020,
      lat: 22.59453056,
      lng: -104.3010083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.82,
    },
    {
      anio: 2020,
      lat: 22.86643056,
      lng: -104.4957306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2020,
      lat: 23.31777778,
      lng: -104.9481917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2020,
      lat: 25.25443333,
      lng: -106.6225194,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 23.01488056,
      lng: -104.6123694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.8,
    },
    {
      anio: 2020,
      lat: 22.82295556,
      lng: -104.4792139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.36,
    },
    {
      anio: 2020,
      lat: 23.04165833,
      lng: -104.6081694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.06,
    },
    {
      anio: 2020,
      lat: 23.07541944,
      lng: -104.2364,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.93,
    },
    {
      anio: 2020,
      lat: 22.98336111,
      lng: -104.6510639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.79,
    },
    {
      anio: 2020,
      lat: 22.96531944,
      lng: -104.5958139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.02,
    },
    {
      anio: 2020,
      lat: 23.36001667,
      lng: -104.9158,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2020,
      lat: 22.87765833,
      lng: -104.6062028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.15,
    },
    {
      anio: 2020,
      lat: 23.44346944,
      lng: -105.0165444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2020,
      lat: 23.35755833,
      lng: -104.81205,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 22.97353889,
      lng: -104.5740056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.29,
    },
    {
      anio: 2020,
      lat: 22.97357778,
      lng: -104.584675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.51,
    },
    {
      anio: 2020,
      lat: 22.91412778,
      lng: -104.6357722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.1,
    },
    {
      anio: 2020,
      lat: 23.45882222,
      lng: -105.5105333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 66.26,
    },
    {
      anio: 2020,
      lat: 23.31849444,
      lng: -105.4873556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.78,
    },
    {
      anio: 2020,
      lat: 23.28038056,
      lng: -105.3625639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 76.72,
    },
    {
      anio: 2020,
      lat: 23.26886667,
      lng: -105.5488944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 107.4,
    },
    {
      anio: 2020,
      lat: 23.23366111,
      lng: -105.3670139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 141.5,
    },
    {
      anio: 2020,
      lat: 25.48596667,
      lng: -106.9314917,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.97,
    },
    {
      anio: 2020,
      lat: 24.49674722,
      lng: -106.0129306,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50.05,
    },
    {
      anio: 2020,
      lat: 24.31224722,
      lng: -105.98515,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.8,
    },
    {
      anio: 2020,
      lat: 24.76848056,
      lng: -106.6928083,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 78,
    },
    {
      anio: 2020,
      lat: 24.50795833,
      lng: -106.1734111,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 251.13,
    },
    {
      anio: 2020,
      lat: 24.74863056,
      lng: -106.0626056,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 185,
    },
    {
      anio: 2020,
      lat: 22.88970556,
      lng: -104.7455306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 24.75543333,
      lng: -106.6862972,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 130,
    },
    {
      anio: 2020,
      lat: 22.91388056,
      lng: -104.5102583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.773,
    },
    {
      anio: 2020,
      lat: 24.80871667,
      lng: -106.1480611,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2020,
      lat: 24.68358056,
      lng: -105.9909139,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.76,
    },
    {
      anio: 2020,
      lat: 24.717875,
      lng: -105.9893333,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2020,
      lat: 24.70196111,
      lng: -105.9805472,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2020,
      lat: 24.71602222,
      lng: -105.9854528,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 24.64756111,
      lng: -105.9808722,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2020,
      lat: 24.73989167,
      lng: -106.0868167,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.5,
    },
    {
      anio: 2020,
      lat: 24.61467778,
      lng: -106.6258944,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2020,
      lat: 24.92325833,
      lng: -106.6503722,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2020,
      lat: 24.95673611,
      lng: -106.947075,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2015,
      lat: 24.26780556,
      lng: -106.4669722,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 84.03,
    },
    {
      anio: 2021,
      lat: 23.57027778,
      lng: -105.8127778,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 82,
    },
    {
      anio: 2022,
      lat: 25.920986,
      lng: -107.567535,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 81,
    },
    {
      anio: 2015,
      lat: 26.65541667,
      lng: -108.1990556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2017,
      lat: 26.80477778,
      lng: -108.1478333,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 23.41228611,
      lng: -105.8020556,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Severo",
      superficie: 77,
    },
    {
      anio: 2022,
      lat: 26.633055,
      lng: -108.374664,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 76,
    },
    {
      anio: 2016,
      lat: 26.81919444,
      lng: -108.2060833,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 75,
    },
    {
      anio: 2021,
      lat: 25.96620556,
      lng: -107.5214361,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 74,
    },
    {
      anio: 2022,
      lat: 26.65264,
      lng: -108.36925,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 73,
    },
    {
      anio: 2016,
      lat: 25.87010556,
      lng: -107.6640806,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2017,
      lat: 25.80207778,
      lng: -107.61595,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2022,
      lat: 26.65821,
      lng: -108.64501,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Selva Baja Espinosa Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2024,
      lat: 26.74216,
      lng: -108.14555,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades pecuarias",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.7149,
    },
    {
      anio: 2023,
      lat: 23.450853,
      lng: -105.814026,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 63.1534,
    },
    {
      anio: 2021,
      lat: 25.75602778,
      lng: -107.6475667,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 62,
    },
    {
      anio: 2018,
      lat: 23.50770833,
      lng: -105.8741944,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2019,
      lat: 26.81907806,
      lng: -108.1579683,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2017,
      lat: 26.86383333,
      lng: -108.3860556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Transportes",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2017,
      lat: 26.65486389,
      lng: -108.2327917,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Naturales",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2018,
      lat: 23.48802778,
      lng: -105.8999444,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2018,
      lat: 23.48608333,
      lng: -105.8033611,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 26.54666667,
      lng: -107.2945444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2021,
      lat: 27.29485556,
      lng: -108.010025,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 25.99583889,
      lng: -107.0208472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 3,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2021,
      lat: 25.86545,
      lng: -106.9301611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 3,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.5,
    },
    {
      anio: 2021,
      lat: 26.85792222,
      lng: -107.3789056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.5,
    },
    {
      anio: 2021,
      lat: 26.78679444,
      lng: -107.2726528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.4,
    },
    {
      anio: 2021,
      lat: 26.82809722,
      lng: -107.0471444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.63,
    },
    {
      anio: 2021,
      lat: 26.783975,
      lng: -107.2778583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.3,
    },
    {
      anio: 2021,
      lat: 27.18391667,
      lng: -107.0479278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.9,
    },
    {
      anio: 2021,
      lat: 26.97321667,
      lng: -107.0398722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.4,
    },
    {
      anio: 2021,
      lat: 27.05153611,
      lng: -107.328575,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2021,
      lat: 27.15067222,
      lng: -107.2062667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.8,
    },
    {
      anio: 2021,
      lat: 27.55741111,
      lng: -107.8159389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.91855556,
      lng: -107.3262917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 26.85562222,
      lng: -107.3206194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2021,
      lat: 25.73047778,
      lng: -106.8174472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.11,
    },
    {
      anio: 2021,
      lat: 25.80174167,
      lng: -106.6369722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.14573889,
      lng: -107.2026139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2021,
      lat: 26.96112222,
      lng: -107.1115694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 82,
    },
    {
      anio: 2021,
      lat: 27.490675,
      lng: -107.8934389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.07730278,
      lng: -106.7496278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.25903611,
      lng: -106.6818111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.28069722,
      lng: -106.6640028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 31,
    },
    {
      anio: 2021,
      lat: 27.02348611,
      lng: -107.3580333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.6,
    },
    {
      anio: 2021,
      lat: 27.51704167,
      lng: -107.8303861,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.8,
    },
    {
      anio: 2021,
      lat: 26.79553889,
      lng: -107.0273917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 194,
    },
    {
      anio: 2021,
      lat: 26.95909444,
      lng: -107.1161278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 27.06516667,
      lng: -107.3240028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.82729444,
      lng: -107.2459139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2021,
      lat: 25.85701111,
      lng: -106.9272194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.88247222,
      lng: -107.4298972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.7,
    },
    {
      anio: 2021,
      lat: 26.90540833,
      lng: -107.2034472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 77,
    },
    {
      anio: 2021,
      lat: 26.82789722,
      lng: -107.0931778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.5,
    },
    {
      anio: 2021,
      lat: 26.20044722,
      lng: -106.8609972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 348,
    },
    {
      anio: 2021,
      lat: 26.40224167,
      lng: -107.2357972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 27.49680833,
      lng: -107.8959194,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.80578611,
      lng: -107.2803083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.31492222,
      lng: -106.8392833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 895,
    },
    {
      anio: 2021,
      lat: 26.76506389,
      lng: -106.8844361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 46.5,
    },
    {
      anio: 2021,
      lat: 26.94076111,
      lng: -107.3495556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83,
    },
    {
      anio: 2021,
      lat: 27.17037778,
      lng: -107.3780111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 27.15605278,
      lng: -107.3482806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2021,
      lat: 27.48676389,
      lng: -107.8650111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 27.54000278,
      lng: -108.0200083,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2021,
      lat: 27.49068889,
      lng: -108.0252278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2021,
      lat: 26.48897222,
      lng: -107.2927056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.28319444,
      lng: -106.8328167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2021,
      lat: 26.347925,
      lng: -106.7222889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.81735833,
      lng: -107.0952556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 27.42844722,
      lng: -107.9788556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.04827222,
      lng: -107.1986278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2021,
      lat: 26.06938056,
      lng: -106.7820806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.08955278,
      lng: -106.7418972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.09141944,
      lng: -106.7708944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43,
    },
    {
      anio: 2021,
      lat: 27.55699167,
      lng: -107.8216444,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 27.09818333,
      lng: -107.0588556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 137,
    },
    {
      anio: 2021,
      lat: 27.50393889,
      lng: -107.8962306,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 27.49435,
      lng: -108.0759444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 37,
    },
    {
      anio: 2021,
      lat: 26.08913333,
      lng: -106.7661111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.28039722,
      lng: -106.8273694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.15078056,
      lng: -106.8185944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.10648889,
      lng: -107.0035278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 27.13149444,
      lng: -107.0956639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 27.49154167,
      lng: -107.8800861,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 26.786325,
      lng: -107.2704306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.09046111,
      lng: -106.7047306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2021,
      lat: 27.52170833,
      lng: -107.9486694,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2021,
      lat: 25.6615,
      lng: -106.9095528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2021,
      lat: 27.49641944,
      lng: -107.6465111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 44,
    },
    {
      anio: 2021,
      lat: 27.12049167,
      lng: -107.9518194,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2021,
      lat: 26.0062,
      lng: -107.1260556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65,
    },
    {
      anio: 2021,
      lat: 26.31255,
      lng: -106.8785972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.16831389,
      lng: -107.3550528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.29903611,
      lng: -106.6852139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.37695833,
      lng: -107.2614139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2021,
      lat: 26.45308056,
      lng: -107.2841611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 27.50606667,
      lng: -108.0782694,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 189,
    },
    {
      anio: 2021,
      lat: 26.32423333,
      lng: -106.7015528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 336,
    },
    {
      anio: 2021,
      lat: 26.08881111,
      lng: -106.7822917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.05818333,
      lng: -106.8321778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.87459444,
      lng: -106.9872389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 26.34467222,
      lng: -106.72185,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 27.55668889,
      lng: -107.8185583,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 26.06445278,
      lng: -106.78845,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 27.14913056,
      lng: -107.0946417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 27.15960556,
      lng: -107.0853222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 27.19380556,
      lng: -107.2487444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.144475,
      lng: -107.3500222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2021,
      lat: 27.15055833,
      lng: -107.3316778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 96.7,
    },
    {
      anio: 2021,
      lat: 27.1166,
      lng: -107.29585,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.4,
    },
    {
      anio: 2021,
      lat: 26.78568611,
      lng: -107.0684444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.27450556,
      lng: -107.1135667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2021,
      lat: 27.16475833,
      lng: -107.3498111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.00597222,
      lng: -107.065325,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.9059,
      lng: -107.1862861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2021,
      lat: 26.50656667,
      lng: -107.6999111,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 147,
    },
    {
      anio: 2021,
      lat: 27.57966111,
      lng: -108.09695,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2021,
      lat: 26.45580833,
      lng: -107.23325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2021,
      lat: 26.175225,
      lng: -106.5978639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 26.101175,
      lng: -106.7886917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.11291667,
      lng: -106.8017667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2021,
      lat: 27.52908056,
      lng: -108.0828583,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 26.47257222,
      lng: -107.3560556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 76,
    },
    {
      anio: 2021,
      lat: 26.70337222,
      lng: -106.9316583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2021,
      lat: 27.15097778,
      lng: -107.3428694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83,
    },
    {
      anio: 2021,
      lat: 27.1421,
      lng: -107.2434694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.84179444,
      lng: -107.3715306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2021,
      lat: 27.59859722,
      lng: -108.025925,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2021,
      lat: 27.57878889,
      lng: -108.043275,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.84692778,
      lng: -107.3765806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2021,
      lat: 26.96616111,
      lng: -106.9802639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.94582778,
      lng: -107.2651083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.5,
    },
    {
      anio: 2021,
      lat: 26.91209167,
      lng: -107.1623972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2021,
      lat: 26.90350556,
      lng: -107.4576167,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 168,
    },
    {
      anio: 2021,
      lat: 27.56795556,
      lng: -108.141225,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2021,
      lat: 27.68314722,
      lng: -108.1412083,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 800,
    },
    {
      anio: 2021,
      lat: 26.26701111,
      lng: -106.8032361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2021,
      lat: 26.26837778,
      lng: -107.0333667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2021,
      lat: 26.24675,
      lng: -107.0012083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.13234722,
      lng: -107.2412139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 187,
    },
    {
      anio: 2021,
      lat: 27.24563333,
      lng: -107.3701222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2021,
      lat: 26.9724,
      lng: -107.2666944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 153,
    },
    {
      anio: 2021,
      lat: 26.82241389,
      lng: -107.0488056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.51534444,
      lng: -108.0898806,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2021,
      lat: 26.47032222,
      lng: -107.3453278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 27.59355556,
      lng: -107.5677194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.76126389,
      lng: -107.071175,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.14665833,
      lng: -106.8231583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.06012222,
      lng: -106.8485222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.05644444,
      lng: -107.4467306,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2021,
      lat: 27.53632778,
      lng: -108.0854611,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2021,
      lat: 26.275925,
      lng: -106.9178556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 525,
    },
    {
      anio: 2021,
      lat: 26.28837222,
      lng: -106.7728472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2021,
      lat: 27.50463611,
      lng: -107.925425,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.76091111,
      lng: -107.2638667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.5,
    },
    {
      anio: 2021,
      lat: 26.07120556,
      lng: -106.7894139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.05557222,
      lng: -106.7928056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 27.25075556,
      lng: -108.2992417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.20352222,
      lng: -106.8103778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 27.53229722,
      lng: -108.0176667,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.44653056,
      lng: -107.9044417,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 82.66,
    },
    {
      anio: 2021,
      lat: 26.30911944,
      lng: -107.7633167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 73,
    },
    {
      anio: 2021,
      lat: 26.14706667,
      lng: -106.6210111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2021,
      lat: 26.21019167,
      lng: -106.5658806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.14968611,
      lng: -106.5874833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.86582778,
      lng: -107.2085944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2021,
      lat: 25.71093056,
      lng: -106.9208194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 304,
    },
    {
      anio: 2021,
      lat: 26.33630278,
      lng: -106.6856444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 296,
    },
    {
      anio: 2021,
      lat: 26.10198611,
      lng: -106.8001056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2021,
      lat: 27.04033333,
      lng: -107.3946722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 27.03328333,
      lng: -107.1328861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62,
    },
    {
      anio: 2021,
      lat: 27.16492778,
      lng: -106.9287278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2021,
      lat: 27.18035833,
      lng: -106.9369417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.30614722,
      lng: -106.6572583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2021,
      lat: 26.20392222,
      lng: -106.53795,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 68,
    },
    {
      anio: 2021,
      lat: 26.09784444,
      lng: -106.8237389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.35035278,
      lng: -107.2668972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.86236111,
      lng: -107.2058444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 27.173575,
      lng: -108.0919528,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.35303333,
      lng: -107.4403639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 27.0064,
      lng: -107.3785972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 104,
    },
    {
      anio: 2021,
      lat: 27.18664167,
      lng: -107.2708306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2021,
      lat: 27.15142778,
      lng: -107.1594583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2021,
      lat: 26.107675,
      lng: -106.7968111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2021,
      lat: 25.74932222,
      lng: -106.9344278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.92629167,
      lng: -106.9924667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2021,
      lat: 27.20039722,
      lng: -108.0036111,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.22393056,
      lng: -107.9732278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2021,
      lat: 26.75781944,
      lng: -107.2826583,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.38,
    },
    {
      anio: 2021,
      lat: 26.775775,
      lng: -107.220475,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4,
    },
    {
      anio: 2021,
      lat: 26.73335,
      lng: -107.1188444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.15,
    },
    {
      anio: 2021,
      lat: 26.8038,
      lng: -107.1115306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 13,
    },
    {
      anio: 2021,
      lat: 26.79930833,
      lng: -107.112425,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.86702778,
      lng: -107.2248944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.6756,
      lng: -107.6173556,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.5,
    },
    {
      anio: 2021,
      lat: 26.84720556,
      lng: -107.1535139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2021,
      lat: 27.29146389,
      lng: -107.5010861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 27.62930833,
      lng: -107.65775,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.37526111,
      lng: -107.3389444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 26.243275,
      lng: -107.5042361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 530,
    },
    {
      anio: 2021,
      lat: 27.56213056,
      lng: -108.1936694,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2021,
      lat: 25.92589167,
      lng: -106.6700083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 26.21311111,
      lng: -106.5230583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 167,
    },
    {
      anio: 2021,
      lat: 26.30489722,
      lng: -106.8930889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60,
    },
    {
      anio: 2021,
      lat: 26.37391944,
      lng: -106.6396722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 730,
    },
    {
      anio: 2021,
      lat: 27.12648056,
      lng: -108.3071917,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 954,
    },
    {
      anio: 2021,
      lat: 27.59614722,
      lng: -108.1349778,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2021,
      lat: 26.48406667,
      lng: -107.3268306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 27.12416111,
      lng: -106.9917917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 220,
    },
    {
      anio: 2021,
      lat: 26.08236111,
      lng: -106.7518472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.19466944,
      lng: -106.6414778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.82555556,
      lng: -107.0459167,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 27.00515278,
      lng: -107.2060111,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2021,
      lat: 26.93901944,
      lng: -107.3373222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2021,
      lat: 27.51910556,
      lng: -107.8744639,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 187,
    },
    {
      anio: 2021,
      lat: 27.57805278,
      lng: -108.1978417,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 26.47548611,
      lng: -107.3680778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2021,
      lat: 26.09388889,
      lng: -106.8122917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.85288889,
      lng: -107.1478861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.88932778,
      lng: -107.4577472,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2021,
      lat: 26.09189444,
      lng: -106.8232944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.22943889,
      lng: -106.870625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2021,
      lat: 27.13082778,
      lng: -107.0443444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.76096944,
      lng: -107.3910056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.5,
    },
    {
      anio: 2021,
      lat: 27.36913333,
      lng: -107.8870389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 26.49857778,
      lng: -107.6354889,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 150,
    },
    {
      anio: 2021,
      lat: 27.23706389,
      lng: -107.8394611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 280,
    },
    {
      anio: 2021,
      lat: 26.89629722,
      lng: -107.1879028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.2,
    },
    {
      anio: 2021,
      lat: 26.06710278,
      lng: -106.7948167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 27.57296389,
      lng: -107.68485,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2021,
      lat: 27.52260833,
      lng: -107.8456417,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.87288333,
      lng: -107.1620972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2021,
      lat: 26.34247778,
      lng: -106.6345333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 124,
    },
    {
      anio: 2021,
      lat: 26.08668889,
      lng: -106.9943389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 27.48319167,
      lng: -108.0737056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2021,
      lat: 27.57898611,
      lng: -108.1845222,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 26.12977778,
      lng: -106.7360444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 26.12642778,
      lng: -106.6388944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2021,
      lat: 27.5452,
      lng: -107.9542611,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 388,
    },
    {
      anio: 2021,
      lat: 26.1838,
      lng: -106.6495944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 25.94409722,
      lng: -106.7465806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 27.128325,
      lng: -108.0410528,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.16475278,
      lng: -107.9666833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 27.59227222,
      lng: -108.0555778,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.60439722,
      lng: -107.7320333,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 74.68,
    },
    {
      anio: 2021,
      lat: 27.39250556,
      lng: -107.7243778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2021,
      lat: 26.81845,
      lng: -107.3898333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2021,
      lat: 26.32351111,
      lng: -107.1118639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.01276111,
      lng: -106.7605889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.52925,
      lng: -107.8983778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.89953611,
      lng: -107.3847972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.5,
    },
    {
      anio: 2021,
      lat: 26.35748889,
      lng: -106.7056278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 27.56599722,
      lng: -108.1440333,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2021,
      lat: 26.27251944,
      lng: -107.123875,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2021,
      lat: 26.04843056,
      lng: -106.6425167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 25.93347778,
      lng: -106.959775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 27.32411111,
      lng: -108.0206778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 25.69500833,
      lng: -106.8521861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.5,
    },
    {
      anio: 2021,
      lat: 25.70111111,
      lng: -106.834275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.12617222,
      lng: -106.8005806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.60339722,
      lng: -107.2958083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2021,
      lat: 27.52617222,
      lng: -107.8574389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.29310556,
      lng: -106.8268417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 27.662225,
      lng: -107.6186222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2021,
      lat: 25.90222222,
      lng: -106.7057111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 27.62962222,
      lng: -108.2531444,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 98,
    },
    {
      anio: 2021,
      lat: 26.75685278,
      lng: -107.2501694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 27.55792778,
      lng: -108.1568,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2021,
      lat: 26.22505278,
      lng: -106.808675,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.090125,
      lng: -106.7928361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.39138611,
      lng: -107.2453417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.069925,
      lng: -106.9529333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2021,
      lat: 26.09818333,
      lng: -106.8100167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 25.96054722,
      lng: -106.9472056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2021,
      lat: 26.14410278,
      lng: -106.9741639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 55,
    },
    {
      anio: 2021,
      lat: 25.78248333,
      lng: -106.9470194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.3,
    },
    {
      anio: 2021,
      lat: 26.10232222,
      lng: -106.6518167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 26.05500278,
      lng: -106.620925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2021,
      lat: 26.75654167,
      lng: -107.2425806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.3,
    },
    {
      anio: 2021,
      lat: 26.7597,
      lng: -107.0509417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 195,
    },
    {
      anio: 2021,
      lat: 26.10718333,
      lng: -106.7042194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2021,
      lat: 26.86495833,
      lng: -107.4028389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 24,
    },
    {
      anio: 2021,
      lat: 27.15230278,
      lng: -107.7851056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 235,
    },
    {
      anio: 2021,
      lat: 26.14881111,
      lng: -106.9481167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.09634722,
      lng: -106.9785806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2021,
      lat: 26.10625833,
      lng: -107.0105278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.358325,
      lng: -107.1886222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.2574,
      lng: -107.0648833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79.5,
    },
    {
      anio: 2021,
      lat: 26.12962778,
      lng: -106.9221639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44,
    },
    {
      anio: 2021,
      lat: 27.50656667,
      lng: -107.9041722,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4,
    },
    {
      anio: 2021,
      lat: 26.09376111,
      lng: -106.8109278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2021,
      lat: 25.98881389,
      lng: -107.0677194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2021,
      lat: 27.41849167,
      lng: -108.3071861,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.02014722,
      lng: -106.7366639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 25.77680833,
      lng: -106.7569278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.12380278,
      lng: -106.9465972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.47711389,
      lng: -107.3417694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.45598611,
      lng: -107.2282361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2021,
      lat: 26.42382778,
      lng: -107.2561,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 25.93632222,
      lng: -106.9614833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.09481111,
      lng: -106.7550528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.7961,
      lng: -107.1922389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 26.05323611,
      lng: -106.8795111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2021,
      lat: 27.2828,
      lng: -108.0538778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.74611944,
      lng: -107.2268694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.15957222,
      lng: -106.8487917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2021,
      lat: 27.07587778,
      lng: -107.2290222,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.80042222,
      lng: -107.1084861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 26.05286667,
      lng: -107.0063528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.13469722,
      lng: -106.9496139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.10038056,
      lng: -106.8152694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 27.09213056,
      lng: -107.0418056,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.32756111,
      lng: -107.2340417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 765,
    },
    {
      anio: 2021,
      lat: 26.08039444,
      lng: -106.9449806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 25.76242778,
      lng: -106.7649194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.8,
    },
    {
      anio: 2021,
      lat: 26.05356389,
      lng: -106.8406972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.05055278,
      lng: -106.99665,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.11143056,
      lng: -106.997875,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2021,
      lat: 26.07603333,
      lng: -107.0230278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.98211667,
      lng: -107.3040778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 26.90812778,
      lng: -107.1766194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2021,
      lat: 26.41602222,
      lng: -107.60485,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 82.5,
    },
    {
      anio: 2021,
      lat: 27.38407778,
      lng: -108.3531056,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 27.04080278,
      lng: -107.9667861,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 57,
    },
    {
      anio: 2021,
      lat: 26.93342222,
      lng: -107.3085861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 27.06668056,
      lng: -107.0797944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Severo",
      superficie: 120,
    },
    {
      anio: 2021,
      lat: 26.01373611,
      lng: -107.0643528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.13136389,
      lng: -106.7468833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.12081111,
      lng: -106.6531528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 418,
    },
    {
      anio: 2021,
      lat: 26.11244444,
      lng: -106.623725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 110,
    },
    {
      anio: 2021,
      lat: 26.04770556,
      lng: -106.7287667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2021,
      lat: 26.10923333,
      lng: -106.6427361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 167,
    },
    {
      anio: 2021,
      lat: 26.18634167,
      lng: -106.8321333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2021,
      lat: 27.154025,
      lng: -106.9939333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 170,
    },
    {
      anio: 2021,
      lat: 26.05545278,
      lng: -107.0155222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.04416389,
      lng: -106.724875,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.76221667,
      lng: -107.3720694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 357,
    },
    {
      anio: 2021,
      lat: 26.87405,
      lng: -107.2474333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 153,
    },
    {
      anio: 2021,
      lat: 26.10126389,
      lng: -107.0316333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 26.01620833,
      lng: -107.0617889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 26.08535833,
      lng: -106.7970917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.06948056,
      lng: -106.7247361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 26.23438889,
      lng: -106.6979528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2021,
      lat: 27.67400556,
      lng: -108.11725,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 288,
    },
    {
      anio: 2021,
      lat: 26.08414444,
      lng: -106.752275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 27.34898889,
      lng: -107.9692833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 650,
    },
    {
      anio: 2021,
      lat: 27.42756111,
      lng: -107.9462,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 493,
    },
    {
      anio: 2021,
      lat: 26.04674722,
      lng: -106.7401583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 26.090225,
      lng: -107.0807111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 130,
    },
    {
      anio: 2021,
      lat: 25.88076389,
      lng: -106.8066778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.00954167,
      lng: -106.8835139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 25.95585833,
      lng: -106.7434,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.11053333,
      lng: -106.9236667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 26.09708611,
      lng: -106.7847278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2021,
      lat: 27.39931944,
      lng: -107.8855833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 176,
    },
    {
      anio: 2021,
      lat: 26.37974722,
      lng: -107.29415,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 26.08033611,
      lng: -106.6974028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 67,
    },
    {
      anio: 2021,
      lat: 25.86708333,
      lng: -106.9432417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.942625,
      lng: -107.0114333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8,
    },
    {
      anio: 2021,
      lat: 26.02064444,
      lng: -106.8897861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.5,
    },
    {
      anio: 2021,
      lat: 25.94648889,
      lng: -106.9403889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.28900556,
      lng: -106.8564556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 130,
    },
    {
      anio: 2021,
      lat: 26.09837778,
      lng: -106.7656,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.22104722,
      lng: -106.7879583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.2,
    },
    {
      anio: 2021,
      lat: 26.0873,
      lng: -106.8053222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.09597778,
      lng: -106.9494722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2021,
      lat: 26.07133889,
      lng: -106.9034944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.11062778,
      lng: -106.9334139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.78768333,
      lng: -107.1922944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.4,
    },
    {
      anio: 2021,
      lat: 26.76375,
      lng: -107.2090361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 27.37528056,
      lng: -108.2407778,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 161,
    },
    {
      anio: 2021,
      lat: 26.35326111,
      lng: -107.4196083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 110,
    },
    {
      anio: 2021,
      lat: 26.081775,
      lng: -106.969375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.48384722,
      lng: -107.8861083,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 27.321175,
      lng: -107.5728722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2021,
      lat: 26.05874722,
      lng: -107.0806917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.07886111,
      lng: -107.0815333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2021,
      lat: 26.10253889,
      lng: -106.7754167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.885575,
      lng: -107.2383,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 56.5,
    },
    {
      anio: 2021,
      lat: 26.08485833,
      lng: -106.81235,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.09848056,
      lng: -106.7716361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.71506389,
      lng: -107.2903,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 326,
    },
    {
      anio: 2021,
      lat: 26.06575833,
      lng: -107.0805417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 96,
    },
    {
      anio: 2021,
      lat: 26.0757,
      lng: -106.9322694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 25.94703611,
      lng: -106.9547556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.04280833,
      lng: -106.9590917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 26.08029722,
      lng: -106.6677694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.18795833,
      lng: -106.7385556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.12610833,
      lng: -106.6753528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 26.12565278,
      lng: -106.7377861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 26.00105556,
      lng: -106.6952528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 26.40781111,
      lng: -107.2399056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 54,
    },
    {
      anio: 2021,
      lat: 27.36167222,
      lng: -107.9366083,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 26.864125,
      lng: -107.2655417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 56,
    },
    {
      anio: 2021,
      lat: 27.08898333,
      lng: -107.0316611,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1600,
    },
    {
      anio: 2021,
      lat: 27.18561944,
      lng: -106.9349306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 863,
    },
    {
      anio: 2021,
      lat: 26.25784722,
      lng: -106.8376417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 293,
    },
    {
      anio: 2021,
      lat: 26.39897222,
      lng: -107.2157917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43,
    },
    {
      anio: 2021,
      lat: 27.51882222,
      lng: -107.8435833,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.10443611,
      lng: -106.7746861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 104,
    },
    {
      anio: 2021,
      lat: 25.94838056,
      lng: -106.7476139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 400,
    },
    {
      anio: 2021,
      lat: 26.03245556,
      lng: -107.0139444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2021,
      lat: 26.55538333,
      lng: -107.3207833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 640,
    },
    {
      anio: 2021,
      lat: 26.95518889,
      lng: -107.1379444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 250,
    },
    {
      anio: 2021,
      lat: 26.75326667,
      lng: -107.2880778,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 26.07962222,
      lng: -106.7964028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2021,
      lat: 26.08039167,
      lng: -106.9701611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 25.94520278,
      lng: -106.9477472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 238,
    },
    {
      anio: 2021,
      lat: 26.77045,
      lng: -107.3119944,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 2727,
    },
    {
      anio: 2021,
      lat: 27.25484722,
      lng: -108.2993944,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.05542778,
      lng: -106.7587389,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 450,
    },
    {
      anio: 2021,
      lat: 26.07593056,
      lng: -107.0264194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2021,
      lat: 25.99163056,
      lng: -106.6085611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2021,
      lat: 25.97745,
      lng: -106.7004861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53,
    },
    {
      anio: 2021,
      lat: 26.09893611,
      lng: -106.6854778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 168,
    },
    {
      anio: 2021,
      lat: 26.27422778,
      lng: -106.7557417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 26.45735,
      lng: -107.2484,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 600,
    },
    {
      anio: 2021,
      lat: 26.11173056,
      lng: -107.009775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 26.08083611,
      lng: -106.9708556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.38922778,
      lng: -107.2408278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 27.49812222,
      lng: -107.8735806,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2021,
      lat: 27.22968889,
      lng: -108.0725028,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2021,
      lat: 26.99800833,
      lng: -107.1981806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.14,
    },
    {
      anio: 2021,
      lat: 26.01376667,
      lng: -106.9960833,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 26.07841389,
      lng: -106.9691417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 26.18013611,
      lng: -106.7616528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 481,
    },
    {
      anio: 2021,
      lat: 26.20013889,
      lng: -107.0317361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 25.86057778,
      lng: -106.9310194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 26.16958333,
      lng: -106.8951917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2021,
      lat: 26.0473,
      lng: -106.9608528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.07948611,
      lng: -107.0588194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 26.15376111,
      lng: -106.6816639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 27.49265,
      lng: -107.8760528,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades ilícitas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2021,
      lat: 27.39608889,
      lng: -108.1488556,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 27.58624444,
      lng: -108.1879778,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 126,
    },
    {
      anio: 2021,
      lat: 26.17570278,
      lng: -106.9070278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2021,
      lat: 27.52263611,
      lng: -107.9573889,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.09429722,
      lng: -106.8428333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.14913333,
      lng: -107.0050556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1300,
    },
    {
      anio: 2021,
      lat: 26.08578333,
      lng: -106.8039889,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 25.77796111,
      lng: -106.76215,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 25.77068889,
      lng: -106.8715639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 25.77133056,
      lng: -106.734825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 25.85783889,
      lng: -106.8457528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.02999167,
      lng: -106.8982806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 25.69819444,
      lng: -106.9496972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 25.74232222,
      lng: -106.7207917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 25.79266944,
      lng: -106.7680583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 25.76152778,
      lng: -106.7225694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 25.79324722,
      lng: -106.7634528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 25.78552222,
      lng: -106.7556861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2021,
      lat: 26.02266667,
      lng: -106.9894222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.09801389,
      lng: -106.9479472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2021,
      lat: 26.08818333,
      lng: -106.950725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.10516111,
      lng: -106.9463639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 26.12593333,
      lng: -106.9458361,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.08503611,
      lng: -107.0125806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 26.13958611,
      lng: -106.9621278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 26.13609722,
      lng: -106.9484556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.49292222,
      lng: -107.8723056,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2021,
      lat: 27.46202778,
      lng: -107.8855528,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 26.46566389,
      lng: -107.2631333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 26.40241944,
      lng: -107.2284111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 54,
    },
    {
      anio: 2021,
      lat: 26.89424722,
      lng: -107.1894333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.8,
    },
    {
      anio: 2021,
      lat: 26.84033611,
      lng: -107.0806667,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 26.89118889,
      lng: -107.4190389,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 96.7,
    },
    {
      anio: 2021,
      lat: 26.92195833,
      lng: -107.4004194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 81.5,
    },
    {
      anio: 2021,
      lat: 27.14969167,
      lng: -108.0540389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 235,
    },
    {
      anio: 2021,
      lat: 27.11165833,
      lng: -108.0292389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 26.39905833,
      lng: -107.2470111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43,
    },
    {
      anio: 2021,
      lat: 26.54548056,
      lng: -107.2698,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades ilícitas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2021,
      lat: 26.42114722,
      lng: -107.3391222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 27.17220833,
      lng: -107.1512972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2021,
      lat: 26.42735833,
      lng: -107.6003167,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 41,
    },
    {
      anio: 2021,
      lat: 26.43185556,
      lng: -107.8450028,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 41.5,
    },
    {
      anio: 2021,
      lat: 26.76980556,
      lng: -107.1231806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2021,
      lat: 26.7462,
      lng: -107.2256722,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.17,
    },
    {
      anio: 2021,
      lat: 26.84652222,
      lng: -107.14445,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2021,
      lat: 27.49706667,
      lng: -107.9291278,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 46,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2021,
      lat: 27.486325,
      lng: -107.9009944,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 47,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.22,
    },
    {
      anio: 2021,
      lat: 23.81559722,
      lng: -105.3015694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Limpias de derecho de vía",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 23.20103889,
      lng: -104.9896472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 24.15911667,
      lng: -105.4809056,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 23.48603889,
      lng: -105.33195,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2021,
      lat: 24.93695406,
      lng: -105.8847841,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 22.97175714,
      lng: -104.6054951,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 22.90438889,
      lng: -104.5613306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 24.04311111,
      lng: -105.7393333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 220,
    },
    {
      anio: 2021,
      lat: 23.48606944,
      lng: -105.3210194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 97.5,
    },
    {
      anio: 2021,
      lat: 22.88044722,
      lng: -104.5737389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 23.39582885,
      lng: -105.3853157,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2021,
      lat: 23.43127778,
      lng: -105.498,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 49.5,
    },
    {
      anio: 2021,
      lat: 23.54541667,
      lng: -105.3832194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2021,
      lat: 23.24717778,
      lng: -105.4047972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 98,
    },
    {
      anio: 2021,
      lat: 23.43041667,
      lng: -105.3801389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.75,
    },
    {
      anio: 2021,
      lat: 23.60067778,
      lng: -105.4296778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2021,
      lat: 23.26183611,
      lng: -105.4137472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1425.9,
    },
    {
      anio: 2021,
      lat: 23.2280658,
      lng: -104.9848118,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 305,
    },
    {
      anio: 2021,
      lat: 23.01273056,
      lng: -104.2186917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1992,
    },
    {
      anio: 2021,
      lat: 22.97673889,
      lng: -104.5931111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 37.5,
    },
    {
      anio: 2021,
      lat: 25.05197535,
      lng: -105.6592467,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 22.95108333,
      lng: -104.4830556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 359,
    },
    {
      anio: 2021,
      lat: 24.56786944,
      lng: -106.0642556,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2021,
      lat: 24.4906092,
      lng: -106.3753131,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 133.5,
    },
    {
      anio: 2021,
      lat: 23.00356342,
      lng: -104.3753953,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 172.15,
    },
    {
      anio: 2021,
      lat: 23.45571533,
      lng: -105.015112,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 23.53452222,
      lng: -105.7239583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 23.24339722,
      lng: -104.7334028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 24.27583889,
      lng: -105.6874722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Cazadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 24.80069917,
      lng: -105.987845,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 580,
    },
    {
      anio: 2021,
      lat: 22.80620556,
      lng: -104.4844056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2021,
      lat: 22.58072413,
      lng: -104.3218404,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1,
    },
    {
      anio: 2021,
      lat: 23.22192222,
      lng: -104.7045833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 110,
    },
    {
      anio: 2021,
      lat: 23.23816492,
      lng: -105.1343545,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 22.7912384,
      lng: -104.5241801,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 25.58229803,
      lng: -107.0087308,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2021,
      lat: 23.503075,
      lng: -105.3140083,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 59.5,
    },
    {
      anio: 2021,
      lat: 23.57249444,
      lng: -105.5094056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 168.25,
    },
    {
      anio: 2021,
      lat: 23.21790556,
      lng: -105.4477,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 311,
    },
    {
      anio: 2021,
      lat: 22.63841477,
      lng: -104.3506526,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 24.74146111,
      lng: -106.1365528,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 24.42236402,
      lng: -105.8229548,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 24.40296667,
      lng: -106.5047694,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 24.24888959,
      lng: -105.3329178,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 23.2852116,
      lng: -105.445466,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 145,
    },
    {
      anio: 2021,
      lat: 22.85732094,
      lng: -104.2664034,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2021,
      lat: 22.82694608,
      lng: -104.292016,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2021,
      lat: 23.08427296,
      lng: -104.176661,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 937,
    },
    {
      anio: 2021,
      lat: 22.56344965,
      lng: -104.3190052,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 24.31238107,
      lng: -105.5586118,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 22.67729167,
      lng: -104.289475,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 102.53,
    },
    {
      anio: 2021,
      lat: 23.06440494,
      lng: -104.6297139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 450,
    },
    {
      anio: 2021,
      lat: 22.79344041,
      lng: -104.7622213,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 860,
    },
    {
      anio: 2021,
      lat: 22.72926944,
      lng: -104.5892,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 730,
    },
    {
      anio: 2021,
      lat: 24.32570833,
      lng: -105.5540528,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.264,
    },
    {
      anio: 2021,
      lat: 22.91728643,
      lng: -104.258322,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 810,
    },
    {
      anio: 2021,
      lat: 23.61597222,
      lng: -105.6503333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2021,
      lat: 23.25558333,
      lng: -105.1845778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2021,
      lat: 23.12022756,
      lng: -105.351787,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9300,
    },
    {
      anio: 2021,
      lat: 24.85138889,
      lng: -106.8827778,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2253,
    },
    {
      anio: 2021,
      lat: 23.03835833,
      lng: -104.2814917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2,
    },
    {
      anio: 2021,
      lat: 23.04786974,
      lng: -104.3674773,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5212,
    },
    {
      anio: 2021,
      lat: 22.62692778,
      lng: -104.2996639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 255.9,
    },
    {
      anio: 2021,
      lat: 23.61779792,
      lng: -105.4819967,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 86,
    },
    {
      anio: 2021,
      lat: 23.69786111,
      lng: -104.3988889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2021,
      lat: 22.8376263,
      lng: -104.2657564,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 190,
    },
    {
      anio: 2021,
      lat: 23.73754398,
      lng: -105.560522,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.58,
    },
    {
      anio: 2021,
      lat: 23.74172222,
      lng: -105.4625556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 22.92332134,
      lng: -104.5362031,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 69.415,
    },
    {
      anio: 2021,
      lat: 23.82921913,
      lng: -105.3278613,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Limpias de derecho de vía",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35.286,
    },
    {
      anio: 2021,
      lat: 22.8563757,
      lng: -104.7298098,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79.013,
    },
    {
      anio: 2021,
      lat: 22.7299,
      lng: -104.5025611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 23.76244444,
      lng: -105.6711389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 540.84,
    },
    {
      anio: 2021,
      lat: 23.80105912,
      lng: -105.3730391,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.439,
    },
    {
      anio: 2021,
      lat: 22.96696346,
      lng: -104.5934326,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.307,
    },
    {
      anio: 2021,
      lat: 22.90663889,
      lng: -104.7375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.03,
    },
    {
      anio: 2021,
      lat: 25.11222778,
      lng: -106.6164639,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 554,
    },
    {
      anio: 2021,
      lat: 25.15998611,
      lng: -106.5229611,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 161,
    },
    {
      anio: 2021,
      lat: 23.73057666,
      lng: -105.4888422,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2021,
      lat: 23.00542651,
      lng: -104.6059001,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45.895,
    },
    {
      anio: 2021,
      lat: 22.89896516,
      lng: -104.7705473,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.356,
    },
    {
      anio: 2021,
      lat: 23.01387607,
      lng: -104.5668134,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 140.12,
    },
    {
      anio: 2021,
      lat: 22.56582122,
      lng: -104.3287847,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 34.99,
    },
    {
      anio: 2021,
      lat: 22.87962135,
      lng: -104.7807278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35.16,
    },
    {
      anio: 2021,
      lat: 24.36291111,
      lng: -105.4860722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2021,
      lat: 22.74536944,
      lng: -104.2599778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.14,
    },
    {
      anio: 2021,
      lat: 23.01692887,
      lng: -104.5390298,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.91,
    },
    {
      anio: 2021,
      lat: 22.91676987,
      lng: -104.2716775,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2021,
      lat: 22.84839176,
      lng: -104.4920349,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 24.29836693,
      lng: -105.5424311,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2021,
      lat: 22.81513158,
      lng: -104.2700997,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 43.81,
    },
    {
      anio: 2021,
      lat: 23.02455738,
      lng: -104.6426067,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.2,
    },
    {
      anio: 2021,
      lat: 24.98968599,
      lng: -106.3046558,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 25.02981746,
      lng: -106.2506195,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.8,
    },
    {
      anio: 2021,
      lat: 22.7049482,
      lng: -104.5162714,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 22.8525,
      lng: -104.7130556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.5,
    },
    {
      anio: 2021,
      lat: 22.93926744,
      lng: -104.5487471,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2021,
      lat: 23.52016187,
      lng: -104.5546716,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2021,
      lat: 22.88602659,
      lng: -104.6188115,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2021,
      lat: 22.56722222,
      lng: -104.3366667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2021,
      lat: 23.02644199,
      lng: -104.6378974,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 24.29722222,
      lng: -105.5925,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.66,
    },
    {
      anio: 2021,
      lat: 22.74044013,
      lng: -104.2580522,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.74,
    },
    {
      anio: 2021,
      lat: 23.91695513,
      lng: -105.4778319,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 240,
    },
    {
      anio: 2021,
      lat: 23.02701874,
      lng: -104.6675805,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70.527,
    },
    {
      anio: 2021,
      lat: 22.95751168,
      lng: -104.4979962,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 130,
    },
    {
      anio: 2021,
      lat: 23.59830784,
      lng: -105.4034553,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2021,
      lat: 22.85782285,
      lng: -104.7019057,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 122.66,
    },
    {
      anio: 2021,
      lat: 23.29861111,
      lng: -104.8633333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 811.67,
    },
    {
      anio: 2021,
      lat: 22.83583333,
      lng: -104.5627778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 101.6,
    },
    {
      anio: 2021,
      lat: 22.68041667,
      lng: -104.2960833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 406,
    },
    {
      anio: 2021,
      lat: 23.22636571,
      lng: -105.1441959,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 181,
    },
    {
      anio: 2021,
      lat: 23.33914055,
      lng: -105.0605736,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 328,
    },
    {
      anio: 2021,
      lat: 22.98214065,
      lng: -104.5569201,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.646,
    },
    {
      anio: 2021,
      lat: 25.15827424,
      lng: -105.7565309,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.7,
    },
    {
      anio: 2021,
      lat: 23.80423422,
      lng: -105.3745909,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.3,
    },
    {
      anio: 2021,
      lat: 23.81343845,
      lng: -105.7911636,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Espinosa Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 23.10735852,
      lng: -105.1556715,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1441,
    },
    {
      anio: 2021,
      lat: 22.77363345,
      lng: -104.5432521,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.26,
    },
    {
      anio: 2021,
      lat: 24.63044444,
      lng: -105.7545472,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2350,
    },
    {
      anio: 2021,
      lat: 22.93342461,
      lng: -104.5620361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.74,
    },
    {
      anio: 2021,
      lat: 22.99808857,
      lng: -104.5992658,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.39,
    },
    {
      anio: 2021,
      lat: 23.04354467,
      lng: -104.2105763,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 23.6415,
      lng: -105.6312222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.78,
    },
    {
      anio: 2021,
      lat: 24.42637384,
      lng: -105.659531,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2021,
      lat: 23.3275,
      lng: -105.0128472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 496,
    },
    {
      anio: 2021,
      lat: 23.56930556,
      lng: -105.3561111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.5,
    },
    {
      anio: 2021,
      lat: 23.2947,
      lng: -104.9634694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3545.2,
    },
    {
      anio: 2021,
      lat: 22.85379893,
      lng: -104.6056448,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2021,
      lat: 22.64325195,
      lng: -104.2942727,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 77.59,
    },
    {
      anio: 2021,
      lat: 22.97158333,
      lng: -104.2265,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80,
    },
    {
      anio: 2021,
      lat: 22.94385978,
      lng: -104.5518456,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 113.69,
    },
    {
      anio: 2021,
      lat: 22.94476944,
      lng: -104.2352167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 590,
    },
    {
      anio: 2021,
      lat: 24.02247713,
      lng: -105.659045,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64.02,
    },
    {
      anio: 2021,
      lat: 24.4932433,
      lng: -106.2430818,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 95.5,
    },
    {
      anio: 2021,
      lat: 23.00177547,
      lng: -104.4382718,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 435.96,
    },
    {
      anio: 2021,
      lat: 22.97003084,
      lng: -104.5662574,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.675,
    },
    {
      anio: 2021,
      lat: 24.83801667,
      lng: -105.8791194,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 615.79,
    },
    {
      anio: 2021,
      lat: 24.57896667,
      lng: -106.5131278,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3837,
    },
    {
      anio: 2021,
      lat: 23.80906827,
      lng: -105.3395934,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.6,
    },
    {
      anio: 2021,
      lat: 24.85630705,
      lng: -106.628349,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 570,
    },
    {
      anio: 2021,
      lat: 24.83163106,
      lng: -106.1022029,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 400,
    },
    {
      anio: 2021,
      lat: 25.24722222,
      lng: -106.6547222,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 600,
    },
    {
      anio: 2021,
      lat: 25.4155,
      lng: -106.2320278,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1056.45,
    },
    {
      anio: 2021,
      lat: 22.94463683,
      lng: -104.6892087,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 195,
    },
    {
      anio: 2021,
      lat: 22.65025,
      lng: -104.3624417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 143,
    },
    {
      anio: 2021,
      lat: 23.72996535,
      lng: -105.2844695,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.94,
    },
    {
      anio: 2021,
      lat: 23.36340787,
      lng: -104.7514807,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 124,
    },
    {
      anio: 2021,
      lat: 23.76500844,
      lng: -105.3646967,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.062,
    },
    {
      anio: 2021,
      lat: 23.77365923,
      lng: -105.3287408,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.01,
    },
    {
      anio: 2021,
      lat: 24.51461111,
      lng: -106.2229417,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 67.4,
    },
    {
      anio: 2021,
      lat: 22.94558333,
      lng: -104.2716667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 76,
    },
    {
      anio: 2021,
      lat: 22.8438195,
      lng: -104.7474723,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 404,
    },
    {
      anio: 2021,
      lat: 23.34433611,
      lng: -105.4964972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1835,
    },
    {
      anio: 2021,
      lat: 24.49895556,
      lng: -106.2209417,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 180,
    },
    {
      anio: 2021,
      lat: 25.48566944,
      lng: -107.03435,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 320,
    },
    {
      anio: 2021,
      lat: 23.86566465,
      lng: -105.7410724,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2021,
      lat: 23.80972222,
      lng: -105.374,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2021,
      lat: 23.56095032,
      lng: -105.7464879,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 314.11,
    },
    {
      anio: 2021,
      lat: 23.61090967,
      lng: -105.707122,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 61.59,
    },
    {
      anio: 2021,
      lat: 25.14111111,
      lng: -105.7594444,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 225,
    },
    {
      anio: 2021,
      lat: 22.59558224,
      lng: -104.319778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95.17,
    },
    {
      anio: 2021,
      lat: 22.94904722,
      lng: -104.5699028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2021,
      lat: 23.79330556,
      lng: -105.3591944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.2,
    },
    {
      anio: 2021,
      lat: 23.19972222,
      lng: -105.3736111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 433,
    },
    {
      anio: 2021,
      lat: 23.22194444,
      lng: -105.2038806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Selva Baja Subcaducifolia",
      impacto: "Impacto Mínimo",
      superficie: 91,
    },
    {
      anio: 2021,
      lat: 24.40392119,
      lng: -105.8550427,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.98,
    },
    {
      anio: 2021,
      lat: 22.86124834,
      lng: -104.3284465,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.43,
    },
    {
      anio: 2021,
      lat: 22.97850203,
      lng: -104.2314117,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.3,
    },
    {
      anio: 2021,
      lat: 22.86630556,
      lng: -104.3226944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.566,
    },
    {
      anio: 2021,
      lat: 22.93175947,
      lng: -104.2703693,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2021,
      lat: 24.10376014,
      lng: -105.797755,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45.2,
    },
    {
      anio: 2021,
      lat: 23.61033889,
      lng: -105.7507583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 710.25,
    },
    {
      anio: 2021,
      lat: 24.41257176,
      lng: -105.9022949,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2021,
      lat: 23.06598298,
      lng: -104.2680095,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 24.90953056,
      lng: -106.8368972,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 96,
    },
    {
      anio: 2021,
      lat: 24.76163889,
      lng: -106.6040528,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1200,
    },
    {
      anio: 2021,
      lat: 22.98796622,
      lng: -104.6087529,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.72,
    },
    {
      anio: 2021,
      lat: 25.62839444,
      lng: -106.415825,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.64,
    },
    {
      anio: 2021,
      lat: 25.47,
      lng: -106.6097222,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2021,
      lat: 25.62527778,
      lng: -106.4972222,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.38,
    },
    {
      anio: 2021,
      lat: 25.42,
      lng: -107.1083333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1878,
    },
    {
      anio: 2021,
      lat: 25.63194444,
      lng: -106.3083333,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 22.96576936,
      lng: -104.6173292,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.59,
    },
    {
      anio: 2021,
      lat: 23.54139269,
      lng: -105.20281,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1600,
    },
    {
      anio: 2021,
      lat: 25.24767477,
      lng: -106.5550863,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2021,
      lat: 25.66833333,
      lng: -106.4252778,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 75,
    },
    {
      anio: 2021,
      lat: 24.16722222,
      lng: -105.6525,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2021,
      lat: 23.00853032,
      lng: -104.5272244,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.25,
    },
    {
      anio: 2021,
      lat: 25.13649982,
      lng: -106.3399278,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 157,
    },
    {
      anio: 2021,
      lat: 22.98297094,
      lng: -104.7072974,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 24.38887199,
      lng: -105.5570909,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.25,
    },
    {
      anio: 2021,
      lat: 23.61573534,
      lng: -105.6623047,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.47,
    },
    {
      anio: 2021,
      lat: 25.56833333,
      lng: -106.5583333,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1231,
    },
    {
      anio: 2021,
      lat: 24.62507302,
      lng: -105.6783392,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 144,
    },
    {
      anio: 2021,
      lat: 22.93083333,
      lng: -104.5722222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.22,
    },
    {
      anio: 2021,
      lat: 25.29083333,
      lng: -106.4413889,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 367,
    },
    {
      anio: 2021,
      lat: 23.58602184,
      lng: -105.4797111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 137,
    },
    {
      anio: 2021,
      lat: 22.96388889,
      lng: -104.665,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.815,
    },
    {
      anio: 2021,
      lat: 24.48056,
      lng: -106.1011618,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 77,
    },
    {
      anio: 2021,
      lat: 24.60744647,
      lng: -105.790254,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 392,
    },
    {
      anio: 2021,
      lat: 25.54073485,
      lng: -106.6778964,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 225,
    },
    {
      anio: 2021,
      lat: 22.97433037,
      lng: -104.6639914,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.53,
    },
    {
      anio: 2021,
      lat: 25.09685682,
      lng: -106.3240207,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2021,
      lat: 23.04361111,
      lng: -104.625,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.04,
    },
    {
      anio: 2021,
      lat: 23.52342997,
      lng: -105.42216,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 101,
    },
    {
      anio: 2021,
      lat: 24.50537353,
      lng: -105.7030095,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.4,
    },
    {
      anio: 2024,
      lat: 24.826696,
      lng: -106.90102,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 49.3195,
    },
    {
      anio: 2018,
      lat: 25.73221694,
      lng: -107.60898,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2024,
      lat: 23.514328,
      lng: -105.80498,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 46.58,
    },
    {
      anio: 2016,
      lat: 26.66452778,
      lng: -108.3658333,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2017,
      lat: 26.71510833,
      lng: -108.131975,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2017,
      lat: 26.77112778,
      lng: -108.0899639,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45,
    },
    {
      anio: 2025,
      lat: 23.572083,
      lng: -105.869,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1589.9831,
    },
    {
      anio: 2016,
      lat: 23.38252778,
      lng: -105.8150556,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2017,
      lat: 26.55786111,
      lng: -108.3647778,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Otras causas",
      semana: 11,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2019,
      lat: 25.8792725,
      lng: -107.6499369,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2018,
      lat: 24.27369444,
      lng: -106.4833611,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Desconocidas",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2023,
      lat: 25.899952,
      lng: -107.548584,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades pecuarias",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.7927,
    },
    {
      anio: 2021,
      lat: 23.46343611,
      lng: -105.839125,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2016,
      lat: 26.81097222,
      lng: -108.1691667,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2017,
      lat: 25.89233333,
      lng: -107.5811667,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2022,
      lat: 23.558336,
      lng: -106.60081,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Cazadores",
      semana: 10,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2017,
      lat: 25.76022222,
      lng: -107.5704167,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34,
    },
    {
      anio: 2020,
      lat: 25.71146944,
      lng: -107.4954194,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2021,
      lat: 26.57208056,
      lng: -108.3382389,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2021,
      lat: 25.74867222,
      lng: -107.6430833,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2025,
      lat: 27.544588,
      lng: -107.42083,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 27.409079,
      lng: -107.39144,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 397,
    },
    {
      anio: 2025,
      lat: 27.258375,
      lng: -106.950325,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2025,
      lat: 26.164658,
      lng: -106.60841,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2025,
      lat: 26.189888,
      lng: -106.819885,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 25.868055,
      lng: -106.715,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 26.237843,
      lng: -106.62885,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 27.08325,
      lng: -108.109116,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 26.496252,
      lng: -107.26901,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2025,
      lat: 26.105528,
      lng: -106.82039,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2025,
      lat: 26.902872,
      lng: -107.632416,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2025,
      lat: 27.183125,
      lng: -108.334755,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 209,
    },
    {
      anio: 2025,
      lat: 27.134289,
      lng: -108.0719,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2025,
      lat: 26.744265,
      lng: -107.283035,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2025,
      lat: 27.122831,
      lng: -107.4528,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2025,
      lat: 26.525553,
      lng: -107.89143,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2025,
      lat: 26.366209,
      lng: -107.36698,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2025,
      lat: 26.493635,
      lng: -107.64368,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 112,
    },
    {
      anio: 2025,
      lat: 26.571869,
      lng: -107.26613,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 107,
    },
    {
      anio: 2025,
      lat: 26.483894,
      lng: -107.805084,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 26.112862,
      lng: -106.80842,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 27.492836,
      lng: -107.97477,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2025,
      lat: 26.673367,
      lng: -107.61285,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 26.625519,
      lng: -107.0331,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 79,
    },
    {
      anio: 2025,
      lat: 26.332825,
      lng: -107.13017,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 71,
    },
    {
      anio: 2025,
      lat: 25.908056,
      lng: -107.02267,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 57,
    },
    {
      anio: 2025,
      lat: 26.217476,
      lng: -107.673294,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 56,
    },
    {
      anio: 2025,
      lat: 27.421238,
      lng: -108.33158,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 26.820663,
      lng: -107.47975,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 25.848333,
      lng: -106.96507,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 42,
    },
    {
      anio: 2025,
      lat: 26.448242,
      lng: -107.75278,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 412,
    },
    {
      anio: 2025,
      lat: 26.545889,
      lng: -107.25261,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.166529,
      lng: -106.88245,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.734821,
      lng: -107.756775,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 39,
    },
    {
      anio: 2025,
      lat: 26.098137,
      lng: -107.05367,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 318,
    },
    {
      anio: 2025,
      lat: 26.88723,
      lng: -107.46918,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 25.958467,
      lng: -106.97499,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.627611,
      lng: -107.83112,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 278,
    },
    {
      anio: 2025,
      lat: 26.195084,
      lng: -106.82686,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 26.7775,
      lng: -107.30444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 190,
    },
    {
      anio: 2025,
      lat: 26.474792,
      lng: -107.14441,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 180,
    },
    {
      anio: 2025,
      lat: 26.694809,
      lng: -107.71732,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2025,
      lat: 27.333559,
      lng: -108.21925,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 118,
    },
    {
      anio: 2025,
      lat: 26.683136,
      lng: -107.856995,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 11,
    },
    {
      anio: 2025,
      lat: 27.059328,
      lng: -108.40614,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 11,
    },
    {
      anio: 2025,
      lat: 27.151583,
      lng: -107.25958,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 107,
    },
    {
      anio: 2025,
      lat: 27.049305,
      lng: -107.44065,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 88,
    },
    {
      anio: 2025,
      lat: 26.104315,
      lng: -107.06838,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 25.893198,
      lng: -107.09261,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 679,
    },
    {
      anio: 2025,
      lat: 26.252272,
      lng: -107.22419,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3772,
    },
    {
      anio: 2025,
      lat: 26.251339,
      lng: -107.30012,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 330,
    },
    {
      anio: 2025,
      lat: 27.477661,
      lng: -107.757385,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2025,
      lat: 27.407383,
      lng: -107.74577,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 234,
    },
    {
      anio: 2025,
      lat: 26.29698,
      lng: -107.040215,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1277,
    },
    {
      anio: 2025,
      lat: 25.822659,
      lng: -106.944275,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2025,
      lat: 27.304153,
      lng: -108.18573,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 25.97441,
      lng: -107.25358,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2025,
      lat: 26.090094,
      lng: -106.92967,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras actividades productivas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 26.374779,
      lng: -107.06082,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 832,
    },
    {
      anio: 2025,
      lat: 27.541992,
      lng: -107.795,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 82,
    },
    {
      anio: 2025,
      lat: 26.679691,
      lng: -107.83773,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 79,
    },
    {
      anio: 2025,
      lat: 27.120039,
      lng: -107.95054,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 74,
    },
    {
      anio: 2025,
      lat: 27.431202,
      lng: -107.874565,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 725.2409,
    },
    {
      anio: 2025,
      lat: 27.037636,
      lng: -107.90223,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70,
    },
    {
      anio: 2025,
      lat: 25.822365,
      lng: -106.995544,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 662,
    },
    {
      anio: 2025,
      lat: 26.163918,
      lng: -106.6153,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 66,
    },
    {
      anio: 2025,
      lat: 27.626284,
      lng: -107.56829,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2025,
      lat: 26.567995,
      lng: -107.096855,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 553,
    },
    {
      anio: 2025,
      lat: 26.40009,
      lng: -107.08465,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 544,
    },
    {
      anio: 2025,
      lat: 26.84135,
      lng: -107.31311,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 5378,
    },
    {
      anio: 2025,
      lat: 26.43759,
      lng: -106.891205,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2025,
      lat: 26.907545,
      lng: -107.62325,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 26.044737,
      lng: -106.938194,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 49,
    },
    {
      anio: 2025,
      lat: 26.665136,
      lng: -107.55422,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 435,
    },
    {
      anio: 2025,
      lat: 27.030996,
      lng: -108.407936,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 425,
    },
    {
      anio: 2025,
      lat: 26.461445,
      lng: -107.390274,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.406816,
      lng: -106.762436,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2025,
      lat: 27.47223,
      lng: -107.949005,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33,
    },
    {
      anio: 2025,
      lat: 26.634108,
      lng: -107.489105,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 302,
    },
    {
      anio: 2025,
      lat: 25.643827,
      lng: -106.67274,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.324179,
      lng: -106.923935,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 265,
    },
    {
      anio: 2025,
      lat: 26.749752,
      lng: -107.34806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1921,
    },
    {
      anio: 2025,
      lat: 26.580809,
      lng: -107.32279,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 187,
    },
    {
      anio: 2025,
      lat: 27.281666,
      lng: -108.24695,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 185,
    },
    {
      anio: 2025,
      lat: 25.790735,
      lng: -106.96426,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2025,
      lat: 26.931377,
      lng: -107.25696,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2025,
      lat: 26.419958,
      lng: -107.60425,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2025,
      lat: 27.120842,
      lng: -107.25397,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 138,
    },
    {
      anio: 2025,
      lat: 26.150362,
      lng: -106.58087,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 132,
    },
    {
      anio: 2025,
      lat: 27.298227,
      lng: -107.562645,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 125.8006,
    },
    {
      anio: 2025,
      lat: 26.345383,
      lng: -107.35392,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 11.211,
    },
    {
      anio: 2025,
      lat: 27.315517,
      lng: -107.90502,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1042.7917,
    },
    {
      anio: 2025,
      lat: 26.29719,
      lng: -107.65176,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 951,
    },
    {
      anio: 2025,
      lat: 27.288748,
      lng: -107.64789,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 755.7345,
    },
    {
      anio: 2025,
      lat: 25.918358,
      lng: -106.951454,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2025,
      lat: 27.59,
      lng: -107.923,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65,
    },
    {
      anio: 2025,
      lat: 27.334225,
      lng: -107.75894,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 616,
    },
    {
      anio: 2025,
      lat: 26.520119,
      lng: -107.48197,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.7095,
    },
    {
      anio: 2025,
      lat: 26.471676,
      lng: -107.31082,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 26.128305,
      lng: -106.821526,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.813816,
      lng: -107.119675,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 37.8626,
    },
    {
      anio: 2025,
      lat: 26.4533,
      lng: -107.17741,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.112652,
      lng: -106.876076,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 25.854708,
      lng: -106.5789,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 28,
    },
    {
      anio: 2025,
      lat: 25.667933,
      lng: -106.7699,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 237.5802,
    },
    {
      anio: 2025,
      lat: 27.071997,
      lng: -107.09185,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2025,
      lat: 26.127295,
      lng: -106.933174,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.8771,
    },
    {
      anio: 2025,
      lat: 26.559328,
      lng: -107.546715,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 149,
    },
    {
      anio: 2025,
      lat: 27.511602,
      lng: -107.98181,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 14.0302,
    },
    {
      anio: 2025,
      lat: 26.091438,
      lng: -106.77888,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2025,
      lat: 27.008244,
      lng: -107.17783,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.6518,
    },
    {
      anio: 2025,
      lat: 25.795723,
      lng: -106.65893,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.003,
    },
    {
      anio: 2025,
      lat: 26.43946,
      lng: -107.28418,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 27.16894,
      lng: -107.39158,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 87.8777,
    },
    {
      anio: 2025,
      lat: 26.35792,
      lng: -106.5849,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2025,
      lat: 26.596714,
      lng: -107.55189,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62,
    },
    {
      anio: 2025,
      lat: 27.237856,
      lng: -107.37333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60.0672,
    },
    {
      anio: 2025,
      lat: 26.832842,
      lng: -107.45692,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2025,
      lat: 26.607294,
      lng: -107.73827,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 4591.6723,
    },
    {
      anio: 2025,
      lat: 25.898453,
      lng: -106.956665,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 27.443327,
      lng: -108.00133,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.515837,
      lng: -107.08568,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 36,
    },
    {
      anio: 2025,
      lat: 27.107622,
      lng: -108.04084,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 35.4534,
    },
    {
      anio: 2025,
      lat: 26.827597,
      lng: -107.897285,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 31.9249,
    },
    {
      anio: 2025,
      lat: 26.39079,
      lng: -107.567566,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 25.74375,
      lng: -106.786446,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.186436,
      lng: -107.72887,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2025,
      lat: 26.076664,
      lng: -106.769394,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 25.768778,
      lng: -106.80064,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 25.69301,
      lng: -106.86492,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2025,
      lat: 26.458334,
      lng: -107.28055,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1.257,
    },
    {
      anio: 2025,
      lat: 27.560514,
      lng: -107.496544,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.4718,
    },
    {
      anio: 2025,
      lat: 26.101555,
      lng: -106.78689,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.0915,
      lng: -106.818054,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.175327,
      lng: -106.618385,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.316341,
      lng: -107.21126,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 3013,
    },
    {
      anio: 2025,
      lat: 26.700434,
      lng: -107.587906,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 99.7048,
    },
    {
      anio: 2025,
      lat: 27.099983,
      lng: -107.57262,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 91.3566,
    },
    {
      anio: 2025,
      lat: 26.484459,
      lng: -107.38022,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 86.5,
    },
    {
      anio: 2025,
      lat: 27.111212,
      lng: -107.248215,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2025,
      lat: 26.497328,
      lng: -107.328186,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 47,
    },
    {
      anio: 2025,
      lat: 27.451773,
      lng: -108.21704,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 27.295475,
      lng: -107.42332,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 338.7739,
    },
    {
      anio: 2025,
      lat: 27.27979,
      lng: -107.984245,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5757,
    },
    {
      anio: 2025,
      lat: 26.614664,
      lng: -107.27543,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 2433,
    },
    {
      anio: 2025,
      lat: 26.100115,
      lng: -106.80903,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.2486,
    },
    {
      anio: 2025,
      lat: 25.82375,
      lng: -106.81036,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 27.526003,
      lng: -108.138115,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2025,
      lat: 26.72166,
      lng: -107.25994,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 149.5905,
    },
    {
      anio: 2025,
      lat: 26.212847,
      lng: -106.50367,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1422,
    },
    {
      anio: 2025,
      lat: 27.090328,
      lng: -108.3825,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 1185,
    },
    {
      anio: 2025,
      lat: 27.51641,
      lng: -107.7533,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 109,
    },
    {
      anio: 2025,
      lat: 26.054136,
      lng: -107.033806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 102.0495,
    },
    {
      anio: 2025,
      lat: 26.114975,
      lng: -106.93282,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 26.310806,
      lng: -106.816505,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 93.5073,
    },
    {
      anio: 2025,
      lat: 26.286888,
      lng: -106.94857,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79.3601,
    },
    {
      anio: 2025,
      lat: 26.62663,
      lng: -107.040855,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 63.7593,
    },
    {
      anio: 2025,
      lat: 26.216034,
      lng: -107.152794,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 55.647,
    },
    {
      anio: 2025,
      lat: 26.618166,
      lng: -107.13611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 523.5478,
    },
    {
      anio: 2025,
      lat: 25.931028,
      lng: -106.99179,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 50.9131,
    },
    {
      anio: 2025,
      lat: 25.928654,
      lng: -107.085625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 508,
    },
    {
      anio: 2025,
      lat: 27.105717,
      lng: -107.29331,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.7598,
    },
    {
      anio: 2025,
      lat: 27.249855,
      lng: -108.24632,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 417.6693,
    },
    {
      anio: 2025,
      lat: 26.026075,
      lng: -106.847595,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 25.747261,
      lng: -106.78686,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.6964,
    },
    {
      anio: 2025,
      lat: 26.483627,
      lng: -106.836685,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2025,
      lat: 25.847761,
      lng: -106.57485,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 32.652,
    },
    {
      anio: 2025,
      lat: 27.464441,
      lng: -107.951416,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.3954,
    },
    {
      anio: 2025,
      lat: 26.024855,
      lng: -106.84611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 2.8153,
    },
    {
      anio: 2025,
      lat: 26.084583,
      lng: -106.69475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2025,
      lat: 25.790703,
      lng: -106.83477,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 26.047514,
      lng: -106.88199,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Otras actividades productivas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2025,
      lat: 27.29814,
      lng: -107.38619,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 147.8919,
    },
    {
      anio: 2025,
      lat: 27.53698,
      lng: -107.962074,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 141.0781,
    },
    {
      anio: 2025,
      lat: 25.862444,
      lng: -106.67912,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2025,
      lat: 26.874037,
      lng: -107.022835,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2025,
      lat: 27.574709,
      lng: -108.032234,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 12,
    },
    {
      anio: 2025,
      lat: 27.542162,
      lng: -107.71342,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 112,
    },
    {
      anio: 2025,
      lat: 26.319798,
      lng: -106.746056,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 86.5827,
    },
    {
      anio: 2025,
      lat: 27.05922,
      lng: -107.57441,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83,
    },
    {
      anio: 2025,
      lat: 26.705194,
      lng: -107.28357,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 523,
    },
    {
      anio: 2025,
      lat: 25.95635,
      lng: -106.90264,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 25.861506,
      lng: -106.68373,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 4.5,
    },
    {
      anio: 2025,
      lat: 25.87178,
      lng: -106.951706,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 38,
    },
    {
      anio: 2025,
      lat: 26.845303,
      lng: -107.21017,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.035631,
      lng: -106.93425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2025,
      lat: 26.701944,
      lng: -107.92879,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 238,
    },
    {
      anio: 2025,
      lat: 27.116224,
      lng: -107.411476,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 222.1686,
    },
    {
      anio: 2025,
      lat: 26.483421,
      lng: -107.344055,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21,
    },
    {
      anio: 2025,
      lat: 25.95675,
      lng: -106.951225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 26.0439,
      lng: -107.01993,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 19,
    },
    {
      anio: 2025,
      lat: 25.94341,
      lng: -107.26677,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 161,
    },
    {
      anio: 2025,
      lat: 26.716461,
      lng: -107.2967,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1583.6242,
    },
    {
      anio: 2025,
      lat: 27.388714,
      lng: -107.70173,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.155,
    },
    {
      anio: 2025,
      lat: 26.308714,
      lng: -106.670105,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 102,
    },
    {
      anio: 2025,
      lat: 25.860806,
      lng: -106.98411,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 26.226944,
      lng: -106.656944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 25.873198,
      lng: -106.9732,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.946255,
      lng: -107.288666,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 27.642262,
      lng: -107.629105,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 27.520994,
      lng: -107.973305,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 26.327969,
      lng: -106.93229,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.1266,
    },
    {
      anio: 2025,
      lat: 26.312025,
      lng: -107.1687,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 80.0342,
    },
    {
      anio: 2025,
      lat: 26.703619,
      lng: -106.89005,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 79,
    },
    {
      anio: 2025,
      lat: 27.169422,
      lng: -108.08923,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 781.8906,
    },
    {
      anio: 2025,
      lat: 26.52647,
      lng: -107.11375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 60.2897,
    },
    {
      anio: 2025,
      lat: 27.462627,
      lng: -107.927666,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.8798,
    },
    {
      anio: 2025,
      lat: 26.43853,
      lng: -106.909904,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 56.7751,
    },
    {
      anio: 2025,
      lat: 27.097155,
      lng: -108.08447,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 528.9088,
    },
    {
      anio: 2025,
      lat: 25.907825,
      lng: -106.929756,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 26.637741,
      lng: -107.076256,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 42,
    },
    {
      anio: 2025,
      lat: 25.857058,
      lng: -106.987495,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.996529,
      lng: -107.487785,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 37.9803,
    },
    {
      anio: 2025,
      lat: 26.471165,
      lng: -107.286934,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2025,
      lat: 25.906528,
      lng: -106.94156,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.579197,
      lng: -106.94314,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 259.6199,
    },
    {
      anio: 2025,
      lat: 27.072819,
      lng: -107.36617,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 259.0318,
    },
    {
      anio: 2025,
      lat: 26.40427,
      lng: -107.3176,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2025,
      lat: 26.857021,
      lng: -107.15282,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 21.4907,
    },
    {
      anio: 2025,
      lat: 25.8618,
      lng: -106.99039,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.0814,
    },
    {
      anio: 2025,
      lat: 26.50437,
      lng: -107.32513,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.5728,
    },
    {
      anio: 2025,
      lat: 26.423641,
      lng: -106.83113,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 204.1457,
    },
    {
      anio: 2025,
      lat: 26.472044,
      lng: -107.12455,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 177.7611,
    },
    {
      anio: 2025,
      lat: 27.331678,
      lng: -108.14629,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 167.952,
    },
    {
      anio: 2025,
      lat: 26.4931,
      lng: -107.29344,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2025,
      lat: 26.518145,
      lng: -107.3195,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.0702,
    },
    {
      anio: 2025,
      lat: 26.862942,
      lng: -107.09299,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 102.5211,
    },
    {
      anio: 2025,
      lat: 26.62254,
      lng: -107.054794,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 100,
    },
    {
      anio: 2025,
      lat: 25.914442,
      lng: -106.69093,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 26.443727,
      lng: -106.82594,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 25.90475,
      lng: -106.94078,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 27.471306,
      lng: -107.9415,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 25.929522,
      lng: -106.9571,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 7.0412,
    },
    {
      anio: 2025,
      lat: 25.90743,
      lng: -106.80447,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 6.219,
    },
    {
      anio: 2025,
      lat: 26.215944,
      lng: -107.71719,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 49.2629,
    },
    {
      anio: 2025,
      lat: 26.91524,
      lng: -107.337265,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 31.7985,
    },
    {
      anio: 2025,
      lat: 27.249895,
      lng: -107.45827,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8908,
    },
    {
      anio: 2025,
      lat: 26.418589,
      lng: -107.98385,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2213.7172,
    },
    {
      anio: 2025,
      lat: 26.170456,
      lng: -106.59183,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.0598,
    },
    {
      anio: 2025,
      lat: 26.008205,
      lng: -106.88378,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Quema de basureros",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.05,
    },
    {
      anio: 2025,
      lat: 27.033817,
      lng: -107.13026,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 178.3189,
    },
    {
      anio: 2025,
      lat: 27.09107,
      lng: -107.21997,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.0431,
    },
    {
      anio: 2025,
      lat: 26.180733,
      lng: -106.86796,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 10.0082,
    },
    {
      anio: 2025,
      lat: 26.542294,
      lng: -107.29354,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8204,
    },
    {
      anio: 2025,
      lat: 25.906445,
      lng: -106.93993,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2025,
      lat: 27.336384,
      lng: -108.15151,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79.2054,
    },
    {
      anio: 2025,
      lat: 26.861,
      lng: -107.376495,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70.92,
    },
    {
      anio: 2025,
      lat: 26.466028,
      lng: -107.3685,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70.697,
    },
    {
      anio: 2025,
      lat: 27.391289,
      lng: -107.13709,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 668.6723,
    },
    {
      anio: 2025,
      lat: 25.885866,
      lng: -106.841034,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60.2184,
    },
    {
      anio: 2025,
      lat: 27.107498,
      lng: -107.387115,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.3774,
    },
    {
      anio: 2025,
      lat: 26.588495,
      lng: -107.52179,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 442.6609,
    },
    {
      anio: 2025,
      lat: 26.77882,
      lng: -107.37541,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.9876,
    },
    {
      anio: 2025,
      lat: 26.676332,
      lng: -107.22821,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 375.9414,
    },
    {
      anio: 2025,
      lat: 26.03585,
      lng: -106.96627,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.2371,
    },
    {
      anio: 2025,
      lat: 26.916603,
      lng: -107.057175,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.8396,
    },
    {
      anio: 2025,
      lat: 26.108229,
      lng: -106.81013,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.0582,
    },
    {
      anio: 2025,
      lat: 26.09075,
      lng: -106.77861,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 25.857244,
      lng: -106.91342,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9545,
    },
    {
      anio: 2025,
      lat: 27.574383,
      lng: -107.71176,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 194.9155,
    },
    {
      anio: 2025,
      lat: 26.95657,
      lng: -106.97673,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8472,
    },
    {
      anio: 2025,
      lat: 27.51178,
      lng: -107.96274,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2025,
      lat: 27.652033,
      lng: -108.22671,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 14.2,
    },
    {
      anio: 2025,
      lat: 26.735834,
      lng: -107.083885,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2025,
      lat: 27.342186,
      lng: -107.396736,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1204.6161,
    },
    {
      anio: 2025,
      lat: 27.500816,
      lng: -107.31343,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.9879,
    },
    {
      anio: 2025,
      lat: 25.825134,
      lng: -106.81667,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 103.9967,
    },
    {
      anio: 2025,
      lat: 26.797777,
      lng: -107.09361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.906834,
      lng: -106.995,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9829,
    },
    {
      anio: 2025,
      lat: 26.739447,
      lng: -107.1204,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9014,
    },
    {
      anio: 2025,
      lat: 25.708097,
      lng: -106.852,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2025,
      lat: 26.028034,
      lng: -107.057434,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 81,
    },
    {
      anio: 2025,
      lat: 27.596672,
      lng: -108.319374,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 747.5334,
    },
    {
      anio: 2025,
      lat: 27.487833,
      lng: -107.87639,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5598,
    },
    {
      anio: 2025,
      lat: 27.51257,
      lng: -107.96361,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.3327,
    },
    {
      anio: 2025,
      lat: 26.899136,
      lng: -107.204506,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.3595,
    },
    {
      anio: 2025,
      lat: 26.813612,
      lng: -107.09139,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2025,
      lat: 26.100645,
      lng: -106.81504,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.9227,
    },
    {
      anio: 2025,
      lat: 26.665945,
      lng: -107.140564,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 368.4499,
    },
    {
      anio: 2025,
      lat: 25.982319,
      lng: -107.05879,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.7022,
    },
    {
      anio: 2025,
      lat: 27.191795,
      lng: -106.96235,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.1219,
    },
    {
      anio: 2025,
      lat: 27.108198,
      lng: -107.89368,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.6388,
    },
    {
      anio: 2025,
      lat: 26.426739,
      lng: -107.86785,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 233.582,
    },
    {
      anio: 2025,
      lat: 25.871805,
      lng: -106.953606,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 27.21041,
      lng: -107.0678,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.6087,
    },
    {
      anio: 2025,
      lat: 25.848764,
      lng: -106.64768,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 189.7531,
    },
    {
      anio: 2025,
      lat: 26.816639,
      lng: -107.41666,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8637,
    },
    {
      anio: 2025,
      lat: 26.422062,
      lng: -106.95051,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.3144,
    },
    {
      anio: 2025,
      lat: 27.131804,
      lng: -107.2936,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.708,
    },
    {
      anio: 2025,
      lat: 27.480972,
      lng: -107.910835,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 27.490494,
      lng: -107.88115,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4646,
    },
    {
      anio: 2025,
      lat: 25.780544,
      lng: -106.687126,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.4553,
    },
    {
      anio: 2025,
      lat: 27.011461,
      lng: -107.56982,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2025,
      lat: 26.003517,
      lng: -106.56083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 485.4543,
    },
    {
      anio: 2025,
      lat: 26.331367,
      lng: -107.610634,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 324,
    },
    {
      anio: 2025,
      lat: 26.295986,
      lng: -106.6771,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.9688,
    },
    {
      anio: 2025,
      lat: 27.046711,
      lng: -107.35968,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 248.3558,
    },
    {
      anio: 2025,
      lat: 25.624683,
      lng: -106.819916,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 206.0539,
    },
    {
      anio: 2025,
      lat: 26.108166,
      lng: -106.79808,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 26.916073,
      lng: -107.23491,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.4792,
    },
    {
      anio: 2025,
      lat: 27.031982,
      lng: -106.973694,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 152.5383,
    },
    {
      anio: 2025,
      lat: 27.35947,
      lng: -107.8592,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 124.3099,
    },
    {
      anio: 2025,
      lat: 26.21733,
      lng: -106.81728,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1996,
    },
    {
      anio: 2025,
      lat: 25.911741,
      lng: -106.73062,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1036,
    },
    {
      anio: 2025,
      lat: 26.090927,
      lng: -106.92686,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.8581,
    },
    {
      anio: 2025,
      lat: 25.672321,
      lng: -106.74665,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 78.8082,
    },
    {
      anio: 2025,
      lat: 26.75381,
      lng: -106.98498,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 7.8422,
    },
    {
      anio: 2025,
      lat: 26.817923,
      lng: -107.262024,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 7.4445,
    },
    {
      anio: 2025,
      lat: 26.346615,
      lng: -106.90049,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 54.7878,
    },
    {
      anio: 2025,
      lat: 26.803589,
      lng: -107.25319,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.2812,
    },
    {
      anio: 2025,
      lat: 27.556292,
      lng: -108.1214,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 39,
    },
    {
      anio: 2025,
      lat: 26.014706,
      lng: -107.12227,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 275,
    },
    {
      anio: 2025,
      lat: 26.601597,
      lng: -106.98032,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2025,
      lat: 26.76655,
      lng: -107.1636,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.6987,
    },
    {
      anio: 2025,
      lat: 26.05281,
      lng: -106.53202,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 20.86,
    },
    {
      anio: 2025,
      lat: 26.089308,
      lng: -106.82276,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.0749,
    },
    {
      anio: 2025,
      lat: 27.698156,
      lng: -108.14378,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.4169,
    },
    {
      anio: 2025,
      lat: 26.682495,
      lng: -107.15716,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 717.6999,
    },
    {
      anio: 2025,
      lat: 27.136658,
      lng: -108.04787,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 65.834,
    },
    {
      anio: 2025,
      lat: 26.847036,
      lng: -107.13891,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65.834,
    },
    {
      anio: 2025,
      lat: 26.864754,
      lng: -107.35868,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64.451,
    },
    {
      anio: 2025,
      lat: 26.13139,
      lng: -106.74245,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2315,
    },
    {
      anio: 2025,
      lat: 26.761852,
      lng: -107.178986,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5121,
    },
    {
      anio: 2025,
      lat: 27.120783,
      lng: -108.07183,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7097,
    },
    {
      anio: 2025,
      lat: 27.518492,
      lng: -108.03222,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.9836,
    },
    {
      anio: 2025,
      lat: 26.798067,
      lng: -107.03017,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.8296,
    },
    {
      anio: 2025,
      lat: 26.083084,
      lng: -106.77028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.41,
    },
    {
      anio: 2025,
      lat: 26.902372,
      lng: -107.070114,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.9817,
    },
    {
      anio: 2025,
      lat: 27.295767,
      lng: -108.0779,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Quema de basureros",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5342,
    },
    {
      anio: 2025,
      lat: 26.830881,
      lng: -107.05406,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.9181,
    },
    {
      anio: 2025,
      lat: 26.131824,
      lng: -106.62265,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55.9813,
    },
    {
      anio: 2025,
      lat: 26.328316,
      lng: -107.16963,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.4608,
    },
    {
      anio: 2025,
      lat: 26.858606,
      lng: -107.38332,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 43.066,
    },
    {
      anio: 2025,
      lat: 26.312784,
      lng: -107.144516,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.7011,
    },
    {
      anio: 2025,
      lat: 27.55575,
      lng: -107.83808,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9341,
    },
    {
      anio: 2025,
      lat: 27.01582,
      lng: -107.34042,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 224.078,
    },
    {
      anio: 2025,
      lat: 27.56546,
      lng: -108.04688,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.8244,
    },
    {
      anio: 2025,
      lat: 26.511469,
      lng: -107.65321,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.6882,
    },
    {
      anio: 2025,
      lat: 27.078026,
      lng: -107.281586,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 131.2092,
    },
    {
      anio: 2025,
      lat: 26.502747,
      lng: -107.0798,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 104.394,
    },
    {
      anio: 2025,
      lat: 27.44531,
      lng: -107.883865,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.0377,
    },
    {
      anio: 2025,
      lat: 27.438972,
      lng: -107.87505,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5689,
    },
    {
      anio: 2025,
      lat: 26.799603,
      lng: -107.2421,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.2688,
    },
    {
      anio: 2025,
      lat: 27.025652,
      lng: -107.17804,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 54.5742,
    },
    {
      anio: 2025,
      lat: 27.102133,
      lng: -107.223495,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.0325,
    },
    {
      anio: 2025,
      lat: 26.167522,
      lng: -106.92571,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.0547,
    },
    {
      anio: 2025,
      lat: 26.962503,
      lng: -107.5332,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 3.471,
    },
    {
      anio: 2025,
      lat: 26.793066,
      lng: -107.19079,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.4468,
    },
    {
      anio: 2025,
      lat: 26.910913,
      lng: -107.53697,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.0607,
    },
    {
      anio: 2025,
      lat: 26.713148,
      lng: -107.14145,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.7675,
    },
    {
      anio: 2025,
      lat: 26.701597,
      lng: -107.2171,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.6223,
    },
    {
      anio: 2025,
      lat: 26.73603,
      lng: -107.10075,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.902908,
      lng: -107.220566,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 26.575708,
      lng: -106.987656,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 94.2632,
    },
    {
      anio: 2025,
      lat: 27.631569,
      lng: -108.0966,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 77.965,
    },
    {
      anio: 2025,
      lat: 26.2975,
      lng: -106.992226,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 47.0147,
    },
    {
      anio: 2025,
      lat: 27.131111,
      lng: -107.32361,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.124,
    },
    {
      anio: 2025,
      lat: 27.3234,
      lng: -107.41059,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.0923,
    },
    {
      anio: 2025,
      lat: 26.314064,
      lng: -107.18957,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.2975,
    },
    {
      anio: 2025,
      lat: 26.325277,
      lng: -106.75278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 99.9116,
    },
    {
      anio: 2025,
      lat: 26.863733,
      lng: -107.19218,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 91.011,
    },
    {
      anio: 2025,
      lat: 27.209444,
      lng: -108.170555,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 73.2337,
    },
    {
      anio: 2025,
      lat: 26.737188,
      lng: -107.12431,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.769,
    },
    {
      anio: 2025,
      lat: 27.506111,
      lng: -108.10722,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.2347,
    },
    {
      anio: 2025,
      lat: 27.504723,
      lng: -107.87195,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.824,
    },
    {
      anio: 2025,
      lat: 26.100056,
      lng: -106.79556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.9582,
    },
    {
      anio: 2025,
      lat: 26.088888,
      lng: -106.76244,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.0887,
    },
    {
      anio: 2025,
      lat: 26.333662,
      lng: -106.761246,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 26.513603,
      lng: -107.626205,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.6546,
    },
    {
      anio: 2025,
      lat: 26.118128,
      lng: -106.61694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 161.9903,
    },
    {
      anio: 2025,
      lat: 27.27537,
      lng: -107.7195,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.7416,
    },
    {
      anio: 2025,
      lat: 26.077522,
      lng: -106.846146,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.6313,
    },
    {
      anio: 2025,
      lat: 27.349178,
      lng: -108.18955,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Transportes",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2.5,
    },
    {
      anio: 2025,
      lat: 27.13889,
      lng: -108.02556,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.2289,
    },
    {
      anio: 2025,
      lat: 26.016111,
      lng: -107.013885,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 439.331,
    },
    {
      anio: 2025,
      lat: 27.071112,
      lng: -107.405556,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 184.7872,
    },
    {
      anio: 2025,
      lat: 26.713612,
      lng: -106.93806,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.129,
    },
    {
      anio: 2025,
      lat: 26.713577,
      lng: -106.89401,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 123.3833,
    },
    {
      anio: 2025,
      lat: 26.19861,
      lng: -106.62639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 1,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.0464,
    },
    {
      anio: 2024,
      lat: 27.4286,
      lng: -108.42576,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 40,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 86.7794,
    },
    {
      anio: 2024,
      lat: 27.644485,
      lng: -108.078835,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 49,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.6213,
    },
    {
      anio: 2024,
      lat: 26.962217,
      lng: -107.54244,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Festividades y rituales",
      semana: 50,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.217,
    },
    {
      anio: 2024,
      lat: 26.006666,
      lng: -107.007774,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Festividades y rituales",
      semana: 50,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 123.7086,
    },
    {
      anio: 2024,
      lat: 27.594723,
      lng: -108.07,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 51,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.1446,
    },
    {
      anio: 2024,
      lat: 27.03139,
      lng: -108.21778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 51,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.6075,
    },
    {
      anio: 2024,
      lat: 26.08639,
      lng: -106.72444,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 51,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.6759,
    },
    {
      anio: 2024,
      lat: 27.491,
      lng: -107.87544,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 51,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.8511,
    },
    {
      anio: 2024,
      lat: 26.786888,
      lng: -107.38362,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 52,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.265,
    },
    {
      anio: 2024,
      lat: 27.119722,
      lng: -108.00389,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 52,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.6267,
    },
    {
      anio: 2024,
      lat: 25.966389,
      lng: -107.12945,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 53,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 79.9345,
    },
    {
      anio: 2024,
      lat: 27.344444,
      lng: -107.50584,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 53,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70.0532,
    },
    {
      anio: 2024,
      lat: 26.879444,
      lng: -107.34417,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 53,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100.6005,
    },
    {
      anio: 2024,
      lat: 27.581879,
      lng: -107.81047,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 55.4905,
    },
    {
      anio: 2024,
      lat: 26.365643,
      lng: -107.51269,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 481.7807,
    },
    {
      anio: 2024,
      lat: 27.496944,
      lng: -107.90139,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.6203,
    },
    {
      anio: 2024,
      lat: 27.504333,
      lng: -107.901794,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3144,
    },
    {
      anio: 2024,
      lat: 26.114658,
      lng: -106.87789,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.1414,
    },
    {
      anio: 2024,
      lat: 26.295008,
      lng: -106.68888,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 61.4467,
    },
    {
      anio: 2024,
      lat: 25.84289,
      lng: -106.9622,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 58.2068,
    },
    {
      anio: 2024,
      lat: 26.214914,
      lng: -107.28098,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 506.9636,
    },
    {
      anio: 2024,
      lat: 26.234444,
      lng: -106.89222,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40.1557,
    },
    {
      anio: 2024,
      lat: 26.661566,
      lng: -107.241714,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 366.1363,
    },
    {
      anio: 2024,
      lat: 26.441725,
      lng: -107.28443,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.8398,
    },
    {
      anio: 2024,
      lat: 26.527683,
      lng: -106.91678,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.7818,
    },
    {
      anio: 2024,
      lat: 26.397911,
      lng: -107.56433,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 225.675,
    },
    {
      anio: 2024,
      lat: 26.475508,
      lng: -107.59669,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 180.2061,
    },
    {
      anio: 2024,
      lat: 25.733055,
      lng: -106.80639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7423,
    },
    {
      anio: 2024,
      lat: 26.2561,
      lng: -106.8078,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.7111,
    },
    {
      anio: 2024,
      lat: 27.508686,
      lng: -107.92172,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3221,
    },
    {
      anio: 2024,
      lat: 26.127764,
      lng: -106.672554,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.2052,
    },
    {
      anio: 2024,
      lat: 26.15473,
      lng: -106.7653,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2599,
    },
    {
      anio: 2024,
      lat: 27.180367,
      lng: -107.970276,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 108.6811,
    },
    {
      anio: 2024,
      lat: 25.735104,
      lng: -106.78167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5579,
    },
    {
      anio: 2024,
      lat: 27.588448,
      lng: -107.872,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.0225,
    },
    {
      anio: 2024,
      lat: 27.152866,
      lng: -107.46092,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 81.5268,
    },
    {
      anio: 2024,
      lat: 26.054472,
      lng: -106.8793,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.1652,
    },
    {
      anio: 2024,
      lat: 27.053188,
      lng: -108.14923,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 69.5284,
    },
    {
      anio: 2024,
      lat: 26.330189,
      lng: -107.721054,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 622.819,
    },
    {
      anio: 2024,
      lat: 26.0409,
      lng: -106.72949,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2055,
    },
    {
      anio: 2024,
      lat: 26.388811,
      lng: -106.668785,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 578.0143,
    },
    {
      anio: 2024,
      lat: 27.428595,
      lng: -107.88695,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 55.0639,
    },
    {
      anio: 2024,
      lat: 26.290398,
      lng: -106.7186,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.4564,
    },
    {
      anio: 2024,
      lat: 26.41715,
      lng: -107.07229,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4304.8469,
    },
    {
      anio: 2024,
      lat: 27.350277,
      lng: -108.34824,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 381.8543,
    },
    {
      anio: 2024,
      lat: 26.138819,
      lng: -107.23368,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 331.649,
    },
    {
      anio: 2024,
      lat: 25.979912,
      lng: -106.7086,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9807,
    },
    {
      anio: 2024,
      lat: 26.393965,
      lng: -106.90822,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9152,
    },
    {
      anio: 2024,
      lat: 26.099112,
      lng: -106.714615,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6561,
    },
    {
      anio: 2024,
      lat: 27.426834,
      lng: -108.32162,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 252.8657,
    },
    {
      anio: 2024,
      lat: 25.756628,
      lng: -106.783356,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4176,
    },
    {
      anio: 2024,
      lat: 27.584723,
      lng: -108.09639,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.3878,
    },
    {
      anio: 2024,
      lat: 26.009703,
      lng: -106.68035,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.5521,
    },
    {
      anio: 2024,
      lat: 26.060219,
      lng: -106.87768,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.037,
    },
    {
      anio: 2024,
      lat: 26.234167,
      lng: -106.84333,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8363,
    },
    {
      anio: 2024,
      lat: 26.018478,
      lng: -106.878044,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8155,
    },
    {
      anio: 2024,
      lat: 26.300266,
      lng: -107.13836,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.2746,
    },
    {
      anio: 2024,
      lat: 27.493084,
      lng: -107.657455,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 144.9687,
    },
    {
      anio: 2024,
      lat: 26.4575,
      lng: -107.28611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3987,
    },
    {
      anio: 2024,
      lat: 26.403658,
      lng: -106.979614,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 127.4662,
    },
    {
      anio: 2024,
      lat: 26.013166,
      lng: -106.90839,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1855,
    },
    {
      anio: 2024,
      lat: 25.672163,
      lng: -106.834236,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1466,
    },
    {
      anio: 2024,
      lat: 27.088081,
      lng: -107.30182,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 105.5122,
    },
    {
      anio: 2024,
      lat: 25.933056,
      lng: -106.97611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.7592,
    },
    {
      anio: 2024,
      lat: 26.432331,
      lng: -107.299164,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6231,
    },
    {
      anio: 2024,
      lat: 25.911509,
      lng: -106.97313,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5683,
    },
    {
      anio: 2024,
      lat: 26.401112,
      lng: -107.31084,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.3415,
    },
    {
      anio: 2024,
      lat: 26.35033,
      lng: -107.495224,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 867.6005,
    },
    {
      anio: 2024,
      lat: 26.88539,
      lng: -107.335686,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 71.1792,
    },
    {
      anio: 2024,
      lat: 26.437494,
      lng: -108.009056,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Quema de basureros",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 69.211,
    },
    {
      anio: 2024,
      lat: 27.492945,
      lng: -107.88353,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.6309,
    },
    {
      anio: 2024,
      lat: 25.748888,
      lng: -106.77583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.492,
    },
    {
      anio: 2024,
      lat: 26.100277,
      lng: -106.93972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.4585,
    },
    {
      anio: 2024,
      lat: 26.184555,
      lng: -107.250595,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 486.5565,
    },
    {
      anio: 2024,
      lat: 25.829002,
      lng: -106.88431,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.9577,
    },
    {
      anio: 2024,
      lat: 25.870832,
      lng: -106.88416,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5852,
    },
    {
      anio: 2024,
      lat: 26.451334,
      lng: -107.43697,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 335.5584,
    },
    {
      anio: 2024,
      lat: 27.608055,
      lng: -107.532776,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.279,
    },
    {
      anio: 2024,
      lat: 26.315834,
      lng: -107.18916,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7308,
    },
    {
      anio: 2024,
      lat: 26.395317,
      lng: -107.38776,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.2649,
    },
    {
      anio: 2024,
      lat: 26.019814,
      lng: -107.065865,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.1754,
    },
    {
      anio: 2024,
      lat: 26.138533,
      lng: -106.822876,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2118,
    },
    {
      anio: 2024,
      lat: 26.188334,
      lng: -106.62722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9573,
    },
    {
      anio: 2024,
      lat: 26.459723,
      lng: -107.246666,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8178,
    },
    {
      anio: 2024,
      lat: 26.11205,
      lng: -106.811615,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6905,
    },
    {
      anio: 2024,
      lat: 27.536198,
      lng: -107.91207,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 156.0996,
    },
    {
      anio: 2024,
      lat: 26.115278,
      lng: -106.62583,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4099,
    },
    {
      anio: 2024,
      lat: 25.748333,
      lng: -106.605,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3103,
    },
    {
      anio: 2024,
      lat: 25.89889,
      lng: -106.97111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2783,
    },
    {
      anio: 2024,
      lat: 26.071972,
      lng: -106.79436,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9737,
    },
    {
      anio: 2024,
      lat: 26.027527,
      lng: -106.99825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.7133,
    },
    {
      anio: 2024,
      lat: 26.072222,
      lng: -106.85472,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5532,
    },
    {
      anio: 2024,
      lat: 27.378407,
      lng: -108.0157,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 99.051,
    },
    {
      anio: 2024,
      lat: 27.007341,
      lng: -107.156906,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 806.3577,
    },
    {
      anio: 2024,
      lat: 26.362644,
      lng: -106.79768,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 72.4331,
    },
    {
      anio: 2024,
      lat: 26.100834,
      lng: -106.81111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.7615,
    },
    {
      anio: 2024,
      lat: 26.558647,
      lng: -106.95306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 570.2513,
    },
    {
      anio: 2024,
      lat: 26.473888,
      lng: -107.20805,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5143,
    },
    {
      anio: 2024,
      lat: 26.426945,
      lng: -107.57111,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 540.4024,
    },
    {
      anio: 2024,
      lat: 26.19111,
      lng: -106.757225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.2716,
    },
    {
      anio: 2024,
      lat: 27.248598,
      lng: -107.37916,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 46.592,
    },
    {
      anio: 2024,
      lat: 26.115564,
      lng: -106.819176,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 46.5779,
    },
    {
      anio: 2024,
      lat: 26.464806,
      lng: -106.99297,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 436.4254,
    },
    {
      anio: 2024,
      lat: 26.928177,
      lng: -107.20435,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2024,
      lat: 26.261,
      lng: -106.73028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7425,
    },
    {
      anio: 2024,
      lat: 26.578833,
      lng: -107.1886,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 272.8231,
    },
    {
      anio: 2024,
      lat: 26.667131,
      lng: -106.87245,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 247.0077,
    },
    {
      anio: 2024,
      lat: 25.694723,
      lng: -106.811386,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3606,
    },
    {
      anio: 2024,
      lat: 25.754116,
      lng: -106.798515,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9678,
    },
    {
      anio: 2024,
      lat: 26.90922,
      lng: -107.20309,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 187.8775,
    },
    {
      anio: 2024,
      lat: 27.31147,
      lng: -108.19385,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 137.0554,
    },
    {
      anio: 2024,
      lat: 26.194042,
      lng: -107.1545,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.716,
    },
    {
      anio: 2024,
      lat: 25.784445,
      lng: -106.93083,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.9062,
    },
    {
      anio: 2024,
      lat: 27.34017,
      lng: -107.72064,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 117.8414,
    },
    {
      anio: 2024,
      lat: 26.619244,
      lng: -107.50429,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 117.0716,
    },
    {
      anio: 2024,
      lat: 27.206108,
      lng: -107.97297,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1115.748,
    },
    {
      anio: 2024,
      lat: 25.880833,
      lng: -106.60944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.095,
    },
    {
      anio: 2024,
      lat: 27.099276,
      lng: -107.234795,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 105.2546,
    },
    {
      anio: 2024,
      lat: 25.815098,
      lng: -106.81771,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 100.5062,
    },
    {
      anio: 2024,
      lat: 26.115053,
      lng: -106.80993,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8696,
    },
    {
      anio: 2024,
      lat: 25.691668,
      lng: -106.83806,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5997,
    },
    {
      anio: 2024,
      lat: 27.564337,
      lng: -107.57651,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 97.8688,
    },
    {
      anio: 2024,
      lat: 27.209839,
      lng: -107.65234,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 85.6907,
    },
    {
      anio: 2024,
      lat: 26.719877,
      lng: -107.69466,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 72.5953,
    },
    {
      anio: 2024,
      lat: 27.237139,
      lng: -107.94378,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.4283,
    },
    {
      anio: 2024,
      lat: 26.551165,
      lng: -107.07717,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 541.814,
    },
    {
      anio: 2024,
      lat: 27.134752,
      lng: -108.00497,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.9546,
    },
    {
      anio: 2024,
      lat: 26.125683,
      lng: -106.61371,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.4778,
    },
    {
      anio: 2024,
      lat: 26.501657,
      lng: -106.93238,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 478.3144,
    },
    {
      anio: 2024,
      lat: 26.138334,
      lng: -106.60917,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.9499,
    },
    {
      anio: 2024,
      lat: 27.318277,
      lng: -107.99156,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.7148,
    },
    {
      anio: 2024,
      lat: 27.112173,
      lng: -107.98275,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.3099,
    },
    {
      anio: 2024,
      lat: 27.473297,
      lng: -107.983925,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 373.7508,
    },
    {
      anio: 2024,
      lat: 26.300833,
      lng: -107.35778,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 311.9492,
    },
    {
      anio: 2024,
      lat: 26.983664,
      lng: -107.33595,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 296.7009,
    },
    {
      anio: 2024,
      lat: 27.155506,
      lng: -108.057724,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 223.2648,
    },
    {
      anio: 2024,
      lat: 26.782043,
      lng: -107.34187,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.0562,
    },
    {
      anio: 2024,
      lat: 26.4275,
      lng: -107.24555,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9955,
    },
    {
      anio: 2024,
      lat: 27.42688,
      lng: -107.85532,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 124.7632,
    },
    {
      anio: 2024,
      lat: 27.616924,
      lng: -107.67636,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 103.9458,
    },
    {
      anio: 2024,
      lat: 25.899944,
      lng: -106.94586,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9587,
    },
    {
      anio: 2024,
      lat: 27.453516,
      lng: -107.99653,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 145.9818,
    },
    {
      anio: 2024,
      lat: 26.989763,
      lng: -107.868324,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.1522,
    },
    {
      anio: 2024,
      lat: 26.898865,
      lng: -107.761215,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 84.4536,
    },
    {
      anio: 2024,
      lat: 26.251873,
      lng: -107.04303,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 75.1582,
    },
    {
      anio: 2024,
      lat: 27.59663,
      lng: -108.28098,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.8884,
    },
    {
      anio: 2024,
      lat: 26.370123,
      lng: -107.62181,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.7453,
    },
    {
      anio: 2024,
      lat: 26.102777,
      lng: -106.8025,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5566,
    },
    {
      anio: 2024,
      lat: 25.8517,
      lng: -106.80167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2682,
    },
    {
      anio: 2024,
      lat: 27.281525,
      lng: -106.98241,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.3214,
    },
    {
      anio: 2024,
      lat: 26.235184,
      lng: -107.04318,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.1173,
    },
    {
      anio: 2024,
      lat: 26.519722,
      lng: -107.337456,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 280.6353,
    },
    {
      anio: 2024,
      lat: 26.751856,
      lng: -107.13147,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.789,
    },
    {
      anio: 2024,
      lat: 25.724527,
      lng: -106.78989,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5351,
    },
    {
      anio: 2024,
      lat: 26.145834,
      lng: -106.624725,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4627,
    },
    {
      anio: 2024,
      lat: 27.232374,
      lng: -107.97862,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 234.1824,
    },
    {
      anio: 2024,
      lat: 26.74015,
      lng: -107.77229,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 198.8125,
    },
    {
      anio: 2024,
      lat: 26.994856,
      lng: -107.15272,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.5507,
    },
    {
      anio: 2024,
      lat: 26.339645,
      lng: -107.36084,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1873.1074,
    },
    {
      anio: 2024,
      lat: 26.36463,
      lng: -106.894394,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 170.2411,
    },
    {
      anio: 2024,
      lat: 26.387094,
      lng: -106.644485,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 167.9233,
    },
    {
      anio: 2024,
      lat: 26.626112,
      lng: -107.49611,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.063,
    },
    {
      anio: 2024,
      lat: 26.531216,
      lng: -107.36696,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1471.4822,
    },
    {
      anio: 2024,
      lat: 26.242931,
      lng: -107.04944,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 136.3661,
    },
    {
      anio: 2024,
      lat: 26.678917,
      lng: -106.88069,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1071.2437,
    },
    {
      anio: 2024,
      lat: 26.291183,
      lng: -106.77324,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 104.32,
    },
    {
      anio: 2024,
      lat: 26.46467,
      lng: -107.30006,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5725,
    },
    {
      anio: 2024,
      lat: 27.48829,
      lng: -107.85642,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 96.5576,
    },
    {
      anio: 2024,
      lat: 27.5676,
      lng: -108.11326,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95.7957,
    },
    {
      anio: 2024,
      lat: 26.553278,
      lng: -106.994736,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 91.0157,
    },
    {
      anio: 2024,
      lat: 26.234802,
      lng: -106.66306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.4731,
    },
    {
      anio: 2024,
      lat: 27.53574,
      lng: -107.97353,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62.3894,
    },
    {
      anio: 2024,
      lat: 26.007988,
      lng: -106.68092,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.3233,
    },
    {
      anio: 2024,
      lat: 26.466206,
      lng: -107.385025,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.0509,
    },
    {
      anio: 2024,
      lat: 27.521141,
      lng: -107.83334,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.9516,
    },
    {
      anio: 2024,
      lat: 26.107721,
      lng: -106.79986,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2444,
    },
    {
      anio: 2024,
      lat: 25.918736,
      lng: -106.89259,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 31.0157,
    },
    {
      anio: 2024,
      lat: 26.36027,
      lng: -107.52848,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 276.1197,
    },
    {
      anio: 2024,
      lat: 26.140461,
      lng: -106.806015,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.1063,
    },
    {
      anio: 2024,
      lat: 26.101944,
      lng: -106.80028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3746,
    },
    {
      anio: 2024,
      lat: 25.89177,
      lng: -106.94196,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.234,
    },
    {
      anio: 2024,
      lat: 26.735939,
      lng: -106.93977,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2214,
    },
    {
      anio: 2024,
      lat: 26.110521,
      lng: -106.82902,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.232,
    },
    {
      anio: 2024,
      lat: 27.109215,
      lng: -108.1648,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.1374,
    },
    {
      anio: 2024,
      lat: 26.716736,
      lng: -107.27547,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.7044,
    },
    {
      anio: 2024,
      lat: 26.731977,
      lng: -107.12317,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9552,
    },
    {
      anio: 2024,
      lat: 25.916695,
      lng: -106.887085,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8375,
    },
    {
      anio: 2024,
      lat: 26.337729,
      lng: -106.882835,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8081,
    },
    {
      anio: 2024,
      lat: 26.805992,
      lng: -107.26244,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6443,
    },
    {
      anio: 2024,
      lat: 26.088356,
      lng: -106.80802,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5491,
    },
    {
      anio: 2024,
      lat: 26.3861,
      lng: -106.93837,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3342,
    },
    {
      anio: 2024,
      lat: 27.523611,
      lng: -107.88255,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.4184,
    },
    {
      anio: 2024,
      lat: 26.007494,
      lng: -106.925026,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8511,
    },
    {
      anio: 2024,
      lat: 26.786705,
      lng: -107.188,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.9098,
    },
    {
      anio: 2024,
      lat: 26.165314,
      lng: -106.80491,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.3277,
    },
    {
      anio: 2024,
      lat: 26.08148,
      lng: -106.6002,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.788,
    },
    {
      anio: 2024,
      lat: 25.628414,
      lng: -106.85496,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.0569,
    },
    {
      anio: 2024,
      lat: 26.050703,
      lng: -106.7077,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.1442,
    },
    {
      anio: 2024,
      lat: 26.760836,
      lng: -107.169044,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.3405,
    },
    {
      anio: 2024,
      lat: 26.60201,
      lng: -107.11289,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 341.3761,
    },
    {
      anio: 2024,
      lat: 27.535784,
      lng: -107.81264,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 33.2449,
    },
    {
      anio: 2024,
      lat: 26.084473,
      lng: -106.62364,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.19,
    },
    {
      anio: 2024,
      lat: 26.341454,
      lng: -106.90268,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.033,
    },
    {
      anio: 2024,
      lat: 26.87015,
      lng: -107.52846,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 297.6581,
    },
    {
      anio: 2024,
      lat: 27.190361,
      lng: -107.47123,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 275.1042,
    },
    {
      anio: 2024,
      lat: 27.396698,
      lng: -108.26485,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 270.0305,
    },
    {
      anio: 2024,
      lat: 25.757053,
      lng: -106.78477,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5851,
    },
    {
      anio: 2024,
      lat: 27.441195,
      lng: -107.868774,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 223.8836,
    },
    {
      anio: 2024,
      lat: 26.096233,
      lng: -106.9503,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2169,
    },
    {
      anio: 2024,
      lat: 26.448792,
      lng: -107.28835,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.0314,
    },
    {
      anio: 2024,
      lat: 26.331371,
      lng: -106.6872,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9606,
    },
    {
      anio: 2024,
      lat: 26.083939,
      lng: -106.785484,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8861,
    },
    {
      anio: 2024,
      lat: 26.620556,
      lng: -107.4975,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.8789,
    },
    {
      anio: 2024,
      lat: 26.32987,
      lng: -106.65709,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.7211,
    },
    {
      anio: 2024,
      lat: 25.874128,
      lng: -106.85488,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2477,
    },
    {
      anio: 2024,
      lat: 26.08467,
      lng: -106.615234,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.4627,
    },
    {
      anio: 2024,
      lat: 25.920706,
      lng: -106.97049,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.0943,
    },
    {
      anio: 2024,
      lat: 26.472591,
      lng: -107.17476,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 102.7382,
    },
    {
      anio: 2024,
      lat: 26.245537,
      lng: -107.343834,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 100.7702,
    },
    {
      anio: 2024,
      lat: 26.236252,
      lng: -106.63534,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.7652,
    },
    {
      anio: 2024,
      lat: 26.089062,
      lng: -106.78053,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5617,
    },
    {
      anio: 2024,
      lat: 26.08314,
      lng: -106.77214,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5097,
    },
    {
      anio: 2024,
      lat: 25.91125,
      lng: -106.953476,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.3473,
    },
    {
      anio: 2024,
      lat: 27.263664,
      lng: -107.7087,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 78.817,
    },
    {
      anio: 2024,
      lat: 26.106066,
      lng: -106.86938,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.7377,
    },
    {
      anio: 2024,
      lat: 27.394405,
      lng: -108.02501,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 65.0817,
    },
    {
      anio: 2024,
      lat: 27.487778,
      lng: -107.87244,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.0276,
    },
    {
      anio: 2024,
      lat: 27.223127,
      lng: -107.93025,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.8093,
    },
    {
      anio: 2024,
      lat: 26.060204,
      lng: -106.65714,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.0817,
    },
    {
      anio: 2024,
      lat: 26.098658,
      lng: -106.73955,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5508,
    },
    {
      anio: 2024,
      lat: 26.032022,
      lng: -106.93803,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3251,
    },
    {
      anio: 2024,
      lat: 27.110277,
      lng: -107.287224,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.9192,
    },
    {
      anio: 2024,
      lat: 26.111294,
      lng: -106.74099,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6084,
    },
    {
      anio: 2024,
      lat: 25.73354,
      lng: -106.8125,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9821,
    },
    {
      anio: 2024,
      lat: 25.855923,
      lng: -106.77659,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8506,
    },
    {
      anio: 2024,
      lat: 26.198658,
      lng: -106.851425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5886,
    },
    {
      anio: 2024,
      lat: 26.410646,
      lng: -107.28163,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.2351,
    },
    {
      anio: 2024,
      lat: 25.969723,
      lng: -106.998886,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.8009,
    },
    {
      anio: 2024,
      lat: 27.457,
      lng: -107.89584,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.606,
    },
    {
      anio: 2024,
      lat: 26.881666,
      lng: -107.060555,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.1287,
    },
    {
      anio: 2024,
      lat: 25.93027,
      lng: -106.7503,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.7287,
    },
    {
      anio: 2024,
      lat: 26.085491,
      lng: -106.583694,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2882,
    },
    {
      anio: 2024,
      lat: 27.491465,
      lng: -107.90002,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.6541,
    },
    {
      anio: 2024,
      lat: 26.150133,
      lng: -106.80042,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4314,
    },
    {
      anio: 2024,
      lat: 27.111666,
      lng: -107.242226,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.2106,
    },
    {
      anio: 2024,
      lat: 27.55377,
      lng: -107.958435,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6791,
    },
    {
      anio: 2024,
      lat: 27.346695,
      lng: -108.09878,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.6395,
    },
    {
      anio: 2024,
      lat: 25.96012,
      lng: -106.75589,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5058,
    },
    {
      anio: 2024,
      lat: 26.128492,
      lng: -106.80926,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.3163,
    },
    {
      anio: 2024,
      lat: 27.14282,
      lng: -107.43296,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.761,
    },
    {
      anio: 2024,
      lat: 26.66838,
      lng: -107.365265,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 62.0007,
    },
    {
      anio: 2024,
      lat: 26.820631,
      lng: -107.1283,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.0813,
    },
    {
      anio: 2024,
      lat: 27.523363,
      lng: -107.21666,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 59.7265,
    },
    {
      anio: 2024,
      lat: 27.37889,
      lng: -108.27276,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 5.6725,
    },
    {
      anio: 2024,
      lat: 26.115978,
      lng: -106.86012,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.1401,
    },
    {
      anio: 2024,
      lat: 27.475441,
      lng: -107.85283,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.0782,
    },
    {
      anio: 2024,
      lat: 27.474144,
      lng: -107.8548,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.0093,
    },
    {
      anio: 2024,
      lat: 27.398098,
      lng: -107.9724,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.2004,
    },
    {
      anio: 2024,
      lat: 27.296936,
      lng: -107.337425,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 211.6046,
    },
    {
      anio: 2024,
      lat: 26.761473,
      lng: -107.954636,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.5949,
    },
    {
      anio: 2024,
      lat: 26.455667,
      lng: -107.24512,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9186,
    },
    {
      anio: 2024,
      lat: 26.245277,
      lng: -106.655556,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8876,
    },
    {
      anio: 2024,
      lat: 26.817108,
      lng: -107.048225,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8081,
    },
    {
      anio: 2024,
      lat: 26.095722,
      lng: -106.818886,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1911,
    },
    {
      anio: 2024,
      lat: 26.233555,
      lng: -106.62392,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1707,
    },
    {
      anio: 2024,
      lat: 26.62372,
      lng: -106.96246,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 109.7264,
    },
    {
      anio: 2024,
      lat: 26.114416,
      lng: -106.80189,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6805,
    },
    {
      anio: 2024,
      lat: 27.449776,
      lng: -107.565636,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.6012,
    },
    {
      anio: 2024,
      lat: 26.849564,
      lng: -107.221756,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.6896,
    },
    {
      anio: 2024,
      lat: 26.276869,
      lng: -106.65898,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.485,
    },
    {
      anio: 2024,
      lat: 26.116608,
      lng: -106.806526,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.0273,
    },
    {
      anio: 2024,
      lat: 26.303328,
      lng: -106.64795,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.7106,
    },
    {
      anio: 2024,
      lat: 27.58737,
      lng: -107.65329,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.3566,
    },
    {
      anio: 2024,
      lat: 27.604055,
      lng: -107.576164,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3026,
    },
    {
      anio: 2024,
      lat: 26.720638,
      lng: -107.185585,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2866,
    },
    {
      anio: 2024,
      lat: 26.077888,
      lng: -106.802086,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6878,
    },
    {
      anio: 2024,
      lat: 26.094473,
      lng: -106.815285,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9459,
    },
    {
      anio: 2024,
      lat: 27.106916,
      lng: -107.30561,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 141.8783,
    },
    {
      anio: 2024,
      lat: 27.072203,
      lng: -107.512665,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.9549,
    },
    {
      anio: 2024,
      lat: 25.663,
      lng: -106.947,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.9628,
    },
    {
      anio: 2024,
      lat: 26.856272,
      lng: -107.14653,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.8075,
    },
    {
      anio: 2024,
      lat: 27.473816,
      lng: -107.8828,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.1412,
    },
    {
      anio: 2024,
      lat: 26.910145,
      lng: -106.9621,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.978,
    },
    {
      anio: 2024,
      lat: 26.068033,
      lng: -106.796906,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5502,
    },
    {
      anio: 2024,
      lat: 26.279945,
      lng: -106.64144,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.3666,
    },
    {
      anio: 2024,
      lat: 26.090342,
      lng: -106.825935,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.1206,
    },
    {
      anio: 2024,
      lat: 26.621666,
      lng: -107.4925,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 28.3014,
    },
    {
      anio: 2024,
      lat: 26.883097,
      lng: -107.23639,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.1516,
    },
    {
      anio: 2024,
      lat: 27.660341,
      lng: -107.614845,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.282,
    },
    {
      anio: 2024,
      lat: 27.455,
      lng: -107.90511,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3482,
    },
    {
      anio: 2024,
      lat: 26.727777,
      lng: -107.075836,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.412,
    },
    {
      anio: 2024,
      lat: 27.50132,
      lng: -107.89886,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1131,
    },
    {
      anio: 2024,
      lat: 27.089722,
      lng: -107.230835,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.9433,
    },
    {
      anio: 2024,
      lat: 26.997765,
      lng: -106.99781,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.5131,
    },
    {
      anio: 2024,
      lat: 27.359045,
      lng: -108.252365,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 88.1864,
    },
    {
      anio: 2024,
      lat: 27.488398,
      lng: -107.87115,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2922,
    },
    {
      anio: 2024,
      lat: 26.784203,
      lng: -107.105934,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.426,
    },
    {
      anio: 2024,
      lat: 26.795336,
      lng: -107.27286,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 3,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.968,
    },
    {
      anio: 2024,
      lat: 26.71729,
      lng: -107.14298,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8915,
    },
    {
      anio: 2023,
      lat: 27.195572,
      lng: -107.55764,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 38,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 169.8426,
    },
    {
      anio: 2023,
      lat: 27.6211,
      lng: -107.5945,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 30,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 62.2167,
    },
    {
      anio: 2023,
      lat: 26.989058,
      lng: -107.36731,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 86.336,
    },
    {
      anio: 2023,
      lat: 27.577019,
      lng: -108.02855,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79.633,
    },
    {
      anio: 2023,
      lat: 26.346107,
      lng: -107.10107,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.3802,
    },
    {
      anio: 2023,
      lat: 27.010567,
      lng: -107.33935,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 70.6789,
    },
    {
      anio: 2023,
      lat: 27.029572,
      lng: -107.126884,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 69.7853,
    },
    {
      anio: 2023,
      lat: 26.237188,
      lng: -107.42837,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 66.6695,
    },
    {
      anio: 2023,
      lat: 26.793861,
      lng: -107.97761,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 633.8367,
    },
    {
      anio: 2023,
      lat: 26.105764,
      lng: -106.66642,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 61.215,
    },
    {
      anio: 2023,
      lat: 26.406221,
      lng: -107.37585,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 58.7472,
    },
    {
      anio: 2023,
      lat: 26.949272,
      lng: -107.063225,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.9216,
    },
    {
      anio: 2023,
      lat: 27.228153,
      lng: -107.41392,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.8042,
    },
    {
      anio: 2023,
      lat: 25.8275,
      lng: -106.9123,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 445.4612,
    },
    {
      anio: 2023,
      lat: 26.294537,
      lng: -107.58571,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 411.6447,
    },
    {
      anio: 2023,
      lat: 25.616175,
      lng: -106.77544,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 409.5072,
    },
    {
      anio: 2023,
      lat: 27.165245,
      lng: -108.14913,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 236.8161,
    },
    {
      anio: 2023,
      lat: 27.017763,
      lng: -107.88622,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23.0012,
    },
    {
      anio: 2023,
      lat: 25.943037,
      lng: -107.05614,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 227.5338,
    },
    {
      anio: 2023,
      lat: 25.881142,
      lng: -106.97375,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.3868,
    },
    {
      anio: 2023,
      lat: 26.283497,
      lng: -107.2368,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 204.9101,
    },
    {
      anio: 2023,
      lat: 26.143187,
      lng: -107.47384,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 198.8099,
    },
    {
      anio: 2023,
      lat: 25.894388,
      lng: -106.9459,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.027,
    },
    {
      anio: 2023,
      lat: 26.2567,
      lng: -107.3007,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1558.2976,
    },
    {
      anio: 2023,
      lat: 26.169033,
      lng: -107.37252,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 136.1861,
    },
    {
      anio: 2023,
      lat: 26.239758,
      lng: -107.40098,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 124.0536,
    },
    {
      anio: 2023,
      lat: 26.5907,
      lng: -107.5679,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 958.6938,
    },
    {
      anio: 2023,
      lat: 26.99986,
      lng: -107.204796,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 91.0468,
    },
    {
      anio: 2023,
      lat: 27.065,
      lng: -107.2625,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 88.752,
    },
    {
      anio: 2023,
      lat: 27.097597,
      lng: -106.98873,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 81.9527,
    },
    {
      anio: 2023,
      lat: 26.2856,
      lng: -107.1805,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 806.6872,
    },
    {
      anio: 2023,
      lat: 26.601116,
      lng: -107.52507,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 800.5783,
    },
    {
      anio: 2023,
      lat: 26.211916,
      lng: -106.84625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.6812,
    },
    {
      anio: 2023,
      lat: 27.33344,
      lng: -107.77664,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 627.6215,
    },
    {
      anio: 2023,
      lat: 26.174225,
      lng: -106.66708,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2171,
    },
    {
      anio: 2023,
      lat: 26.13253,
      lng: -107.02328,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2075,
    },
    {
      anio: 2023,
      lat: 26.163328,
      lng: -107.10359,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 602.308,
    },
    {
      anio: 2023,
      lat: 26.198303,
      lng: -107.09377,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 60.0776,
    },
    {
      anio: 2023,
      lat: 26.672167,
      lng: -107.50441,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 563.6486,
    },
    {
      anio: 2023,
      lat: 26.222347,
      lng: -107.34129,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 556.5017,
    },
    {
      anio: 2023,
      lat: 26.206484,
      lng: -107.56184,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 5238.8379,
    },
    {
      anio: 2023,
      lat: 26.434933,
      lng: -107.36467,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.2396,
    },
    {
      anio: 2023,
      lat: 26.84296,
      lng: -107.037254,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.888,
    },
    {
      anio: 2023,
      lat: 26.99126,
      lng: -107.36567,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.528,
    },
    {
      anio: 2023,
      lat: 26.306326,
      lng: -107.339775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.9253,
    },
    {
      anio: 2023,
      lat: 26.835295,
      lng: -107.690926,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 388.9831,
    },
    {
      anio: 2023,
      lat: 26.03618,
      lng: -106.77659,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6366,
    },
    {
      anio: 2023,
      lat: 26.360264,
      lng: -107.08078,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 355.9737,
    },
    {
      anio: 2023,
      lat: 26.1551,
      lng: -107.3612,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3465.9498,
    },
    {
      anio: 2023,
      lat: 27.57322,
      lng: -107.623985,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 339.2936,
    },
    {
      anio: 2023,
      lat: 27.471199,
      lng: -107.925285,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.5137,
    },
    {
      anio: 2023,
      lat: 27.02763,
      lng: -107.89826,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.5076,
    },
    {
      anio: 2023,
      lat: 26.541939,
      lng: -107.36398,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 281.2656,
    },
    {
      anio: 2023,
      lat: 26.368523,
      lng: -107.131874,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 261.5068,
    },
    {
      anio: 2023,
      lat: 25.878973,
      lng: -106.71852,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.3392,
    },
    {
      anio: 2023,
      lat: 27.12838,
      lng: -108.0512,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.2767,
    },
    {
      anio: 2023,
      lat: 26.248674,
      lng: -107.03234,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 199.1484,
    },
    {
      anio: 2023,
      lat: 26.9805,
      lng: -107.3554,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.6419,
    },
    {
      anio: 2023,
      lat: 25.912117,
      lng: -106.69953,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.2712,
    },
    {
      anio: 2023,
      lat: 25.939966,
      lng: -107.03552,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.0109,
    },
    {
      anio: 2023,
      lat: 26.173784,
      lng: -107.02562,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 130.5713,
    },
    {
      anio: 2023,
      lat: 25.837183,
      lng: -106.813286,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 129.0275,
    },
    {
      anio: 2023,
      lat: 26.41519,
      lng: -107.31253,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.7436,
    },
    {
      anio: 2023,
      lat: 26.4651,
      lng: -107.4078,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 1214.3312,
    },
    {
      anio: 2023,
      lat: 26.918255,
      lng: -106.965485,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 111.2908,
    },
    {
      anio: 2023,
      lat: 26.290674,
      lng: -107.285065,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 105.2967,
    },
    {
      anio: 2023,
      lat: 26.875664,
      lng: -107.4999,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 105.1308,
    },
    {
      anio: 2023,
      lat: 26.570269,
      lng: -107.64104,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 103.672,
    },
    {
      anio: 2023,
      lat: 27.4104,
      lng: -108.3192,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 101.5857,
    },
    {
      anio: 2023,
      lat: 26.421703,
      lng: -107.33729,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6793,
    },
    {
      anio: 2023,
      lat: 25.8299,
      lng: -106.832085,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 97.5442,
    },
    {
      anio: 2023,
      lat: 25.995764,
      lng: -107.06874,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 88.8879,
    },
    {
      anio: 2023,
      lat: 26.220308,
      lng: -106.82164,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.8735,
    },
    {
      anio: 2023,
      lat: 26.189985,
      lng: -107.1735,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 86.2277,
    },
    {
      anio: 2023,
      lat: 26.331772,
      lng: -107.32412,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 80.4571,
    },
    {
      anio: 2023,
      lat: 26.784384,
      lng: -107.22137,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.2084,
    },
    {
      anio: 2023,
      lat: 27.37758,
      lng: -108.29817,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 62.7403,
    },
    {
      anio: 2023,
      lat: 26.814417,
      lng: -107.09166,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.1433,
    },
    {
      anio: 2023,
      lat: 26.31866,
      lng: -107.678764,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 573.345,
    },
    {
      anio: 2023,
      lat: 26.0574,
      lng: -106.9198,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.2813,
    },
    {
      anio: 2023,
      lat: 26.022583,
      lng: -106.76505,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.7238,
    },
    {
      anio: 2023,
      lat: 27.5712,
      lng: -108.0709,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.3482,
    },
    {
      anio: 2023,
      lat: 27.150852,
      lng: -107.227,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 403.2025,
    },
    {
      anio: 2023,
      lat: 25.9784,
      lng: -107.1239,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 396.7135,
    },
    {
      anio: 2023,
      lat: 26.430931,
      lng: -107.195366,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2987,
    },
    {
      anio: 2023,
      lat: 27.596199,
      lng: -108.1332,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31.7837,
    },
    {
      anio: 2023,
      lat: 26.124052,
      lng: -106.81159,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1149,
    },
    {
      anio: 2023,
      lat: 27.4754,
      lng: -107.861,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.6842,
    },
    {
      anio: 2023,
      lat: 25.934431,
      lng: -106.96677,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.5609,
    },
    {
      anio: 2023,
      lat: 26.064756,
      lng: -106.65764,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 241.4164,
    },
    {
      anio: 2023,
      lat: 26.18335,
      lng: -106.869446,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.3719,
    },
    {
      anio: 2023,
      lat: 26.891752,
      lng: -107.04413,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.0631,
    },
    {
      anio: 2023,
      lat: 26.512892,
      lng: -107.35374,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 194.7358,
    },
    {
      anio: 2023,
      lat: 26.495,
      lng: -107.8762,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 180.2095,
    },
    {
      anio: 2023,
      lat: 26.8126,
      lng: -107.2306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.1528,
    },
    {
      anio: 2023,
      lat: 26.186363,
      lng: -107.77514,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1.6365,
    },
    {
      anio: 2023,
      lat: 26.0641,
      lng: -107.0246,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.6513,
    },
    {
      anio: 2023,
      lat: 25.8455,
      lng: -106.905,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.3645,
    },
    {
      anio: 2023,
      lat: 26.216625,
      lng: -106.92533,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.023,
    },
    {
      anio: 2023,
      lat: 26.11651,
      lng: -107.209854,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 109.6174,
    },
    {
      anio: 2023,
      lat: 25.97424,
      lng: -107.1595,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 100.8953,
    },
    {
      anio: 2023,
      lat: 27.066458,
      lng: -107.231995,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 79.0034,
    },
    {
      anio: 2023,
      lat: 26.25243,
      lng: -106.75922,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 66.7581,
    },
    {
      anio: 2023,
      lat: 26.086683,
      lng: -106.66513,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.8436,
    },
    {
      anio: 2023,
      lat: 26.320908,
      lng: -106.95664,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 49.0016,
    },
    {
      anio: 2023,
      lat: 26.122936,
      lng: -106.60427,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.2285,
    },
    {
      anio: 2023,
      lat: 25.8425,
      lng: -106.9028,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.1324,
    },
    {
      anio: 2023,
      lat: 26.179052,
      lng: -107.48263,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 314.5602,
    },
    {
      anio: 2023,
      lat: 27.568403,
      lng: -108.155815,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.0743,
    },
    {
      anio: 2023,
      lat: 26.151087,
      lng: -107.54473,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 263.8541,
    },
    {
      anio: 2023,
      lat: 26.838684,
      lng: -107.06998,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6962,
    },
    {
      anio: 2023,
      lat: 27.551409,
      lng: -107.296745,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 149.4318,
    },
    {
      anio: 2023,
      lat: 26.231983,
      lng: -107.308395,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 148.9988,
    },
    {
      anio: 2023,
      lat: 26.77016,
      lng: -107.79448,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1462.1866,
    },
    {
      anio: 2023,
      lat: 26.125511,
      lng: -107.504196,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 134.7114,
    },
    {
      anio: 2023,
      lat: 27.445122,
      lng: -108.2313,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 128.5079,
    },
    {
      anio: 2023,
      lat: 26.385159,
      lng: -107.07611,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 121.9068,
    },
    {
      anio: 2023,
      lat: 26.903652,
      lng: -107.19158,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.9443,
    },
    {
      anio: 2023,
      lat: 26.091396,
      lng: -106.80829,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.0515,
    },
    {
      anio: 2023,
      lat: 26.184029,
      lng: -107.836044,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.5352,
    },
    {
      anio: 2023,
      lat: 27.142658,
      lng: -108.40704,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.3997,
    },
    {
      anio: 2023,
      lat: 26.020603,
      lng: -106.720276,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 78.7596,
    },
    {
      anio: 2023,
      lat: 26.313686,
      lng: -107.123955,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 68.8127,
    },
    {
      anio: 2023,
      lat: 26.686953,
      lng: -107.50106,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 59.8832,
    },
    {
      anio: 2023,
      lat: 26.307142,
      lng: -107.579834,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 587.7351,
    },
    {
      anio: 2023,
      lat: 26.179789,
      lng: -106.84421,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.8065,
    },
    {
      anio: 2023,
      lat: 27.146769,
      lng: -107.92925,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 536.1953,
    },
    {
      anio: 2023,
      lat: 26.382998,
      lng: -107.18132,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.9059,
    },
    {
      anio: 2023,
      lat: 27.479473,
      lng: -107.86247,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.8931,
    },
    {
      anio: 2023,
      lat: 27.143894,
      lng: -107.02333,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.6926,
    },
    {
      anio: 2023,
      lat: 26.121172,
      lng: -106.82256,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.779,
    },
    {
      anio: 2023,
      lat: 26.405708,
      lng: -107.34198,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.5567,
    },
    {
      anio: 2023,
      lat: 26.215017,
      lng: -107.22596,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 445.0687,
    },
    {
      anio: 2023,
      lat: 26.36235,
      lng: -107.04835,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.2635,
    },
    {
      anio: 2023,
      lat: 26.579533,
      lng: -107.53656,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 383.7987,
    },
    {
      anio: 2023,
      lat: 27.491735,
      lng: -108.26438,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.7195,
    },
    {
      anio: 2023,
      lat: 26.014603,
      lng: -107.112404,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 341.3092,
    },
    {
      anio: 2023,
      lat: 26.365278,
      lng: -107.271385,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32.4165,
    },
    {
      anio: 2023,
      lat: 27.22163,
      lng: -107.6471,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2148,
    },
    {
      anio: 2023,
      lat: 27.09506,
      lng: -108.04632,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.526,
    },
    {
      anio: 2023,
      lat: 25.710997,
      lng: -106.81791,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.69,
    },
    {
      anio: 2023,
      lat: 26.2479,
      lng: -107.01505,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.214,
    },
    {
      anio: 2023,
      lat: 25.870705,
      lng: -107.1905,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2093.3672,
    },
    {
      anio: 2023,
      lat: 26.210114,
      lng: -107.39278,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2072.002,
    },
    {
      anio: 2023,
      lat: 26.055737,
      lng: -107.15157,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 2001.4604,
    },
    {
      anio: 2023,
      lat: 25.657133,
      lng: -106.77851,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.863,
    },
    {
      anio: 2023,
      lat: 26.266691,
      lng: -107.04814,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 171.3731,
    },
    {
      anio: 2023,
      lat: 26.635075,
      lng: -107.96817,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1698.0759,
    },
    {
      anio: 2023,
      lat: 26.478003,
      lng: -107.28601,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6508,
    },
    {
      anio: 2023,
      lat: 26.218937,
      lng: -107.66408,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1557.3692,
    },
    {
      anio: 2023,
      lat: 26.479652,
      lng: -107.308205,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.5009,
    },
    {
      anio: 2023,
      lat: 27.48307,
      lng: -107.87902,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3461,
    },
    {
      anio: 2023,
      lat: 26.837805,
      lng: -107.72009,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 119.0866,
    },
    {
      anio: 2023,
      lat: 26.073437,
      lng: -106.94104,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5547,
    },
    {
      anio: 2023,
      lat: 26.201641,
      lng: -107.80855,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 224.7659,
    },
    {
      anio: 2023,
      lat: 26.195467,
      lng: -107.79331,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 7.6203,
    },
    {
      anio: 2023,
      lat: 26.337,
      lng: -107.3413,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.3728,
    },
    {
      anio: 2023,
      lat: 25.894823,
      lng: -106.87059,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 7.0893,
    },
    {
      anio: 2023,
      lat: 26.233938,
      lng: -106.8261,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.0883,
    },
    {
      anio: 2023,
      lat: 25.979218,
      lng: -107.09332,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 68.6411,
    },
    {
      anio: 2023,
      lat: 26.603811,
      lng: -107.36764,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 66.2456,
    },
    {
      anio: 2023,
      lat: 26.3138,
      lng: -107.18605,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.559,
    },
    {
      anio: 2023,
      lat: 27.468,
      lng: -107.9073,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.8582,
    },
    {
      anio: 2023,
      lat: 25.5788,
      lng: -106.82747,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 579.1014,
    },
    {
      anio: 2023,
      lat: 26.198212,
      lng: -107.78465,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.6229,
    },
    {
      anio: 2023,
      lat: 27.657036,
      lng: -107.619194,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 54.1485,
    },
    {
      anio: 2023,
      lat: 25.766783,
      lng: -106.86554,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53.6732,
    },
    {
      anio: 2023,
      lat: 26.500534,
      lng: -107.31722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.2599,
    },
    {
      anio: 2023,
      lat: 27.2132,
      lng: -108.1161,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 41.5117,
    },
    {
      anio: 2023,
      lat: 26.89653,
      lng: -107.081474,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.0482,
    },
    {
      anio: 2023,
      lat: 27.5429,
      lng: -107.31833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.6286,
    },
    {
      anio: 2023,
      lat: 26.611166,
      lng: -107.453514,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 384.4188,
    },
    {
      anio: 2023,
      lat: 25.957,
      lng: -107.153,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 354.5381,
    },
    {
      anio: 2023,
      lat: 26.753912,
      lng: -107.27761,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.45,
    },
    {
      anio: 2023,
      lat: 25.884106,
      lng: -107.02528,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 34.3788,
    },
    {
      anio: 2023,
      lat: 26.0628,
      lng: -107.08707,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 34.3505,
    },
    {
      anio: 2023,
      lat: 26.668394,
      lng: -107.73946,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 33.8141,
    },
    {
      anio: 2023,
      lat: 26.279684,
      lng: -107.29077,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.7104,
    },
    {
      anio: 2023,
      lat: 26.112083,
      lng: -106.819626,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1514,
    },
    {
      anio: 2023,
      lat: 26.616539,
      lng: -107.50834,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.6209,
    },
    {
      anio: 2023,
      lat: 26.185694,
      lng: -107.35943,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 283.6468,
    },
    {
      anio: 2023,
      lat: 27.282364,
      lng: -108.069214,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27.209,
    },
    {
      anio: 2023,
      lat: 26.457983,
      lng: -107.289986,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4713,
    },
    {
      anio: 2023,
      lat: 26.156376,
      lng: -107.04646,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3347,
    },
    {
      anio: 2023,
      lat: 25.697512,
      lng: -106.81536,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.9747,
    },
    {
      anio: 2023,
      lat: 26.165161,
      lng: -107.052216,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.2965,
    },
    {
      anio: 2023,
      lat: 26.242445,
      lng: -107.32111,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.1904,
    },
    {
      anio: 2023,
      lat: 27.268265,
      lng: -108.06769,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 2.1625,
    },
    {
      anio: 2023,
      lat: 26.018013,
      lng: -107.084015,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 208.5049,
    },
    {
      anio: 2023,
      lat: 27.13782,
      lng: -108.1189,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 206.9659,
    },
    {
      anio: 2023,
      lat: 26.207804,
      lng: -107.82906,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.9896,
    },
    {
      anio: 2023,
      lat: 26.750122,
      lng: -107.38466,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 195.2757,
    },
    {
      anio: 2023,
      lat: 25.899998,
      lng: -106.7298,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.2852,
    },
    {
      anio: 2023,
      lat: 27.522522,
      lng: -107.885414,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.7524,
    },
    {
      anio: 2023,
      lat: 26.315262,
      lng: -107.199234,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.5085,
    },
    {
      anio: 2023,
      lat: 26.012321,
      lng: -107.068115,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2556,
    },
    {
      anio: 2023,
      lat: 26.463964,
      lng: -107.29494,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9554,
    },
    {
      anio: 2023,
      lat: 26.412989,
      lng: -107.277534,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6451,
    },
    {
      anio: 2023,
      lat: 26.750406,
      lng: -107.11539,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.514,
    },
    {
      anio: 2023,
      lat: 26.18675,
      lng: -107.786545,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 9.6473,
    },
    {
      anio: 2023,
      lat: 26.71424,
      lng: -107.998535,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.0998,
    },
    {
      anio: 2023,
      lat: 27.227644,
      lng: -108.276634,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.4606,
    },
    {
      anio: 2023,
      lat: 26.01442,
      lng: -106.95134,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.8783,
    },
    {
      anio: 2023,
      lat: 26.312817,
      lng: -107.24859,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.9421,
    },
    {
      anio: 2023,
      lat: 25.726128,
      lng: -106.98767,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 676.0574,
    },
    {
      anio: 2023,
      lat: 26.25294,
      lng: -107.81342,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 520.5286,
    },
    {
      anio: 2023,
      lat: 27.5805,
      lng: -108.2577,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.9196,
    },
    {
      anio: 2023,
      lat: 26.6464,
      lng: -107.46645,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 465.0017,
    },
    {
      anio: 2023,
      lat: 26.189522,
      lng: -107.79561,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 4.3518,
    },
    {
      anio: 2023,
      lat: 26.377,
      lng: -107.4692,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.7394,
    },
    {
      anio: 2023,
      lat: 26.514957,
      lng: -106.84714,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 41.5558,
    },
    {
      anio: 2023,
      lat: 26.59932,
      lng: -106.98617,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.3086,
    },
    {
      anio: 2023,
      lat: 27.4202,
      lng: -107.82741,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 39.161,
    },
    {
      anio: 2023,
      lat: 27.669865,
      lng: -107.61772,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.8861,
    },
    {
      anio: 2023,
      lat: 26.20461,
      lng: -107.51503,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 3397.0172,
    },
    {
      anio: 2023,
      lat: 25.675285,
      lng: -106.84497,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9874,
    },
    {
      anio: 2023,
      lat: 26.031881,
      lng: -106.74034,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5939,
    },
    {
      anio: 2023,
      lat: 26.00926,
      lng: -106.98704,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5117,
    },
    {
      anio: 2023,
      lat: 27.565384,
      lng: -107.6878,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 235.6701,
    },
    {
      anio: 2023,
      lat: 26.164,
      lng: -107.779,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 230.9242,
    },
    {
      anio: 2023,
      lat: 26.240425,
      lng: -106.83337,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.8269,
    },
    {
      anio: 2023,
      lat: 26.023586,
      lng: -107.16106,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1884.3889,
    },
    {
      anio: 2023,
      lat: 26.822931,
      lng: -107.10217,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.2754,
    },
    {
      anio: 2023,
      lat: 26.613762,
      lng: -107.05464,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 180.8905,
    },
    {
      anio: 2023,
      lat: 27.481117,
      lng: -107.86353,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.9055,
    },
    {
      anio: 2023,
      lat: 25.799902,
      lng: -106.91387,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 16.2983,
    },
    {
      anio: 2023,
      lat: 26.174425,
      lng: -107.7641,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1.4678,
    },
    {
      anio: 2023,
      lat: 27.335608,
      lng: -108.32823,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.531,
    },
    {
      anio: 2023,
      lat: 26.357231,
      lng: -106.73219,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 140.3051,
    },
    {
      anio: 2023,
      lat: 26.0241,
      lng: -106.9187,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3783,
    },
    {
      anio: 2023,
      lat: 25.878237,
      lng: -106.96227,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3261,
    },
    {
      anio: 2023,
      lat: 26.7452,
      lng: -107.75932,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 132.4774,
    },
    {
      anio: 2023,
      lat: 27.2965,
      lng: -108.0721,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3081,
    },
    {
      anio: 2023,
      lat: 26.371288,
      lng: -106.746254,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 115.8943,
    },
    {
      anio: 2023,
      lat: 27.257984,
      lng: -108.27372,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.3133,
    },
    {
      anio: 2023,
      lat: 26.011314,
      lng: -106.882744,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 10.3977,
    },
    {
      anio: 2023,
      lat: 26.186323,
      lng: -106.80273,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.502,
    },
    {
      anio: 2023,
      lat: 26.079325,
      lng: -106.940475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.3675,
    },
    {
      anio: 2023,
      lat: 26.06412,
      lng: -106.97664,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.6753,
    },
    {
      anio: 2023,
      lat: 27.448706,
      lng: -108.10778,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.6283,
    },
    {
      anio: 2023,
      lat: 26.739239,
      lng: -107.26532,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.3456,
    },
    {
      anio: 2023,
      lat: 25.638573,
      lng: -106.76452,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2626,
    },
    {
      anio: 2023,
      lat: 26.167984,
      lng: -107.76571,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 5.305,
    },
    {
      anio: 2023,
      lat: 26.413202,
      lng: -107.28529,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5161,
    },
    {
      anio: 2023,
      lat: 26.828236,
      lng: -107.08951,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.3255,
    },
    {
      anio: 2023,
      lat: 26.084314,
      lng: -106.9925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.1693,
    },
    {
      anio: 2023,
      lat: 27.312,
      lng: -107.473,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.3872,
    },
    {
      anio: 2023,
      lat: 26.128222,
      lng: -106.81722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.9181,
    },
    {
      anio: 2023,
      lat: 26.326656,
      lng: -107.16586,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.415,
    },
    {
      anio: 2023,
      lat: 26.46783,
      lng: -106.83531,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.4457,
    },
    {
      anio: 2023,
      lat: 26.174406,
      lng: -106.619606,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9242,
    },
    {
      anio: 2023,
      lat: 26.46721,
      lng: -107.20464,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8516,
    },
    {
      anio: 2023,
      lat: 26.7666,
      lng: -107.984,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 279.984,
    },
    {
      anio: 2023,
      lat: 26.3,
      lng: -107.67,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 275.5479,
    },
    {
      anio: 2023,
      lat: 26.417084,
      lng: -107.28003,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6618,
    },
    {
      anio: 2023,
      lat: 26.417048,
      lng: -107.276886,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3704,
    },
    {
      anio: 2023,
      lat: 25.79542,
      lng: -106.91571,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 23.3999,
    },
    {
      anio: 2023,
      lat: 26.215694,
      lng: -106.85108,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2319,
    },
    {
      anio: 2023,
      lat: 26.314392,
      lng: -107.10332,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.0302,
    },
    {
      anio: 2023,
      lat: 26.450047,
      lng: -107.35005,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.0274,
    },
    {
      anio: 2023,
      lat: 26.428364,
      lng: -106.86412,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.1842,
    },
    {
      anio: 2023,
      lat: 27.07662,
      lng: -107.9422,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18.012,
    },
    {
      anio: 2023,
      lat: 27.56542,
      lng: -108.02778,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.2577,
    },
    {
      anio: 2023,
      lat: 27.569,
      lng: -107.719,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 159.564,
    },
    {
      anio: 2023,
      lat: 25.62102,
      lng: -106.85753,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.2481,
    },
    {
      anio: 2023,
      lat: 26.4733,
      lng: -106.9269,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 139.9799,
    },
    {
      anio: 2023,
      lat: 26.286419,
      lng: -107.29972,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.5508,
    },
    {
      anio: 2023,
      lat: 27.386772,
      lng: -107.305336,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 123.2781,
    },
    {
      anio: 2023,
      lat: 26.09286,
      lng: -106.81013,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.9015,
    },
    {
      anio: 2023,
      lat: 26.447239,
      lng: -106.84138,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.8098,
    },
    {
      anio: 2023,
      lat: 25.651314,
      lng: -106.75043,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 117.3899,
    },
    {
      anio: 2023,
      lat: 26.827284,
      lng: -107.09807,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.0851,
    },
    {
      anio: 2023,
      lat: 26.066975,
      lng: -106.79417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6838,
    },
    {
      anio: 2023,
      lat: 26.3594,
      lng: -106.7529,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 99.6936,
    },
    {
      anio: 2023,
      lat: 26.1581,
      lng: -106.6296,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.9182,
    },
    {
      anio: 2023,
      lat: 27.6471,
      lng: -107.6372,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 65.5127,
    },
    {
      anio: 2023,
      lat: 26.04509,
      lng: -106.761566,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.686,
    },
    {
      anio: 2023,
      lat: 26.32619,
      lng: -107.657,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46.514,
    },
    {
      anio: 2023,
      lat: 26.432337,
      lng: -107.62313,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5583,
    },
    {
      anio: 2023,
      lat: 25.931662,
      lng: -106.88344,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5134,
    },
    {
      anio: 2023,
      lat: 27.026089,
      lng: -108.402275,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 41.7586,
    },
    {
      anio: 2023,
      lat: 26.395712,
      lng: -107.30892,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.9662,
    },
    {
      anio: 2023,
      lat: 26.475725,
      lng: -106.88933,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 38.1926,
    },
    {
      anio: 2023,
      lat: 26.924381,
      lng: -107.32376,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.2468,
    },
    {
      anio: 2023,
      lat: 26.335144,
      lng: -107.070145,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 339.7892,
    },
    {
      anio: 2023,
      lat: 26.63141,
      lng: -107.47782,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 333.6949,
    },
    {
      anio: 2023,
      lat: 25.745,
      lng: -106.665,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.5507,
    },
    {
      anio: 2023,
      lat: 27.3112,
      lng: -107.47833,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.2136,
    },
    {
      anio: 2023,
      lat: 26.105602,
      lng: -106.80869,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.1513,
    },
    {
      anio: 2023,
      lat: 26.9895,
      lng: -107.1428,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.613,
    },
    {
      anio: 2023,
      lat: 26.6748,
      lng: -107.4651,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.4328,
    },
    {
      anio: 2023,
      lat: 26.11352,
      lng: -106.83346,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.0144,
    },
    {
      anio: 2023,
      lat: 26.134653,
      lng: -106.60639,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.9561,
    },
    {
      anio: 2023,
      lat: 26.983019,
      lng: -107.74914,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 171.8602,
    },
    {
      anio: 2023,
      lat: 27.201525,
      lng: -107.41306,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6181,
    },
    {
      anio: 2023,
      lat: 26.064674,
      lng: -106.97901,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.8965,
    },
    {
      anio: 2023,
      lat: 26.396511,
      lng: -107.30227,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Transportes",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5303,
    },
    {
      anio: 2023,
      lat: 26.041779,
      lng: -106.8998,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2185,
    },
    {
      anio: 2023,
      lat: 26.03428,
      lng: -106.7067,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 117.9199,
    },
    {
      anio: 2023,
      lat: 26.896269,
      lng: -107.39671,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 115.7902,
    },
    {
      anio: 2023,
      lat: 26.807388,
      lng: -107.292656,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 112.0452,
    },
    {
      anio: 2023,
      lat: 27.63782,
      lng: -107.61798,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.0121,
    },
    {
      anio: 2023,
      lat: 27.309845,
      lng: -107.97669,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.6262,
    },
    {
      anio: 2023,
      lat: 27.206015,
      lng: -108.00834,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.0797,
    },
    {
      anio: 2023,
      lat: 26.450731,
      lng: -106.81865,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 59.0081,
    },
    {
      anio: 2023,
      lat: 27.297775,
      lng: -108.2002,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 57.9234,
    },
    {
      anio: 2023,
      lat: 26.380884,
      lng: -107.86527,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53.8196,
    },
    {
      anio: 2023,
      lat: 27.559347,
      lng: -107.65264,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 41.0259,
    },
    {
      anio: 2023,
      lat: 26.688396,
      lng: -107.25689,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.558,
    },
    {
      anio: 2023,
      lat: 26.471714,
      lng: -106.78071,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.3115,
    },
    {
      anio: 2023,
      lat: 26.385225,
      lng: -106.616425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 139.7976,
    },
    {
      anio: 2023,
      lat: 26.349945,
      lng: -106.67043,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 128.3575,
    },
    {
      anio: 2023,
      lat: 27.175203,
      lng: -107.39664,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 113.0311,
    },
    {
      anio: 2023,
      lat: 26.370672,
      lng: -107.84601,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.0927,
    },
    {
      anio: 2023,
      lat: 27.57431,
      lng: -108.233086,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 46.7989,
    },
    {
      anio: 2023,
      lat: 26.88772,
      lng: -107.354744,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.854,
    },
    {
      anio: 2023,
      lat: 27.566534,
      lng: -107.90726,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.7449,
    },
    {
      anio: 2023,
      lat: 27.519178,
      lng: -108.01628,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.585,
    },
    {
      anio: 2023,
      lat: 25.951256,
      lng: -106.87281,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.0058,
    },
    {
      anio: 2023,
      lat: 25.714464,
      lng: -106.852196,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5607,
    },
    {
      anio: 2023,
      lat: 26.70298,
      lng: -107.54551,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 42.3153,
    },
    {
      anio: 2023,
      lat: 26.968597,
      lng: -107.653694,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.6418,
    },
    {
      anio: 2023,
      lat: 27.488762,
      lng: -107.881996,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.333,
    },
    {
      anio: 2023,
      lat: 25.8935,
      lng: -106.9367,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1919,
    },
    {
      anio: 2023,
      lat: 27.099886,
      lng: -107.35586,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 260.815,
    },
    {
      anio: 2023,
      lat: 26.514633,
      lng: -106.86752,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.8273,
    },
    {
      anio: 2023,
      lat: 26.87506,
      lng: -107.36133,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.0419,
    },
    {
      anio: 2023,
      lat: 26.774176,
      lng: -107.04753,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.1283,
    },
    {
      anio: 2023,
      lat: 26.158138,
      lng: -106.76625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6968,
    },
    {
      anio: 2023,
      lat: 26.696547,
      lng: -106.884094,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 121.8669,
    },
    {
      anio: 2023,
      lat: 27.049839,
      lng: -107.02342,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 109.6857,
    },
    {
      anio: 2023,
      lat: 26.046812,
      lng: -106.94098,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8458,
    },
    {
      anio: 2023,
      lat: 27.18478,
      lng: -107.372444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.7267,
    },
    {
      anio: 2023,
      lat: 27.215736,
      lng: -107.93623,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 0.5469,
    },
    {
      anio: 2023,
      lat: 26.096844,
      lng: -106.80505,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.4552,
    },
    {
      anio: 2023,
      lat: 26.368963,
      lng: -107.8489,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.9805,
    },
    {
      anio: 2023,
      lat: 26.188152,
      lng: -106.90761,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 41.5517,
    },
    {
      anio: 2023,
      lat: 26.205954,
      lng: -107.778175,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 39.604,
    },
    {
      anio: 2023,
      lat: 26.084,
      lng: -107.00135,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.931,
    },
    {
      anio: 2023,
      lat: 26.477879,
      lng: -106.86074,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.8247,
    },
    {
      anio: 2023,
      lat: 26.97195,
      lng: -107.66043,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6164,
    },
    {
      anio: 2023,
      lat: 26.502995,
      lng: -106.824196,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.5414,
    },
    {
      anio: 2023,
      lat: 27.104622,
      lng: -108.0814,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.0038,
    },
    {
      anio: 2023,
      lat: 26.984173,
      lng: -107.28539,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23.3831,
    },
    {
      anio: 2023,
      lat: 27.267303,
      lng: -107.43404,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.3893,
    },
    {
      anio: 2023,
      lat: 25.97231,
      lng: -107.06251,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.884,
    },
    {
      anio: 2023,
      lat: 25.944967,
      lng: -106.92573,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.4239,
    },
    {
      anio: 2023,
      lat: 26.495995,
      lng: -106.83151,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.2423,
    },
    {
      anio: 2023,
      lat: 26.294645,
      lng: -107.09769,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.802,
    },
    {
      anio: 2023,
      lat: 26.091806,
      lng: -106.75003,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.511,
    },
    {
      anio: 2023,
      lat: 26.2899,
      lng: -107.10647,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.9409,
    },
    {
      anio: 2023,
      lat: 25.949991,
      lng: -106.959,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.3485,
    },
    {
      anio: 2023,
      lat: 26.107153,
      lng: -106.79765,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.1094,
    },
    {
      anio: 2023,
      lat: 26.091967,
      lng: -106.75383,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.0801,
    },
    {
      anio: 2023,
      lat: 27.453915,
      lng: -107.986725,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 34.6605,
    },
    {
      anio: 2023,
      lat: 25.762089,
      lng: -106.83276,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1749,
    },
    {
      anio: 2023,
      lat: 26.194458,
      lng: -106.84772,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.8596,
    },
    {
      anio: 2023,
      lat: 26.824589,
      lng: -107.04163,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4282,
    },
    {
      anio: 2023,
      lat: 26.846199,
      lng: -107.12693,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4143,
    },
    {
      anio: 2023,
      lat: 26.091442,
      lng: -106.82378,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1793,
    },
    {
      anio: 2023,
      lat: 26.7786,
      lng: -107.1807,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.877,
    },
    {
      anio: 2023,
      lat: 26.099112,
      lng: -106.784386,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.8391,
    },
    {
      anio: 2023,
      lat: 27.454203,
      lng: -107.92047,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.1587,
    },
    {
      anio: 2023,
      lat: 25.868872,
      lng: -106.97139,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.6272,
    },
    {
      anio: 2023,
      lat: 27.183197,
      lng: -107.309586,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.9768,
    },
    {
      anio: 2023,
      lat: 26.68997,
      lng: -107.18925,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.3148,
    },
    {
      anio: 2023,
      lat: 27.468409,
      lng: -107.93994,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.3322,
    },
    {
      anio: 2023,
      lat: 26.03302,
      lng: -106.77722,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.959,
    },
    {
      anio: 2023,
      lat: 26.086525,
      lng: -106.810555,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.3985,
    },
    {
      anio: 2023,
      lat: 26.467869,
      lng: -107.24169,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.353,
    },
    {
      anio: 2023,
      lat: 26.683088,
      lng: -106.90679,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.2804,
    },
    {
      anio: 2023,
      lat: 26.994867,
      lng: -107.10492,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6214,
    },
    {
      anio: 2023,
      lat: 26.112633,
      lng: -106.8126,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1469,
    },
    {
      anio: 2023,
      lat: 26.08691,
      lng: -106.75894,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.904,
    },
    {
      anio: 2023,
      lat: 26.816463,
      lng: -107.04599,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8042,
    },
    {
      anio: 2023,
      lat: 26.108805,
      lng: -106.80331,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.456,
    },
    {
      anio: 2023,
      lat: 26.131222,
      lng: -106.59417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 72.8071,
    },
    {
      anio: 2023,
      lat: 26.843712,
      lng: -106.97862,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5023,
    },
    {
      anio: 2023,
      lat: 26.2164,
      lng: -106.63324,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.7639,
    },
    {
      anio: 2023,
      lat: 26.817684,
      lng: -107.089424,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.596,
    },
    {
      anio: 2023,
      lat: 26.822983,
      lng: -107.01873,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 82.4189,
    },
    {
      anio: 2023,
      lat: 26.121166,
      lng: -106.59391,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.4172,
    },
    {
      anio: 2023,
      lat: 27.491766,
      lng: -107.86554,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51.5104,
    },
    {
      anio: 2023,
      lat: 26.829367,
      lng: -107.00141,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9575,
    },
    {
      anio: 2023,
      lat: 26.108637,
      lng: -106.580345,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.5542,
    },
    {
      anio: 2023,
      lat: 27.458666,
      lng: -107.92175,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.937,
    },
    {
      anio: 2023,
      lat: 26.37117,
      lng: -107.27606,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.515,
    },
    {
      anio: 2023,
      lat: 26.080334,
      lng: -106.813225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.1941,
    },
    {
      anio: 2023,
      lat: 26.994198,
      lng: -107.09613,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.0378,
    },
    {
      anio: 2023,
      lat: 26.110611,
      lng: -106.60035,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.8462,
    },
    {
      anio: 2023,
      lat: 26.843548,
      lng: -107.22231,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.0202,
    },
    {
      anio: 2023,
      lat: 26.95839,
      lng: -107.04383,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.1038,
    },
    {
      anio: 2023,
      lat: 27.182886,
      lng: -107.391914,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 26.5465,
    },
    {
      anio: 2023,
      lat: 26.089975,
      lng: -106.7779,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.588,
    },
    {
      anio: 2023,
      lat: 26.967222,
      lng: -106.99028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.7313,
    },
    {
      anio: 2023,
      lat: 25.942776,
      lng: -106.95362,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 136.3034,
    },
    {
      anio: 2023,
      lat: 26.454695,
      lng: -107.288475,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.988,
    },
    {
      anio: 2023,
      lat: 26.888641,
      lng: -107.00143,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 97.477,
    },
    {
      anio: 2023,
      lat: 26.916883,
      lng: -107.17901,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.8952,
    },
    {
      anio: 2023,
      lat: 27.64216,
      lng: -107.60978,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.2754,
    },
    {
      anio: 2023,
      lat: 26.832455,
      lng: -107.18186,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.071,
    },
    {
      anio: 2023,
      lat: 26.8499,
      lng: -107.0342,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.4641,
    },
    {
      anio: 2023,
      lat: 26.445211,
      lng: -107.22421,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.253,
    },
    {
      anio: 2023,
      lat: 26.78576,
      lng: -107.23751,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.482,
    },
    {
      anio: 2023,
      lat: 27.554564,
      lng: -107.824646,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.076,
    },
    {
      anio: 2023,
      lat: 26.394405,
      lng: -107.620384,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.702,
    },
    {
      anio: 2023,
      lat: 26.435328,
      lng: -107.23132,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.507,
    },
    {
      anio: 2023,
      lat: 27.504944,
      lng: -107.90219,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.917,
    },
    {
      anio: 2023,
      lat: 26.430895,
      lng: -107.2328,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 2,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.454,
    },
    {
      anio: 2023,
      lat: 26.360628,
      lng: -107.246574,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 2,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.2579,
    },
    {
      anio: 2023,
      lat: 26.090914,
      lng: -106.81301,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 1,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.7513,
    },
    {
      anio: 2022,
      lat: 25.931791,
      lng: -106.74841,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2022,
      lat: 26.368063,
      lng: -106.71577,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2022,
      lat: 26.729723,
      lng: -107.14445,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 27.198376,
      lng: -107.9573,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2022,
      lat: 26.777222,
      lng: -107.26092,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.6395,
      lng: -108.28549,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 92.16,
    },
    {
      anio: 2022,
      lat: 26.075062,
      lng: -106.66559,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.138,
    },
    {
      anio: 2022,
      lat: 26.148378,
      lng: -106.622025,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.78,
    },
    {
      anio: 2022,
      lat: 26.177975,
      lng: -107.03329,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 27.58855,
      lng: -108.15732,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 45.5,
    },
    {
      anio: 2022,
      lat: 27.464483,
      lng: -107.91249,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.685654,
      lng: -107.192856,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.29,
    },
    {
      anio: 2022,
      lat: 27.2775,
      lng: -108.32026,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 31.01,
    },
    {
      anio: 2022,
      lat: 26.448566,
      lng: -107.40355,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.47003,
      lng: -107.38622,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2022,
      lat: 26.87069,
      lng: -107.37289,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.419,
    },
    {
      anio: 2022,
      lat: 26.820648,
      lng: -107.39989,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.52,
    },
    {
      anio: 2022,
      lat: 26.118584,
      lng: -106.77788,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.010973,
      lng: -106.76825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Naturales",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.884312,
      lng: -107.480774,
      estado: "Chihuahua",
      municipio: "Batopilas de Manuel Gómez Morín",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 145,
    },
    {
      anio: 2022,
      lat: 26.818155,
      lng: -108.03289,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1263.15,
    },
    {
      anio: 2022,
      lat: 26.09627,
      lng: -107.099266,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1209.7,
    },
    {
      anio: 2022,
      lat: 26.208559,
      lng: -107.33328,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 93.5,
    },
    {
      anio: 2022,
      lat: 26.479288,
      lng: -107.01968,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2022,
      lat: 26.129156,
      lng: -106.76001,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2022,
      lat: 27.581974,
      lng: -108.116684,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 87.74,
    },
    {
      anio: 2022,
      lat: 26.17615,
      lng: -106.69138,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2022,
      lat: 26.524925,
      lng: -107.33178,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2022,
      lat: 26.092638,
      lng: -106.799774,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2022,
      lat: 26.15218,
      lng: -106.928825,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 82,
    },
    {
      anio: 2022,
      lat: 26.515581,
      lng: -107.66752,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 80,
    },
    {
      anio: 2022,
      lat: 26.495628,
      lng: -107.7096,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 27.51735,
      lng: -107.65007,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 78.98,
    },
    {
      anio: 2022,
      lat: 26.349941,
      lng: -107.26441,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 26.394655,
      lng: -107.22089,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Naturales",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 26.73545,
      lng: -107.07972,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 26.821507,
      lng: -107.06022,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.74,
    },
    {
      anio: 2022,
      lat: 26.866581,
      lng: -107.273926,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64,
    },
    {
      anio: 2022,
      lat: 25.909775,
      lng: -106.86726,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 61.54,
    },
    {
      anio: 2022,
      lat: 26.00565,
      lng: -106.889565,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2022,
      lat: 27.090183,
      lng: -107.26689,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.36,
    },
    {
      anio: 2022,
      lat: 27.499939,
      lng: -107.916306,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.34,
    },
    {
      anio: 2022,
      lat: 26.3518,
      lng: -106.91429,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.23,
    },
    {
      anio: 2022,
      lat: 25.850069,
      lng: -106.9013,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50.28,
    },
    {
      anio: 2022,
      lat: 27.591516,
      lng: -107.88021,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2022,
      lat: 26.02464,
      lng: -107.00692,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.079756,
      lng: -107.039505,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 27.056704,
      lng: -107.071175,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 49.7,
    },
    {
      anio: 2022,
      lat: 25.68528,
      lng: -106.81088,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.09,
    },
    {
      anio: 2022,
      lat: 25.988338,
      lng: -107.1356,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2022,
      lat: 26.166866,
      lng: -106.59856,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades pecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2022,
      lat: 25.85756,
      lng: -106.77977,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2022,
      lat: 26.23151,
      lng: -106.76243,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.19,
    },
    {
      anio: 2022,
      lat: 26.876389,
      lng: -107.41028,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.08,
    },
    {
      anio: 2022,
      lat: 26.04998,
      lng: -107.08726,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.902779,
      lng: -107.08278,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 25.85641,
      lng: -106.76958,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2022,
      lat: 26.406233,
      lng: -107.38545,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 308.87,
    },
    {
      anio: 2022,
      lat: 27.053942,
      lng: -107.29781,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 303,
    },
    {
      anio: 2022,
      lat: 26.051083,
      lng: -106.860695,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.02665,
      lng: -106.92966,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.234083,
      lng: -107.488174,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 267,
    },
    {
      anio: 2022,
      lat: 26.051584,
      lng: -106.73558,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.58,
    },
    {
      anio: 2022,
      lat: 26.064747,
      lng: -106.91918,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.538,
    },
    {
      anio: 2022,
      lat: 26.217936,
      lng: -106.910774,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades pecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2022,
      lat: 25.896944,
      lng: -106.86561,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2022,
      lat: 26.134775,
      lng: -106.88008,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2022,
      lat: 25.908972,
      lng: -106.9565,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 25.800825,
      lng: -106.855995,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 189.22,
    },
    {
      anio: 2022,
      lat: 26.313223,
      lng: -106.74783,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 181.44,
    },
    {
      anio: 2022,
      lat: 26.315216,
      lng: -107.33966,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2022,
      lat: 26.08525,
      lng: -106.67126,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2022,
      lat: 25.938864,
      lng: -106.947426,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2022,
      lat: 26.077133,
      lng: -107.03494,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 15,
    },
    {
      anio: 2022,
      lat: 26.088827,
      lng: -106.79977,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.081722,
      lng: -106.810585,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 25.907883,
      lng: -106.95597,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.259455,
      lng: -106.779495,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 135.74,
    },
    {
      anio: 2022,
      lat: 27.05625,
      lng: -106.99346,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 133.4,
    },
    {
      anio: 2022,
      lat: 26.43225,
      lng: -107.11313,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 131.27,
    },
    {
      anio: 2022,
      lat: 27.502129,
      lng: -107.85671,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.87,
    },
    {
      anio: 2022,
      lat: 27.423042,
      lng: -108.267365,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 117.59,
    },
    {
      anio: 2022,
      lat: 26.798647,
      lng: -107.195,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.6,
    },
    {
      anio: 2022,
      lat: 26.583311,
      lng: -106.98602,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 109,
    },
    {
      anio: 2022,
      lat: 26.475634,
      lng: -107.26965,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 26.135744,
      lng: -106.72143,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 25.78928,
      lng: -106.95314,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 26.703886,
      lng: -107.077774,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Quema de basureros",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 25.903334,
      lng: -106.93967,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.504747,
      lng: -107.87247,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 26.075472,
      lng: -106.79328,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.544361,
      lng: -107.824,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.581955,
      lng: -108.30917,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 86.78,
    },
    {
      anio: 2022,
      lat: 26.096323,
      lng: -106.781105,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.05,
    },
    {
      anio: 2022,
      lat: 26.037655,
      lng: -106.896774,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 25.827509,
      lng: -106.921974,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 26.826487,
      lng: -107.048096,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.44,
    },
    {
      anio: 2022,
      lat: 25.825573,
      lng: -106.79646,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 63.8715,
    },
    {
      anio: 2022,
      lat: 26.192791,
      lng: -107.071976,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55.75,
    },
    {
      anio: 2022,
      lat: 26.131165,
      lng: -106.807434,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 25.838491,
      lng: -106.91492,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 47.021,
    },
    {
      anio: 2022,
      lat: 27.229584,
      lng: -107.94704,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 417.76,
    },
    {
      anio: 2022,
      lat: 26.057827,
      lng: -106.81102,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 25.834381,
      lng: -106.98775,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 34.8506,
    },
    {
      anio: 2022,
      lat: 26.36548,
      lng: -107.648575,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2022,
      lat: 26.683725,
      lng: -107.17422,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 315.33,
    },
    {
      anio: 2022,
      lat: 26.101158,
      lng: -106.77788,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 27.50896,
      lng: -107.877975,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2022,
      lat: 26.129744,
      lng: -106.95167,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2022,
      lat: 26.040453,
      lng: -106.95182,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2022,
      lat: 25.759363,
      lng: -106.88446,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 215.48,
    },
    {
      anio: 2022,
      lat: 25.83297,
      lng: -106.68296,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 202.4,
    },
    {
      anio: 2022,
      lat: 26.05027,
      lng: -106.92296,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 26.181902,
      lng: -107.2096,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1822,
    },
    {
      anio: 2022,
      lat: 26.12702,
      lng: -106.82306,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.63,
    },
    {
      anio: 2022,
      lat: 27.48679,
      lng: -107.84916,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.77,
    },
    {
      anio: 2022,
      lat: 27.1597,
      lng: -108.2393,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 1235.05,
    },
    {
      anio: 2022,
      lat: 25.668139,
      lng: -106.81705,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.86,
    },
    {
      anio: 2022,
      lat: 25.921059,
      lng: -106.83663,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.003,
    },
    {
      anio: 2022,
      lat: 26.136486,
      lng: -106.83827,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.82,
    },
    {
      anio: 2022,
      lat: 25.684074,
      lng: -106.84692,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 25.896595,
      lng: -106.92697,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 27.508478,
      lng: -107.92771,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 26.095425,
      lng: -106.81291,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.514008,
      lng: -107.83677,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 26.799633,
      lng: -107.234726,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.6,
    },
    {
      anio: 2022,
      lat: 27.176329,
      lng: -107.2626,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 93.126,
    },
    {
      anio: 2022,
      lat: 27.101164,
      lng: -107.17863,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.2437,
    },
    {
      anio: 2022,
      lat: 27.093464,
      lng: -108.0276,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 68.705,
    },
    {
      anio: 2022,
      lat: 25.74788,
      lng: -106.93016,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 603.2355,
    },
    {
      anio: 2022,
      lat: 27.520214,
      lng: -108.0906,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.89,
    },
    {
      anio: 2022,
      lat: 25.81731,
      lng: -106.63425,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.608,
    },
    {
      anio: 2022,
      lat: 27.039461,
      lng: -107.29731,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.64,
    },
    {
      anio: 2022,
      lat: 26.070292,
      lng: -106.47082,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.09,
    },
    {
      anio: 2022,
      lat: 25.796139,
      lng: -106.961555,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 25.78145,
      lng: -106.920525,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 27.463188,
      lng: -107.900085,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 365.91,
    },
    {
      anio: 2022,
      lat: 26.304281,
      lng: -106.69779,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 279.249,
    },
    {
      anio: 2022,
      lat: 26.030886,
      lng: -106.92381,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.663,
    },
    {
      anio: 2022,
      lat: 25.639967,
      lng: -106.66126,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 246.199,
    },
    {
      anio: 2022,
      lat: 25.681444,
      lng: -106.7566,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 204,
    },
    {
      anio: 2022,
      lat: 25.978783,
      lng: -107.010735,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2022,
      lat: 26.079203,
      lng: -106.80846,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 27.39387,
      lng: -107.93677,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 173.5,
    },
    {
      anio: 2022,
      lat: 26.021183,
      lng: -106.933304,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.192,
    },
    {
      anio: 2022,
      lat: 25.824017,
      lng: -106.85212,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 116.45,
    },
    {
      anio: 2022,
      lat: 27.467508,
      lng: -108.309395,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1076.1563,
    },
    {
      anio: 2022,
      lat: 27.576159,
      lng: -108.02033,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2022,
      lat: 26.452206,
      lng: -107.18561,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 27.514347,
      lng: -107.89857,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.117172,
      lng: -106.75082,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.129,
    },
    {
      anio: 2022,
      lat: 26.02582,
      lng: -106.648575,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35,
    },
    {
      anio: 2022,
      lat: 25.996244,
      lng: -107.046555,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.483986,
      lng: -106.94458,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 296.237,
    },
    {
      anio: 2022,
      lat: 27.585266,
      lng: -107.992935,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 252.177,
    },
    {
      anio: 2022,
      lat: 26.605028,
      lng: -107.847084,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2022,
      lat: 25.857672,
      lng: -106.90067,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.987,
    },
    {
      anio: 2022,
      lat: 27.119436,
      lng: -107.94066,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 197.306,
    },
    {
      anio: 2022,
      lat: 27.066908,
      lng: -107.12175,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.69,
    },
    {
      anio: 2022,
      lat: 27.382263,
      lng: -108.02352,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 191,
    },
    {
      anio: 2022,
      lat: 26.216888,
      lng: -106.81531,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.157454,
      lng: -106.7263,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2022,
      lat: 25.902525,
      lng: -106.92821,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.362,
    },
    {
      anio: 2022,
      lat: 25.906155,
      lng: -106.991776,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Oyamel",
      impacto: "Impacto Mínimo",
      superficie: 1.32,
    },
    {
      anio: 2022,
      lat: 25.871815,
      lng: -106.939,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.872,
    },
    {
      anio: 2022,
      lat: 27.59039,
      lng: -107.62156,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2022,
      lat: 26.563206,
      lng: -106.94085,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 26.018024,
      lng: -106.64311,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 63.005,
    },
    {
      anio: 2022,
      lat: 26.28665,
      lng: -107.6325,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 581,
    },
    {
      anio: 2022,
      lat: 27.52906,
      lng: -107.86412,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 55.8069,
    },
    {
      anio: 2022,
      lat: 26.452095,
      lng: -107.301346,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.088892,
      lng: -106.75515,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.10161,
      lng: -106.796394,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.469748,
      lng: -107.63747,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.507,
    },
    {
      anio: 2022,
      lat: 26.884142,
      lng: -107.275444,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.915,
    },
    {
      anio: 2022,
      lat: 26.076462,
      lng: -106.82593,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.369577,
      lng: -106.801125,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2022,
      lat: 26.019827,
      lng: -106.79434,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 25.824612,
      lng: -106.807526,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.61,
    },
    {
      anio: 2022,
      lat: 27.531834,
      lng: -107.97705,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.91,
    },
    {
      anio: 2022,
      lat: 26.70395,
      lng: -107.09871,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.01,
    },
    {
      anio: 2022,
      lat: 27.185242,
      lng: -106.98998,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.6056,
    },
    {
      anio: 2022,
      lat: 27.144745,
      lng: -108.07098,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 110.72,
    },
    {
      anio: 2022,
      lat: 25.870886,
      lng: -106.84346,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 109.828,
    },
    {
      anio: 2022,
      lat: 26.041897,
      lng: -107.104164,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 107.29,
    },
    {
      anio: 2022,
      lat: 26.43498,
      lng: -107.33382,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 26.639275,
      lng: -107.40787,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 620.65,
    },
    {
      anio: 2022,
      lat: 27.401253,
      lng: -107.34021,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2022,
      lat: 26.74916,
      lng: -107.286736,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2022,
      lat: 27.653791,
      lng: -108.225945,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 71,
    },
    {
      anio: 2022,
      lat: 26.105806,
      lng: -106.76154,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.099497,
      lng: -106.82187,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.74,
    },
    {
      anio: 2022,
      lat: 26.34675,
      lng: -107.28323,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46.569,
    },
    {
      anio: 2022,
      lat: 26.90387,
      lng: -107.23175,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.45,
    },
    {
      anio: 2022,
      lat: 26.90661,
      lng: -107.33713,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 30.323,
    },
    {
      anio: 2022,
      lat: 25.972742,
      lng: -107.10163,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.092194,
      lng: -106.82322,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 27.376984,
      lng: -107.56831,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.506,
    },
    {
      anio: 2022,
      lat: 26.082336,
      lng: -106.772736,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 26.181917,
      lng: -107.1164,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 100,
    },
    {
      anio: 2022,
      lat: 27.449045,
      lng: -107.691055,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 87.32,
    },
    {
      anio: 2022,
      lat: 25.828506,
      lng: -106.88625,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 26.714338,
      lng: -107.76547,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 73,
    },
    {
      anio: 2022,
      lat: 26.90325,
      lng: -107.21846,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 69.16,
    },
    {
      anio: 2022,
      lat: 27.555786,
      lng: -107.84053,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.91,
    },
    {
      anio: 2022,
      lat: 27.220858,
      lng: -107.05015,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 27.055712,
      lng: -107.27258,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.02,
    },
    {
      anio: 2022,
      lat: 25.760628,
      lng: -106.837524,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.986166,
      lng: -107.11232,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.97,
    },
    {
      anio: 2022,
      lat: 26.887205,
      lng: -107.29872,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.5,
    },
    {
      anio: 2022,
      lat: 26.37209,
      lng: -106.75563,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.16,
    },
    {
      anio: 2022,
      lat: 26.210016,
      lng: -106.62982,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2022,
      lat: 26.57106,
      lng: -107.7247,
      estado: "Chihuahua",
      municipio: "Morelos",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 26.800838,
      lng: -107.27098,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.95,
    },
    {
      anio: 2022,
      lat: 27.433512,
      lng: -107.22051,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 164.97,
    },
    {
      anio: 2022,
      lat: 27.229,
      lng: -107.39,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 144.37,
    },
    {
      anio: 2022,
      lat: 27.6286,
      lng: -107.59975,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Festividades y rituales",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 141.903,
    },
    {
      anio: 2022,
      lat: 27.297503,
      lng: -107.07563,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2022,
      lat: 26.034655,
      lng: -106.78057,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 25.864498,
      lng: -106.78658,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.107494,
      lng: -107.40641,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.074236,
      lng: -107.06913,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.25,
    },
    {
      anio: 2022,
      lat: 26.876581,
      lng: -107.027176,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2022,
      lat: 27.563158,
      lng: -108.00532,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2022,
      lat: 27.573,
      lng: -107.97,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 26.21453,
      lng: -107.44446,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 49,
    },
    {
      anio: 2022,
      lat: 26.976725,
      lng: -107.02618,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.76,
    },
    {
      anio: 2022,
      lat: 26.731655,
      lng: -107.15359,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2022,
      lat: 26.046541,
      lng: -106.93419,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.334682,
      lng: -107.19417,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 26.108467,
      lng: -106.80347,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 26.892427,
      lng: -107.19861,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.3,
    },
    {
      anio: 2022,
      lat: 27.341053,
      lng: -108.14969,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.03,
    },
    {
      anio: 2022,
      lat: 27.100233,
      lng: -107.320206,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 25.641161,
      lng: -106.81091,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.143686,
      lng: -106.88925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 27.567028,
      lng: -107.82039,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2022,
      lat: 27.550325,
      lng: -107.82728,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2022,
      lat: 27.571888,
      lng: -107.82917,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Transportes",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2022,
      lat: 26.063581,
      lng: -107.03612,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 27.019678,
      lng: -107.29006,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2022,
      lat: 27.081272,
      lng: -107.1432,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.54,
    },
    {
      anio: 2022,
      lat: 26.118917,
      lng: -106.78175,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 27.502792,
      lng: -107.44112,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 115.32,
    },
    {
      anio: 2022,
      lat: 26.893059,
      lng: -106.90482,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.52,
    },
    {
      anio: 2022,
      lat: 25.715208,
      lng: -106.82381,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 27.509373,
      lng: -107.96605,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2022,
      lat: 26.855919,
      lng: -107.3925,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5,
    },
    {
      anio: 2022,
      lat: 26.735977,
      lng: -107.06948,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.2,
    },
    {
      anio: 2022,
      lat: 26.981363,
      lng: -107.07312,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 43.08,
    },
    {
      anio: 2022,
      lat: 26.936802,
      lng: -107.06433,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.5,
    },
    {
      anio: 2022,
      lat: 26.082806,
      lng: -106.75508,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 27.311697,
      lng: -107.37249,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 284.6,
    },
    {
      anio: 2022,
      lat: 26.059628,
      lng: -106.91,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.727,
    },
    {
      anio: 2022,
      lat: 26.45321,
      lng: -107.3819,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5,
    },
    {
      anio: 2022,
      lat: 26.225283,
      lng: -106.81753,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.94,
    },
    {
      anio: 2022,
      lat: 26.8874,
      lng: -107.17943,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.5,
    },
    {
      anio: 2022,
      lat: 26.064945,
      lng: -106.78772,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 27.46054,
      lng: -107.65355,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2022,
      lat: 26.99639,
      lng: -107.1563,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2022,
      lat: 26.40354,
      lng: -107.32451,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2022,
      lat: 26.063555,
      lng: -106.78647,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 26.72892,
      lng: -107.10547,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2022,
      lat: 26.798058,
      lng: -107.17385,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2022,
      lat: 27.577753,
      lng: -107.5318,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 110.7,
    },
    {
      anio: 2022,
      lat: 26.119583,
      lng: -106.784,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.03,
    },
    {
      anio: 2022,
      lat: 26.79875,
      lng: -107.17314,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.03,
    },
    {
      anio: 2022,
      lat: 26.733192,
      lng: -107.105705,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.783,
    },
    {
      anio: 2022,
      lat: 27.521261,
      lng: -107.95018,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2022,
      lat: 26.519684,
      lng: -107.27011,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 27.192204,
      lng: -107.04207,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64,
    },
    {
      anio: 2022,
      lat: 27.503366,
      lng: -107.892166,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2022,
      lat: 27.413778,
      lng: -107.88813,
      estado: "Chihuahua",
      municipio: "Urique",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.87,
    },
    {
      anio: 2022,
      lat: 26.060925,
      lng: -106.860756,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.905567,
      lng: -107.14825,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.787798,
      lng: -107.18239,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8,
    },
    {
      anio: 2022,
      lat: 26.35775,
      lng: -106.838936,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 249.52,
    },
    {
      anio: 2022,
      lat: 26.072496,
      lng: -106.988144,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 25.953594,
      lng: -106.988434,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 18,
    },
    {
      anio: 2022,
      lat: 26.392778,
      lng: -107.30225,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2022,
      lat: 26.093834,
      lng: -106.77492,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 26.08249,
      lng: -106.76684,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2022,
      lat: 26.072811,
      lng: -106.77868,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2022,
      lat: 27.64075,
      lng: -107.634415,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.879,
    },
    {
      anio: 2022,
      lat: 25.812,
      lng: -106.95007,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 26.268059,
      lng: -106.79015,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 500.56,
    },
    {
      anio: 2022,
      lat: 26.028473,
      lng: -106.975975,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2022,
      lat: 26.891556,
      lng: -106.9975,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2,
    },
    {
      anio: 2022,
      lat: 26.9702,
      lng: -107.18955,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2022,
      lat: 26.08331,
      lng: -107.01784,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2022,
      lat: 26.878069,
      lng: -106.91384,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 58.375,
    },
    {
      anio: 2022,
      lat: 26.038666,
      lng: -107.01707,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.794374,
      lng: -107.13208,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.6,
    },
    {
      anio: 2022,
      lat: 26.047558,
      lng: -106.90173,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.73585,
      lng: -107.135895,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2022,
      lat: 27.603312,
      lng: -108.26539,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.583,
    },
    {
      anio: 2022,
      lat: 26.810278,
      lng: -107.17917,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.2,
    },
    {
      anio: 2022,
      lat: 25.81284,
      lng: -106.959465,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 180.556,
    },
    {
      anio: 2022,
      lat: 26.816128,
      lng: -107.136696,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 27.60041,
      lng: -108.3145,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.181,
    },
    {
      anio: 2022,
      lat: 26.0515,
      lng: -106.71651,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.97987,
      lng: -107.30714,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.612,
    },
    {
      anio: 2022,
      lat: 26.820555,
      lng: -107.04986,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.76,
    },
    {
      anio: 2022,
      lat: 26.081322,
      lng: -106.81925,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.63,
    },
    {
      anio: 2022,
      lat: 26.023119,
      lng: -106.62754,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 212.207,
    },
    {
      anio: 2022,
      lat: 26.81588,
      lng: -107.1294,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.12,
    },
    {
      anio: 2022,
      lat: 26.08725,
      lng: -106.95026,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 26.421112,
      lng: -107.33553,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.045,
    },
    {
      anio: 2022,
      lat: 26.761639,
      lng: -107.04198,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 100.2,
    },
    {
      anio: 2022,
      lat: 26.07214,
      lng: -106.80697,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2022,
      lat: 27.341175,
      lng: -108.24248,
      estado: "Chihuahua",
      municipio: "Guazapares",
      causa: "Fumadores",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 26.062012,
      lng: -106.734184,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 79.773,
    },
    {
      anio: 2022,
      lat: 26.86815,
      lng: -107.19469,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 59.091,
    },
    {
      anio: 2022,
      lat: 26.008802,
      lng: -107.01201,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 26.921112,
      lng: -107.129486,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.67,
    },
    {
      anio: 2022,
      lat: 26.119402,
      lng: -106.978264,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 26.82586,
      lng: -107.05881,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 26.327814,
      lng: -107.2966,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.36,
    },
    {
      anio: 2022,
      lat: 26.083988,
      lng: -107.02234,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 26.34185,
      lng: -106.90786,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Fogatas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 61.065,
    },
    {
      anio: 2022,
      lat: 26.312447,
      lng: -106.86955,
      estado: "Chihuahua",
      municipio: "Guadalupe y Calvo",
      causa: "Intencional",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2022,
      lat: 26.807117,
      lng: -107.06204,
      estado: "Chihuahua",
      municipio: "Guachochi",
      causa: "Intencional",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1,
    },
    {
      anio: 2025,
      lat: 25.381111,
      lng: -106.86806,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 160,
    },
    {
      anio: 2025,
      lat: 25.55139,
      lng: -106.35306,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1000,
    },
    {
      anio: 2025,
      lat: 22.967777,
      lng: -104.912224,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 934,
    },
    {
      anio: 2025,
      lat: 22.678333,
      lng: -104.51361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 23.229445,
      lng: -104.91889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2025,
      lat: 22.742222,
      lng: -104.69583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 570,
    },
    {
      anio: 2025,
      lat: 24.631666,
      lng: -105.42,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2025,
      lat: 22.675278,
      lng: -104.855,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 351,
    },
    {
      anio: 2025,
      lat: 23.796112,
      lng: -105.37639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2025,
      lat: 25.163889,
      lng: -106.56194,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 210,
    },
    {
      anio: 2025,
      lat: 23.491945,
      lng: -104.59778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2025,
      lat: 25.304445,
      lng: -106.80889,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 161,
    },
    {
      anio: 2025,
      lat: 25.443056,
      lng: -106.897224,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.6,
    },
    {
      anio: 2025,
      lat: 23.161945,
      lng: -104.88416,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2025,
      lat: 22.485277,
      lng: -104.41333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 102,
    },
    {
      anio: 2025,
      lat: 24.383888,
      lng: -105.492775,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 22.930555,
      lng: -104.50056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 23.28,
      lng: -104.77722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 22.997223,
      lng: -104.53389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 23.186666,
      lng: -105.23583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 92,
    },
    {
      anio: 2025,
      lat: 23.04889,
      lng: -105.31389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 750,
    },
    {
      anio: 2025,
      lat: 22.660278,
      lng: -104.7075,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 73,
    },
    {
      anio: 2025,
      lat: 24.770834,
      lng: -106.06528,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2025,
      lat: 22.957777,
      lng: -104.8875,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 520,
    },
    {
      anio: 2025,
      lat: 25.398611,
      lng: -106.88167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Festividades y rituales",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 484,
    },
    {
      anio: 2025,
      lat: 23.555277,
      lng: -105.495834,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46.2648,
    },
    {
      anio: 2025,
      lat: 22.720833,
      lng: -104.74416,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 355,
    },
    {
      anio: 2025,
      lat: 22.603333,
      lng: -104.54667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 22.974722,
      lng: -104.64528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 22.730556,
      lng: -104.66194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 23.40889,
      lng: -104.36472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2025,
      lat: 22.9175,
      lng: -104.75528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2025,
      lat: 22.547777,
      lng: -104.319725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26,
    },
    {
      anio: 2025,
      lat: 23.030556,
      lng: -104.92139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 212,
    },
    {
      anio: 2025,
      lat: 22.8975,
      lng: -104.53778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.655834,
      lng: -104.76,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 24.667778,
      lng: -106.01056,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 25.091389,
      lng: -106.11278,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 23.251112,
      lng: -104.91861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.824167,
      lng: -104.49778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.762777,
      lng: -104.71111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.886389,
      lng: -104.6175,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.938055,
      lng: -104.49639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2025,
      lat: 24.879444,
      lng: -105.77472,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2025,
      lat: 22.606667,
      lng: -104.95722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2025,
      lat: 22.75639,
      lng: -104.738335,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 151,
    },
    {
      anio: 2025,
      lat: 23.32611,
      lng: -105.5475,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 145,
    },
    {
      anio: 2025,
      lat: 22.645277,
      lng: -104.30666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.5,
    },
    {
      anio: 2025,
      lat: 22.828056,
      lng: -104.70333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 116,
    },
    {
      anio: 2025,
      lat: 24.975277,
      lng: -106.96445,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 22.986944,
      lng: -104.655556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 22.96,
      lng: -104.75305,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Severo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 22.866388,
      lng: -104.63389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 96,
    },
    {
      anio: 2025,
      lat: 25.17389,
      lng: -107.123886,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9409.864,
    },
    {
      anio: 2025,
      lat: 22.84,
      lng: -104.5725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2025,
      lat: 23.201944,
      lng: -105.19556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 89,
    },
    {
      anio: 2025,
      lat: 24.484444,
      lng: -106.576385,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 8807,
    },
    {
      anio: 2025,
      lat: 24.63139,
      lng: -106.63695,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 876,
    },
    {
      anio: 2025,
      lat: 23.799723,
      lng: -105.37334,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 22.671944,
      lng: -104.92389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2025,
      lat: 25.475834,
      lng: -107.01778,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 57,
    },
    {
      anio: 2025,
      lat: 25.419445,
      lng: -107.17028,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3142,
    },
    {
      anio: 2025,
      lat: 23.537971,
      lng: -105.35298,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1305,
    },
    {
      anio: 2025,
      lat: 24.923056,
      lng: -106.39167,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 31,
    },
    {
      anio: 2025,
      lat: 23.234444,
      lng: -104.87889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2025,
      lat: 25.298056,
      lng: -107.166664,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2000,
    },
    {
      anio: 2025,
      lat: 22.812778,
      lng: -104.75166,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 146,
    },
    {
      anio: 2025,
      lat: 23.020277,
      lng: -104.49,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 121,
    },
    {
      anio: 2025,
      lat: 24.5625,
      lng: -106.64167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1154.7881,
    },
    {
      anio: 2025,
      lat: 22.829166,
      lng: -104.74555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2025,
      lat: 22.864166,
      lng: -104.496666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 22.65611,
      lng: -104.49028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 24.922222,
      lng: -106.24139,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 950,
    },
    {
      anio: 2025,
      lat: 25.141111,
      lng: -106.59472,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 834,
    },
    {
      anio: 2025,
      lat: 23.730278,
      lng: -105.64278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2025,
      lat: 24.920555,
      lng: -106.914444,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 732,
    },
    {
      anio: 2025,
      lat: 24.722778,
      lng: -106.361946,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 714,
    },
    {
      anio: 2025,
      lat: 24.33639,
      lng: -106.081665,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7090,
    },
    {
      anio: 2025,
      lat: 25.104445,
      lng: -107.01945,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Festividades y rituales",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 639,
    },
    {
      anio: 2025,
      lat: 25.255278,
      lng: -105.92083,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5300,
    },
    {
      anio: 2025,
      lat: 25.457777,
      lng: -106.221664,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2025,
      lat: 24.061945,
      lng: -105.87889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5021.1288,
    },
    {
      anio: 2025,
      lat: 23.086666,
      lng: -104.60083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 22.623333,
      lng: -104.96111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 430,
    },
    {
      anio: 2025,
      lat: 23.254168,
      lng: -104.83361,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4057,
    },
    {
      anio: 2025,
      lat: 24.886389,
      lng: -106.775276,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 357,
    },
    {
      anio: 2025,
      lat: 22.584723,
      lng: -104.755,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Festividades y rituales",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 340,
    },
    {
      anio: 2025,
      lat: 23.804445,
      lng: -105.333336,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 300,
    },
    {
      anio: 2025,
      lat: 24.463055,
      lng: -106.23333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2025,
      lat: 25.123611,
      lng: -106.83444,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 222,
    },
    {
      anio: 2025,
      lat: 23.677223,
      lng: -105.493614,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 221,
    },
    {
      anio: 2025,
      lat: 22.678612,
      lng: -105.065,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 220,
    },
    {
      anio: 2025,
      lat: 23.802288,
      lng: -105.33595,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 215.2257,
    },
    {
      anio: 2025,
      lat: 23.79889,
      lng: -105.360275,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.896944,
      lng: -104.665276,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 23.168333,
      lng: -105.36528,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1993.8,
    },
    {
      anio: 2025,
      lat: 23.643055,
      lng: -105.6425,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1967,
    },
    {
      anio: 2025,
      lat: 24.979445,
      lng: -106.19556,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1710,
    },
    {
      anio: 2025,
      lat: 22.692223,
      lng: -104.57833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1680,
    },
    {
      anio: 2025,
      lat: 23.857779,
      lng: -105.49611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 165,
    },
    {
      anio: 2025,
      lat: 23.004444,
      lng: -104.64861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2025,
      lat: 22.955278,
      lng: -104.624725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.4,
    },
    {
      anio: 2025,
      lat: 23.306894,
      lng: -105.3986,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 138.2866,
    },
    {
      anio: 2025,
      lat: 24.696667,
      lng: -106.65861,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1359,
    },
    {
      anio: 2025,
      lat: 22.994167,
      lng: -104.43667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 135,
    },
    {
      anio: 2025,
      lat: 22.93361,
      lng: -104.45472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 130,
    },
    {
      anio: 2025,
      lat: 25.472778,
      lng: -107.11667,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1209,
    },
    {
      anio: 2025,
      lat: 25.038055,
      lng: -106.42889,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 120,
    },
    {
      anio: 2025,
      lat: 22.669445,
      lng: -104.535,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1190,
    },
    {
      anio: 2025,
      lat: 24.145653,
      lng: -105.57102,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 85.2706,
    },
    {
      anio: 2025,
      lat: 22.87092,
      lng: -104.76252,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.4826,
    },
    {
      anio: 2025,
      lat: 22.715834,
      lng: -104.318054,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 740,
    },
    {
      anio: 2025,
      lat: 22.864723,
      lng: -104.575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 669.0052,
    },
    {
      anio: 2025,
      lat: 22.953888,
      lng: -104.67472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 612,
    },
    {
      anio: 2025,
      lat: 23.843334,
      lng: -105.60472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.7059,
    },
    {
      anio: 2025,
      lat: 25.035833,
      lng: -106.27278,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 519,
    },
    {
      anio: 2025,
      lat: 23.678333,
      lng: -105.49111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2025,
      lat: 22.60111,
      lng: -104.954445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 37,
    },
    {
      anio: 2025,
      lat: 22.935278,
      lng: -104.50667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32,
    },
    {
      anio: 2025,
      lat: 22.990833,
      lng: -104.77611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 292.1861,
    },
    {
      anio: 2025,
      lat: 24.78139,
      lng: -105.958336,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 277.1932,
    },
    {
      anio: 2025,
      lat: 24.751667,
      lng: -106.77889,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 276.881,
    },
    {
      anio: 2025,
      lat: 23.032223,
      lng: -105.33861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 239.6481,
    },
    {
      anio: 2025,
      lat: 22.880833,
      lng: -104.78917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2025,
      lat: 22.805555,
      lng: -104.37139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 210,
    },
    {
      anio: 2025,
      lat: 24.993835,
      lng: -106.47798,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2093.9261,
    },
    {
      anio: 2025,
      lat: 22.952223,
      lng: -104.243614,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 205.3398,
    },
    {
      anio: 2025,
      lat: 25.12139,
      lng: -106.51139,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 191,
    },
    {
      anio: 2025,
      lat: 22.73611,
      lng: -104.49472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 181,
    },
    {
      anio: 2025,
      lat: 25.051945,
      lng: -106.37361,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 107.1519,
    },
    {
      anio: 2025,
      lat: 25.03,
      lng: -106.90889,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 101.1354,
    },
    {
      anio: 2025,
      lat: 23.845,
      lng: -105.59389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 100,
    },
    {
      anio: 2025,
      lat: 23.291945,
      lng: -104.92528,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2025,
      lat: 23.80889,
      lng: -105.34111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras actividades productivas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 9.6869,
    },
    {
      anio: 2025,
      lat: 22.722778,
      lng: -104.53611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 74.1591,
    },
    {
      anio: 2025,
      lat: 23.074127,
      lng: -104.67546,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 73.3597,
    },
    {
      anio: 2025,
      lat: 24.287222,
      lng: -106.46555,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7275.2355,
    },
    {
      anio: 2025,
      lat: 23.062288,
      lng: -104.60128,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 67.7522,
    },
    {
      anio: 2025,
      lat: 22.903334,
      lng: -104.748055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.7448,
    },
    {
      anio: 2025,
      lat: 22.880278,
      lng: -104.765,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 64.561,
    },
    {
      anio: 2025,
      lat: 22.901667,
      lng: -104.77,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.3958,
    },
    {
      anio: 2025,
      lat: 25.062878,
      lng: -106.706665,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 50.0744,
    },
    {
      anio: 2025,
      lat: 23.593056,
      lng: -105.87417,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 499.2586,
    },
    {
      anio: 2025,
      lat: 22.863333,
      lng: -104.664444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 31.771,
    },
    {
      anio: 2025,
      lat: 22.671108,
      lng: -104.34664,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.6266,
    },
    {
      anio: 2025,
      lat: 23.020555,
      lng: -104.65361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.5405,
    },
    {
      anio: 2025,
      lat: 23.59389,
      lng: -105.718056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2025,
      lat: 22.450556,
      lng: -104.480835,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2025,
      lat: 22.99627,
      lng: -104.318344,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1971,
    },
    {
      anio: 2025,
      lat: 23.73421,
      lng: -104.40543,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 10.0873,
    },
    {
      anio: 2025,
      lat: 24.125278,
      lng: -105.95556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2025,
      lat: 22.81889,
      lng: -104.51556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5836,
    },
    {
      anio: 2025,
      lat: 23.098612,
      lng: -105.08639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 744.2102,
    },
    {
      anio: 2025,
      lat: 23.594723,
      lng: -105.725,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Otras actividades productivas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 71.5101,
    },
    {
      anio: 2025,
      lat: 22.659025,
      lng: -104.3724,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.0836,
    },
    {
      anio: 2025,
      lat: 22.881111,
      lng: -104.47806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 610.9814,
    },
    {
      anio: 2025,
      lat: 22.961945,
      lng: -104.6225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5569,
    },
    {
      anio: 2025,
      lat: 23.68714,
      lng: -105.69966,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.8198,
    },
    {
      anio: 2025,
      lat: 25.058332,
      lng: -106.53139,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 45.4616,
    },
    {
      anio: 2025,
      lat: 22.847221,
      lng: -104.736664,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 417.305,
    },
    {
      anio: 2025,
      lat: 23.764166,
      lng: -105.361946,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.7285,
    },
    {
      anio: 2025,
      lat: 24.241388,
      lng: -105.87972,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 371.3565,
    },
    {
      anio: 2025,
      lat: 25.032778,
      lng: -106.87889,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 32.0821,
    },
    {
      anio: 2025,
      lat: 22.823889,
      lng: -104.251945,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 253.4601,
    },
    {
      anio: 2025,
      lat: 22.904167,
      lng: -104.5675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.578,
    },
    {
      anio: 2025,
      lat: 23.221666,
      lng: -104.876114,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 225.2052,
    },
    {
      anio: 2025,
      lat: 23.794445,
      lng: -105.33583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.055,
    },
    {
      anio: 2025,
      lat: 23.196945,
      lng: -105.05222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.5779,
    },
    {
      anio: 2025,
      lat: 23.073889,
      lng: -104.19361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.8413,
    },
    {
      anio: 2025,
      lat: 22.67361,
      lng: -104.8375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1436.5491,
    },
    {
      anio: 2025,
      lat: 23.788055,
      lng: -105.38333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.0996,
    },
    {
      anio: 2025,
      lat: 23.030678,
      lng: -104.65746,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.4258,
    },
    {
      anio: 2025,
      lat: 22.925606,
      lng: -104.79934,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 118.8486,
    },
    {
      anio: 2025,
      lat: 22.600277,
      lng: -104.285835,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 77.2871,
    },
    {
      anio: 2025,
      lat: 24.351683,
      lng: -106.18394,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 723.5738,
    },
    {
      anio: 2025,
      lat: 22.555,
      lng: -104.92083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 622.3591,
    },
    {
      anio: 2025,
      lat: 22.728611,
      lng: -104.62666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 50,
    },
    {
      anio: 2025,
      lat: 24.322678,
      lng: -105.47473,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.7594,
    },
    {
      anio: 2025,
      lat: 25.435305,
      lng: -106.12301,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.7357,
    },
    {
      anio: 2025,
      lat: 22.709723,
      lng: -104.50916,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.0993,
    },
    {
      anio: 2025,
      lat: 23.660355,
      lng: -105.81507,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.9182,
    },
    {
      anio: 2025,
      lat: 22.930555,
      lng: -104.577225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.711,
    },
    {
      anio: 2025,
      lat: 22.954445,
      lng: -104.686386,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.704,
    },
    {
      anio: 2025,
      lat: 22.947779,
      lng: -104.59944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.1418,
    },
    {
      anio: 2025,
      lat: 24.406559,
      lng: -105.59599,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.2512,
    },
    {
      anio: 2025,
      lat: 22.9775,
      lng: -104.30222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 223.2294,
    },
    {
      anio: 2025,
      lat: 23.788055,
      lng: -105.38333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.9409,
    },
    {
      anio: 2025,
      lat: 22.889723,
      lng: -104.954445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 197.242,
    },
    {
      anio: 2025,
      lat: 25.247223,
      lng: -107.09,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1903.8274,
    },
    {
      anio: 2025,
      lat: 22.937222,
      lng: -104.59111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 18.5618,
    },
    {
      anio: 2025,
      lat: 23.642044,
      lng: -105.62427,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.8366,
    },
    {
      anio: 2025,
      lat: 22.817669,
      lng: -104.333244,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.039,
    },
    {
      anio: 2025,
      lat: 23.785887,
      lng: -105.37752,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.534,
    },
    {
      anio: 2025,
      lat: 22.907778,
      lng: -104.64833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 93.1296,
    },
    {
      anio: 2025,
      lat: 25.177221,
      lng: -106.53333,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65.9941,
    },
    {
      anio: 2025,
      lat: 24.989166,
      lng: -105.92333,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 47.5133,
    },
    {
      anio: 2025,
      lat: 22.962488,
      lng: -104.446335,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.6705,
    },
    {
      anio: 2025,
      lat: 23.055,
      lng: -104.62111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.5584,
    },
    {
      anio: 2025,
      lat: 22.943056,
      lng: -104.6125,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.9476,
    },
    {
      anio: 2025,
      lat: 22.994167,
      lng: -104.43056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25.1457,
    },
    {
      anio: 2025,
      lat: 22.843056,
      lng: -104.52722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 2.3664,
    },
    {
      anio: 2025,
      lat: 25.086374,
      lng: -106.458305,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Otras actividades productivas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2321.8226,
    },
    {
      anio: 2025,
      lat: 22.771389,
      lng: -104.50222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.2794,
    },
    {
      anio: 2025,
      lat: 22.785278,
      lng: -104.53833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 137.9107,
    },
    {
      anio: 2025,
      lat: 23.761932,
      lng: -105.361946,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.196,
    },
    {
      anio: 2025,
      lat: 22.9325,
      lng: -104.60833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.7498,
    },
    {
      anio: 2025,
      lat: 23.046944,
      lng: -104.87055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1044.3997,
    },
    {
      anio: 2025,
      lat: 23.778334,
      lng: -105.388054,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9328,
    },
    {
      anio: 2025,
      lat: 23.607779,
      lng: -105.540276,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 87.9574,
    },
    {
      anio: 2025,
      lat: 23.41361,
      lng: -105.11389,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 849.4672,
    },
    {
      anio: 2025,
      lat: 23.248888,
      lng: -104.95861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 81.7194,
    },
    {
      anio: 2025,
      lat: 25.506945,
      lng: -106.92306,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.5887,
    },
    {
      anio: 2025,
      lat: 23.0225,
      lng: -104.67917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 62.4076,
    },
    {
      anio: 2025,
      lat: 23.449167,
      lng: -104.945274,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 56.4955,
    },
    {
      anio: 2025,
      lat: 23.81165,
      lng: -105.37758,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.0063,
    },
    {
      anio: 2025,
      lat: 22.874994,
      lng: -104.759834,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.9046,
    },
    {
      anio: 2025,
      lat: 22.929445,
      lng: -104.51722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.9983,
    },
    {
      anio: 2025,
      lat: 22.894175,
      lng: -104.75011,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.1977,
    },
    {
      anio: 2025,
      lat: 23.41404,
      lng: -105.3875,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40.5738,
    },
    {
      anio: 2025,
      lat: 22.764608,
      lng: -104.50772,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.8424,
    },
    {
      anio: 2025,
      lat: 22.845278,
      lng: -104.77472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.4518,
    },
    {
      anio: 2025,
      lat: 24.117239,
      lng: -105.70105,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3452,
    },
    {
      anio: 2025,
      lat: 23.018423,
      lng: -104.31563,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2071,
    },
    {
      anio: 2025,
      lat: 23.7525,
      lng: -105.35555,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1249,
    },
    {
      anio: 2025,
      lat: 23.7887,
      lng: -105.368904,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6973,
    },
    {
      anio: 2025,
      lat: 22.692778,
      lng: -104.469444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.4712,
    },
    {
      anio: 2025,
      lat: 22.904167,
      lng: -104.64694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 167.6308,
    },
    {
      anio: 2025,
      lat: 22.970917,
      lng: -104.42701,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 166.9284,
    },
    {
      anio: 2025,
      lat: 22.637545,
      lng: -104.96179,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3539,
    },
    {
      anio: 2025,
      lat: 23.783777,
      lng: -105.38245,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.981,
    },
    {
      anio: 2025,
      lat: 22.979166,
      lng: -104.476944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.3659,
    },
    {
      anio: 2025,
      lat: 24.309166,
      lng: -106.48944,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1031.5299,
    },
    {
      anio: 2025,
      lat: 22.735268,
      lng: -104.4136,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 52.2363,
    },
    {
      anio: 2025,
      lat: 24.715763,
      lng: -106.22466,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 74.2989,
    },
    {
      anio: 2025,
      lat: 22.658333,
      lng: -104.37444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 69.4011,
    },
    {
      anio: 2025,
      lat: 25.657454,
      lng: -106.98135,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Ayarín",
      impacto: "Impacto Mínimo",
      superficie: 6.6498,
    },
    {
      anio: 2025,
      lat: 22.651276,
      lng: -104.365555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.3729,
    },
    {
      anio: 2025,
      lat: 23.703075,
      lng: -105.67538,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.3424,
    },
    {
      anio: 2025,
      lat: 23.046389,
      lng: -104.5075,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53.0406,
    },
    {
      anio: 2025,
      lat: 22.921944,
      lng: -104.5775,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.2516,
    },
    {
      anio: 2025,
      lat: 24.974636,
      lng: -106.7606,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.6747,
    },
    {
      anio: 2025,
      lat: 22.86861,
      lng: -104.72195,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.5239,
    },
    {
      anio: 2025,
      lat: 23.315556,
      lng: -105.4825,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.3577,
    },
    {
      anio: 2025,
      lat: 24.745,
      lng: -105.84278,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.4915,
    },
    {
      anio: 2025,
      lat: 23.770277,
      lng: -105.37556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1219,
    },
    {
      anio: 2025,
      lat: 23.016388,
      lng: -104.66111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18.4359,
    },
    {
      anio: 2025,
      lat: 23.022497,
      lng: -104.619995,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Ayarín",
      impacto: "Impacto Mínimo",
      superficie: 1.7512,
    },
    {
      anio: 2025,
      lat: 23.816944,
      lng: -105.55278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7457,
    },
    {
      anio: 2025,
      lat: 23.400942,
      lng: -105.124214,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 95.0404,
    },
    {
      anio: 2025,
      lat: 23.053055,
      lng: -105.34583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 919.5947,
    },
    {
      anio: 2025,
      lat: 22.850542,
      lng: -104.792694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.0098,
    },
    {
      anio: 2025,
      lat: 22.778334,
      lng: -104.799446,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.8254,
    },
    {
      anio: 2025,
      lat: 23.176184,
      lng: -105.144295,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 60.0117,
    },
    {
      anio: 2025,
      lat: 24.656944,
      lng: -106.67028,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 55.316,
    },
    {
      anio: 2025,
      lat: 24.731945,
      lng: -105.98972,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 53.1905,
    },
    {
      anio: 2025,
      lat: 22.683056,
      lng: -104.821945,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Mínimo",
      superficie: 52.6319,
    },
    {
      anio: 2025,
      lat: 22.873888,
      lng: -104.63695,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.1186,
    },
    {
      anio: 2025,
      lat: 22.86106,
      lng: -104.34743,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 46.969,
    },
    {
      anio: 2025,
      lat: 22.99145,
      lng: -104.557014,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2463,
    },
    {
      anio: 2025,
      lat: 23.74892,
      lng: -105.38139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.6082,
    },
    {
      anio: 2025,
      lat: 23.801884,
      lng: -105.392876,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1924,
    },
    {
      anio: 2025,
      lat: 22.678612,
      lng: -104.90833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 188.3323,
    },
    {
      anio: 2025,
      lat: 23.041945,
      lng: -104.291664,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.783,
    },
    {
      anio: 2025,
      lat: 22.687778,
      lng: -104.38306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 17.7654,
    },
    {
      anio: 2025,
      lat: 23.114445,
      lng: -105.07833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 153.887,
    },
    {
      anio: 2025,
      lat: 22.931389,
      lng: -104.59917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3022,
    },
    {
      anio: 2025,
      lat: 23.535156,
      lng: -105.3638,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 1.279,
    },
    {
      anio: 2025,
      lat: 25.261486,
      lng: -107.07053,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 106.7811,
    },
    {
      anio: 2025,
      lat: 22.651667,
      lng: -104.700554,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 91.7979,
    },
    {
      anio: 2025,
      lat: 23.777561,
      lng: -105.34808,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.1574,
    },
    {
      anio: 2025,
      lat: 25.039444,
      lng: -106.23602,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.147,
    },
    {
      anio: 2025,
      lat: 22.90158,
      lng: -104.48252,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 68.8878,
    },
    {
      anio: 2025,
      lat: 25.09761,
      lng: -106.650085,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2774,
    },
    {
      anio: 2025,
      lat: 22.756666,
      lng: -104.67472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 60.7119,
    },
    {
      anio: 2025,
      lat: 22.611258,
      lng: -105.005035,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 340.9212,
    },
    {
      anio: 2025,
      lat: 22.907778,
      lng: -104.21555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.0716,
    },
    {
      anio: 2025,
      lat: 23.710854,
      lng: -105.56648,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4801,
    },
    {
      anio: 2025,
      lat: 25.345556,
      lng: -107.06639,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2367.6057,
    },
    {
      anio: 2025,
      lat: 23.051756,
      lng: -104.59978,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.5185,
    },
    {
      anio: 2025,
      lat: 22.48611,
      lng: -104.54972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 226.8949,
    },
    {
      anio: 2025,
      lat: 25.146421,
      lng: -106.56201,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.3624,
    },
    {
      anio: 2025,
      lat: 22.935236,
      lng: -104.58932,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 19.8405,
    },
    {
      anio: 2025,
      lat: 22.657223,
      lng: -104.31834,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.969,
    },
    {
      anio: 2025,
      lat: 23.79363,
      lng: -105.35922,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.8774,
    },
    {
      anio: 2025,
      lat: 22.72139,
      lng: -104.50389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.376,
    },
    {
      anio: 2025,
      lat: 22.778055,
      lng: -104.54361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 154.5402,
    },
    {
      anio: 2025,
      lat: 23.064722,
      lng: -104.842224,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 151.0056,
    },
    {
      anio: 2025,
      lat: 23.758888,
      lng: -105.35639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.1004,
    },
    {
      anio: 2025,
      lat: 25.105892,
      lng: -106.55356,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9398,
    },
    {
      anio: 2025,
      lat: 22.95926,
      lng: -104.44627,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.5083,
    },
    {
      anio: 2025,
      lat: 24.926216,
      lng: -106.90594,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 91.9002,
    },
    {
      anio: 2025,
      lat: 24.491112,
      lng: -105.66,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.1331,
    },
    {
      anio: 2025,
      lat: 22.995556,
      lng: -104.7775,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.6629,
    },
    {
      anio: 2025,
      lat: 23.804848,
      lng: -105.314865,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 481.8918,
    },
    {
      anio: 2025,
      lat: 23.003819,
      lng: -104.65879,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.6286,
    },
    {
      anio: 2025,
      lat: 22.778248,
      lng: -104.50905,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.92,
    },
    {
      anio: 2025,
      lat: 22.65648,
      lng: -104.845924,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Selva Mediana Subcaducifolia",
      impacto: "Impacto Mínimo",
      superficie: 30.3767,
    },
    {
      anio: 2025,
      lat: 22.981071,
      lng: -104.64409,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.9216,
    },
    {
      anio: 2025,
      lat: 24.475555,
      lng: -106.49416,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 237.0358,
    },
    {
      anio: 2025,
      lat: 22.552183,
      lng: -104.93379,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 235.3187,
    },
    {
      anio: 2025,
      lat: 24.971909,
      lng: -106.29915,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.1305,
    },
    {
      anio: 2025,
      lat: 22.939167,
      lng: -104.611946,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.0756,
    },
    {
      anio: 2025,
      lat: 23.042778,
      lng: -104.21889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 191.8648,
    },
    {
      anio: 2025,
      lat: 23.2725,
      lng: -104.90222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4062,
    },
    {
      anio: 2025,
      lat: 24.29158,
      lng: -105.82877,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3318,
    },
    {
      anio: 2025,
      lat: 22.922314,
      lng: -104.58337,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.681,
    },
    {
      anio: 2025,
      lat: 24.320555,
      lng: -105.46889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 101.5448,
    },
    {
      anio: 2025,
      lat: 23.00361,
      lng: -104.313614,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.1251,
    },
    {
      anio: 2025,
      lat: 22.641388,
      lng: -104.41695,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 65.4756,
    },
    {
      anio: 2025,
      lat: 22.973333,
      lng: -104.941925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.494,
    },
    {
      anio: 2025,
      lat: 22.725555,
      lng: -104.30417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 99.448,
    },
    {
      anio: 2025,
      lat: 22.695267,
      lng: -104.52232,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 49.0146,
    },
    {
      anio: 2025,
      lat: 24.726084,
      lng: -106.178764,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 34.1076,
    },
    {
      anio: 2025,
      lat: 24.583055,
      lng: -105.61139,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.2503,
    },
    {
      anio: 2025,
      lat: 22.967222,
      lng: -104.611115,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.2524,
    },
    {
      anio: 2025,
      lat: 24.255278,
      lng: -105.910835,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2373,
    },
    {
      anio: 2025,
      lat: 23.814377,
      lng: -105.381775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.134,
    },
    {
      anio: 2025,
      lat: 24.185608,
      lng: -105.93856,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 30.9482,
    },
    {
      anio: 2025,
      lat: 23.778603,
      lng: -105.319534,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.0157,
    },
    {
      anio: 2025,
      lat: 22.893553,
      lng: -104.77821,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.7499,
    },
    {
      anio: 2025,
      lat: 25.773561,
      lng: -106.179054,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.8064,
    },
    {
      anio: 2025,
      lat: 22.97889,
      lng: -104.85167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.1843,
    },
    {
      anio: 2025,
      lat: 22.631527,
      lng: -104.28873,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.0768,
    },
    {
      anio: 2025,
      lat: 22.625,
      lng: -104.75611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 134.6413,
    },
    {
      anio: 2025,
      lat: 22.953611,
      lng: -104.6125,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.1324,
    },
    {
      anio: 2025,
      lat: 22.961111,
      lng: -104.62666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.2682,
    },
    {
      anio: 2025,
      lat: 22.979816,
      lng: -104.58602,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.4274,
    },
    {
      anio: 2025,
      lat: 22.958334,
      lng: -104.61222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.4305,
    },
    {
      anio: 2025,
      lat: 25.120832,
      lng: -106.43083,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Intencional",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.6441,
    },
    {
      anio: 2025,
      lat: 23.858889,
      lng: -105.34028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 211.2441,
    },
    {
      anio: 2025,
      lat: 25.48,
      lng: -106.94778,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 138.9498,
    },
    {
      anio: 2025,
      lat: 22.912777,
      lng: -104.60306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3567,
    },
    {
      anio: 2025,
      lat: 23.7875,
      lng: -105.33111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.222,
    },
    {
      anio: 2025,
      lat: 23.787777,
      lng: -105.37945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.7616,
    },
    {
      anio: 2025,
      lat: 22.957777,
      lng: -104.625275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.6521,
    },
    {
      anio: 2025,
      lat: 23.035555,
      lng: -104.632225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 72.7255,
    },
    {
      anio: 2025,
      lat: 23.0225,
      lng: -104.62,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.4133,
    },
    {
      anio: 2025,
      lat: 22.959167,
      lng: -104.498886,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 35.6501,
    },
    {
      anio: 2025,
      lat: 24.955278,
      lng: -106.25389,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.8189,
    },
    {
      anio: 2025,
      lat: 22.58,
      lng: -104.4575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 113.2811,
    },
    {
      anio: 2025,
      lat: 23.00513,
      lng: -104.325134,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.9,
    },
    {
      anio: 2025,
      lat: 23.017778,
      lng: -105.206665,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 8,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 38.7766,
    },
    {
      anio: 2025,
      lat: 22.795408,
      lng: -104.56998,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.7853,
    },
    {
      anio: 2025,
      lat: 24.435917,
      lng: -105.794556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.1886,
    },
    {
      anio: 2025,
      lat: 24.95111,
      lng: -106.534164,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades pecuarias",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 31.5173,
    },
    {
      anio: 2025,
      lat: 24.258055,
      lng: -105.49639,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Quema de basureros",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9501,
    },
    {
      anio: 2025,
      lat: 22.787777,
      lng: -104.89528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 6,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 222.1946,
    },
    {
      anio: 2025,
      lat: 25.11,
      lng: -106.35389,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.9089,
    },
    {
      anio: 2025,
      lat: 25.415833,
      lng: -106.34695,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.6471,
    },
    {
      anio: 2025,
      lat: 22.9475,
      lng: -104.483055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 126.4878,
    },
    {
      anio: 2025,
      lat: 23.158056,
      lng: -105.03833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 3,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 105.109,
    },
    {
      anio: 2025,
      lat: 25.194445,
      lng: -106.27361,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.3798,
    },
    {
      anio: 2024,
      lat: 23.146944,
      lng: -105.02556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 43,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.7274,
    },
    {
      anio: 2024,
      lat: 23.028889,
      lng: -105.32306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 44,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 49.2795,
    },
    {
      anio: 2024,
      lat: 22.601944,
      lng: -104.58806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 44,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 108.0661,
    },
    {
      anio: 2024,
      lat: 23.459444,
      lng: -104.73444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 46,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.5662,
    },
    {
      anio: 2024,
      lat: 23.127222,
      lng: -104.35306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 49,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 53.6383,
    },
    {
      anio: 2024,
      lat: 25.141945,
      lng: -106.57806,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 50,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 53.341,
    },
    {
      anio: 2024,
      lat: 25.542778,
      lng: -106.54222,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 52,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 63.787,
    },
    {
      anio: 2024,
      lat: 23.731112,
      lng: -105.28,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 53,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.088,
    },
    {
      anio: 2024,
      lat: 24.285278,
      lng: -106.438614,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 53,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 480.9521,
    },
    {
      anio: 2024,
      lat: 23.326944,
      lng: -105.04806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 53,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 412.7764,
    },
    {
      anio: 2024,
      lat: 25.0975,
      lng: -105.59361,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 53,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.9397,
    },
    {
      anio: 2024,
      lat: 22.805834,
      lng: -104.60333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 395.8668,
    },
    {
      anio: 2024,
      lat: 24.53965,
      lng: -105.62184,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.349,
    },
    {
      anio: 2024,
      lat: 23.601667,
      lng: -105.56028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 147.938,
    },
    {
      anio: 2024,
      lat: 22.967194,
      lng: -104.31176,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 910.695,
    },
    {
      anio: 2024,
      lat: 22.5825,
      lng: -104.69611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7460.0001,
    },
    {
      anio: 2024,
      lat: 22.9575,
      lng: -104.94722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 687.3236,
    },
    {
      anio: 2024,
      lat: 25.43833,
      lng: -106.203186,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62.021,
    },
    {
      anio: 2024,
      lat: 23.5448,
      lng: -105.71143,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 615.7404,
    },
    {
      anio: 2024,
      lat: 24.181667,
      lng: -105.95722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5253.2928,
    },
    {
      anio: 2024,
      lat: 24.71891,
      lng: -106.30763,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 5120.4773,
    },
    {
      anio: 2024,
      lat: 23.633612,
      lng: -105.666115,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 437.7366,
    },
    {
      anio: 2024,
      lat: 22.909744,
      lng: -104.631714,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.228,
    },
    {
      anio: 2024,
      lat: 24.337969,
      lng: -105.62159,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 40.273,
    },
    {
      anio: 2024,
      lat: 22.707222,
      lng: -104.53528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 393.9926,
    },
    {
      anio: 2024,
      lat: 25.1175,
      lng: -105.699165,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 376.119,
    },
    {
      anio: 2024,
      lat: 24.373056,
      lng: -106.13778,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3562.2029,
    },
    {
      anio: 2024,
      lat: 25.145834,
      lng: -106.23,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 267.2739,
    },
    {
      anio: 2024,
      lat: 22.71608,
      lng: -104.71612,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.203,
    },
    {
      anio: 2024,
      lat: 22.981112,
      lng: -104.63333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.1639,
    },
    {
      anio: 2024,
      lat: 22.889444,
      lng: -104.59805,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 180.6451,
    },
    {
      anio: 2024,
      lat: 23.480833,
      lng: -105.60167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 177.306,
    },
    {
      anio: 2024,
      lat: 24.367777,
      lng: -106.18806,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 163.2081,
    },
    {
      anio: 2024,
      lat: 23.285833,
      lng: -104.938614,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 159.907,
    },
    {
      anio: 2024,
      lat: 24.78111,
      lng: -106.58,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 155.6941,
    },
    {
      anio: 2024,
      lat: 25.483828,
      lng: -106.2604,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.319,
    },
    {
      anio: 2024,
      lat: 25.26361,
      lng: -106.11667,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1039.622,
    },
    {
      anio: 2024,
      lat: 23.245562,
      lng: -104.93564,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.5171,
    },
    {
      anio: 2024,
      lat: 23.005411,
      lng: -104.68121,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 84.0487,
    },
    {
      anio: 2024,
      lat: 22.897161,
      lng: -104.66043,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 80.4142,
    },
    {
      anio: 2024,
      lat: 22.91407,
      lng: -104.62606,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.296,
    },
    {
      anio: 2024,
      lat: 23.678055,
      lng: -105.66778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 660.8953,
    },
    {
      anio: 2024,
      lat: 23.839445,
      lng: -105.62028,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 65.8821,
    },
    {
      anio: 2024,
      lat: 22.793222,
      lng: -104.75987,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 63.2181,
    },
    {
      anio: 2024,
      lat: 23.759445,
      lng: -105.687775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62.4217,
    },
    {
      anio: 2024,
      lat: 22.888056,
      lng: -104.631386,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 62.207,
    },
    {
      anio: 2024,
      lat: 22.710278,
      lng: -104.80278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 586.871,
    },
    {
      anio: 2024,
      lat: 22.806944,
      lng: -104.36444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51.617,
    },
    {
      anio: 2024,
      lat: 24.33,
      lng: -106.493614,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 50.9499,
    },
    {
      anio: 2024,
      lat: 22.765833,
      lng: -104.507225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.663,
    },
    {
      anio: 2024,
      lat: 24.33182,
      lng: -105.86288,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.387,
    },
    {
      anio: 2024,
      lat: 23.639723,
      lng: -105.59472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.436,
    },
    {
      anio: 2024,
      lat: 24.954445,
      lng: -105.83583,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.644,
    },
    {
      anio: 2024,
      lat: 23.504444,
      lng: -104.958336,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.501,
    },
    {
      anio: 2024,
      lat: 23.001667,
      lng: -104.5375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.3202,
    },
    {
      anio: 2024,
      lat: 24.945833,
      lng: -106.038055,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 22.98,
    },
    {
      anio: 2024,
      lat: 22.463888,
      lng: -104.390274,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 185.558,
    },
    {
      anio: 2024,
      lat: 23.536667,
      lng: -105.54305,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 172.9918,
    },
    {
      anio: 2024,
      lat: 23.24516,
      lng: -104.776634,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 16.5299,
    },
    {
      anio: 2024,
      lat: 22.863155,
      lng: -104.71355,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.502,
    },
    {
      anio: 2024,
      lat: 24.94839,
      lng: -106.2416,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.2631,
    },
    {
      anio: 2024,
      lat: 22.796112,
      lng: -104.56639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.182,
    },
    {
      anio: 2024,
      lat: 22.966852,
      lng: -104.67892,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 125.282,
    },
    {
      anio: 2024,
      lat: 24.683056,
      lng: -105.50222,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 123.438,
    },
    {
      anio: 2024,
      lat: 22.98425,
      lng: -104.64575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.608,
    },
    {
      anio: 2024,
      lat: 22.931263,
      lng: -104.41048,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 1158.4808,
    },
    {
      anio: 2024,
      lat: 22.849388,
      lng: -104.577286,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 108.8951,
    },
    {
      anio: 2024,
      lat: 22.7028,
      lng: -104.3471,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 106.854,
    },
    {
      anio: 2024,
      lat: 23.29139,
      lng: -105.15528,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 106.363,
    },
    {
      anio: 2024,
      lat: 24.900517,
      lng: -106.430916,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 92.4688,
    },
    {
      anio: 2024,
      lat: 23.055555,
      lng: -104.75361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 874.9276,
    },
    {
      anio: 2024,
      lat: 22.63328,
      lng: -104.29928,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 77.8521,
    },
    {
      anio: 2024,
      lat: 22.76862,
      lng: -104.52751,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Quema de basureros",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 71.4755,
    },
    {
      anio: 2024,
      lat: 22.889444,
      lng: -104.24167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 711.3995,
    },
    {
      anio: 2024,
      lat: 24.85,
      lng: -106.829445,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 675.098,
    },
    {
      anio: 2024,
      lat: 23.78139,
      lng: -105.37889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.2036,
    },
    {
      anio: 2024,
      lat: 25.1075,
      lng: -106.53528,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.4004,
    },
    {
      anio: 2024,
      lat: 23.0753,
      lng: -104.57278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 55.8429,
    },
    {
      anio: 2024,
      lat: 23.8002,
      lng: -105.36358,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.576,
    },
    {
      anio: 2024,
      lat: 23.0617,
      lng: -104.49988,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 36.509,
    },
    {
      anio: 2024,
      lat: 23.455,
      lng: -105.691666,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 361.493,
    },
    {
      anio: 2024,
      lat: 23.042223,
      lng: -104.264725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 324.2838,
    },
    {
      anio: 2024,
      lat: 22.77389,
      lng: -104.43806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 246.957,
    },
    {
      anio: 2024,
      lat: 22.779724,
      lng: -104.519005,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.157,
    },
    {
      anio: 2024,
      lat: 24.98735,
      lng: -106.51287,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 216.499,
    },
    {
      anio: 2024,
      lat: 22.873611,
      lng: -104.50083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.9044,
    },
    {
      anio: 2024,
      lat: 22.9575,
      lng: -105.199165,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 1988.5477,
    },
    {
      anio: 2024,
      lat: 23.85128,
      lng: -105.41943,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.4618,
    },
    {
      anio: 2024,
      lat: 22.972778,
      lng: -104.650276,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7989,
    },
    {
      anio: 2024,
      lat: 24.657156,
      lng: -106.04272,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 16.013,
    },
    {
      anio: 2024,
      lat: 25.232222,
      lng: -106.4525,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 132.145,
    },
    {
      anio: 2024,
      lat: 23.69,
      lng: -105.80722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 119.1546,
    },
    {
      anio: 2024,
      lat: 22.685833,
      lng: -104.299164,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 119.0898,
    },
    {
      anio: 2024,
      lat: 22.641111,
      lng: -104.60917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 105.373,
    },
    {
      anio: 2024,
      lat: 22.824444,
      lng: -104.49528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.2,
    },
    {
      anio: 2024,
      lat: 24.706161,
      lng: -106.376,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 94.5665,
    },
    {
      anio: 2024,
      lat: 22.937262,
      lng: -104.87088,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 77.879,
    },
    {
      anio: 2024,
      lat: 23.097778,
      lng: -105.15305,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 66.9229,
    },
    {
      anio: 2024,
      lat: 25.577778,
      lng: -106.98889,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65.1031,
    },
    {
      anio: 2024,
      lat: 23.572311,
      lng: -105.39171,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.36,
    },
    {
      anio: 2024,
      lat: 22.97973,
      lng: -104.63129,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.8383,
    },
    {
      anio: 2024,
      lat: 23.229166,
      lng: -104.879166,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 47.98,
    },
    {
      anio: 2024,
      lat: 23.216402,
      lng: -104.87911,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.8061,
    },
    {
      anio: 2024,
      lat: 23.057222,
      lng: -105.30222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 347.513,
    },
    {
      anio: 2024,
      lat: 25.43361,
      lng: -106.81111,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.6478,
    },
    {
      anio: 2024,
      lat: 22.684166,
      lng: -104.374725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 315.5911,
    },
    {
      anio: 2024,
      lat: 22.936945,
      lng: -104.59639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.686,
    },
    {
      anio: 2024,
      lat: 22.610277,
      lng: -104.869446,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 282.298,
    },
    {
      anio: 2024,
      lat: 22.973333,
      lng: -104.3675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.4818,
    },
    {
      anio: 2024,
      lat: 23.325,
      lng: -105.06555,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 221.9517,
    },
    {
      anio: 2024,
      lat: 23.004158,
      lng: -104.321075,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.44,
    },
    {
      anio: 2024,
      lat: 22.871666,
      lng: -104.345276,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 178.376,
    },
    {
      anio: 2024,
      lat: 24.972778,
      lng: -106.76861,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 173.543,
    },
    {
      anio: 2024,
      lat: 23.005833,
      lng: -104.86305,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 169.1061,
    },
    {
      anio: 2024,
      lat: 23.641111,
      lng: -105.632774,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16.7975,
    },
    {
      anio: 2024,
      lat: 24.911112,
      lng: -105.83667,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 1.504,
    },
    {
      anio: 2024,
      lat: 23.675278,
      lng: -105.58222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 139.989,
    },
    {
      anio: 2024,
      lat: 22.827778,
      lng: -104.59639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.766,
    },
    {
      anio: 2024,
      lat: 22.887163,
      lng: -104.58483,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.2411,
    },
    {
      anio: 2024,
      lat: 22.889444,
      lng: -104.61667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 104.334,
    },
    {
      anio: 2024,
      lat: 22.768888,
      lng: -104.22639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 84.3926,
    },
    {
      anio: 2024,
      lat: 24.571112,
      lng: -106.6,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 73.251,
    },
    {
      anio: 2024,
      lat: 22.803333,
      lng: -104.31695,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 70.2407,
    },
    {
      anio: 2024,
      lat: 22.709192,
      lng: -104.50478,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.392,
    },
    {
      anio: 2024,
      lat: 22.905,
      lng: -104.96306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 616.0741,
    },
    {
      anio: 2024,
      lat: 25.146667,
      lng: -107.03083,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.9504,
    },
    {
      anio: 2024,
      lat: 25.14889,
      lng: -107.03639,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.8244,
    },
    {
      anio: 2024,
      lat: 24.30861,
      lng: -105.91417,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5186.8079,
    },
    {
      anio: 2024,
      lat: 25.003334,
      lng: -106.36083,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 515.347,
    },
    {
      anio: 2024,
      lat: 22.820555,
      lng: -104.636665,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.5144,
    },
    {
      anio: 2024,
      lat: 22.916666,
      lng: -104.76667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 43.582,
    },
    {
      anio: 2024,
      lat: 24.151667,
      lng: -105.54083,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.605,
    },
    {
      anio: 2024,
      lat: 22.89264,
      lng: -104.65363,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.2082,
    },
    {
      anio: 2024,
      lat: 23.196678,
      lng: -104.88057,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.65,
    },
    {
      anio: 2024,
      lat: 22.90905,
      lng: -104.85218,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28.7913,
    },
    {
      anio: 2024,
      lat: 22.88751,
      lng: -104.76785,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.468,
    },
    {
      anio: 2024,
      lat: 23.623333,
      lng: -105.62722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.0331,
    },
    {
      anio: 2024,
      lat: 22.595,
      lng: -104.36139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 194.684,
    },
    {
      anio: 2024,
      lat: 25.023611,
      lng: -106.72722,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 190.053,
    },
    {
      anio: 2024,
      lat: 22.900555,
      lng: -104.44139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.14,
    },
    {
      anio: 2024,
      lat: 22.5825,
      lng: -104.327225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 150.6628,
    },
    {
      anio: 2024,
      lat: 24.687222,
      lng: -106.265274,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1265.5294,
    },
    {
      anio: 2024,
      lat: 22.723055,
      lng: -104.291115,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.217,
    },
    {
      anio: 2024,
      lat: 23.768888,
      lng: -105.687775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.681,
    },
    {
      anio: 2024,
      lat: 22.80575,
      lng: -104.52623,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.236,
    },
    {
      anio: 2024,
      lat: 22.714592,
      lng: -104.35855,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 42.6348,
    },
    {
      anio: 2024,
      lat: 22.796944,
      lng: -104.825554,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 380.7408,
    },
    {
      anio: 2024,
      lat: 23.003536,
      lng: -104.45255,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.559,
    },
    {
      anio: 2024,
      lat: 23.409721,
      lng: -104.83195,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 32.19,
    },
    {
      anio: 2024,
      lat: 23.744167,
      lng: -105.64833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2024,
    },
    {
      anio: 2024,
      lat: 24.8775,
      lng: -106.89611,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2834.651,
    },
    {
      anio: 2024,
      lat: 23.064981,
      lng: -104.732056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 27.7079,
    },
    {
      anio: 2024,
      lat: 25.28002,
      lng: -106.63713,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.344,
    },
    {
      anio: 2024,
      lat: 23.118334,
      lng: -105.24111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 232.44,
    },
    {
      anio: 2024,
      lat: 23.021389,
      lng: -104.66583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.4023,
    },
    {
      anio: 2024,
      lat: 23.448055,
      lng: -105.37778,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 213.7835,
    },
    {
      anio: 2024,
      lat: 25.08031,
      lng: -106.558914,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 19.0043,
    },
    {
      anio: 2024,
      lat: 24.98611,
      lng: -106.619446,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 1865.1439,
    },
    {
      anio: 2024,
      lat: 23.41499,
      lng: -105.39163,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.4883,
    },
    {
      anio: 2024,
      lat: 22.950556,
      lng: -104.7925,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 179.916,
    },
    {
      anio: 2024,
      lat: 25.02861,
      lng: -106.710556,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 170.669,
    },
    {
      anio: 2024,
      lat: 24.535555,
      lng: -105.55222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 14.1796,
    },
    {
      anio: 2024,
      lat: 23.62554,
      lng: -105.50283,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 134.8617,
    },
    {
      anio: 2024,
      lat: 22.88248,
      lng: -104.33814,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 13.343,
    },
    {
      anio: 2024,
      lat: 22.90658,
      lng: -104.74423,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.0474,
    },
    {
      anio: 2024,
      lat: 22.696945,
      lng: -104.36417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 118.23,
    },
    {
      anio: 2024,
      lat: 22.929811,
      lng: -104.50354,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1594,
    },
    {
      anio: 2024,
      lat: 23.01417,
      lng: -104.75611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.9457,
    },
    {
      anio: 2024,
      lat: 22.85302,
      lng: -104.30062,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.4923,
    },
    {
      anio: 2024,
      lat: 25.15639,
      lng: -107.03361,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 9.661,
    },
    {
      anio: 2024,
      lat: 22.983334,
      lng: -104.59861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.834,
    },
    {
      anio: 2024,
      lat: 23.25565,
      lng: -104.77417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.758,
    },
    {
      anio: 2024,
      lat: 22.599167,
      lng: -104.509445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 6.746,
    },
    {
      anio: 2024,
      lat: 22.6475,
      lng: -104.29361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.12,
    },
    {
      anio: 2024,
      lat: 22.837778,
      lng: -104.48389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 605.3558,
    },
    {
      anio: 2024,
      lat: 22.72076,
      lng: -104.4005,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 55.032,
    },
    {
      anio: 2024,
      lat: 23.243889,
      lng: -104.7725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 50.6078,
    },
    {
      anio: 2024,
      lat: 24.905834,
      lng: -106.81861,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 45.0082,
    },
    {
      anio: 2024,
      lat: 24.959679,
      lng: -106.160194,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 399.0057,
    },
    {
      anio: 2024,
      lat: 22.919167,
      lng: -104.80278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.6813,
    },
    {
      anio: 2024,
      lat: 24.822777,
      lng: -106.74111,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.412,
    },
    {
      anio: 2024,
      lat: 23.74922,
      lng: -105.70454,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.907,
    },
    {
      anio: 2024,
      lat: 23.7586,
      lng: -105.41645,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.3771,
    },
    {
      anio: 2024,
      lat: 23.148333,
      lng: -105.23278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 270.6199,
    },
    {
      anio: 2024,
      lat: 23.150278,
      lng: -104.297226,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 261.45,
    },
    {
      anio: 2024,
      lat: 23.044361,
      lng: -104.843864,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 143.085,
    },
    {
      anio: 2024,
      lat: 22.885277,
      lng: -104.60694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.293,
    },
    {
      anio: 2024,
      lat: 23.07496,
      lng: -104.49917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 118.962,
    },
    {
      anio: 2024,
      lat: 23.638067,
      lng: -105.32514,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.8313,
    },
    {
      anio: 2024,
      lat: 23.658056,
      lng: -105.29444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Moderado",
      superficie: 455.9735,
    },
    {
      anio: 2024,
      lat: 24.825277,
      lng: -106.86305,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 79.4171,
    },
    {
      anio: 2024,
      lat: 23.659115,
      lng: -105.82108,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.3538,
    },
    {
      anio: 2024,
      lat: 23.109167,
      lng: -104.59278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 35.7096,
    },
    {
      anio: 2024,
      lat: 23.805834,
      lng: -105.33,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32.4744,
    },
    {
      anio: 2024,
      lat: 24.339031,
      lng: -105.57975,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.546,
    },
    {
      anio: 2024,
      lat: 23.166666,
      lng: -105.066666,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.9797,
    },
    {
      anio: 2024,
      lat: 22.71861,
      lng: -104.55167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 224.1363,
    },
    {
      anio: 2024,
      lat: 25.109331,
      lng: -106.54706,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.054,
    },
    {
      anio: 2024,
      lat: 22.946945,
      lng: -104.620834,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.888,
    },
    {
      anio: 2024,
      lat: 23.25639,
      lng: -104.88639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7962,
    },
    {
      anio: 2024,
      lat: 22.675556,
      lng: -104.29278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.0415,
    },
    {
      anio: 2024,
      lat: 22.845833,
      lng: -104.50806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.603,
    },
    {
      anio: 2024,
      lat: 24.985556,
      lng: -106.22833,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.44,
    },
    {
      anio: 2024,
      lat: 23.146667,
      lng: -105.58139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 142.8343,
    },
    {
      anio: 2024,
      lat: 23.02223,
      lng: -105.23027,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 9.774,
    },
    {
      anio: 2024,
      lat: 23.007223,
      lng: -104.87028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.7882,
    },
    {
      anio: 2024,
      lat: 23.27,
      lng: -104.895,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.473,
    },
    {
      anio: 2024,
      lat: 23.064722,
      lng: -104.25361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 56.7473,
    },
    {
      anio: 2024,
      lat: 23.266388,
      lng: -105.38556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 52.421,
    },
    {
      anio: 2024,
      lat: 24.892221,
      lng: -106.94972,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 49.0481,
    },
    {
      anio: 2024,
      lat: 22.835278,
      lng: -104.28445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5006,
    },
    {
      anio: 2024,
      lat: 23.39585,
      lng: -104.89839,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.3577,
    },
    {
      anio: 2024,
      lat: 23.7523,
      lng: -105.68229,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.3206,
    },
    {
      anio: 2024,
      lat: 22.970556,
      lng: -104.61806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.234,
    },
    {
      anio: 2024,
      lat: 22.886667,
      lng: -104.825836,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.426,
    },
    {
      anio: 2024,
      lat: 22.727777,
      lng: -104.541664,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Moderado",
      superficie: 263.3007,
    },
    {
      anio: 2024,
      lat: 22.642778,
      lng: -104.69556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.2411,
    },
    {
      anio: 2024,
      lat: 25.530277,
      lng: -107.09167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 234.2158,
    },
    {
      anio: 2024,
      lat: 24.933056,
      lng: -106.96445,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Intencional",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 197.5545,
    },
    {
      anio: 2024,
      lat: 22.840279,
      lng: -104.52611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.7284,
    },
    {
      anio: 2024,
      lat: 23.28582,
      lng: -104.84422,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.58,
    },
    {
      anio: 2024,
      lat: 22.883333,
      lng: -104.53139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.5548,
    },
    {
      anio: 2024,
      lat: 25.175556,
      lng: -106.71639,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 153.7836,
    },
    {
      anio: 2024,
      lat: 23.61086,
      lng: -105.525696,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.271,
    },
    {
      anio: 2024,
      lat: 25.04373,
      lng: -106.53961,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.7291,
    },
    {
      anio: 2024,
      lat: 24.044167,
      lng: -105.826385,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1381.7609,
    },
    {
      anio: 2024,
      lat: 22.72415,
      lng: -104.502716,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.3358,
    },
    {
      anio: 2024,
      lat: 22.508055,
      lng: -104.486946,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 0.9986,
    },
    {
      anio: 2024,
      lat: 23.15446,
      lng: -104.93841,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 82.4516,
    },
    {
      anio: 2024,
      lat: 22.95233,
      lng: -104.58772,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.1694,
    },
    {
      anio: 2024,
      lat: 22.647223,
      lng: -104.92528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 675.408,
    },
    {
      anio: 2024,
      lat: 23.026667,
      lng: -104.73139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.1744,
    },
    {
      anio: 2024,
      lat: 24.905111,
      lng: -106.32699,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 55.3402,
    },
    {
      anio: 2024,
      lat: 24.483889,
      lng: -106.145836,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 53.6699,
    },
    {
      anio: 2024,
      lat: 24.97298,
      lng: -106.60351,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 48.4922,
    },
    {
      anio: 2024,
      lat: 22.65148,
      lng: -104.39027,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 47.9312,
    },
    {
      anio: 2024,
      lat: 22.960556,
      lng: -104.638336,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 4.367,
    },
    {
      anio: 2024,
      lat: 25.48009,
      lng: -106.775795,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2372,
    },
    {
      anio: 2024,
      lat: 22.879444,
      lng: -104.96889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.9207,
    },
    {
      anio: 2024,
      lat: 25.383055,
      lng: -106.140274,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 391.4588,
    },
    {
      anio: 2024,
      lat: 23.72062,
      lng: -105.63912,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.798,
    },
    {
      anio: 2024,
      lat: 22.88889,
      lng: -104.67083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.8161,
    },
    {
      anio: 2024,
      lat: 22.964445,
      lng: -104.82166,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.033,
    },
    {
      anio: 2024,
      lat: 22.839722,
      lng: -104.94278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades pecuarias",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 164.215,
    },
    {
      anio: 2024,
      lat: 22.87049,
      lng: -104.60994,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.3394,
    },
    {
      anio: 2024,
      lat: 24.83,
      lng: -106.03889,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 57.2279,
    },
    {
      anio: 2024,
      lat: 23.789444,
      lng: -105.36667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.009,
    },
    {
      anio: 2024,
      lat: 24.538334,
      lng: -105.60306,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.6193,
    },
    {
      anio: 2024,
      lat: 23.682777,
      lng: -105.58889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.4673,
    },
    {
      anio: 2024,
      lat: 23.041666,
      lng: -104.28083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 263.992,
    },
    {
      anio: 2024,
      lat: 22.713331,
      lng: -104.50351,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.5572,
    },
    {
      anio: 2024,
      lat: 23.422222,
      lng: -105.01,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.551,
    },
    {
      anio: 2024,
      lat: 23.658056,
      lng: -105.30556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 136.1809,
    },
    {
      anio: 2024,
      lat: 23.7175,
      lng: -105.281944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 118.051,
    },
    {
      anio: 2024,
      lat: 23.733055,
      lng: -105.32306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.9469,
    },
    {
      anio: 2024,
      lat: 22.872223,
      lng: -104.56861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 95.7873,
    },
    {
      anio: 2024,
      lat: 22.978333,
      lng: -104.77722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.3793,
    },
    {
      anio: 2024,
      lat: 25.23889,
      lng: -106.45389,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 76.2976,
    },
    {
      anio: 2024,
      lat: 22.955,
      lng: -104.37028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5117,
    },
    {
      anio: 2024,
      lat: 22.679167,
      lng: -104.418335,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.8768,
    },
    {
      anio: 2024,
      lat: 22.9816,
      lng: -104.8254,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 47.2471,
    },
    {
      anio: 2024,
      lat: 23.702223,
      lng: -105.281944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 373.9395,
    },
    {
      anio: 2024,
      lat: 24.438612,
      lng: -105.70583,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.445,
    },
    {
      anio: 2024,
      lat: 23.661388,
      lng: -105.6125,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.2647,
    },
    {
      anio: 2024,
      lat: 22.788334,
      lng: -104.84278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 32.613,
    },
    {
      anio: 2024,
      lat: 22.421944,
      lng: -104.34111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.1826,
    },
    {
      anio: 2024,
      lat: 22.866945,
      lng: -104.27028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 238.4493,
    },
    {
      anio: 2024,
      lat: 23.151112,
      lng: -105.22583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 207.5864,
    },
    {
      anio: 2024,
      lat: 23.032778,
      lng: -104.84639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.1741,
    },
    {
      anio: 2024,
      lat: 24.485,
      lng: -105.77333,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Otras actividades productivas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 15.9807,
    },
    {
      anio: 2024,
      lat: 23.731667,
      lng: -105.35083,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 111.4055,
    },
    {
      anio: 2024,
      lat: 23.796112,
      lng: -105.41944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.717,
    },
    {
      anio: 2024,
      lat: 22.930834,
      lng: -104.42306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 66.6841,
    },
    {
      anio: 2024,
      lat: 22.730833,
      lng: -104.66111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 48.3731,
    },
    {
      anio: 2024,
      lat: 24.84551,
      lng: -106.86984,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 363.7339,
    },
    {
      anio: 2024,
      lat: 22.867222,
      lng: -104.473335,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 301.8389,
    },
    {
      anio: 2024,
      lat: 22.880833,
      lng: -104.49528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.9501,
    },
    {
      anio: 2024,
      lat: 23.849722,
      lng: -105.32861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.9219,
    },
    {
      anio: 2024,
      lat: 22.885834,
      lng: -104.62805,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.1839,
    },
    {
      anio: 2024,
      lat: 25.128334,
      lng: -106.53167,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.4051,
    },
    {
      anio: 2024,
      lat: 22.726389,
      lng: -104.52778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 102.2606,
    },
    {
      anio: 2024,
      lat: 23.185833,
      lng: -105.42667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 917.0189,
    },
    {
      anio: 2024,
      lat: 22.896667,
      lng: -104.71555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.2509,
    },
    {
      anio: 2024,
      lat: 22.880278,
      lng: -104.55666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.2007,
    },
    {
      anio: 2024,
      lat: 23.786945,
      lng: -105.58972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.206,
    },
    {
      anio: 2024,
      lat: 24.404722,
      lng: -105.81111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Residuos de aprovechamiento forestal",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1479,
    },
    {
      anio: 2024,
      lat: 24.354488,
      lng: -105.45954,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 94.1171,
    },
    {
      anio: 2024,
      lat: 22.69111,
      lng: -104.8225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 83.205,
    },
    {
      anio: 2024,
      lat: 25.0375,
      lng: -106.40444,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 66.757,
    },
    {
      anio: 2024,
      lat: 22.740278,
      lng: -104.492226,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 64.7902,
    },
    {
      anio: 2024,
      lat: 22.936666,
      lng: -104.88,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 49.6195,
    },
    {
      anio: 2024,
      lat: 22.809444,
      lng: -104.69361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 29.9746,
    },
    {
      anio: 2024,
      lat: 22.706944,
      lng: -104.51278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.0487,
    },
    {
      anio: 2024,
      lat: 22.625834,
      lng: -104.99861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 169.5991,
    },
    {
      anio: 2024,
      lat: 25.609474,
      lng: -106.93031,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.9174,
    },
    {
      anio: 2024,
      lat: 25.472778,
      lng: -105.79389,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.9519,
    },
    {
      anio: 2024,
      lat: 22.934166,
      lng: -104.375275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1184,
    },
    {
      anio: 2024,
      lat: 22.57,
      lng: -104.288055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 96.6529,
    },
    {
      anio: 2024,
      lat: 22.543888,
      lng: -104.415276,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 86.829,
    },
    {
      anio: 2024,
      lat: 25.229445,
      lng: -106.506386,
      estado: "Durango",
      municipio: "Topia",
      causa: "Residuos de aprovechamiento forestal",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.7143,
    },
    {
      anio: 2024,
      lat: 22.786945,
      lng: -104.825554,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 66.532,
    },
    {
      anio: 2024,
      lat: 24.231667,
      lng: -105.73722,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 36.1175,
    },
    {
      anio: 2024,
      lat: 24.744722,
      lng: -105.86639,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Residuos de aprovechamiento forestal",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.7346,
    },
    {
      anio: 2024,
      lat: 25.285278,
      lng: -106.95361,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 21.199,
    },
    {
      anio: 2024,
      lat: 25.12265,
      lng: -106.50539,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.727,
    },
    {
      anio: 2024,
      lat: 25.479445,
      lng: -106.190834,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3086,
    },
    {
      anio: 2024,
      lat: 23.025278,
      lng: -104.90833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 80.1315,
    },
    {
      anio: 2024,
      lat: 24.771389,
      lng: -105.92083,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.6224,
    },
    {
      anio: 2024,
      lat: 24.761389,
      lng: -106.78083,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.933,
    },
    {
      anio: 2024,
      lat: 22.765278,
      lng: -104.60833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.9068,
    },
    {
      anio: 2024,
      lat: 25.310833,
      lng: -106.30417,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.4117,
    },
    {
      anio: 2024,
      lat: 23.781666,
      lng: -105.336945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.483,
    },
    {
      anio: 2024,
      lat: 25.128334,
      lng: -106.53555,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Quema de basureros",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.3331,
    },
    {
      anio: 2024,
      lat: 25.084581,
      lng: -106.58827,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5113,
    },
    {
      anio: 2024,
      lat: 22.890556,
      lng: -104.65195,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.8403,
    },
    {
      anio: 2024,
      lat: 23.009445,
      lng: -104.62361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.2991,
    },
    {
      anio: 2024,
      lat: 25.088055,
      lng: -106.52333,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8237,
    },
    {
      anio: 2024,
      lat: 22.961945,
      lng: -104.62556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.905,
    },
    {
      anio: 2024,
      lat: 22.89889,
      lng: -104.58139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.23,
    },
    {
      anio: 2024,
      lat: 24.370277,
      lng: -105.75,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.6072,
    },
    {
      anio: 2024,
      lat: 23.774723,
      lng: -105.43584,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2024,
      lat: 25.110834,
      lng: -106.55055,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 4,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.53,
    },
    {
      anio: 2024,
      lat: 22.9475,
      lng: -104.930275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 4,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.58,
    },
    {
      anio: 2024,
      lat: 23.695,
      lng: -105.649445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 4,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 18.2036,
    },
    {
      anio: 2024,
      lat: 22.80889,
      lng: -104.501114,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 3,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.79,
    },
    {
      anio: 2023,
      lat: 24.591667,
      lng: -105.7475,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Naturales",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 493.49,
    },
    {
      anio: 2023,
      lat: 25.036388,
      lng: -105.60833,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 116.2089,
    },
    {
      anio: 2023,
      lat: 24.89,
      lng: -105.84695,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 27,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1090.48,
    },
    {
      anio: 2023,
      lat: 23.705,
      lng: -105.40583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.99,
    },
    {
      anio: 2023,
      lat: 22.999722,
      lng: -104.59861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83.78,
    },
    {
      anio: 2023,
      lat: 24.543888,
      lng: -105.499725,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Naturales",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 81.85,
    },
    {
      anio: 2023,
      lat: 25.208889,
      lng: -105.85889,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.82,
    },
    {
      anio: 2023,
      lat: 23.446388,
      lng: -104.964165,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 73.9551,
    },
    {
      anio: 2023,
      lat: 23.673056,
      lng: -105.71917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 71.45,
    },
    {
      anio: 2023,
      lat: 23.32,
      lng: -104.87417,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 67.69,
    },
    {
      anio: 2023,
      lat: 23.308056,
      lng: -104.815,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 642.34,
    },
    {
      anio: 2023,
      lat: 23.3,
      lng: -105.385,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 633.79,
    },
    {
      anio: 2023,
      lat: 25.406944,
      lng: -106.26,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 53.41,
    },
    {
      anio: 2023,
      lat: 22.920834,
      lng: -104.454445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.58,
    },
    {
      anio: 2023,
      lat: 23.473055,
      lng: -105.48,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.1,
    },
    {
      anio: 2023,
      lat: 25.390833,
      lng: -106.910835,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 363.93,
    },
    {
      anio: 2023,
      lat: 23.118334,
      lng: -105.407776,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2505.59,
    },
    {
      anio: 2023,
      lat: 23.630833,
      lng: -105.49111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 247.89,
    },
    {
      anio: 2023,
      lat: 25.205833,
      lng: -106.36584,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 237.31,
    },
    {
      anio: 2023,
      lat: 22.735834,
      lng: -104.77695,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2315.16,
    },
    {
      anio: 2023,
      lat: 24.22611,
      lng: -105.96917,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Ayarín",
      impacto: "Impacto Mínimo",
      superficie: 22.36,
    },
    {
      anio: 2023,
      lat: 24.266945,
      lng: -105.744446,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Naturales",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.17,
    },
    {
      anio: 2023,
      lat: 22.786388,
      lng: -104.553055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.47,
    },
    {
      anio: 2023,
      lat: 25.233889,
      lng: -106.15111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 127.5584,
    },
    {
      anio: 2023,
      lat: 25.1225,
      lng: -106.23583,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 110.42,
    },
    {
      anio: 2023,
      lat: 23.51,
      lng: -104.891945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Naturales",
      semana: 26,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.88,
    },
    {
      anio: 2023,
      lat: 22.774445,
      lng: -104.81639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 783.2276,
    },
    {
      anio: 2023,
      lat: 24.838055,
      lng: -106.851944,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 661.56,
    },
    {
      anio: 2023,
      lat: 24.628334,
      lng: -106.0125,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Actividades agrícolas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65.23,
    },
    {
      anio: 2023,
      lat: 24.29,
      lng: -105.97889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.88,
    },
    {
      anio: 2023,
      lat: 23.154167,
      lng: -104.428055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 461.1,
    },
    {
      anio: 2023,
      lat: 24.655834,
      lng: -105.751945,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.78,
    },
    {
      anio: 2023,
      lat: 22.8625,
      lng: -104.603615,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31.92,
    },
    {
      anio: 2023,
      lat: 23.435,
      lng: -105.105,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 303.63,
    },
    {
      anio: 2023,
      lat: 22.6925,
      lng: -105.03028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 268.998,
    },
    {
      anio: 2023,
      lat: 25.5775,
      lng: -106.39694,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.61,
    },
    {
      anio: 2023,
      lat: 23.349445,
      lng: -105.14278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 216.32,
    },
    {
      anio: 2023,
      lat: 25.060833,
      lng: -106.39306,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 211.82,
    },
    {
      anio: 2023,
      lat: 22.860834,
      lng: -104.50389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2023,
      lat: 23.190556,
      lng: -105.358055,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1809.32,
    },
    {
      anio: 2023,
      lat: 22.668333,
      lng: -104.458336,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2023,
      lat: 23.007223,
      lng: -104.67111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.73,
    },
    {
      anio: 2023,
      lat: 23.523611,
      lng: -105.524445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1409.3024,
    },
    {
      anio: 2023,
      lat: 25.469723,
      lng: -106.038055,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 134.72,
    },
    {
      anio: 2023,
      lat: 23.116667,
      lng: -105.27333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 25,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1226.87,
    },
    {
      anio: 2023,
      lat: 23.161388,
      lng: -104.368614,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 369.92,
    },
    {
      anio: 2023,
      lat: 23.048056,
      lng: -104.215836,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 87.1554,
    },
    {
      anio: 2023,
      lat: 25.383055,
      lng: -106.009445,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 51,
    },
    {
      anio: 2023,
      lat: 23.187778,
      lng: -104.85,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 441.0372,
    },
    {
      anio: 2023,
      lat: 22.940556,
      lng: -104.68361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 397.94,
    },
    {
      anio: 2023,
      lat: 22.924444,
      lng: -104.753334,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.56,
    },
    {
      anio: 2023,
      lat: 23.617222,
      lng: -105.46167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 309.2,
    },
    {
      anio: 2023,
      lat: 22.770834,
      lng: -104.523056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.8,
    },
    {
      anio: 2023,
      lat: 23.813334,
      lng: -105.315,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.57,
    },
    {
      anio: 2023,
      lat: 23.060556,
      lng: -104.691666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 244.1371,
    },
    {
      anio: 2023,
      lat: 22.981112,
      lng: -104.632225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.82,
    },
    {
      anio: 2023,
      lat: 22.818333,
      lng: -104.36528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 15.23,
    },
    {
      anio: 2023,
      lat: 22.835,
      lng: -104.363335,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.46,
    },
    {
      anio: 2023,
      lat: 22.946112,
      lng: -104.621666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.3,
    },
    {
      anio: 2023,
      lat: 25.316944,
      lng: -106.615,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fogatas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1226.28,
    },
    {
      anio: 2023,
      lat: 25.431667,
      lng: -106.90945,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.2,
    },
    {
      anio: 2023,
      lat: 22.783056,
      lng: -104.58083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 116.94,
    },
    {
      anio: 2023,
      lat: 24.275555,
      lng: -106.068886,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1061.29,
    },
    {
      anio: 2023,
      lat: 25.178888,
      lng: -106.57389,
      estado: "Durango",
      municipio: "Topia",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.92,
    },
    {
      anio: 2023,
      lat: 22.92639,
      lng: -104.524445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.27,
    },
    {
      anio: 2023,
      lat: 22.793333,
      lng: -104.54611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 67.68,
    },
    {
      anio: 2023,
      lat: 23.58639,
      lng: -105.726944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 63.4,
    },
    {
      anio: 2023,
      lat: 23.133612,
      lng: -104.4725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 63.3,
    },
    {
      anio: 2023,
      lat: 23.004168,
      lng: -104.56472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 61.7,
    },
    {
      anio: 2023,
      lat: 23.780556,
      lng: -105.376945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.32,
    },
    {
      anio: 2023,
      lat: 23.036112,
      lng: -104.60306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 514.25,
    },
    {
      anio: 2023,
      lat: 23.333055,
      lng: -105.38,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 424,
    },
    {
      anio: 2023,
      lat: 24.519444,
      lng: -106.54195,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4030.77,
    },
    {
      anio: 2023,
      lat: 23.654167,
      lng: -105.710556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.72,
    },
    {
      anio: 2023,
      lat: 22.73,
      lng: -104.62,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.1684,
    },
    {
      anio: 2023,
      lat: 25.5225,
      lng: -106.68445,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 315.8999,
    },
    {
      anio: 2023,
      lat: 22.892584,
      lng: -104.645836,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.19,
    },
    {
      anio: 2023,
      lat: 22.881945,
      lng: -104.56695,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27.5,
    },
    {
      anio: 2023,
      lat: 22.754723,
      lng: -104.42194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 264.21,
    },
    {
      anio: 2023,
      lat: 25.197779,
      lng: -107.12972,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2575.81,
    },
    {
      anio: 2023,
      lat: 22.918056,
      lng: -104.63556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 247.41,
    },
    {
      anio: 2023,
      lat: 23.171944,
      lng: -105.013885,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.92,
    },
    {
      anio: 2023,
      lat: 22.8575,
      lng: -104.68667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 237.21,
    },
    {
      anio: 2023,
      lat: 22.838612,
      lng: -104.513885,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.84,
    },
    {
      anio: 2023,
      lat: 25.248056,
      lng: -105.889725,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.49,
    },
    {
      anio: 2023,
      lat: 25.549723,
      lng: -107.10333,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1900.44,
    },
    {
      anio: 2023,
      lat: 23.000834,
      lng: -104.34917,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16.69,
    },
    {
      anio: 2023,
      lat: 22.95861,
      lng: -104.50611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.34,
    },
    {
      anio: 2023,
      lat: 24.893888,
      lng: -106.56084,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1231,
    },
    {
      anio: 2023,
      lat: 25.440834,
      lng: -106.812225,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.2,
    },
    {
      anio: 2023,
      lat: 23.030556,
      lng: -104.62945,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 111.91,
    },
    {
      anio: 2023,
      lat: 22.98,
      lng: -104.80222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2023,
      lat: 25.486944,
      lng: -106.00361,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.5,
    },
    {
      anio: 2023,
      lat: 25.671389,
      lng: -106.24084,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.3,
    },
    {
      anio: 2023,
      lat: 24.606945,
      lng: -105.60111,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2023,
      lat: 23.268888,
      lng: -105.34583,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 922.88,
    },
    {
      anio: 2023,
      lat: 23.02389,
      lng: -104.59111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 87.64,
    },
    {
      anio: 2023,
      lat: 22.862778,
      lng: -104.49861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.15,
    },
    {
      anio: 2023,
      lat: 22.831388,
      lng: -104.469444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.15,
    },
    {
      anio: 2023,
      lat: 24.400278,
      lng: -106.436386,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 565.97,
    },
    {
      anio: 2023,
      lat: 23.841944,
      lng: -105.278336,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.84,
    },
    {
      anio: 2023,
      lat: 22.845556,
      lng: -104.59028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 465.932,
    },
    {
      anio: 2023,
      lat: 23.487223,
      lng: -105.35944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2023,
      lat: 23.174166,
      lng: -105.28083,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 434.3,
    },
    {
      anio: 2023,
      lat: 24.618889,
      lng: -105.87,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4261,
    },
    {
      anio: 2023,
      lat: 23.043056,
      lng: -104.66333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.25,
    },
    {
      anio: 2023,
      lat: 23.556944,
      lng: -105.53139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 287,
    },
    {
      anio: 2023,
      lat: 23.069445,
      lng: -104.58528,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.83,
    },
    {
      anio: 2023,
      lat: 25.453611,
      lng: -106.983055,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 278.55,
    },
    {
      anio: 2023,
      lat: 22.805555,
      lng: -104.717224,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 271.68,
    },
    {
      anio: 2023,
      lat: 22.793333,
      lng: -104.47056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.8,
    },
    {
      anio: 2023,
      lat: 23.173334,
      lng: -104.94639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Ayarín",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2023,
      lat: 24.9475,
      lng: -106.20583,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 237.99,
    },
    {
      anio: 2023,
      lat: 23.160833,
      lng: -105.01722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 215,
    },
    {
      anio: 2023,
      lat: 22.90361,
      lng: -104.50889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 20.8,
    },
    {
      anio: 2023,
      lat: 22.595,
      lng: -104.4375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 207,
    },
    {
      anio: 2023,
      lat: 24.745832,
      lng: -106.63,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1994.9,
    },
    {
      anio: 2023,
      lat: 23.068611,
      lng: -104.20472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 197.5,
    },
    {
      anio: 2023,
      lat: 24.275,
      lng: -106.047775,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 188.77,
    },
    {
      anio: 2023,
      lat: 22.964167,
      lng: -104.66861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2023,
      lat: 24.95861,
      lng: -106.30417,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 141,
    },
    {
      anio: 2023,
      lat: 23.41361,
      lng: -104.375275,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 131.59,
    },
    {
      anio: 2023,
      lat: 23.324167,
      lng: -105.33806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1062.88,
    },
    {
      anio: 2023,
      lat: 22.765,
      lng: -104.575,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 731.8,
    },
    {
      anio: 2023,
      lat: 23.265,
      lng: -105.242775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 71.4,
    },
    {
      anio: 2023,
      lat: 24.37139,
      lng: -105.95556,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.98,
    },
    {
      anio: 2023,
      lat: 23.051666,
      lng: -104.83861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 585.76,
    },
    {
      anio: 2023,
      lat: 22.66,
      lng: -104.80111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 560.54,
    },
    {
      anio: 2023,
      lat: 22.51111,
      lng: -104.35139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5304.35,
    },
    {
      anio: 2023,
      lat: 22.755833,
      lng: -104.49028,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 511,
    },
    {
      anio: 2023,
      lat: 22.910278,
      lng: -104.65583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 455,
    },
    {
      anio: 2023,
      lat: 22.608055,
      lng: -104.66389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4331.4,
    },
    {
      anio: 2023,
      lat: 25.1525,
      lng: -106.32472,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 428,
    },
    {
      anio: 2023,
      lat: 23.023333,
      lng: -104.61305,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.2,
    },
    {
      anio: 2023,
      lat: 22.90889,
      lng: -104.74333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 36.8,
    },
    {
      anio: 2023,
      lat: 22.658056,
      lng: -104.9,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2995,
    },
    {
      anio: 2023,
      lat: 24.939722,
      lng: -106.33611,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 259.34,
    },
    {
      anio: 2023,
      lat: 22.567778,
      lng: -104.58833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 240.63,
    },
    {
      anio: 2023,
      lat: 22.855556,
      lng: -104.490555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.27,
    },
    {
      anio: 2023,
      lat: 25.409166,
      lng: -106.95944,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.29,
    },
    {
      anio: 2023,
      lat: 25.5725,
      lng: -106.83083,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 150.3,
    },
    {
      anio: 2023,
      lat: 22.793333,
      lng: -104.609726,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10.43,
    },
    {
      anio: 2023,
      lat: 23,
      lng: -104.54083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 103,
    },
    {
      anio: 2023,
      lat: 23.5575,
      lng: -105.7275,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 973,
    },
    {
      anio: 2023,
      lat: 23.023611,
      lng: -104.756386,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 94.1477,
    },
    {
      anio: 2023,
      lat: 23.276388,
      lng: -105.17306,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.55,
    },
    {
      anio: 2023,
      lat: 24.998888,
      lng: -106.32694,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 851,
    },
    {
      anio: 2023,
      lat: 22.976389,
      lng: -104.646385,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.04,
    },
    {
      anio: 2023,
      lat: 22.993889,
      lng: -104.428055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.32,
    },
    {
      anio: 2023,
      lat: 24.122778,
      lng: -105.62334,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.18,
    },
    {
      anio: 2023,
      lat: 24.053612,
      lng: -105.575554,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 704,
    },
    {
      anio: 2023,
      lat: 23.799444,
      lng: -105.361946,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.27,
    },
    {
      anio: 2023,
      lat: 23.293056,
      lng: -105.41639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 279.8877,
    },
    {
      anio: 2023,
      lat: 25.218056,
      lng: -106.58111,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 245,
    },
    {
      anio: 2023,
      lat: 22.81639,
      lng: -104.766945,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 223.2,
    },
    {
      anio: 2023,
      lat: 23.01361,
      lng: -104.61972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.78,
    },
    {
      anio: 2023,
      lat: 22.819166,
      lng: -104.79417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 187.93,
    },
    {
      anio: 2023,
      lat: 24.896944,
      lng: -106.90195,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 161.56,
    },
    {
      anio: 2023,
      lat: 24.99639,
      lng: -106.958336,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 12.65,
    },
    {
      anio: 2023,
      lat: 25.553333,
      lng: -106.81416,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 104.5777,
    },
    {
      anio: 2023,
      lat: 23.033056,
      lng: -104.76778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 96,
    },
    {
      anio: 2023,
      lat: 23.022778,
      lng: -104.76417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.1,
    },
    {
      anio: 2023,
      lat: 24.945833,
      lng: -106.94666,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 57.98,
    },
    {
      anio: 2023,
      lat: 22.654167,
      lng: -104.28639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 48,
    },
    {
      anio: 2023,
      lat: 22.89,
      lng: -104.395,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 37.61,
    },
    {
      anio: 2023,
      lat: 24.944445,
      lng: -106.98028,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 37.5,
    },
    {
      anio: 2023,
      lat: 23.684166,
      lng: -105.51556,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 310.95,
    },
    {
      anio: 2023,
      lat: 25.126667,
      lng: -106.56167,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 235,
    },
    {
      anio: 2023,
      lat: 23.02111,
      lng: -104.77361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 187,
    },
    {
      anio: 2023,
      lat: 22.879168,
      lng: -104.7475,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.96,
    },
    {
      anio: 2023,
      lat: 22.74,
      lng: -104.476944,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 130,
    },
    {
      anio: 2023,
      lat: 23.286112,
      lng: -105.17944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 111,
    },
    {
      anio: 2023,
      lat: 22.591389,
      lng: -104.53222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 0.72,
    },
    {
      anio: 2023,
      lat: 23.776388,
      lng: -105.34194,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.49,
    },
    {
      anio: 2023,
      lat: 25.235,
      lng: -106.50305,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83.7,
    },
    {
      anio: 2023,
      lat: 22.783056,
      lng: -104.56416,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 66,
    },
    {
      anio: 2023,
      lat: 23.311388,
      lng: -105.23889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 635.83,
    },
    {
      anio: 2023,
      lat: 25.258612,
      lng: -105.852776,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 397,
    },
    {
      anio: 2023,
      lat: 22.755833,
      lng: -104.80889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 214,
    },
    {
      anio: 2023,
      lat: 24.970833,
      lng: -106.225,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 209.29,
    },
    {
      anio: 2023,
      lat: 22.968334,
      lng: -104.43056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.9,
    },
    {
      anio: 2023,
      lat: 25.55,
      lng: -106.8,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 201,
    },
    {
      anio: 2023,
      lat: 25.032223,
      lng: -105.6975,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Otras actividades productivas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.82,
    },
    {
      anio: 2023,
      lat: 25.5575,
      lng: -106.81167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 181,
    },
    {
      anio: 2023,
      lat: 22.983055,
      lng: -104.501114,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.7,
    },
    {
      anio: 2023,
      lat: 23.005556,
      lng: -104.62444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.5,
    },
    {
      anio: 2023,
      lat: 22.819723,
      lng: -104.35472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.31,
    },
    {
      anio: 2023,
      lat: 22.831388,
      lng: -104.48444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.28,
    },
    {
      anio: 2023,
      lat: 23.011944,
      lng: -104.62195,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.71,
    },
    {
      anio: 2023,
      lat: 24.692223,
      lng: -105.97,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 86.93,
    },
    {
      anio: 2023,
      lat: 23.776388,
      lng: -105.695,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.6,
    },
    {
      anio: 2023,
      lat: 24.965,
      lng: -106.77028,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 59.37,
    },
    {
      anio: 2023,
      lat: 23.761944,
      lng: -105.36528,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.75,
    },
    {
      anio: 2023,
      lat: 24.863611,
      lng: -106.11083,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 494.4,
    },
    {
      anio: 2023,
      lat: 23.130833,
      lng: -104.18667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 378,
    },
    {
      anio: 2023,
      lat: 22.845,
      lng: -104.49722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.53,
    },
    {
      anio: 2023,
      lat: 23.80139,
      lng: -105.70778,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.24,
    },
    {
      anio: 2023,
      lat: 23.020277,
      lng: -104.68584,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 209,
    },
    {
      anio: 2023,
      lat: 25.10389,
      lng: -106.56,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.67,
    },
    {
      anio: 2023,
      lat: 22.972221,
      lng: -104.37444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.26,
    },
    {
      anio: 2023,
      lat: 23.770277,
      lng: -105.39445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.13,
    },
    {
      anio: 2023,
      lat: 23.154722,
      lng: -104.596664,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 108,
    },
    {
      anio: 2023,
      lat: 22.886389,
      lng: -104.765274,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.64,
    },
    {
      anio: 2023,
      lat: 22.682777,
      lng: -104.77055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 649.9,
    },
    {
      anio: 2023,
      lat: 23.03861,
      lng: -104.710556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 62,
    },
    {
      anio: 2023,
      lat: 22.969166,
      lng: -104.6175,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.7,
    },
    {
      anio: 2023,
      lat: 25.491388,
      lng: -106.93833,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.5,
    },
    {
      anio: 2023,
      lat: 22.706944,
      lng: -104.52278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.37,
    },
    {
      anio: 2023,
      lat: 23.258055,
      lng: -104.91139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.53,
    },
    {
      anio: 2023,
      lat: 23.056667,
      lng: -104.7225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 43.3,
    },
    {
      anio: 2023,
      lat: 24.91,
      lng: -106.83083,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 38.84,
    },
    {
      anio: 2023,
      lat: 23.320833,
      lng: -105.09167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 385,
    },
    {
      anio: 2023,
      lat: 23.044445,
      lng: -104.74722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.5,
    },
    {
      anio: 2023,
      lat: 22.964445,
      lng: -104.29,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2023,
      lat: 23.776667,
      lng: -105.346664,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.39,
    },
    {
      anio: 2023,
      lat: 23.105833,
      lng: -104.54611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.38,
    },
    {
      anio: 2023,
      lat: 23.15611,
      lng: -105.07278,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 212,
    },
    {
      anio: 2023,
      lat: 23.783333,
      lng: -105.37722,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.1,
    },
    {
      anio: 2023,
      lat: 22.691668,
      lng: -104.79389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2023,
      lat: 23.7775,
      lng: -105.3425,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.69,
    },
    {
      anio: 2023,
      lat: 23.342222,
      lng: -105.10917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 158,
    },
    {
      anio: 2023,
      lat: 23.661667,
      lng: -105.656944,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.57,
    },
    {
      anio: 2023,
      lat: 22.955,
      lng: -104.617775,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.11,
    },
    {
      anio: 2023,
      lat: 23.063055,
      lng: -104.70389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 131,
    },
    {
      anio: 2023,
      lat: 22.792223,
      lng: -104.319725,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 119,
    },
    {
      anio: 2023,
      lat: 23.8675,
      lng: -105.30972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2023,
      lat: 23.779444,
      lng: -105.34333,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 0.45,
    },
    {
      anio: 2023,
      lat: 22.711945,
      lng: -104.77194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 522,
    },
    {
      anio: 2023,
      lat: 25.132223,
      lng: -106.437775,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 33.63,
    },
    {
      anio: 2023,
      lat: 24.183332,
      lng: -105.91889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 3095.5,
    },
    {
      anio: 2023,
      lat: 25.604166,
      lng: -106.10111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 25.78,
    },
    {
      anio: 2023,
      lat: 22.716667,
      lng: -104.75472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 243,
    },
    {
      anio: 2023,
      lat: 22.840279,
      lng: -104.48805,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.14,
    },
    {
      anio: 2023,
      lat: 22.963888,
      lng: -104.611664,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.41,
    },
    {
      anio: 2023,
      lat: 24.891666,
      lng: -105.67639,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 111,
    },
    {
      anio: 2023,
      lat: 23.575,
      lng: -105.34805,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2023,
      lat: 25.018778,
      lng: -105.68039,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 83.6,
    },
    {
      anio: 2023,
      lat: 22.606112,
      lng: -104.98111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 82,
    },
    {
      anio: 2023,
      lat: 22.831388,
      lng: -104.350555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2023,
      lat: 25.2125,
      lng: -106.57694,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.33,
    },
    {
      anio: 2023,
      lat: 22.97889,
      lng: -104.46667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 39.57,
    },
    {
      anio: 2023,
      lat: 23.731945,
      lng: -105.50305,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.65,
    },
    {
      anio: 2023,
      lat: 22.976389,
      lng: -104.65222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2023,
      lat: 23.05,
      lng: -104.763885,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 182.0781,
    },
    {
      anio: 2023,
      lat: 25.136389,
      lng: -106.43806,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.6,
    },
    {
      anio: 2023,
      lat: 22.94,
      lng: -104.556114,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.51,
    },
    {
      anio: 2023,
      lat: 23.421112,
      lng: -105.086945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 125,
    },
    {
      anio: 2023,
      lat: 24.956112,
      lng: -106.94945,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Otras actividades productivas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2023,
      lat: 22.848055,
      lng: -104.50056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.64,
    },
    {
      anio: 2023,
      lat: 23.012777,
      lng: -104.64972,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.87,
    },
    {
      anio: 2023,
      lat: 25.12,
      lng: -106.439445,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 45.46,
    },
    {
      anio: 2023,
      lat: 22.967222,
      lng: -104.37334,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.37,
    },
    {
      anio: 2023,
      lat: 24.272223,
      lng: -105.344444,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40.4,
    },
    {
      anio: 2023,
      lat: 22.870695,
      lng: -104.50236,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.2,
    },
    {
      anio: 2023,
      lat: 22.936666,
      lng: -104.52389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 37,
    },
    {
      anio: 2023,
      lat: 23.747223,
      lng: -105.53667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2023,
      lat: 22.935833,
      lng: -104.516945,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 29.4,
    },
    {
      anio: 2023,
      lat: 22.76389,
      lng: -104.523056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 26.65,
    },
    {
      anio: 2023,
      lat: 24.702778,
      lng: -105.974724,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 264.9,
    },
    {
      anio: 2023,
      lat: 23.052221,
      lng: -104.464165,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.95,
    },
    {
      anio: 2023,
      lat: 22.889444,
      lng: -104.56611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.97,
    },
    {
      anio: 2023,
      lat: 25.353611,
      lng: -106.93222,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 20.2,
    },
    {
      anio: 2023,
      lat: 22.751944,
      lng: -104.53555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 148.3,
    },
    {
      anio: 2023,
      lat: 23.676945,
      lng: -105.46833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13.34,
    },
    {
      anio: 2023,
      lat: 22.750834,
      lng: -104.265,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.5,
    },
    {
      anio: 2023,
      lat: 24.813889,
      lng: -106.68584,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.14,
    },
    {
      anio: 2023,
      lat: 22.88,
      lng: -104.68083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 12,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 43.52,
    },
    {
      anio: 2023,
      lat: 22.725834,
      lng: -104.31111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.57,
    },
    {
      anio: 2023,
      lat: 22.918612,
      lng: -104.65,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.34,
    },
    {
      anio: 2023,
      lat: 24.003334,
      lng: -105.695274,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 86.3,
    },
    {
      anio: 2023,
      lat: 23.033056,
      lng: -104.57278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.65,
    },
    {
      anio: 2023,
      lat: 23.052778,
      lng: -104.46445,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 46,
    },
    {
      anio: 2023,
      lat: 22.808332,
      lng: -104.34611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 38.86,
    },
    {
      anio: 2023,
      lat: 23.809723,
      lng: -105.333336,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.24,
    },
    {
      anio: 2023,
      lat: 23.005833,
      lng: -104.615555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.77,
    },
    {
      anio: 2023,
      lat: 23.788334,
      lng: -105.3775,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.56,
    },
    {
      anio: 2023,
      lat: 23.086666,
      lng: -104.66583,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.36,
    },
    {
      anio: 2023,
      lat: 22.965555,
      lng: -104.62278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.8,
    },
    {
      anio: 2023,
      lat: 23.814444,
      lng: -105.335,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2023,
      lat: 25.11,
      lng: -106.549164,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.75,
    },
    {
      anio: 2023,
      lat: 23.79889,
      lng: -105.37639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3.4,
    },
    {
      anio: 2023,
      lat: 23.838055,
      lng: -105.28611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.49,
    },
    {
      anio: 2023,
      lat: 24.368889,
      lng: -105.53472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 23.7,
    },
    {
      anio: 2023,
      lat: 22.940834,
      lng: -104.60167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.22,
    },
    {
      anio: 2023,
      lat: 23.821667,
      lng: -105.494446,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.87,
    },
    {
      anio: 2023,
      lat: 22.9825,
      lng: -104.67555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 0.39,
    },
    {
      anio: 2023,
      lat: 23.769444,
      lng: -105.61667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 40.95,
    },
    {
      anio: 2023,
      lat: 25.111944,
      lng: -106.54444,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.6,
    },
    {
      anio: 2023,
      lat: 23.758888,
      lng: -105.354164,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.26,
    },
    {
      anio: 2023,
      lat: 23.77861,
      lng: -105.32667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.3,
    },
    {
      anio: 2023,
      lat: 23.755556,
      lng: -105.35917,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2023,
      lat: 22.95139,
      lng: -104.61,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 6,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.3,
    },
    {
      anio: 2023,
      lat: 23.792778,
      lng: -105.352776,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 6,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.554,
    },
    {
      anio: 2022,
      lat: 24.988333,
      lng: -105.98861,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.4,
    },
    {
      anio: 2022,
      lat: 24.325832,
      lng: -105.69444,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 24.527779,
      lng: -105.5275,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.56,
    },
    {
      anio: 2022,
      lat: 25.414167,
      lng: -106.85778,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 99,
    },
    {
      anio: 2022,
      lat: 25.7,
      lng: -106.12639,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41,
    },
    {
      anio: 2022,
      lat: 25.132778,
      lng: -106.02111,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.11,
    },
    {
      anio: 2022,
      lat: 25.1375,
      lng: -106.14445,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.92,
    },
    {
      anio: 2022,
      lat: 24.461111,
      lng: -105.685555,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.65,
    },
    {
      anio: 2022,
      lat: 22.690277,
      lng: -104.568054,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 900,
    },
    {
      anio: 2022,
      lat: 25.408611,
      lng: -106.968056,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 444,
    },
    {
      anio: 2022,
      lat: 22.866667,
      lng: -104.69806,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4.4,
    },
    {
      anio: 2022,
      lat: 24.889166,
      lng: -106.619225,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 280,
    },
    {
      anio: 2022,
      lat: 25.321945,
      lng: -106.33528,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2022,
      lat: 22.694166,
      lng: -104.59695,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 25.411667,
      lng: -106.944725,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 93,
    },
    {
      anio: 2022,
      lat: 25.17,
      lng: -106.07972,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 88,
    },
    {
      anio: 2022,
      lat: 24.735834,
      lng: -105.74167,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Naturales",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 859,
    },
    {
      anio: 2022,
      lat: 25.265556,
      lng: -106.40278,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 841,
    },
    {
      anio: 2022,
      lat: 22.688334,
      lng: -105.023056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 76,
    },
    {
      anio: 2022,
      lat: 24.794445,
      lng: -106.602776,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 736.15,
    },
    {
      anio: 2022,
      lat: 24.933056,
      lng: -106.35472,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 65,
    },
    {
      anio: 2022,
      lat: 24.5275,
      lng: -105.71222,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 594,
    },
    {
      anio: 2022,
      lat: 23.678055,
      lng: -105.48861,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 59,
    },
    {
      anio: 2022,
      lat: 23.57611,
      lng: -105.43889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.65,
    },
    {
      anio: 2022,
      lat: 22.92389,
      lng: -104.53555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 49.9,
    },
    {
      anio: 2022,
      lat: 24.884445,
      lng: -105.451385,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 436,
    },
    {
      anio: 2022,
      lat: 23.558056,
      lng: -105.50445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 312,
    },
    {
      anio: 2022,
      lat: 22.695833,
      lng: -104.52167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 294,
    },
    {
      anio: 2022,
      lat: 24.469166,
      lng: -106.15,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.89,
    },
    {
      anio: 2022,
      lat: 23.576666,
      lng: -105.72139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2022,
      lat: 22.809444,
      lng: -104.55,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 27.9,
    },
    {
      anio: 2022,
      lat: 24.440512,
      lng: -106.158134,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.47,
    },
    {
      anio: 2022,
      lat: 23.724445,
      lng: -105.55972,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.38,
    },
    {
      anio: 2022,
      lat: 23.53111,
      lng: -104.86611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2022,
      lat: 22.9775,
      lng: -104.21611,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2042,
    },
    {
      anio: 2022,
      lat: 23.645555,
      lng: -105.39056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.5,
    },
    {
      anio: 2022,
      lat: 23.340555,
      lng: -105.084724,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2022,
      lat: 23.620556,
      lng: -105.65806,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.12,
    },
    {
      anio: 2022,
      lat: 24.493095,
      lng: -106.15736,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.13,
    },
    {
      anio: 2022,
      lat: 25.098055,
      lng: -106.333885,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11,
    },
    {
      anio: 2022,
      lat: 24.273056,
      lng: -105.846664,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 22.711472,
      lng: -104.48278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 64.38,
    },
    {
      anio: 2022,
      lat: 23.322779,
      lng: -105.10833,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 590,
    },
    {
      anio: 2022,
      lat: 25.147223,
      lng: -106.08139,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Moderado",
      superficie: 547,
    },
    {
      anio: 2022,
      lat: 22.918888,
      lng: -104.28667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 491,
    },
    {
      anio: 2022,
      lat: 22.592222,
      lng: -104.33722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 4808,
    },
    {
      anio: 2022,
      lat: 25.042778,
      lng: -106.35833,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 470,
    },
    {
      anio: 2022,
      lat: 22.632778,
      lng: -104.64306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 454,
    },
    {
      anio: 2022,
      lat: 22.960833,
      lng: -104.570274,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 42.4,
    },
    {
      anio: 2022,
      lat: 22.977612,
      lng: -104.58189,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.7,
    },
    {
      anio: 2022,
      lat: 22.678139,
      lng: -104.624084,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.78,
    },
    {
      anio: 2022,
      lat: 22.829721,
      lng: -104.538055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.3,
    },
    {
      anio: 2022,
      lat: 22.751833,
      lng: -104.49472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.11,
    },
    {
      anio: 2022,
      lat: 25.470833,
      lng: -106.98167,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2022,
      lat: 22.975555,
      lng: -104.38333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 153,
    },
    {
      anio: 2022,
      lat: 22.874166,
      lng: -104.295,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2022,
      lat: 24.519444,
      lng: -105.71472,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 113,
    },
    {
      anio: 2022,
      lat: 24.068056,
      lng: -105.80194,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 111,
    },
    {
      anio: 2022,
      lat: 22.835556,
      lng: -104.51278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.11,
    },
    {
      anio: 2022,
      lat: 25.451666,
      lng: -106.933334,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1,
    },
    {
      anio: 2022,
      lat: 23.404167,
      lng: -105.189445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 102.54,
    },
    {
      anio: 2022,
      lat: 25.453888,
      lng: -106.98361,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 98,
    },
    {
      anio: 2022,
      lat: 22.879168,
      lng: -104.32278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 91,
    },
    {
      anio: 2022,
      lat: 24.972778,
      lng: -106.30972,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 84,
    },
    {
      anio: 2022,
      lat: 25.12139,
      lng: -106.14778,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.4,
    },
    {
      anio: 2022,
      lat: 22.682222,
      lng: -104.63084,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 42,
    },
    {
      anio: 2022,
      lat: 25.258333,
      lng: -106.405,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 40,
    },
    {
      anio: 2022,
      lat: 23.541111,
      lng: -105.61611,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 366,
    },
    {
      anio: 2022,
      lat: 24.825,
      lng: -106.583336,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 3470,
    },
    {
      anio: 2022,
      lat: 22.92389,
      lng: -104.43472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 316,
    },
    {
      anio: 2022,
      lat: 23.706944,
      lng: -104.40833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 217.5,
    },
    {
      anio: 2022,
      lat: 23.56,
      lng: -105.38111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.13,
    },
    {
      anio: 2022,
      lat: 23.798056,
      lng: -105.763885,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 662.57,
    },
    {
      anio: 2022,
      lat: 25.076944,
      lng: -106.34389,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 62,
    },
    {
      anio: 2022,
      lat: 23.019444,
      lng: -104.62361,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 59,
    },
    {
      anio: 2022,
      lat: 24.601944,
      lng: -106.094444,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5658,
    },
    {
      anio: 2022,
      lat: 22.650278,
      lng: -104.76889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 473,
    },
    {
      anio: 2022,
      lat: 23.696667,
      lng: -104.4675,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Pastizal Natural",
      impacto: "Impacto Mínimo",
      superficie: 4178,
    },
    {
      anio: 2022,
      lat: 22.926111,
      lng: -104.53083,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 41.4,
    },
    {
      anio: 2022,
      lat: 22.747223,
      lng: -104.73055,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 400,
    },
    {
      anio: 2022,
      lat: 22.911484,
      lng: -104.68621,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.7,
    },
    {
      anio: 2022,
      lat: 22.678055,
      lng: -104.327774,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 263,
    },
    {
      anio: 2022,
      lat: 25.443611,
      lng: -107.087776,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2308,
    },
    {
      anio: 2022,
      lat: 23.206112,
      lng: -104.84111,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 2090,
    },
    {
      anio: 2022,
      lat: 22.663334,
      lng: -105.013336,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 2060,
    },
    {
      anio: 2022,
      lat: 22.898333,
      lng: -104.49861,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 1870,
    },
    {
      anio: 2022,
      lat: 23.398333,
      lng: -105.023056,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17.86,
    },
    {
      anio: 2022,
      lat: 23.082777,
      lng: -104.69139,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2022,
      lat: 22.433056,
      lng: -104.33722,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1485,
    },
    {
      anio: 2022,
      lat: 23.598612,
      lng: -105.454445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2022,
      lat: 24.11389,
      lng: -105.73778,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.2,
    },
    {
      anio: 2022,
      lat: 22.998333,
      lng: -104.51833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1035,
    },
    {
      anio: 2022,
      lat: 25.567778,
      lng: -107.05889,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1005,
    },
    {
      anio: 2022,
      lat: 23.033333,
      lng: -104.74167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 90,
    },
    {
      anio: 2022,
      lat: 25.256945,
      lng: -106.098335,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 607,
    },
    {
      anio: 2022,
      lat: 22.954445,
      lng: -104.620834,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.72,
    },
    {
      anio: 2022,
      lat: 22.891666,
      lng: -104.75694,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.6,
    },
    {
      anio: 2022,
      lat: 23.424444,
      lng: -105.135,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 459,
    },
    {
      anio: 2022,
      lat: 23.158611,
      lng: -104.65667,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 378,
    },
    {
      anio: 2022,
      lat: 22.97,
      lng: -104.65833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2022,
      lat: 23.13611,
      lng: -105.22945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 150,
    },
    {
      anio: 2022,
      lat: 25.107222,
      lng: -106.21028,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.4,
    },
    {
      anio: 2022,
      lat: 25.226667,
      lng: -106.56416,
      estado: "Durango",
      municipio: "Topia",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 88,
    },
    {
      anio: 2022,
      lat: 22.47525,
      lng: -104.63731,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6788,
    },
    {
      anio: 2022,
      lat: 22.955278,
      lng: -104.61889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.4,
    },
    {
      anio: 2022,
      lat: 22.666111,
      lng: -104.361115,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 63,
    },
    {
      anio: 2022,
      lat: 22.739445,
      lng: -104.54389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 552,
    },
    {
      anio: 2022,
      lat: 25.562222,
      lng: -106.94583,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 23.0225,
      lng: -105.02,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 400,
    },
    {
      anio: 2022,
      lat: 23.529444,
      lng: -105.34167,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.4,
    },
    {
      anio: 2022,
      lat: 25.390833,
      lng: -106.204445,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 330,
    },
    {
      anio: 2022,
      lat: 23.144722,
      lng: -105.14889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31.55,
    },
    {
      anio: 2022,
      lat: 22.55611,
      lng: -104.95194,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 295,
    },
    {
      anio: 2022,
      lat: 23.606388,
      lng: -105.40889,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.46,
    },
    {
      anio: 2022,
      lat: 22.823889,
      lng: -104.56472,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 237,
    },
    {
      anio: 2022,
      lat: 22.8525,
      lng: -104.717224,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 220,
    },
    {
      anio: 2022,
      lat: 23.498611,
      lng: -105.583885,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 200,
    },
    {
      anio: 2022,
      lat: 22.44389,
      lng: -104.33111,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 181,
    },
    {
      anio: 2022,
      lat: 24.204166,
      lng: -105.50833,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.65,
    },
    {
      anio: 2022,
      lat: 22.772223,
      lng: -104.28333,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 152,
    },
    {
      anio: 2022,
      lat: 25.45,
      lng: -106.91139,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.26,
    },
    {
      anio: 2022,
      lat: 23.071388,
      lng: -105.25694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2022,
      lat: 23.796112,
      lng: -105.359726,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 25.161112,
      lng: -106.21639,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.5,
    },
    {
      anio: 2022,
      lat: 23.376802,
      lng: -105.154945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7.32,
    },
    {
      anio: 2022,
      lat: 23.13915,
      lng: -104.4386,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 71.8,
    },
    {
      anio: 2022,
      lat: 23.833334,
      lng: -105.26667,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 66,
    },
    {
      anio: 2022,
      lat: 24.36567,
      lng: -105.4342,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 65.86,
    },
    {
      anio: 2022,
      lat: 22.897778,
      lng: -104.59,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 57.32,
    },
    {
      anio: 2022,
      lat: 23.080555,
      lng: -104.278336,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 5.7,
    },
    {
      anio: 2022,
      lat: 23.009167,
      lng: -104.68584,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 52.74,
    },
    {
      anio: 2022,
      lat: 25.507223,
      lng: -105.94028,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.24,
    },
    {
      anio: 2022,
      lat: 23.266,
      lng: -105.18506,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 51.7,
    },
    {
      anio: 2022,
      lat: 24.195,
      lng: -105.5675,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 22.87861,
      lng: -104.74555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3.5,
    },
    {
      anio: 2022,
      lat: 23.2325,
      lng: -105.11222,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 341.85,
    },
    {
      anio: 2022,
      lat: 23.22444,
      lng: -105.16014,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 186,
    },
    {
      anio: 2022,
      lat: 23.558056,
      lng: -105.37945,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 22.901112,
      lng: -104.73483,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.95,
    },
    {
      anio: 2022,
      lat: 23.255833,
      lng: -104.77556,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2022,
      lat: 23.046776,
      lng: -104.489174,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 123.3,
    },
    {
      anio: 2022,
      lat: 22.980556,
      lng: -104.72945,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 115.25,
    },
    {
      anio: 2022,
      lat: 24.10111,
      lng: -105.65889,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 16,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.1,
    },
    {
      anio: 2022,
      lat: 22.56639,
      lng: -104.605,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 966,
    },
    {
      anio: 2022,
      lat: 25.115166,
      lng: -106.23417,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.88,
    },
    {
      anio: 2022,
      lat: 22.940834,
      lng: -104.60833,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.8,
    },
    {
      anio: 2022,
      lat: 23.56611,
      lng: -105.41805,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.7,
    },
    {
      anio: 2022,
      lat: 22.878334,
      lng: -104.496666,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 21.44,
    },
    {
      anio: 2022,
      lat: 23.010279,
      lng: -104.68056,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 176.83,
    },
    {
      anio: 2022,
      lat: 25.198334,
      lng: -106.10472,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Naturales",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.44,
    },
    {
      anio: 2022,
      lat: 23.736944,
      lng: -105.55444,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 24.474619,
      lng: -105.79747,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fogatas",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 22.930555,
      lng: -104.6375,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 8.21,
    },
    {
      anio: 2022,
      lat: 22.90889,
      lng: -104.78398,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 79.22,
    },
    {
      anio: 2022,
      lat: 22.653,
      lng: -104.794,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 781.98,
    },
    {
      anio: 2022,
      lat: 22.880556,
      lng: -104.475,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 752,
    },
    {
      anio: 2022,
      lat: 25.338837,
      lng: -106.042366,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 56.6,
    },
    {
      anio: 2022,
      lat: 23.407515,
      lng: -104.88814,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 44.55,
    },
    {
      anio: 2022,
      lat: 22.898056,
      lng: -104.638054,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 39.5,
    },
    {
      anio: 2022,
      lat: 23.409695,
      lng: -105.1282,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 283.6,
    },
    {
      anio: 2022,
      lat: 23.71861,
      lng: -105.42472,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.78,
    },
    {
      anio: 2022,
      lat: 22.990833,
      lng: -104.64278,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 26.84,
    },
    {
      anio: 2022,
      lat: 23.147228,
      lng: -104.99895,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 243,
    },
    {
      anio: 2022,
      lat: 22.92443,
      lng: -104.55438,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 209.6,
    },
    {
      anio: 2022,
      lat: 25.073055,
      lng: -106.22667,
      estado: "Durango",
      municipio: "Canelas",
      causa: "Fumadores",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.7,
    },
    {
      anio: 2022,
      lat: 25.5225,
      lng: -106.94583,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.44,
    },
    {
      anio: 2022,
      lat: 24.429,
      lng: -106.448,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 135,
    },
    {
      anio: 2022,
      lat: 23.064444,
      lng: -104.61389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 11.44,
    },
    {
      anio: 2022,
      lat: 24.340555,
      lng: -105.50611,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.16,
    },
    {
      anio: 2022,
      lat: 25.134056,
      lng: -106.12478,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.96,
    },
    {
      anio: 2022,
      lat: 23.1,
      lng: -104.381,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 683.6,
    },
    {
      anio: 2022,
      lat: 22.539,
      lng: -104.577,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 13,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 604.49,
    },
    {
      anio: 2022,
      lat: 22.869444,
      lng: -104.75889,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 55.8,
    },
    {
      anio: 2022,
      lat: 25.1525,
      lng: -106.4075,
      estado: "Durango",
      municipio: "Topia",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.66,
    },
    {
      anio: 2022,
      lat: 23.69389,
      lng: -105.40639,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.2,
    },
    {
      anio: 2022,
      lat: 22.92389,
      lng: -104.40639,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 34.42,
    },
    {
      anio: 2022,
      lat: 22.91375,
      lng: -104.76303,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 28.6,
    },
    {
      anio: 2022,
      lat: 22.976944,
      lng: -104.64555,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.8,
    },
    {
      anio: 2022,
      lat: 23.443611,
      lng: -105.69358,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 266,
    },
    {
      anio: 2022,
      lat: 22.963888,
      lng: -104.623886,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.3,
    },
    {
      anio: 2022,
      lat: 22.984444,
      lng: -104.63167,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2.23,
    },
    {
      anio: 2022,
      lat: 22.953333,
      lng: -104.65195,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.7,
    },
    {
      anio: 2022,
      lat: 22.925,
      lng: -104.62778,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 13,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 23.524445,
      lng: -105.340836,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 74.44,
    },
    {
      anio: 2022,
      lat: 22.991667,
      lng: -104.668,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 71.7,
    },
    {
      anio: 2022,
      lat: 23.646,
      lng: -105.631,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 65,
    },
    {
      anio: 2022,
      lat: 23.3835,
      lng: -104.956,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 491.5,
    },
    {
      anio: 2022,
      lat: 24.864166,
      lng: -105.941666,
      estado: "Durango",
      municipio: "Otáez",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.5,
    },
    {
      anio: 2022,
      lat: 25.5105,
      lng: -106.67806,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 443,
    },
    {
      anio: 2022,
      lat: 22.766666,
      lng: -104.539444,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2.9,
    },
    {
      anio: 2022,
      lat: 24.037138,
      lng: -105.81028,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 24.3,
    },
    {
      anio: 2022,
      lat: 24.082916,
      lng: -105.50608,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 206,
    },
    {
      anio: 2022,
      lat: 25.476389,
      lng: -106.93611,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.37,
    },
    {
      anio: 2022,
      lat: 22.984,
      lng: -104.389,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 135.84,
    },
    {
      anio: 2022,
      lat: 25.493055,
      lng: -106.93584,
      estado: "Durango",
      municipio: "Tamazula",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.23,
    },
    {
      anio: 2022,
      lat: 22.857222,
      lng: -104.58417,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 12,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 109.82,
    },
    {
      anio: 2022,
      lat: 23.706112,
      lng: -105.55139,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 12,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 23.842695,
      lng: -105.292694,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Quema de basureros",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9.5,
    },
    {
      anio: 2022,
      lat: 23.2975,
      lng: -105.180275,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.55,
    },
    {
      anio: 2022,
      lat: 24.428444,
      lng: -105.52878,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.4,
    },
    {
      anio: 2022,
      lat: 23.456667,
      lng: -104.9925,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 23.779833,
      lng: -105.69689,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 87.3,
    },
    {
      anio: 2022,
      lat: 24.852556,
      lng: -105.62755,
      estado: "Durango",
      municipio: "Santiago Papasquiaro",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 32.3,
    },
    {
      anio: 2022,
      lat: 22.871666,
      lng: -104.56,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 22.28,
    },
    {
      anio: 2022,
      lat: 22.996666,
      lng: -104.562225,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 17.14,
    },
    {
      anio: 2022,
      lat: 22.846111,
      lng: -104.50222,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 23.43137,
      lng: -105.064445,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Residuos de aprovechamiento forestal",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8.89,
    },
    {
      anio: 2022,
      lat: 22.958055,
      lng: -104.72086,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5.83,
    },
    {
      anio: 2022,
      lat: 23.503723,
      lng: -105.36478,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 44.1,
    },
    {
      anio: 2022,
      lat: 23.800888,
      lng: -105.29931,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.53,
    },
    {
      anio: 2022,
      lat: 22.885778,
      lng: -104.64858,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29.1,
    },
    {
      anio: 2022,
      lat: 23.186045,
      lng: -105.27165,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Desconocidas",
      semana: 9,
      vegetacion: "Pastizal Halófilo",
      impacto: "Impacto Mínimo",
      superficie: 23,
    },
    {
      anio: 2022,
      lat: 23.021973,
      lng: -104.84928,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 13.6,
    },
    {
      anio: 2022,
      lat: 23.709139,
      lng: -105.55128,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fumadores",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12.8,
    },
    {
      anio: 2022,
      lat: 24.055084,
      lng: -105.969666,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 58.68,
    },
    {
      anio: 2022,
      lat: 25.452583,
      lng: -106.22753,
      estado: "Durango",
      municipio: "Tepehuanes",
      causa: "Desconocidas",
      semana: 8,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.6,
    },
    {
      anio: 2022,
      lat: 22.879723,
      lng: -104.49306,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Actividades agrícolas",
      semana: 8,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 23.686333,
      lng: -104.39239,
      estado: "Durango",
      municipio: "Mezquital",
      causa: "Limpias de derecho de vía",
      semana: 7,
      vegetacion: "Matorral Desértico Micrófilo",
      impacto: "Impacto Mínimo",
      superficie: 62.5,
    },
    {
      anio: 2022,
      lat: 23.807587,
      lng: -105.335724,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Fogatas",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.55,
    },
    {
      anio: 2022,
      lat: 24.434109,
      lng: -105.824326,
      estado: "Durango",
      municipio: "San Dimas",
      causa: "Desconocidas",
      semana: 5,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.1,
    },
    {
      anio: 2022,
      lat: 23.566528,
      lng: -105.52825,
      estado: "Durango",
      municipio: "Pueblo Nuevo",
      causa: "Actividades agrícolas",
      semana: 5,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 109.37,
    },
    {
      anio: 2024,
      lat: 27.026722,
      lng: -108.22636,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 51,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 31.8537,
    },
    {
      anio: 2016,
      lat: 25.89630833,
      lng: -107.5584639,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 31,
    },
    {
      anio: 2017,
      lat: 25.89147222,
      lng: -107.5961389,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2019,
      lat: 25.85702417,
      lng: -107.6087231,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2020,
      lat: 26.71406111,
      lng: -108.3393389,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2020,
      lat: 26.7719,
      lng: -108.0794694,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2021,
      lat: 25.77893056,
      lng: -107.5702111,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 3,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 30,
    },
    {
      anio: 2018,
      lat: 25.76561333,
      lng: -107.6478108,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2022,
      lat: 23.657583,
      lng: -106.58674,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Limpias de derecho de vía",
      semana: 11,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 29,
    },
    {
      anio: 2018,
      lat: 25.85726944,
      lng: -107.6009167,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 28,
    },
    {
      anio: 2017,
      lat: 25.83451944,
      lng: -107.6194278,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2020,
      lat: 24.12463889,
      lng: -106.1632194,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 27,
    },
    {
      anio: 2016,
      lat: 23.53652778,
      lng: -105.8919722,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 26.77547222,
      lng: -108.2854722,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Otras causas",
      semana: 14,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 25.81497222,
      lng: -107.6560278,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 18,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 23.52175,
      lng: -105.7811389,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agropecuarias",
      semana: 19,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2017,
      lat: 25.86662222,
      lng: -107.5698639,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2018,
      lat: 25.85216667,
      lng: -107.6213333,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2018,
      lat: 26.65595556,
      lng: -108.3683167,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2019,
      lat: 25.9583,
      lng: -107.6657019,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 25,
    },
    {
      anio: 2024,
      lat: 26.780684,
      lng: -108.08379,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Otras actividades productivas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24.1676,
    },
    {
      anio: 2022,
      lat: 23.52856,
      lng: -105.83091,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 24,
    },
    {
      anio: 2024,
      lat: 23.526577,
      lng: -105.8283,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22.0569,
    },
    {
      anio: 2020,
      lat: 25.81626111,
      lng: -107.6480389,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades ilícitas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2022,
      lat: 26.732433,
      lng: -108.11762,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 22,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 22,
    },
    {
      anio: 2024,
      lat: 26.779648,
      lng: -108.06668,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Otras actividades productivas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 21.0549,
    },
    {
      anio: 2015,
      lat: 26.78077778,
      lng: -108.0852778,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Cultivos ilícitos",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 25.89091667,
      lng: -107.5394444,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2016,
      lat: 26.63316667,
      lng: -108.3784722,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 25.80361111,
      lng: -107.5467778,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2017,
      lat: 26.74072222,
      lng: -108.0433611,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2018,
      lat: 26.57484722,
      lng: -108.3297972,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 11,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 26.75627222,
      lng: -108.0509389,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2019,
      lat: 25.79632722,
      lng: -107.5202175,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 27,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2020,
      lat: 25.7895,
      lng: -107.6443194,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 20,
    },
    {
      anio: 2025,
      lat: 25.794756,
      lng: -107.42287,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 19.6582,
    },
    {
      anio: 2021,
      lat: 25.79669722,
      lng: -107.5536722,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 19,
    },
    {
      anio: 2023,
      lat: 26.842142,
      lng: -108.41192,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Transportes",
      semana: 7,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 18.9886,
    },
    {
      anio: 2016,
      lat: 23.48761111,
      lng: -105.8805556,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2018,
      lat: 25.85277583,
      lng: -107.5998883,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 18,
    },
    {
      anio: 2016,
      lat: 23.33325,
      lng: -105.8386111,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2019,
      lat: 25.79745,
      lng: -107.5710444,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2019,
      lat: 25.88358333,
      lng: -107.5935028,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 17,
    },
    {
      anio: 2022,
      lat: 25.817362,
      lng: -107.64075,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Intencional",
      semana: 25,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 16,
    },
    {
      anio: 2015,
      lat: 26.74794722,
      lng: -108.1064167,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2016,
      lat: 26.78422222,
      lng: -108.1373611,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2018,
      lat: 25.87069167,
      lng: -107.5612444,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2019,
      lat: 25.97083389,
      lng: -107.6746828,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2020,
      lat: 25.88678889,
      lng: -107.6574694,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades ilícitas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 15,
    },
    {
      anio: 2024,
      lat: 23.457727,
      lng: -105.81859,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14.2242,
    },
    {
      anio: 2024,
      lat: 23.455244,
      lng: -105.82049,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 15,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 14.0839,
    },
    {
      anio: 2016,
      lat: 26.79494444,
      lng: -108.1512778,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2021,
      lat: 25.76042222,
      lng: -107.4792306,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 14,
    },
    {
      anio: 2022,
      lat: 26.798466,
      lng: -108.248055,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 13,
    },
    {
      anio: 2023,
      lat: 23.525047,
      lng: -106.58265,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Actividades agrícolas",
      semana: 20,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 12.4124,
    },
    {
      anio: 2023,
      lat: 25.844166,
      lng: -107.54972,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 7,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 12.0565,
    },
    {
      anio: 2015,
      lat: 26.74880556,
      lng: -108.0578889,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Cultivos ilícitos",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 26.76292778,
      lng: -108.03415,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 25.89477778,
      lng: -107.5815556,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2017,
      lat: 26.78872222,
      lng: -108.11875,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2019,
      lat: 25.76380194,
      lng: -107.5384686,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2021,
      lat: 25.87146944,
      lng: -107.6587,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades ilícitas",
      semana: 3,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 12,
    },
    {
      anio: 2025,
      lat: 25.765163,
      lng: -107.54322,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 10,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 11.1076,
    },
    {
      anio: 2023,
      lat: 25.879723,
      lng: -107.592224,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10.9936,
    },
    {
      anio: 2015,
      lat: 23.63188889,
      lng: -106.4766944,
      estado: "Sinaloa",
      municipio: "Mazatlán",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2015,
      lat: 26.74980556,
      lng: -108.0529722,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Cultivos ilícitos",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2015,
      lat: 25.88505556,
      lng: -107.5790833,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 23.52981667,
      lng: -105.8980917,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fogatas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2016,
      lat: 23.55441667,
      lng: -105.9206111,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 25.79444444,
      lng: -107.5131833,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 25.83222222,
      lng: -107.6235,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 23.52176111,
      lng: -105.8465389,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2017,
      lat: 26.77372222,
      lng: -108.0609722,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Naturales",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 23.45016667,
      lng: -105.8356667,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Quema de basureros",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.64652778,
      lng: -108.3748,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Selva Baja Espinosa",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 25.81900556,
      lng: -107.5640194,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.64124444,
      lng: -108.3748,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 22,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2018,
      lat: 26.78869444,
      lng: -108.0652778,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2019,
      lat: 25.82380556,
      lng: -107.5558611,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2020,
      lat: 25.81446111,
      lng: -107.6392306,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 26.715406,
      lng: -108.28987,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2022,
      lat: 23.447578,
      lng: -105.83579,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 10,
    },
    {
      anio: 2023,
      lat: 25.678162,
      lng: -107.46588,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Quema de basureros",
      semana: 21,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 9.871,
    },
    {
      anio: 2024,
      lat: 24.88821,
      lng: -106.95198,
      estado: "Sinaloa",
      municipio: "Culiacán",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Severo",
      superficie: 9.2755,
    },
    {
      anio: 2018,
      lat: 25.768675,
      lng: -107.5746611,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 20,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 9,
    },
    {
      anio: 2015,
      lat: 26.71311111,
      lng: -108.3321111,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 23.54675,
      lng: -105.9138889,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 23.54882778,
      lng: -105.8986389,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Moderado",
      superficie: 8,
    },
    {
      anio: 2016,
      lat: 26.6485,
      lng: -108.3750556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 23.554,
      lng: -105.8386111,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Otras causas",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 25.84411111,
      lng: -107.5407222,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2017,
      lat: 26.802,
      lng: -108.1513333,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 26.79288889,
      lng: -108.1103056,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fogatas",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 25.86527778,
      lng: -107.5769444,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 13,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2018,
      lat: 23.44977778,
      lng: -105.8295556,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Desconocidas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2021,
      lat: 25.85645556,
      lng: -107.57085,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2022,
      lat: 26.694075,
      lng: -108.34158,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 8,
    },
    {
      anio: 2023,
      lat: 25.901945,
      lng: -107.53333,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Quema de basureros",
      semana: 15,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7.5562,
    },
    {
      anio: 2018,
      lat: 26.773425,
      lng: -108.0325444,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 25.90423333,
      lng: -107.6022889,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 24,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2018,
      lat: 26.77805556,
      lng: -108.0910556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2022,
      lat: 25.90488,
      lng: -107.64328,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Intencional",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 7,
    },
    {
      anio: 2023,
      lat: 23.5665,
      lng: -105.82886,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6.6103,
    },
    {
      anio: 2023,
      lat: 25.841688,
      lng: -107.57707,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 2,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6.068,
    },
    {
      anio: 2015,
      lat: 25.91522222,
      lng: -107.5866111,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2017,
      lat: 25.91278611,
      lng: -107.59945,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Otras causas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2022,
      lat: 25.88175,
      lng: -107.529335,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 24,
      vegetacion: "Bosque de Encino-Pino",
      impacto: "Impacto Mínimo",
      superficie: 6,
    },
    {
      anio: 2015,
      lat: 23.39861111,
      lng: -105.8231389,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fumadores",
      semana: 5,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 23.48533333,
      lng: -105.8664444,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 23.46797222,
      lng: -105.9197222,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2017,
      lat: 23.581,
      lng: -105.9026389,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Otras causas",
      semana: 49,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.88030556,
      lng: -107.5937222,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.88691944,
      lng: -107.5706028,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 26.77497222,
      lng: -108.0935556,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2018,
      lat: 25.88508333,
      lng: -107.5786389,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2019,
      lat: 24.28405556,
      lng: -106.5481639,
      estado: "Sinaloa",
      municipio: "Cosalá",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2020,
      lat: 23.50188056,
      lng: -105.8540806,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades ilícitas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2025,
      lat: 23.486845,
      lng: -105.845146,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Intencional",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 9782.2347,
    },
    {
      anio: 2025,
      lat: 25.722694,
      lng: -107.56678,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2022,
      lat: 25.743973,
      lng: -107.559166,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agrícolas",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 5,
    },
    {
      anio: 2023,
      lat: 26.5945,
      lng: -108.30389,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades pecuarias",
      semana: 10,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 4.541,
    },
    {
      anio: 2023,
      lat: 25.885645,
      lng: -107.54983,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 2,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4.457,
    },
    {
      anio: 2015,
      lat: 25.81305556,
      lng: -107.5195833,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.89958333,
      lng: -107.5875556,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 10,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 23.55025,
      lng: -105.90075,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Cultivos ilícitos",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 25.88763889,
      lng: -107.5952222,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 22,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 25.896,
      lng: -107.5904167,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2017,
      lat: 25.83569444,
      lng: -107.6265556,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.85775,
      lng: -107.6022222,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Desconocidas",
      semana: 16,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 26.78282778,
      lng: -108.1331944,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Actividades agrícolas",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2018,
      lat: 25.83761111,
      lng: -107.9314167,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2020,
      lat: 25.97151944,
      lng: -107.6543889,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Actividades ilícitas",
      semana: 26,
      vegetacion: "Bosque de Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 25.88358333,
      lng: -107.5649694,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2021,
      lat: 23.4452,
      lng: -105.8329722,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 21,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 4,
    },
    {
      anio: 2016,
      lat: 25.87995556,
      lng: -107.5967861,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 25.87466667,
      lng: -107.5825278,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 23.47736111,
      lng: -105.8564444,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Otras causas",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2017,
      lat: 25.87366667,
      lng: -107.578,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Otras causas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2018,
      lat: 25.90438889,
      lng: -107.5878056,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.89775,
      lng: -107.5899694,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2020,
      lat: 25.8767,
      lng: -107.5983167,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 21,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2022,
      lat: 23.454027,
      lng: -105.83134,
      estado: "Sinaloa",
      municipio: "Concordia",
      causa: "Actividades agrícolas",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 3,
    },
    {
      anio: 2015,
      lat: 25.87561111,
      lng: -107.5664722,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.87733889,
      lng: -107.5945222,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 25.86261111,
      lng: -107.5981917,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Cultivos ilícitos",
      semana: 23,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2017,
      lat: 25.86661111,
      lng: -107.5698611,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades agropecuarias",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.82680556,
      lng: -107.5664167,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.87,
      lng: -107.5960556,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 11,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2018,
      lat: 25.85091667,
      lng: -107.5673056,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Desconocidas",
      semana: 12,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.87089444,
      lng: -107.6291806,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 19,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2019,
      lat: 25.82731389,
      lng: -107.5685528,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 25.81611111,
      lng: -107.5963583,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades ilícitas",
      semana: 17,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2020,
      lat: 26.78646111,
      lng: -108.0347,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fogatas",
      semana: 26,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 25.87934167,
      lng: -107.5894778,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2021,
      lat: 25.81481389,
      lng: -107.5889472,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 20,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2022,
      lat: 25.842812,
      lng: -107.524,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Intencional",
      semana: 14,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 2,
    },
    {
      anio: 2016,
      lat: 23.64336111,
      lng: -106.7572333,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Otras causas",
      semana: 17,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1.62,
    },
    {
      anio: 2016,
      lat: 26.61016667,
      lng: -108.3943889,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Fumadores",
      semana: 21,
      vegetacion: "Selva Baja Caducifolia",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2022,
      lat: 25.859945,
      lng: -107.59172,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Actividades pecuarias",
      semana: 7,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.5,
    },
    {
      anio: 2024,
      lat: 25.936666,
      lng: -107.64861,
      estado: "Sinaloa",
      municipio: "Sinaloa",
      causa: "Quema de basureros",
      semana: 25,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1.2448,
    },
    {
      anio: 2021,
      lat: 25.88008056,
      lng: -107.5891111,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 18,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1.22,
    },
    {
      anio: 2018,
      lat: 26.77361667,
      lng: -108.1267056,
      estado: "Sinaloa",
      municipio: "Choix",
      causa: "Naturales",
      semana: 24,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2019,
      lat: 25.87064167,
      lng: -107.5955444,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 17,
      vegetacion: "Bosque de Pino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2020,
      lat: 25.85916944,
      lng: -107.5835139,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Quema de basureros",
      semana: 18,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 25.81640833,
      lng: -107.5660028,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fumadores",
      semana: 15,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2022,
      lat: 25.80839,
      lng: -107.56575,
      estado: "Sinaloa",
      municipio: "Badiraguato",
      causa: "Fogatas",
      semana: 9,
      vegetacion: "Bosque de Pino-Encino",
      impacto: "Impacto Mínimo",
      superficie: 1,
    },
    {
      anio: 2021,
      lat: 23.51526111,
      lng: -106.6318194,
      estado: "Sinaloa",
      municipio: "San Ignacio",
      causa: "Actividades ilícitas",
      semana: 17,
      vegetacion: "Selva Mediana Subperennifolia",
      impacto: "Impacto Mínimo",
      superficie: 0.325,
    },
  ];
})();
